import { createContext, useContext, useEffect, useState, useCallback } from "react";

const dict = {
  en: {
    nav_features: "Features",
    nav_howit: "How it works",
    nav_pricing: "Pricing",
    nav_download: "Download",
    nav_support: "Support",
    lp_download_eyebrow: "Download",
    lp_download_h2: "Get Lumioos on every device",
    lp_download_h2_one: "Lumioos is now on {platform}",
    lp_download_h2_two: "Lumioos for {p1} & {p2}",
    lp_download_sub: "Install Lumioos natively on Windows now — Apple and Android coming soon.",
    lp_download_sub_one: "Install Lumioos natively on {platform}. More platforms coming soon.",
    lp_download_sub_two: "Install on {p1} or {p2} — more devices coming soon.",
    lp_download_live: "Live",
    lp_download_soon: "Coming soon",
    lp_download_install: "Install free",
    lp_download_notify: "We'll launch soon",
    nav_signin: "Sign in",
    nav_get_started: "Get started",
    hero_badge: "Trusted by creators worldwide — Claude 4.5 · GPT-5 · Gemini 3",
    hero_h1_a: "One AI workspace.",
    hero_h1_b: "Every model. Every language",
    hero_sub: "Claude 4.5, GPT-5, and Gemini 3 in one place — built for creators, writers, and freelancers who need more than chat. Write, translate, learn, and prep interviews in 6 native languages. From {from_price}/mo.",
    hero_cta_primary: "Start free — no card needed",
    hero_cta_secondary: "See how it works",
    hero_card_eyebrow: "Live AI answer",
    hero_card_question: "Write a short birthday message in Turkish",
    hero_card_assistant: "Lumioos Assistant",
    hero_card_answer: "Doğum günün kutlu olsun! Hayatımın her anında yanımda olduğun için minnettarım. Bu yeni yaşın sana sağlık, mutluluk ve bol kahkaha getirsin. Seni çok seviyorum! 🎉",
    hero_card_time: "Replied in 4s",
    feat_section_eyebrow: "What Lumioos does",
    feat_section_h2: "One workspace. Everything you need.",
    feat_section_sub: "Stop juggling 6 tabs. Chat, write, translate, learn, code, produce videos — all from one clean workspace.",
    feat_chat_title: "Smart AI Chat",
    feat_chat_desc: "Ask anything — translation, writing, learning, advice, ideas, code. Attach a screenshot for visual analysis. Speak instead of typing. Lumioos understands everyday questions, professional work and technical problems alike.",
    feat_chat_li1: "Write emails, posts, essays in any tone",
    feat_chat_li2: "Translate between 6 languages",
    feat_chat_li3: "Image upload + voice input",
    feat_chat_li4: "Code & technical help when you need it",
    trust_no_card: "No credit card required",
    // Free trial messaging (driven by /api/billing/trial-config)
    trial_badge: "{days}-day Pro trial · no card required",
    trial_banner_text: "{days} days left in your free Pro trial",
    trial_banner_ending_today: "Your free trial ends today — upgrade to keep Pro features",
    trial_banner_cta: "Upgrade now",
    trial_banner_close: "Dismiss",
    trial_pill_label: "Trial · {days}d left",
    trial_pill_cta: "Upgrade",
    trial_pill_tooltip: "You're on a free Pro trial — click to upgrade before it ends.",
    trial_ribbon_text: "🎁 Get {days} days of Pro free — no credit card required",
    trial_ribbon_pill: "Limited offer",
    trial_ribbon_cta: "Start free",
    hero_cta_trial: "Start {days}-Day Free Trial",
    // Refer & Earn page
    ref_back: "Back",
    ref_title: "Refer & Earn",
    ref_subtitle: "Invite a friend → you get +{days} days of Pro for each signup, your friend starts with 14 days free Pro (standard 7-day trial + 7-day referral bonus).",
    ref_loading: "Loading…",
    ref_invited: "Invited",
    ref_days_earned: "Pro days earned",
    ref_your_link: "Your invite link",
    ref_copy: "Copy",
    ref_copied: "Copied",
    ref_share: "Share",
    ref_your_code: "Your code:",
    ref_recent: "Recent invites",
    ref_days_awarded: "+{days} days Pro",
    ref_how_to_share: "📣 How to share?",
    ref_share_whatsapp: "Drop it in WhatsApp / Telegram groups",
    ref_share_twitter: "Share on X with a demo screenshot",
    ref_share_linkedin: "Post on LinkedIn with the link",
    ref_share_forum: "Mention in Salesforce / Trailhead forums & Reddit",
    ref_link_copied: "Link copied",
    ref_copy_error: "Could not copy",
    ref_load_error: "Could not load referrals",
    ref_share_message: "Try Lumioos with my link — sign up and get 14 days of Pro free!",
    // Trial-ended recovery modal
    trial_ended_close: "Close",
    trial_ended_title: "Welcome back to Free",
    trial_ended_subtitle: "Your 7-day Pro trial just ended.",
    trial_ended_losing: "You're losing access to",
    trial_ended_feat_video: "🎬 Video Producer (Sora 2)",
    trial_ended_feat_interview: "🎤 Interview Practice (mock interviews)",
    trial_ended_feat_image: "🖼️ Image Producer (GPT Image 1)",
    trial_ended_feat_salesforce: "⚡ Salesforce / Trailhead Agent",
    trial_ended_promo_eyebrow: "One-time offer",
    trial_ended_promo_headline: "20% OFF Pro — just for you",
    trial_ended_promo_sub: "Promo code {code} auto-applies at checkout. Valid only now.",
    trial_ended_cta_upgrade: "Upgrade with {code} → 20% OFF",
    trial_ended_cta_later: "Maybe later",
    trust_stripe: "Stripe-secured payments",
    trust_privacy: "Your data stays private",
    trust_rating: "Loved by early users",
    // Comparison section
    cmp_eyebrow: "Why Lumioos",
    cmp_h2: "Different by design.",
    cmp_sub: "ChatGPT Plus is a great product. Lumioos is built for creators who want access to multiple AI models, native multi-language tools, and features beyond chat — at a price that fits a side project.",
    cmp_col_feature: "What you get",
    cmp_col_chatgpt: "ChatGPT Plus",
    cmp_col_lumioos: "Lumioos",
    cmp_price: "Starting price",
    cmp_price_chatgpt: "$20/mo",
    cmp_price_lumioos: "$9/mo",
    cmp_models: "AI Models included",
    cmp_models_chatgpt: "OpenAI",
    cmp_models_lumioos: "Claude 4.5 + GPT-5 + Gemini 3",
    cmp_voice: "Voice & screenshot input",
    cmp_yes: "Yes",
    cmp_no: "No",
    cmp_langs: "Native multi-language UI",
    cmp_langs_chatgpt: "English-first",
    cmp_langs_lumioos: "6 native languages",
    cmp_interview: "Interview Practice coach",
    cmp_cta: "Try Lumioos free",
    cmp_footnote: "Both are great tools — choose what fits your workflow. ChatGPT Plus is a trademark of OpenAI, not affiliated with Lumioos.",
    // Brand video / demo section
    demo_eyebrow: "See it in action",
    demo_h2: "Watch Lumioos in 60 seconds.",
    demo_sub: "From cluttered tabs to one clean workspace — see what Lumioos does for creators and writers.",
    demo_tab_write: "Write",
    demo_tab_translate: "Translate",
    demo_tab_interview: "Interview",
    // Chat image mode
    chat_image_mode_idle: "Image",
    chat_image_mode_active: "Image",
    chat_mode_image_hint: "Create images",
    chat_mode_code_hint: "Fast coding help",
    chat_mode_cv_hint: "Build a CV",
    chat_bg_writing: "AI is writing your reply…",
    chat_mode_travel: "Travel",
    chat_mode_travel_hint: "trip planner",
    chat_travel_placeholder: "Where are you going? e.g. '7 days in Tokyo, mid-range budget, late October'",
    travel_mode_pro_only: "Travel planner is a Pro feature. Upgrade to unlock unlimited itineraries.",
    travel_mode_pro_only_short: "Travel — Pro feature",
    chat_cv_placeholder: "Upload your CV or tell me: name, target job, experience, education, skills…",
    chat_mode_video_hint: "Make a video",
    model_desc_haiku: "Quick everyday chat",
    model_desc_sonnet: "Deep thinking & writing",
    model_desc_gpt4o: "Balanced general-purpose",
    model_desc_gemini: "Multimodal & vision",
    model_desc_gpt5: "Hardest tasks · top reasoning",
    model_badge_fast: "FAST",
    model_locked_toast: "{model} is on the {tier} plan. Upgrade to unlock.",
    chat_gpt5_this_month: "this month",
    chat_gpt5_meter_label: "GPT-5 messages this month",
    chat_image_mode_on: "Generate an image instead",
    chat_image_mode_off: "Switch back to text chat",
    chat_image_placeholder: "Describe the image you want to generate…",
    chat_download_image: "Download",
    // CV Builder
    cv_eyebrow: "AI CV Builder",
    cv_h1: "Build a CV that gets interviews.",
    cv_sub: "Fill the form, AI writes the resume. Edit anytime with plain instructions like 'make summary shorter'.",
    cv_quota: "This month",
    cv_back_projects: "Projects",
    cv_form_h: "Your information",
    cv_full_name: "Full name *",
    cv_headline: "Headline (e.g. Product Designer)",
    cv_email: "Email",
    cv_phone: "Phone",
    cv_location: "Location",
    cv_target_role: "Target role",
    cv_summary: "Brief about you",
    cv_skills: "Skills (comma-separated)",
    cv_languages: "Languages (comma-separated)",
    cv_experience: "Experience",
    cv_education: "Education",
    cv_add: "Add",
    cv_template: "Template",
    cv_tone: "Tone",
    cv_generate: "Generate CV",
    cv_regenerate: "Regenerate CV",
    cv_generating: "Writing your CV…",
    cv_generated: "CV generated and saved to Projects",
    cv_failed: "CV generation failed",
    cv_name_required: "Full name is required",
    cv_saved: "Saved to Projects",
    cv_download_pdf: "Download PDF",
    cv_edit_h: "Refine with AI",
    cv_edit_sub: "Tell the AI exactly what to change.",
    cv_apply: "Apply with AI",
    cv_editing: "Updating…",
    cv_updated: "CV updated",
    cv_empty_h: "Fill the form, then click Generate",
    cv_empty_sub: "Your CV will appear here. Saved to Projects automatically — edit anytime.",
    // Best AI / Smart Default section
    bestai_eyebrow: "Smart Default",
    bestai_h2: "Powered by Claude 4.5.",
    bestai_sub: "Currently #1 for writing, code and reasoning. Switch to GPT-5 or Gemini 3 anytime — no extra cost.",
    bestai_table_h: "Pick the right model for the job.",
    bestai_table_sub: "Lumioos gives you all three — switch with one click per chat.",
    bestai_footnote: "All three models included in your Lumioos subscription — switch with one click, no extra cost.",
    demo_user_write: "Write a LinkedIn post announcing my new SaaS launch — keep it confident, not cringey.",
    demo_ai_write: "🚀 Three years in stealth, one wild idea, and finally — Lumioos is live.\\n\\nIt's the AI workspace I always wanted: every model, every language, half the price. If you've ever paid for 3 AI tools and still felt like something was missing — this is for you.\\n\\nLink in comments. Would love your honest take.",
    demo_user_translate: "Translate this into French, but make it sound like a native speaker writing to a friend, not a textbook: 'Hey, are we still on for dinner tomorrow?'",
    demo_ai_translate: "Salut ! On est toujours d'accord pour dîner demain ?",
    demo_user_interview: "Tell me about a time you handled conflict at work.",
    demo_ai_interview: "🎯 Strong answer framework (STAR):\\n• Situation: A teammate disagreed publicly with my design proposal\\n• Task: De-escalate without backing down\\n• Action: I asked for their concerns 1-on-1, found a real issue, integrated their feedback\\n• Result: Shipped a better version, kept the relationship\\n\\nYour turn — try it with your own example. I'll score you in real time.",
    hero_card_live: "Live",
    hero_chip_voice: "Voice → Text",
    hero_chip_image: "See your screenshots",
    hero_chip_lang: "6 languages",
    // Stats strip
    stat_1_n: "Languages",
    stat_1_v: "6",
    stat_2_n: "AI models",
    stat_2_v: "3+",
    stat_3_n: "Avg. answer time",
    stat_3_v: "8s",
    stat_4_n: "Uptime",
    stat_4_v: "99.9%",
    // Feature section
    // Feature-flag "Coming soon" copy used on Landing promos when admin
    // flips a feature to coming_soon (ad visible, access locked).
    coming_soon_badge: "Coming soon",
    gs_ad_cta_soon: "Get notified at launch",
    gs_ad_locked: "Locked for now — flipping live soon.",
    gs_coming_soon_toast: "Game Studio is launching soon — we'll let you know!",
    feat_video_title: "Cinematic Video Producer",
    feat_video_desc: "Type a topic in any of 6 languages. In minutes, get a script, AI-narrated voiceover, cinematic scenes and a ready-to-publish MP4 — perfect for social media, marketing or education.",
    feat_video_li1: "Scripts in your language (TR · EN · ES · FR · DE · IT · PT · JA · ZH)",
    feat_video_li2: "9 natural AI voices — pick the perfect tone",
    feat_video_li3: "Cinematic AI visuals — no stock-footage look",
    feat_video_li4: "Download MP4 + voiceover + scenes",
    feat_speed_t: "Lightning fast",
    feat_speed_d: "Chat answers in seconds. Videos in minutes. Zero waiting.",
    feat_secure_t: "Bank-grade security",
    feat_secure_d: "End-to-end encrypted sessions. Your prompts are never used to train AI.",
    feat_global_t: "Global by design",
    feat_global_d: "Native support for 6 languages — including Turkish, Japanese and Chinese.",
    // How
    how_eyebrow: "How it works",
    how_h2: "Three steps. Zero learning curve.",
    how_s1_t: "Sign in free",
    how_s1_d: "No credit card. Create your account with email or Google in under 30 seconds.",
    how_s2_t: "Ask or describe",
    how_s2_d: "Type, speak, or drop a screenshot in chat. Or type a video topic in your language.",
    how_s3_t: "Use the result",
    how_s3_d: "Copy the answer to your task. Download the MP4. Publish it. Done.",
    // Landing pricing (matches real plans)
    lp_pricing_eyebrow: "Simple, fair pricing",
    lp_pricing_h2: "Start free. Upgrade only when you need more.",
    lp_pricing_sub: "Every plan includes core AI features. No hidden fees. Cancel anytime.",
    lp_plan_popular: "Most popular",
    lp_plan_start: "Get started",
    lp_plan_free_desc: "Perfect for trying Lumioo and personal use.",
    lp_plan_free_f1: "5 AI images / month",
    lp_plan_free_f2: "10 chat messages / day",
    lp_plan_free_f3: "All 6 languages",
    lp_plan_creator_desc: "For freelancers, students and creators.",
    lp_plan_creator_f1: "50 AI images / month (HD)",
    lp_plan_creator_f2: "Unlimited chat with image + voice",
    lp_plan_creator_f3: "No watermark",
    lp_plan_creator_f4: "Priority response speed",
    lp_plan_pro_desc: "For professionals and small teams.",
    lp_plan_pro_f1: "150 AI images / month (HD)",
    lp_plan_pro_f2: "Everything in Creator",
    lp_plan_pro_f3: "Full Interview Practice access",
    lp_plan_pro_f4: "Priority support",
    lp_plan_pro_f5: "✨ CV Chat & Review — unlimited (PDF/Word/image)",
    lp_plan_power_desc: "For heavy users and power creators.",
    lp_plan_power_f1: "Everything in Pro",
    lp_plan_power_f2: "500 AI images/month (HD)",
    lp_plan_power_f3: "GPT-5 · 1500 messages, Opus 4.5 · 100/mo",
    lp_plan_power_f4: "Priority support · fair-use",
    lp_plan_power_f5: "✨ CV Chat & Review — unlimited + priority",
    lp_pricing_trust1: "Secured by Stripe",
    lp_pricing_trust2: "Cancel anytime",
    lp_pricing_trust3: "GDPR compliant",
    // Final CTA
    cta_h2_a: "Ready to work",
    cta_h2_b: "smarter?",
    cta_sub: "Join professionals who trust Lumioo every day. Free forever for personal use.",
    cta_btn: "Create your free account",
    cta_smallprint: "No credit card. 30-second signup. Cancel anytime.",
    footer_tag: "Built for professionals.",
    footer_privacy: "Privacy",
    footer_terms: "Terms",
    footer_support: "Support",
    support_eyebrow: "Support",
    support_h1: "How can we help?",
    support_sub: "Send us a message — bug reports, feature ideas, billing questions, anything. We read every one and reply to the email you give us.",
    support_back: "Back to home",
    support_name: "Your name",
    support_name_ph: "John Doe",
    support_email: "Your email",
    support_message: "Message",
    support_message_ph: "Tell us what's going on…",
    support_send: "Send message",
    support_sending: "Sending…",
    support_send_another: "Send another",
    support_sent_h2: "Message sent!",
    support_sent_sub: "Thanks — we'll get back to you at the email you provided, usually within 1 business day.",
    support_validation: "Please fill all fields (message must be at least 5 characters).",
    support_rate_limit: "Too many messages — please try again in an hour.",
    support_error: "Could not send. Please try again.",
    support_privacy_note: "Your message goes to our team. We never share your email.",
    // Auth
    auth_eyebrow_login: "Sign in to",
    auth_eyebrow_register: "Create your",
    auth_h1_login: "Welcome back.",
    auth_h1_register: "Lumioo account.",
    auth_sub_login: "Pick up where you left off.",
    auth_sub_register: "Get 50 free credits to start earning.",
    auth_name: "Name",
    auth_email: "Email",
    auth_password: "Password",
    auth_signin: "Sign in",
    auth_create: "Create account",
    auth_no_account: "No account yet?",
    auth_have_account: "Already have an account?",
    auth_forgot: "Forgot password?",
    fp_eyebrow: "Account recovery",
    fp_title: "Reset your password",
    fp_subtitle: "Enter the email tied to your account and we'll send you a reset link.",
    fp_send_btn: "Send reset link",
    fp_back_login: "Back to login",
    fp_sent_title: "Check your inbox",
    fp_sent_body: "If an account exists for {email}, a reset link is on its way. It's valid for 1 hour.",
    fp_sent_hint: "Don't see it? Check spam or try again in a couple of minutes.",
    rp_title: "Set a new password",
    rp_subtitle: "Pick a strong password — at least 8 characters.",
    rp_new_password: "New password",
    rp_confirm_password: "Confirm password",
    rp_submit_btn: "Save new password",
    rp_mismatch: "Passwords don't match",
    rp_too_short: "Password must be at least 8 characters",
    rp_invalid: "This reset link is invalid or expired.",
    rp_success: "Password updated. You're signed in.",
    rp_no_token_title: "No reset token found",
    rp_no_token_body: "This link looks broken. Please request a new reset email.",
    rp_request_new: "Request a new link",
    auth_create_one: "Create one",
    auth_demo: "Demo account",
    welcome_back: "Welcome back!",
    account_created: "Account created. Welcome!",
    auth_failed: "Authentication failed",
    // Sidebar
    side_dashboard: "Dashboard",
    side_chat: "AI Chat",
    side_video: "Video Producer",
    side_image: "Image Producer",
    side_cv: "CV Builder",
    side_interview: "Interview Practice",
    side_games: "Game Studio",
    gs_eyebrow: "Tool",
    gs_h1: "Game Studio",
    gs_sub: "Describe a game in any style — Lumioos AI builds a downloadable HTML game in ~15 seconds. Plays on phone, desktop, anywhere.",
    gs_credits: "credits",
    gs_examples: "Examples — tap to use as a starter",
    gs_title_label: "Game title (optional)",
    gs_title_ph: "e.g. Sheep Rescue",
    gs_prompt_label: "Describe your game",
    gs_prompt_ph: "Example: A platformer where a cat jumps to collect fish. Pastel pixel art. Three levels.",
    gs_cost_note: "Cost: 3 credits per generation",
    gs_generate_btn: "Generate game",
    gs_generating_btn: "Generating…",
    gs_generating: "Generating your game…",
    gs_generating_hint: "~15 seconds — Claude 4.5 is writing the code",
    gs_done: "Game ready! Tap Play below.",
    gs_generate_failed: "Generation failed — try a clearer prompt",
    gs_my_games: "My games",
    gs_play: "Play",
    gs_download: "Download .html",
    gs_download_short: ".html",
    gs_refresh: "Refresh",
    gs_clear_all: "Clear all",
    gs_clear_confirm: "Delete ALL games?",
    gs_clear_yes: "Yes",
    gs_cleared_count: "Cleared {count} games · moved to trash (7-day restore)",
    gs_library_full: "library full — oldest auto-deletes",
    gs_trash: "Trash",
    gs_trash_title: "Trash",
    gs_trash_sub: "Deleted games are kept for 7 days, then auto-purged forever.",
    gs_trash_empty: "Trash is empty.",
    gs_restore: "Restore",
    gs_restored: "Game restored",
    gs_suggest_higher_title: "Heads up:",
    gs_suggest_higher_body: "Mario / RPG / FPS / 3D-style games are usually too ambitious for Simple. Try Detailed (8 credits) or Premium (15 credits) for richer levels and visuals.",
    cancel: "Cancel",
    gs_download_failed: "Download failed",
    gs_delete: "Delete",
    gs_delete_confirm: "Delete this game?",
    gs_delete_failed: "Delete failed",
    gs_locked_title: "Game Studio is a Creator+ feature",
    gs_locked_desc: "Upgrade to Creator ($9/mo), Pro ($29/mo) or Power ($79/mo) to start generating games. Free users can still browse the showcase below.",
    gs_upgrade_btn: "See plans →",
    gs_ad_h2: "Imagine a game.",
    gs_ad_sub: "Type 'a cat catching fish under a pixel-art moon' — get a playable HTML game in 15 seconds. Plays on phone, desktop, anywhere. Download the .html and keep it forever.",
    gs_ad_b1: "Generate from a single sentence — any style, any mechanic",
    gs_ad_b2: "Download as a single .html file — no installs, no servers",
    gs_ad_b3: "Touch + keyboard controls baked in — works on every device",
    gs_ad_b4: "Pro $29 → 25 credits/mo · Power $79 → 80 credits/mo (Pro/Power only)",
    gs_ad_cta: "Start free trial — build your first game",
    gs_ad_see_plans: "See pricing",
    gs_quality_label: "Generation quality",
    gs_quality_hint: "⚡ Tip: Premium for story games, RPGs, FPS-like shooters and basic 3D mazes. Real 3D / AAA / multiplayer aren't supported — single-file HTML5 only.",
    gs_tier_simple_label: "Simple",
    gs_tier_simple_desc: "Quick arcade · Sonnet 4.5",
    gs_tier_detailed_label: "Detailed",
    gs_tier_detailed_desc: "Multi-level · sound · particles · Sonnet 4.5",
    gs_tier_premium_label: "Premium",
    gs_tier_premium_desc: "Story / RPG / 3D · Opus 4.5",
    gs_cost_note_dyn: "Cost: {cost} credits",
    side_games: "Game Studio",
    // ---- INTERVIEW PRACTICE ----
    iv_eyebrow: "Interview Practice",
    iv_h1: "Practice any interview. Out loud.",
    iv_sub: "Upload your question sheets as photos. Lumioos extracts every Q&A, builds your private bank, and quizzes you — by voice or text. Perfect for USCIS citizenship, green card, job and certification interviews.",
    iv_my_banks: "My question banks",
    iv_total: "total",
    iv_loading: "Loading…",
    iv_empty_title: "No question banks yet",
    iv_empty_sub: "Create one above, then upload a photo of your study sheet or add questions manually.",
    iv_questions: "questions",
    iv_open: "Open",
    iv_create: "Create bank",
    iv_bank_name_ph: "Bank name (e.g. USCIS Civics)",
    iv_bank_desc_ph: "Short description (optional)",
    iv_bank_created: "Bank created",
    iv_create_fail: "Could not create bank",
    iv_confirm_delete: "Delete this bank and all its questions?",
    iv_deleted: "Deleted",
    iv_delete_fail: "Delete failed",
    iv_load_fail: "Failed to load",
    iv_hint_title: "How it works",
    iv_hint_sub: "Take a photo of any interview prep sheet (US citizenship test, green card questions, job interview prep, certification questions). Lumioos reads it with AI vision, extracts every question with all accepted answers, and stores it forever. Then practice by voice (AI speaks the question, you answer with your mic) or by text.",
    iv_back_library: "Back to library",
    iv_practice: "Practice",
    iv_start_h2: "Start interview",
    iv_mode_text: "Text mode",
    iv_mode_voice: "Voice mode",
    iv_mode_text_hint: "Read each question, type your answer. AI grades by meaning, not exact words.",
    iv_mode_voice_hint: "AI speaks every question. Tap the mic, answer out loud. AI transcribes and grades.",
    iv_order_label: "Question order",
    iv_order_random: "Random",
    iv_order_sequential: "Sequential",
    iv_limit_label: "How many questions",
    iv_limit_all: "All ({n} questions)",
    iv_limit_all_short: "All",
    iv_limit_max: "max {n}",
    iv_limit_clamped: "Bank only has {n} questions — using all of them.",
    iv_or: "or",
    iv_start_now: "Start now",
    iv_start_fail: "Could not start session",
    iv_no_questions_start: "Add at least one question first",
    iv_upload_title: "Upload images or PDFs",
    iv_upload_sub: "Photos, screenshots, or PDF files of question sheets. AI extracts every Q&A automatically (up to 100 files, PDFs are read page by page).",
    iv_choose_images: "Choose images",
    iv_choose_files: "Choose images or PDFs",
    iv_extracting: "Extracting Q&A…",
    iv_extracted: "questions added from images",
    iv_extract_fail: "Could not extract questions",
    iv_budget_partial: "Added {n} questions, but your AI key ran out of credit mid-way. Top up to get the rest.",
    iv_partial_extract: "Added {n} questions ({f} batches failed — try again to get the rest).",
    iv_progress_label: "Processing batch {c} of {n}…",
    feat_iv_eyebrow: "Interview Practice",
    feat_iv_title: "Train for any interview — out loud or in writing",
    feat_iv_desc: "Upload your study sheets (photo or PDF). Lumioos extracts every Q&A, then quizzes you with a live AI interviewer that speaks the questions, listens to your spoken answers, and grades by meaning — strict to the exam answer key.",
    feat_iv_li1: "USCIS citizenship & green card prep",
    feat_iv_li2: "Job & technical interview practice",
    feat_iv_li3: "Voice + ear-training (questions hidden) modes",
    feat_iv_li4: "Strict grading + per-question report at the end",
    feat_iv_cta: "Start interview practice",
    feat_iv_use_cases: "USCIS · Green Card · Job · Certifications · Anything",
    feat_iv_badge: "NEW",
    iv_speed_label: "Speech speed",
    iv_speed_slow: "Slow",
    iv_speed_normal: "Normal",
    iv_speed_fast: "Fast",
    iv_speed_faster: "Faster",
    iv_speed_hint: "How fast the interviewer speaks the questions.",
    iv_range_label: "Question range",
    iv_range_hint: "1 to {n}",
    iv_range_from: "From",
    iv_range_to: "to",
    iv_range_clear: "clear",
    iv_range_note: "Leave empty to use all questions. Range applies to the source order (e.g., 1 → 50).",
    iv_range_invalid: "End must be ≥ start.",
    iv_deleted_undo: "Bank deleted ({n} questions). You can undo within 10 seconds.",
    iv_q_deleted_undo: "Question deleted. You can undo within 8 seconds.",
    iv_undo: "Undo",
    iv_restored: "Restored.",
    iv_restore_fail: "Could not restore",
    iv_delete_warning: "Permanent delete",
    iv_delete_q: "Delete this bank and its {n} questions?",
    iv_delete_desc: "You are about to delete the bank",
    iv_delete_type_to_confirm: 'Type "{name}" to confirm:',
    iv_delete_btn: "Delete bank",
    iv_voice_label: "Interviewer voice",
    iv_voice_female: "Female (Nova)",
    iv_voice_male: "Male (Ash) — gentle",
    iv_voice_female2: "Female (Shimmer)",
    iv_voice_male2: "Male (Fable) — friendly",
    iv_voice_hint: "Choose the voice of your AI interviewer.",
    iv_finish_early: "Finish exam",
    iv_finish_early_confirm: "End the exam now? You've answered {n} of {total} questions.",
    iv_finish_early_btn: "End now",
    iv_keep_going: "Keep going",
    iv_finishing: "Finishing…",
    iv_congrats: "Congratulations! 🎉",
    iv_congrats_sub: "You passed with a great score.",
    iv_good_job: "Well done!",
    iv_good_job_sub: "Solid performance — keep practising.",
    iv_keep_practising: "Keep practising",
    iv_keep_practising_sub: "Review your wrong answers below and try again.",
    iv_score_label: "Score",
    iv_wrong_review: "Review wrong answers",
    iv_resume_eyebrow: "In progress",
    iv_resume_title: "You have an unfinished interview",
    iv_resume_progress: "{done} / {total} questions answered so far",
    iv_resume_btn: "Resume",
    iv_resume_discard: "Discard",
    iv_resume_discard_confirm: "Discard this unfinished session and start fresh?",
    iv_resume_discarded: "Session discarded",
    iv_large_upload_warn: "Your upload is about {mb}MB. Very large uploads can fail on slow connections. Continue?",
    iv_trash: "Trash",
    iv_trash_title: "Recently deleted",
    iv_trash_banks: "Deleted banks",
    iv_trash_questions: "Deleted questions",
    iv_trash_empty: "Trash is empty.",
    iv_trash_load_fail: "Could not load trash",
    iv_purge: "Delete forever",
    iv_purge_confirm: "Permanently delete this bank? This cannot be undone.",
    iv_progress_preparing: "Preparing files…",
    iv_report_title: "Question-by-question breakdown",
    iv_your_answer: "Your answer",
    iv_skipped: "(skipped)",
    iv_max_10: "Max 10 images at once",
    iv_max_100: "Max 100 images at once",
    iv_manual_title: "Add manually",
    iv_manual_sub: "Type a question and the answers you want Lumioos to accept.",
    iv_add_question: "Add question",
    iv_cancel: "Cancel",
    iv_question: "Question",
    iv_accepted_answers: "Accepted answers (one per line)",
    iv_accepted_ph: "Executive\nLegislative\nJudicial\nCongress\nPresident",
    iv_min_required: "Min required",
    iv_min_hint: "How many of the accepted answers must the user say? (Usually 1)",
    iv_add: "Add",
    iv_q_added: "Question added",
    iv_add_fail: "Could not add question",
    iv_need_q_and_a: "Question and at least 1 answer required",
    iv_question_list: "Questions",
    iv_no_questions: "No questions yet. Upload a photo or add manually.",
    iv_confirm_delete_q: "Delete this question?",
    iv_back_bank: "Back to bank",
    iv_voice_interview: "Voice interview",
    iv_text_interview: "Text interview",
    iv_record: "Record answer",
    iv_stop_record: "Stop & transcribe",
    iv_transcribing: "Transcribing…",
    iv_voice_answer_ph: "Your transcribed answer will appear here. You can also edit before submitting.",
    iv_text_answer_ph: "Type your answer here…",
    iv_submit: "Submit",
    iv_skip: "Skip",
    iv_correct: "Correct",
    iv_wrong: "Not quite",
    iv_accepted_were: "Accepted answers were:",
    iv_see_results: "See results",
    iv_next_question: "Next question",
    iv_need_n_answers: "Give at least {n} different answers",
    iv_results: "Results",
    iv_accuracy: "accuracy",
    iv_restart: "Restart bank",
    iv_speak: "Speak question",
    iv_show_question: "Show question",
    iv_hide_question: "Hide question (ear training)",
    iv_question_hidden: "Question hidden — listen to the audio",
    iv_voice_intro_line: "Hi! When you're ready, press Start and I'll begin asking the questions.",
    iv_voice_ready: "I'm ready, let's start",
    iv_show_q_label: "Show questions on screen?",
    iv_show_q_on: "Show",
    iv_show_q_off: "Hide (ear training)",
    iv_show_q_on_hint: "Question text is visible while practicing.",
    iv_show_q_off_hint: "Only the audio plays — great for listening practice.",
    iv_starred_label: "Which questions to ask?",
    iv_starred_all: "All questions",
    iv_starred_only: "Only starred / important",
    iv_starred_hint: "Star (⭐) questions you want to focus on. Lumioos auto-stars questions marked important/likely in your source.",
    iv_starred_badge: "Important",
    iv_star: "Star this question",
    iv_unstar: "Unstar",
    iv_edit_question_tooltip: "Edit question and answers",
    iv_edit_question_label: "Question",
    iv_edit_answers_label: "Accepted answers (one per line)",
    iv_edit_answers_placeholder: "new moon\nfull moon\ncrescent",
    iv_edit_save: "Save",
    iv_edit_saved: "Question updated",
    iv_edit_fail: "Could not save changes",
    iv_edit_question_empty: "Question cannot be empty",
    iv_edit_answers_empty: "At least one accepted answer is required",
    iv_tts_fail: "Could not play question audio",
    iv_stt_fail: "Could not transcribe audio",
    iv_mic_denied: "Microphone access denied",
    iv_need_answer: "Type or record an answer first",
    iv_submit_fail: "Could not submit answer",
    iv_skip_fail: "Could not skip",
    side_projects: "Projects",
    side_credits: "Credits",
    side_logout: "Logout",
    delete_account: "Delete my account",
    delete_account_confirm_1: "This will permanently delete your account and all your data (chats, videos, images, CV, subscription). This cannot be undone. Continue?",
    delete_account_confirm_2: "Are you absolutely sure? This action is irreversible.",
    delete_account_ok: "Your account has been deleted. A confirmation email is on the way.",
    delete_account_err: "Could not delete account. Please try again or contact support.",
    side_theme: "Theme",
    side_language: "Language",
    side_integrations: "Integrations",
    side_help: "Help & Tokens",
    side_admin: "Admin",
    side_ai_workforce: "AI Workforce",
    wf_badge: "ADMIN · PHASE 1",
    wf_title: "AI Workforce",
    wf_subtitle: "Manage your private AI company workforce. Delegate objectives, monitor progress, and approve every action that touches the outside world.",
    wf_total_agents: "Total Agents",
    wf_active_agents: "Active Agents",
    wf_busy_agents: "Busy Agents",
    wf_tasks_in_progress: "Tasks in Progress",
    wf_tasks_completed: "Completed Tasks",
    wf_tasks_failed: "Failed Tasks",
    wf_approvals_pending: "Pending Approvals",
    wf_agents_title: "AI Employees",
    wf_workspace_company: "Company Workspace",
    wf_phase_notice_title: "Sub-Phase 1A · Foundation ready",
    wf_phase_notice_body: "Tasks, CEO orchestration, agent messaging and approvals arrive in Sub-Phase 1B → 1D. The employees above are already configured and ready — no further action needed until then.",
    wf_refresh: "Refresh",
    wf_ceo_chat_title: "CEO Chat",
    wf_ceo_chat_empty: 'Talk to CEO AI naturally. Try: "What tasks are waiting for approval?" or "Research 3 signup ideas."',
    wf_ceo_chat_placeholder: "Ask CEO anything, or say 'research X', 'cancel the task', 'approve draft'…",
    wf_ceo_chat_hint: "Intent is auto-detected: questions answer from real DB, task/control/approval intents call the real workforce APIs. No fake capabilities — CEO says so when a tool isn't wired.",
    wf_chat_view_task: "View task →",
    wf_new_objective: "New Objective",
    wf_task_title_placeholder: "e.g. Create a 3-day marketing plan for Lumioos",
    wf_task_desc_placeholder: "Describe the objective in detail. What outcome do you want? Any constraints?",
    wf_send_to_ceo: "Send to CEO AI",
    wf_ceo_will_plan: "CEO AI ({model}) will plan → assign to specialists → collect results. Marketing/Sales/Support/Finance outputs enter the approval queue.",
    wf_recent_tasks: "Recent Tasks",
    wf_no_tasks: "No tasks yet. Create your first objective above.",
    wf_recent_activity: "Recent Activity",
    wf_no_activity: "No activity yet.",
    wf_agent_chat_empty: "Say hello to {name}, or give a direct task.",
    wf_agent_chat_placeholder: "Talk to {name}…",
    wf_tab_overview: "Overview",
    wf_tab_chat: "Chat",
    wf_tab_current: "Current",
    wf_tab_history: "History",
    wf_tab_activity: "Activity",
    wf_tab_memory: "Memory",
    wf_tab_config: "Config",
    wf_field_status: "Status",
    wf_field_completed: "Completed",
    wf_field_completed_count: "{n} completed",
    wf_field_last_activity: "Last activity",
    wf_field_none: "—",
    wf_no_active_tasks: "No active tasks.",
    wf_no_history: "No history yet.",
    wf_no_memory: "No memory yet.",
    wf_cfg_model: "Model (actually running)",
    wf_cfg_allowed_tools: "Allowed tools",
    wf_cfg_system_instructions: "System instructions",
    wf_cfg_agent_id: "Agent ID",
    wf_task_objective: "Objective",
    wf_task_ceo_plan: "CEO Plan",
    wf_task_children: "Child Tasks ({n})",
    wf_task_view_result: "View result ({n} chars)",
    wf_task_error_prefix: "Error:",
    wf_task_ceo_summary: "CEO Summary",
    wf_task_agent_messages: "Agent Messages ({n})",
    wf_task_pause: "Pause",
    wf_task_resume: "Resume",
    wf_task_retry: "Retry",
    wf_task_cancel: "Cancel",
    wf_approve: "Approve",
    wf_reject: "Reject",
    wf_approval_status_prefix: "Approval {status}",
    wf_approvals_title: "Pending Approvals ({n})",
    wf_no_approvals: "No pending approvals.",
    wf_lwr_badge: "LIVE WEB RESEARCH",
    wf_lwr_counts: "{searches} searches · {sources} sources · {pages} pages read",
    wf_status_idle: "Idle",
    wf_status_working: "Working",
    wf_status_waiting_for_approval: "Awaiting approval",
    wf_status_paused: "Paused",
    wf_status_error: "Error",
    wf_status_offline: "Offline",
    wf_status_pending: "Pending",
    wf_status_planning: "Planning",
    wf_status_assigned: "Assigned",
    wf_status_in_progress: "In progress",
    wf_status_completed: "Completed",
    wf_status_failed: "Failed",
    wf_status_cancelled: "Cancelled",
    wf_leads_title: "Leads",
    wf_leads_open: "Open Leads",
    wf_leads_overview_title: "Lead Pipeline",
    wf_leads_total: "Total Leads",
    wf_leads_new: "New",
    wf_leads_qualified: "Qualified",
    wf_leads_reviewing: "Reviewing",
    wf_leads_approved: "Approved",
    wf_leads_rejected: "Rejected",
    wf_leads_archived: "Archived",
    wf_leads_verified: "Verified",
    wf_leads_needs_review: "Needs review",
    wf_leads_none: "No leads yet. Ask Sales AI to find some.",
    wf_leads_filter_status: "Status",
    wf_leads_filter_verification: "Verification",
    wf_leads_filter_min_score: "Min fit score",
    wf_leads_filter_industry: "Industry",
    wf_leads_filter_all: "All",
    wf_leads_sort: "Sort",
    wf_leads_sort_score: "Highest fit score",
    wf_leads_sort_newest: "Newest",
    wf_leads_sort_name: "Company name",
    wf_leads_col_company: "Company",
    wf_leads_col_website: "Website",
    wf_leads_col_industry: "Industry",
    wf_leads_col_location: "Location",
    wf_leads_col_score: "Fit score",
    wf_leads_col_verification: "Verification",
    wf_leads_col_status: "Status",
    wf_leads_col_discovered: "Discovered",
    wf_leads_score_reasons: "Why this score",
    wf_leads_concerns: "Concerns",
    wf_leads_sources: "Evidence sources",
    wf_leads_discovery_task: "Discovery task",
    wf_leads_actions_approve: "Approve",
    wf_leads_actions_reject: "Reject",
    wf_leads_actions_archive: "Archive",
    wf_leads_action_ok: "Lead {action}",
    wf_leads_action_fail: "Could not {action} lead",
    wf_leads_no_outreach_note: "Approving marks this lead for follow-up. No email, DM, or contact is sent.",
    wf_lead_status_new: "New",
    wf_lead_status_qualified: "Qualified",
    wf_lead_status_reviewing: "Reviewing",
    wf_lead_status_approved: "Approved",
    wf_lead_status_rejected: "Rejected",
    wf_lead_status_archived: "Archived",
    wf_verif_verified: "Verified",
    wf_verif_needs_review: "Needs review",
    wf_verif_unverified: "Unverified",
    wf_toast_task_created: "Objective sent to CEO AI — planning starting…",
    wf_toast_task_short: "Provide a longer title and description",
    wf_toast_task_create_fail: "Could not create task",
    wf_toast_task_load_fail: "Could not load task",
    wf_toast_workforce_load_fail: "Could not load AI Workforce",
    wf_toast_task_action_ok: "Task {action}",
    wf_toast_task_action_fail: "Could not {action} task",
    wf_toast_approved: "Approved",
    wf_toast_rejected: "Rejected",
    wf_toast_approval_fail: "Could not resolve approval",
    wf_chat_error_prefix: "Error:",
    wf_chat_error_fallback: "chat failed",
    auth_google: "Continue with Google",
    auth_or: "or with email",
    integrations_eyebrow: "Connect",
    integrations_h1: "Integrations",
    integrations_sub: "Connect Salesforce, Splunk, Defender, Trend Micro, SentinelOne, CrowdStrike and more. Lumioo will fetch your cases and solve them.",
    help_eyebrow: "Documentation",
    help_h1: "Token & API key guide",
    help_faq: "Frequently asked",
    help_sub: "Step-by-step guides for getting an API token from every supported platform. Click any 'Open' button to jump straight to the right page.",
    // Dashboard
    dash_eyebrow: "Dashboard",
    dash_hello: "Hello",
    dash_sub: "Pick a tool and start producing.",
    dash_credits_label: "Available credits",
    dash_open: "Open tool",
    dash_chat_card_desc: "Ask anything: Salesforce, cybersecurity, code, projects.",
    dash_video_card_desc: "Topic → full YouTube package + MP4 video.",
    dash_interview_card_desc: "Practice job interviews with an AI interviewer.",
    dash_pro_only_badge: "Creator & Pro",
    dash_card_unlock: "Upgrade to unlock",
    dash_recent_eye: "Recent projects",
    dash_recent_h2: "Your latest work",
    dash_view_all: "View all",
    dash_no_projects: "No projects yet. Start with",
    dash_or: "or",
    // Chat
    chat_eyebrow: "Tool",
    chat_h1: "AI Chat",
    chat_sub: "Ask anything — writing, translation, advice, code, learning, ideas.",
    chat_new: "New chat",
    chat_sessions: "Conversations",
    chat_empty_title: "How can I help today?",
    chat_empty_sub: "Start typing or try one of these prompts.",
    chat_placeholder: "Ask Lumioo anything…",
    chat_send: "Send",
    admin_finance_title: "Finance",
    admin_finance_sub: "Revenue, costs, profit/loss this month. Estimates — Stripe is source of truth.",
    admin_finance_prev: "prev",
    admin_finance_refresh: "Refresh",
    admin_fin_revenue: "Revenue",
    admin_fin_llm_cost: "LLM cost",
    admin_fin_image_cost: "Image cost",
    admin_fin_net_profit: "Net profit",
    admin_fin_net_loss: "Net LOSS",
    admin_fin_margin: "Margin",
    admin_fin_paid_tx: "paid tx",
    admin_fin_messages: "messages",
    admin_fin_images: "images",
    chat_delete_all: "Clear all",
    chat_delete_all_confirm: "Are you sure you want to delete ALL {n} chats? This cannot be undone.",
    chat_delete_all_done: "Deleted {n} chats",
    chat_model: "Model",
    chat_speed: "Speed",
    chat_mode_quick: "Quick",
    chat_mode_quick_sub: "Gemini Flash · fast",
    chat_mode_smart: "Smart",
    chat_mode_smart_sub: "Sonnet 4.6 · deeper",
    chat_mode_genius: "Genius",
    chat_mode_genius_sub: "GPT-5 · top reasoning",
    chat_mode_master: "Master",
    chat_mode_master_sub: "Opus 4.5 · most capable",
    chat_opus_meter_label: "Master (Opus 4.5) this month",
    chat_thinking: "Thinking…",
    chat_stop: "Stop",
    chat_continue: "Continue",
    chat_stopped_marker: "⏹ Stopped",
    chat_continue_prompt: "Please continue from where you left off.",
    chat_thinking_fast: "⚡ Fast",
    chat_thinking_balanced: "🎯 Balanced",
    chat_thinking_thorough: "🧠 Thorough",
    bestai_task_writing: "Long-form writing",
    bestai_task_code: "Code & debug",
    bestai_task_translate: "Translate (TR/AR/RU)",
    bestai_task_reasoning: "Hardest reasoning",
    bestai_task_capable: "Most capable",
    bestai_task_quick: "Quick answers",
    gpt56_promo_badge: "NEW · PRO & POWER EXCLUSIVE",
    gpt56_promo_title: "GPT 5.6 Family",
    gpt56_promo_desc: "Meet the next generation of GPT — three flavors, one purpose: give you the exact balance of depth, breadth, and speed you need for every task. Available today on {plans} plans.",
    gpt56_promo_plans_hl: "Pro & Power",
    gpt56_sol_tag: "Deepest reasoning",
    gpt56_sol_desc: "For the hardest problems — long analyses, research, complex code review. When accuracy matters more than speed.",
    gpt56_terra_tag: "Balanced power",
    gpt56_terra_desc: "Your everyday workhorse. Great answers, fast enough, wide knowledge — the sweet spot between Sol and Luna.",
    gpt56_luna_tag: "Fastest 5.6",
    gpt56_luna_desc: "Snappy replies for chat, brainstorming, and quick lookups. Still smarter than most models — just faster.",
    gpt56_cta_plans: "See Pro & Power plans →",
    gpt56_cta_trial: "Start 14-day free trial",
    router_promo_badge: "NEW · PRO EXCLUSIVE",
    router_promo_desc: "The most powerful model on the planet — automatically routed to your hardest tasks. One toggle in chat sends complex code, analysis, and reasoning to OpenAI GPT-5, while everyday questions stay snappy on Claude 4.5. No model picker. No friction.",
    router_promo_bullet1: "Auto-selects GPT-5 for hard tasks",
    router_promo_bullet2: "World-leading reasoning + code",
    router_promo_bullet3: "Priority queue, no rate limits",
    router_promo_bullet4: "One-click toggle in chat",
    router_promo_cta: "Upgrade to Pro",
    router_promo_included: "Included free with every Pro plan",
    sonnet_promo_pill: "Best for general tasks",
    sonnet_promo_default_label: "— Lumioos default",
    sonnet_promo_desc: "Anthropic's flagship model leads independent benchmarks for writing, code, and complex reasoning. Lower hallucination rate than GPT-5 and stronger multilingual quality. Set as Lumioos default so new users get the best results out of the box.",
    sonnet_col_writing: "Writing",
    sonnet_col_code: "Code",
    sonnet_col_reasoning: "Reasoning",
    chat_delete: "Delete",
    chat_copy: "Copy",
    chat_copied: "Copied",
    chat_no_sessions: "No conversations yet.",
    chat_suggest_1: "Explain a Splunk SPL alert for failed admin logins",
    chat_suggest_2: "Write Python to deduplicate a list of dicts",
    chat_suggest_3: "Draft a Salesforce case reply for a slow Lightning page",
    chat_suggest_4: "Plan a SaaS MVP for AI invoice processing",
    // Video
    video_eyebrow: "Tool",
    video_h1: "AI Video Producer",
    video_sub: "A topic in → a complete YouTube package with a finished MP4.",
    video_topic: "Topic",
    video_topic_ph: "e.g. How AI Will Reshape Online Income in 2026",
    video_tone: "Tone",
    video_length: "Length",
    video_voice: "Voice",
    video_generate: "Generate video package",
    video_generating: "Producing your video… (30–90s)",
    video_loading_sub: "Writing script, painting scenes, recording voice, stitching MP4…",
    video_empty: "Your generated video assets will show here.",
    video_title_l: "Title",
    video_desc_l: "Description",
    video_voiceover: "Voiceover",
    video_download_audio: "Download MP3",
    video_download_video: "Download MP4",
    video_scenes: "Scenes",
    video_copy_meta: "Copy metadata",
    video_meta_copied: "Metadata copied",
    video_no_mp4: "MP4 not available — you can still use scenes + audio separately.",
    scene: "Scene",
    image_unavailable: "Image unavailable",
    // Projects
    projects_eyebrow: "History",
    projects_h1: "Your projects",
    projects_sub: "Everything you have produced with Lumioo.",
    projects_empty: "No projects yet.",
    projects_clear_all: "Clear all",
    projects_clear_confirm: "Delete ALL projects?",
    projects_clear_yes: "Yes, delete all",
    projects_cleared_count: "Cleared {count} projects",
    try_chat: "Try AI Chat",
    try_video: "Try Video Producer",
    // toasts
    err_generic: "Something went wrong",
    err_topic_required: "Please enter a topic",
    err_message_required: "Type a message",
    video_ready: "Video package ready",
    answer_ready: "Answer ready",
    stage_queued: "Queued…",
    stage_script: "Writing script…",
    stage_images_audio: "Painting scenes & recording voice…",
    stage_stitching: "Stitching MP4…",
    stage_done: "Done",
    // Chat extras
    chat_attach_image: "Attach image",
    chat_websearch_label: "Web",
    chat_websearch_on: "Web search ON — Lumioos will fetch fresh facts before answering",
    chat_websearch_off: "Web search OFF — Lumioos uses its built-in knowledge. Turn ON for current events.",
    chat_enable_web_retry: "Enable Web Search & retry",
    cv_mode_pro_only: "CV chat & review is a Pro feature. Upgrade to unlock CV creation, file upload, AI review and PDF export.",
    cv_upload_title: "Upload your CV (optional)",
    cv_upload_hint: "PDF, Word, TXT or image — Lumioos will review it and tailor it to the job you're applying for.",
    cv_upload_btn: "Upload CV",
    cv_upload_ok: "CV loaded — type the job role and Lumioos will review it",
    cv_upload_image_ok: "CV image attached — Lumioos will read it on next message",
    cv_upload_ready: "ready — type the job role you're applying for",
    cv_upload_too_large: "File too large (max 8 MB)",
    cv_upload_failed: "Could not read this file",
    cv_saved_label: "Saved CV:",
    cv_saved_replace: "Replace",
    cv_saved_delete: "Delete",
    cv_saved_delete_confirm: "Delete your saved CV? You'll need to upload it again next time.",
    cv_saved_deleted: "Saved CV deleted",
    cv_pdf_btn: "Download PDF",
    cv_pdf_no_content: "Send a message first so Lumioos can draft your CV.",
    cv_pdf_ready: "PDF ready",
    cv_pdf_failed: "Could not generate PDF",
    cv_ats_btn: "ATS Score",
    cv_ats_prompt: "Paste the target job description (min 20 chars):",
    cv_ats_too_short: "Please paste a longer job description",
    cv_ats_ready: "ATS score ready",
    cv_ats_result_title: "ATS Score Result",
    cv_ats_categories: "Categories",
    cv_ats_matched: "Matched keywords",
    cv_ats_missing: "Missing keywords",
    cv_ats_recommendations: "Recommendations",
    cv_optimize_btn: "Optimize",
    cv_optimize_prompt: "Paste the target job description (or leave empty to give an instruction):",
    cv_optimize_instruction: "How should Lumioos optimize your CV?",
    cv_optimize_need_input: "Provide either a job description or an instruction",
    cv_optimize_empty: "No CV returned",
    cv_optimize_ready: "Optimized CV ready",
    cv_optimize_result_title: "Optimized CV",
    cv_history_btn: "History",
    cv_history_title: "CV Version History",
    cv_history_empty: "No CVs saved yet.",
    cv_history_current: "Active",
    cv_history_restore: "Restore",
    cv_history_restored: "Version restored",
    cv_cover_btn: "Cover Letter",
    cv_cover_title: "AI Cover Letter",
    cv_cover_jd_label: "Job description",
    cv_cover_jd_placeholder: "Paste the full job description here…",
    cv_cover_jd_too_short: "Please paste a longer job description",
    cv_cover_company_label: "Company",
    cv_cover_role_label: "Role",
    cv_cover_tone_label: "Tone",
    cv_cover_tone_confident: "Confident & professional",
    cv_cover_tone_warm: "Warm & friendly",
    cv_cover_tone_formal: "Formal",
    cv_cover_tone_enthusiastic: "Enthusiastic",
    cv_cover_generate: "Generate Cover Letter",
    cv_cover_hint: "Uses your saved CV — no re-upload needed.",
    cv_cover_ready: "Cover letter ready",
    cv_cover_empty: "No cover letter returned",
    cv_cover_regenerate: "Regenerate",
    cv_cover_success: "Cover letter added to your chat.",
    cv_cover_pdf_btn: "Download as PDF",
    cv_cover_pdf_ready: "Cover letter PDF ready",
    cv_cover_copy_btn: "Copy",
    cv_diff_btn: "Diff",
    cv_diff_title: "CV Version Diff",
    cv_diff_empty: "No changes.",
    cv_diff_restore_this: "Restore this version",
    cv_diff_close: "Close",
    copied: "Copied",
    chat_start_recording: "Start voice",
    chat_stop_recording: "Stop & transcribe",
    chat_image_attached: "Image ready",
    chat_image_remove: "Remove image",
    chat_only_image: "Please choose an image file",
    chat_image_too_large: "Image too large (max 8 MB)",
    chat_image_max: "You can attach up to 10 images per message",
    chat_drop_title: "Drop your image to attach",
    chat_drop_sub: "PNG / JPG / WebP — max 8 MB",
    chat_upgrade_title: "You've hit your daily limit",
    chat_upgrade_sub: "{used} of {limit} messages used today on the Free plan. Upgrade to keep going — your limit resets at midnight UTC.",
    chat_upgrade_benefits: "What you unlock",
    chat_upgrade_b1: "Unlimited chat messages",
    chat_upgrade_b2: "Full Interview Practice access",
    chat_upgrade_b3: "Image + voice in chat",
    chat_upgrade_b4: "No watermark on videos",
    chat_upgrade_cta: "See plans",
    chat_upgrade_later: "Maybe later",
    iv_gate_title: "Interview Practice is locked",
    iv_gate_sub: "This is a Creator & Pro feature. Upgrade to unlock unlimited question banks, voice mode, and detailed reports.",
    iv_gate_what_you_get: "What you unlock",
    iv_gate_b1: "Unlimited question banks (PDF / image upload)",
    iv_gate_b2: "Voice + text interview modes with AI grading",
    iv_gate_b3: "Animated AI interviewer + 4 voices",
    iv_gate_b4: "Detailed performance reports + email summary",
    iv_gate_cta: "See plans",
    iv_gate_back: "Back to Lumioos",
    vd_gate_title: "AI Video Producer is locked",
    vd_gate_sub: "Real AI videos with Sora 2 — Creator & Pro plans only.",
    vd_gate_what_you_get: "What you unlock",
    vd_gate_b1: "Real cinematic AI video clips (Sora 2)",
    vd_gate_b2: "Multi-scene videos with AI narration in 9 languages",
    vd_gate_b3: "1280×720 MP4 download — no watermark",
    vd_gate_b4: "Up to 15 videos/month on Creator, 50 on Pro",
    vd_gate_cta: "Upgrade to unlock",
    vd_gate_back: "Back to Dashboard",
    cancel_btn: "Cancel subscription",
    cancel_tooltip: "You'll keep access until your expiry date",
    cancel_confirm: "Cancel your subscription? You keep full access until the current expiry date.",
    cancel_ok: "Subscription cancelled — access remains until expiry.",
    cancel_ok_with_date: "Subscription cancelled. You'll keep your benefits until {date}.",
    cancel_fail: "Could not cancel — please try again.",
    bug_open: "Report a bug",
    bug_title: "Report a bug or issue",
    bug_sub: "Tell us what went wrong. Add a screenshot or PDF if it helps.",
    bug_placeholder: "What did you expect to happen? What actually happened?",
    bug_attach: "Attach screenshot or PDF (optional)",
    bug_send: "Send report",
    bug_sending: "Sending...",
    bug_thanks: "Thanks! We'll look into it.",
    bug_send_fail: "Could not send — please try again.",
    bug_message_short: "Please write at least 3 characters.",
    bug_file_too_large: "File too large (max 5 MB)",
    bug_only_image_or_pdf: "Only images or PDF files allowed",
    chat_describe_image: "What do you see in this image?",
    chat_voice_added: "Voice transcribed",
    chat_voice_empty: "Couldn't hear anything — try again",
    chat_mic_denied: "Microphone access denied",
    chat_recording_ph: "Recording… click stop when done",
    // Video extras
    video_language: "Language",
    // Projects extras
    project_view: "View",
    project_delete: "Delete",
    project_delete_confirm: "Confirm",
    project_cancel: "Cancel",
    project_deleted: "Project deleted",
    project_confirm_delete: "Delete this project permanently?",
    project_back: "Back to projects",
    project_not_found: "Project not found",
    project_no_video: "No MP4 saved for this project.",
    project_download: "Download MP4",
    project_download_started: "Download started",
    // Billing / Pricing
    side_billing: "Billing",
    side_referrals: "Refer & Earn",
    side_upgrade: "Upgrade",
    pricing_eyebrow: "Plans",
    pricing_h1: "Choose your plan",
    pricing_sub: "Upgrade anytime. Cancel anytime. Real subscriptions, real value.",
    pricing_current: "Current plan",
    pricing_expires: "renews",
    pricing_popular: "Most popular",
    pricing_month: "month",
    pricing_month_short: "mo",
    pricing_subscribe: "Subscribe",
    pricing_current_plan: "Current plan",
    pricing_free_default: "Default plan",
    pricing_redirecting: "Redirecting…",
    pricing_disclaimer: "Payments processed by Stripe. By subscribing you agree to monthly billing. Cancel from your account anytime.",
    pricing_mobile_note_title: "Prices shown are for web checkout.",
    pricing_mobile_note_body: "Subscriptions purchased inside our iOS or Android app may cost more due to App Store fees (up to 30%). Save more by subscribing here on the web.",
    // --- Lumioos Jarvis (Phase 1) ---
    side_jarvis: "Jarvis",
    jarvis_available_with: "Available with Pro and Power",
    jarvis_locked_body: "Control your computer with natural language. Open apps, record with OBS, browse the web, and run scheduled automations — all from Lumioos.",
    jarvis_upgrade_to_pro: "Upgrade to Pro",
    jarvis_upgrade_to_power: "Upgrade to Power",
    jarvis_current_plan_prefix: "Your current plan",
    jarvis_month_or_year: "Monthly and yearly plans available",
    jarvis_features_title: "What Jarvis can do",
    jarvis_feat_pair: "Pair your Windows computer securely and control it remotely",
    jarvis_feat_command: "Send text or voice commands in Turkish or English",
    jarvis_feat_schedule: "Create scheduled and recurring automation tasks",
    jarvis_feat_screenshots: "Live screenshots and per-step verification of every action",
    jarvis_feat_history: "Full task history with logs, status and completion timestamps",
    jarvis_feat_safety: "Emergency Stop, action approvals and audit trail for safety",
    jarvis_compare_title: "Pro vs Power",
    jarvis_plan_pro_headline: "Solo automation",
    jarvis_plan_power_headline: "Team-grade automation",
    jarvis_recommended: "Recommended",
    jarvis_paired_computers: "paired computers",
    jarvis_tasks_per_month: "tasks / month",
    jarvis_scheduled_tasks: "active scheduled tasks",
    jarvis_pro_browsers: "Chrome, Edge, OBS Studio, File Explorer, VS Code, Teams",
    jarvis_pro_history: "14-day screenshot & log retention",
    jarvis_power_recurring: "Recurring automation & priority execution",
    jarvis_power_history: "60-day screenshot & log retention",
    jarvis_power_advanced: "Advanced retry, verification & recovery",
    jarvis_billing_link_line: "See all plan details and pricing on the billing page.",
    jarvis_see_all_plans: "See all plans",
    jarvis_active_badge: "Jarvis active",
    jarvis_dashboard_subtitle: "Pair a Windows computer and start automating with natural-language commands.",
    jarvis_current_plan: "Current plan",
    jarvis_tasks_this_month: "Tasks this month",
    jarvis_pair_soon_title: "Pair a computer to get started",
    jarvis_pair_soon_body: "Download the free Lumioos Desktop Agent for Windows and pair it with a one-time code. Coming with the next release.",
    jarvis_phase2_soon: "Phase 2 — Desktop Agent shipping shortly",
    pricing_faq_title: "Frequently asked",
    pricing_faq_why_pro_q: "Why is Pro $29?",
    pricing_faq_why_pro_a: "Pro now includes Sora-2 video, GPT-5, Claude Opus 4.5, GPT Image 1 and unlimited chat. Buying these separately would cost $80+/month (ChatGPT Plus $20 + Runway $15 + Midjourney $10 + Claude Pro $20 + extras). We bundle everything for $29 so creators and freelancers save 60%+. Existing Pro customers stay on their original $10 price as long as their subscription is active.",
    pricing_faq_cancel_q: "Can I cancel anytime?",
    pricing_faq_cancel_a: "Yes — one click from Billing settings. No refunds for the current month, but you keep Pro access until the period ends. We never auto-renew without warning.",
    pricing_faq_existing_q: "I signed up before — does my price change?",
    pricing_faq_existing_a: "No. If you're already paying $5 (Creator) or $10 (Pro), your Stripe subscription stays at that price until YOU cancel or change tiers. Only brand-new signups see the new pricing.",
    billing_checking: "Confirming payment…",
    billing_checking_sub: "This usually takes a few seconds.",
    billing_paid: "Payment successful 🎉",
    billing_paid_sub: "Plan activated:",
    billing_pending: "Still processing",
    billing_pending_sub: "Refresh in a moment — the plan will activate automatically.",
    billing_expired: "Session expired",
    billing_failed: "Payment not completed",
    billing_to_dashboard: "Go to dashboard",
    billing_back: "Back to pricing",
    video_already_running: "A video is already being generated. Wait for it to finish or dismiss it.",
    video_dismiss_confirm: "Dismiss this job? (Video will keep generating in the background and will still appear in Projects.)",
    pricing_monthly: "Monthly",
    pricing_yearly: "Yearly",
    pricing_save_2mo: "Save 2 months",
    pricing_year: "year",
    pricing_year_short: "yr",
    pricing_yearly_savings: "You save ${saved} per year",
    pricing_admin_unlimited: "Admin — Unlimited (no limits)",
    pricing_admin_skip: "Admin: unlimited",
    redeem_have_code: "Have a code?",
    redeem_apply: "Apply",
    redeem_required: "Enter a code",
    redeem_success: "Code applied",
    // OAuth error help modal (iter 59) — shown when Salesforce blocks the connection
    oauth_err_title: "Salesforce didn't authorize the connection",
    oauth_err_blocked_subtitle: "This is your Salesforce org's security policy blocking the app. This isn't a Lumioos bug — most users won't see it.",
    oauth_err_generic_subtitle: "OAuth handshake failed. Try the steps below or reconnect.",
    oauth_err_step1: "Easiest fix: use a fresh Trailhead Playground (free, instant)",
    oauth_err_step2: "Go to trailhead.salesforce.com → Hands-on Orgs → Launch a new Playground",
    oauth_err_step3: "Come back here, click Reconnect, and use the new Playground's credentials",
    oauth_err_alt_title: "If you must use your current org (Enterprise/Sandbox):",
    oauth_err_alt_step1: "Your org admin needs to add Lumioos as a Trusted App",
    oauth_err_alt_step2: "Setup → Connected Apps OAuth Policies → relax 'IP Relaxation' to 'Relax IP restrictions'",
    oauth_err_alt_step3: "Or: Setup → Manage Apps → contact your Salesforce admin to whitelist Lumioos",
    oauth_err_reconnect: "Reconnect",
    oauth_err_close: "Close",
    oauth_err_raw: "Technical error code",
    // PWA install (iter 60)
    pwa_install_lumioos: "Install Lumioos",
    pwa_install_subtitle: "Add to your home screen — no app store needed.",
    pwa_install_short: "Install",
    pwa_not_now: "Not now",
    pwa_got_it: "Got it",
    pwa_ios_safari_required: "Open this site in Safari to install",
    pwa_ios_safari_required_sub: "On iPhone, only Safari can add apps to the home screen. Copy this link and paste it into Safari.",
    pwa_ios_copy_link: "Copy link",
    pwa_modal_title_ios: "Install on iPhone / iPad",
    pwa_modal_title_android: "Install on Android",
    pwa_modal_title_mac: "Install on Mac",
    pwa_modal_title_desktop: "Install on Desktop",
    pwa_modal_ios_step1: "Tap the Share icon at the bottom of Safari (square with up arrow)",
    pwa_modal_ios_step2: "Scroll down and tap \"Add to Home Screen\"",
    pwa_modal_ios_step3: "Tap \"Add\" in the top right corner",
    pwa_modal_ios_step4: "Lumioos will appear on your home screen like a native app",
    pwa_modal_android_step1: "Tap the ⋮ menu in the top right of Chrome",
    pwa_modal_android_step2: "Tap \"Add to Home screen\" or \"Install app\"",
    pwa_modal_android_step3: "Tap \"Install\" in the popup",
    pwa_modal_android_step4: "Lumioos opens like a native app from your home screen",
    pwa_modal_mac_step1: "Click the install icon in the address bar (⊕ icon, right side)",
    pwa_modal_mac_step2: "OR: Chrome menu (⋮) → \"Install Lumioos…\"",
    pwa_modal_mac_step3: "Click \"Install\" in the popup",
    pwa_modal_mac_step4: "Lumioos opens in its own window like a native app",
    pwa_modal_desktop_step1: "Look for the install icon in your browser's address bar (⊕ or ↓)",
    pwa_modal_desktop_step2: "If you don't see it, open browser menu and look for \"Install Lumioos\" or \"Add to Apps\"",
    pwa_modal_desktop_step3: "Confirm by clicking \"Install\"",
    pwa_modal_desktop_step4: "Lumioos opens in its own desktop window",
    // ---------------- Jarvis (Control Center + Help Center) ----------------
    jarvis_paired_computers_title: "Paired computers",
    jarvis_pair_a_computer_btn: "Pair a computer",
    jarvis_no_devices_hint: "No computers paired yet. Click Pair a computer to get started.",
    jarvis_send_command_title: "Send a command",
    jarvis_command_placeholder: "Open OBS, launch Chrome to mylumioos.com, record for 30 seconds, stop and verify the video",
    jarvis_target_label: "Target: {name}",
    jarvis_pair_first_hint: "Pair a computer to enable commands",
    jarvis_send_to_jarvis_btn: "Send to Jarvis",
    jarvis_task_history_title: "Task history",
    jarvis_no_tasks_hint: "No tasks yet. Send your first command above.",
    jarvis_device_selected: "Selected",
    jarvis_device_select: "Select",
    jarvis_device_revoked_badge: "Revoked",
    jarvis_status_online: "Online",
    jarvis_status_offline_last_seen: "Offline · last seen {ago}",
    jarvis_status_never: "never",
    jarvis_status_unknown: "unknown",
    jarvis_toast_type_command_first: "Type a command first",
    jarvis_toast_pair_first: "Pair and select a computer first",
    jarvis_toast_task_queued: "Task queued — the agent will pick it up shortly.",
    jarvis_toast_monthly_limit: "Monthly task limit reached ({max}). Upgrade for more.",
    jarvis_toast_task_queue_failed: "Failed to queue task",
    jarvis_toast_revoke_confirm: "Revoke this device? The agent will stop working immediately.",
    jarvis_toast_device_revoked: "Device revoked",
    jarvis_toast_device_revoke_failed: "Failed to revoke device",
    jarvis_toast_task_cancelled: "Task cancelled",
    jarvis_toast_task_cancel_failed: "Failed to cancel task",
    jarvis_toast_delete_task_confirm: "Delete this task from history?",
    jarvis_toast_task_deleted: "Task deleted",
    jarvis_toast_task_delete_failed: "Failed to delete task",
    jarvis_toast_clear_all_tasks_confirm: "Delete every task in history? In-progress tasks are kept.",
    jarvis_toast_tasks_cleared: "Cleared {n} tasks",
    jarvis_toast_delete_device_confirm: "Remove this computer permanently? All its task history will also be deleted.",
    jarvis_toast_device_deleted: "Computer removed",
    jarvis_clear_all_tasks_btn: "Clear all",
    jarvis_task_status_queued: "Queued",
    jarvis_task_status_running: "Running",
    jarvis_task_status_completed: "Completed",
    jarvis_task_status_failed: "Failed",
    jarvis_task_status_cancelled: "Cancelled",
    jarvis_task_cancel_btn: "Cancel",
    jarvis_task_error_label: "Error:",
    jarvis_task_steps_label: "Steps",
    jarvis_task_screenshots_label: "Screenshots ({n})",
    jarvis_task_result_label: "Result",
    jarvis_task_steps_count: "{n} steps",
    jarvis_task_screenshots_count: "{n} screenshots",
    jarvis_time_seconds_ago: "{n}s ago",
    jarvis_time_minutes_ago: "{n}m ago",
    jarvis_time_hours_ago: "{n}h ago",
    jarvis_time_days_ago: "{n}d ago",
    jarvis_download_windows: "Download for Windows",
    jarvis_download_macos: "Download for macOS",
    jarvis_download_linux: "Download for Linux (macOS build)",
    jarvis_alt_downloads_title: "Using a different computer?",
    jarvis_sys_title: "System information",
    jarvis_sys_detected_os: "Detected OS",
    jarvis_sys_installed_agent: "Installed Agent",
    jarvis_sys_latest_version: "Latest Version",
    jarvis_sys_status_connected: "Connected",
    jarvis_sys_status_offline: "Offline",
    jarvis_sys_status_unpaired: "Not paired",
    jarvis_sys_not_installed: "Not installed",
    jarvis_sys_compat_uptodate: "Your Desktop Agent is up to date.",
    jarvis_sys_compat_outdated: "Your installed Agent v{installed} is older than v{latest} — re-download and reinstall for the latest features.",
    jarvis_sys_compat_no_agent: "Install the Desktop Agent below to enable Jarvis on this computer.",
    // Help center — header & controls
    jarvis_hc_intro_pill: "Setup & Help",
    jarvis_hc_title: "Setup & Help Center",
    jarvis_hc_subtitle: "Install, connect and troubleshoot your Desktop Agent in minutes — no tutorials needed.",
    jarvis_hc_search_placeholder: "Search help topics, steps, errors…",
    jarvis_hc_no_results: "No results match your search. Try a different keyword.",
    jarvis_hc_tab_wizard: "Setup Wizard",
    jarvis_hc_tab_troubleshoot: "Troubleshooting",
    jarvis_hc_tab_faq: "FAQ",
    jarvis_hc_video_title: "Video walkthrough",
    jarvis_hc_video_placeholder: "A guided video tour is coming soon — for now, follow the step-by-step wizard.",
    jarvis_hc_step_of: "Step {n} of {total}",
    jarvis_hc_prev: "Previous",
    jarvis_hc_next: "Next",
    jarvis_hc_done: "All done",
    jarvis_hc_need_help: "Need help with this step?",
    jarvis_hc_screenshot_soon: "A screenshot preview for this step is coming soon.",
    jarvis_hc_troubleshoot_title: "Common problems & fixes",
    jarvis_hc_troubleshoot_subtitle: "Tap any issue to see the likely cause and a quick solution.",
    jarvis_hc_faq_title: "Frequently asked questions",
    jarvis_hc_faq_subtitle: "Everything you need to know about installing, running and updating Jarvis.",
    jarvis_hc_problem_label: "Problem",
    jarvis_hc_cause_label: "Likely cause",
    jarvis_hc_solution_label: "Solution",
    // Wizard — 12 steps (title / desc / help)
    jarvis_hc_step_download_title: "Download Desktop Agent",
    jarvis_hc_step_download_desc: "Click the download button to get the ZIP built for your operating system (Windows or macOS).",
    jarvis_hc_step_download_help: "If nothing downloads, check your browser's popup blocker or Downloads folder settings.",
    jarvis_hc_step_extract_title: "Extract the downloaded file",
    jarvis_hc_step_extract_desc: "Right-click the ZIP and choose \"Extract All\" on Windows, or double-click it on macOS.",
    jarvis_hc_step_extract_help: "Never run the files directly from inside the ZIP — always extract first, then open the folder.",
    jarvis_hc_step_open_folder_title: "Open the Desktop Agent folder",
    jarvis_hc_step_open_folder_desc: "Enter the freshly extracted folder called \"lumioos-desktop-agent\" (usually in Downloads).",
    jarvis_hc_step_open_folder_help: "Keep this window open — you'll double-click a few files from here in the next steps.",
    jarvis_hc_step_run_install_title: "Run install-agent",
    jarvis_hc_step_run_install_desc: "Double-click install-agent.bat on Windows or install-agent.command on macOS. It installs Python packages the agent needs.",
    jarvis_hc_step_run_install_help: "A terminal window opens and closes on its own. You only need to run this once, ever.",
    jarvis_hc_step_generate_code_title: "Generate a Pairing Code",
    jarvis_hc_step_generate_code_desc: "Come back to this page, click \"Pair a computer\" and copy the 6-digit code shown on screen.",
    jarvis_hc_step_generate_code_help: "Codes expire in 10 minutes and can only be used once. Generate a fresh one if it expires.",
    jarvis_hc_step_run_pair_title: "Run pair-agent",
    jarvis_hc_step_run_pair_desc: "Double-click pair-agent.bat (Windows) or pair-agent.command (macOS). A terminal will ask for your pairing code.",
    jarvis_hc_step_run_pair_help: "Only run pair-agent the first time you set up a new computer. After that, always use start-agent.",
    jarvis_hc_step_paste_code_title: "Paste the Pairing Code",
    jarvis_hc_step_paste_code_desc: "Paste the 6-digit code into the terminal and press Enter to authorize the computer.",
    jarvis_hc_step_paste_code_help: "On Windows use right-click to paste; on macOS use Cmd+V. Nothing appears while typing — that's normal.",
    jarvis_hc_step_connected_title: "Wait until Connected Successfully",
    jarvis_hc_step_connected_desc: "The terminal will show \"✓ Paired successfully!\". You can safely close the window afterwards.",
    jarvis_hc_step_connected_help: "If pairing fails, check your internet connection and generate a fresh code — old codes expire fast.",
    jarvis_hc_step_run_start_title: "Run start-agent",
    jarvis_hc_step_run_start_desc: "Double-click start-agent.bat (Windows) or start-agent.command (macOS) to bring the agent online.",
    jarvis_hc_step_run_start_help: "Leave this terminal window open — closing it takes the agent offline until you reopen start-agent.",
    jarvis_hc_step_return_jarvis_title: "Return to Jarvis",
    jarvis_hc_step_return_jarvis_desc: "Come back to this page in your browser — no need to log out or refresh.",
    jarvis_hc_step_return_jarvis_help: "Your paired computer will show up in the Paired computers list within a few seconds.",
    jarvis_hc_step_verify_online_title: "Verify the computer is Online",
    jarvis_hc_step_verify_online_desc: "A green dot next to your computer name means the agent is running and ready for commands.",
    jarvis_hc_step_verify_online_help: "A gray dot means start-agent is not running. Re-open it on your PC and try again.",
    jarvis_hc_step_first_command_title: "Send your first command",
    jarvis_hc_step_first_command_desc: "Type \"open youtube.com\" in the command box and press Send. Watch the task history for live screenshots.",
    jarvis_hc_step_first_command_help: "Start small: try opening a website first, then experiment with OBS recording and multi-step flows.",
    // Troubleshooting — 11 problems
    jarvis_hc_ts_windows_defender_title: "Windows Defender blocked the app",
    jarvis_hc_ts_windows_defender_cause: "SmartScreen flags any new .bat file that isn't code-signed with a Microsoft-trusted certificate.",
    jarvis_hc_ts_windows_defender_solution: "Click \"More info\" on the popup, then \"Run anyway\". This only happens once per file — Windows remembers your choice.",
    jarvis_hc_ts_macos_security_title: "macOS Security blocked the app",
    jarvis_hc_ts_macos_security_cause: "Gatekeeper prevents unsigned scripts from running by default.",
    jarvis_hc_ts_macos_security_solution: "Open System Settings → Privacy & Security → scroll down and click \"Open Anyway\" next to the blocked file.",
    jarvis_hc_ts_pairing_failed_title: "Pairing failed",
    jarvis_hc_ts_pairing_failed_cause: "The code expired (10 min limit), was mistyped, or has already been used.",
    jarvis_hc_ts_pairing_failed_solution: "Click \"Pair a computer\" again to get a fresh code, then paste it into pair-agent within 10 minutes.",
    jarvis_hc_ts_agent_offline_title: "Desktop Agent is Offline",
    jarvis_hc_ts_agent_offline_cause: "The start-agent window was closed, or your computer went to sleep.",
    jarvis_hc_ts_agent_offline_solution: "Open the Desktop Agent folder on your PC and double-click start-agent again. Leave the terminal window open.",
    jarvis_hc_ts_obs_not_detected_title: "OBS not detected",
    jarvis_hc_ts_obs_not_detected_cause: "OBS Studio is not installed, or its WebSocket server (obs-websocket) is disabled.",
    jarvis_hc_ts_obs_not_detected_solution: "Install OBS Studio 28+, then in OBS go to Tools → WebSocket Server Settings and check \"Enable WebSocket server\".",
    jarvis_hc_ts_browser_not_open_title: "Browser did not open",
    jarvis_hc_ts_browser_not_open_cause: "Playwright's built-in Chromium wasn't installed during setup.",
    jarvis_hc_ts_browser_not_open_solution: "Re-run install-agent — it will install Playwright and its Chromium browser automatically.",
    jarvis_hc_ts_python_failed_title: "Python installation failed",
    jarvis_hc_ts_python_failed_cause: "Python 3.10+ is not installed, or was installed without \"Add to PATH\" enabled.",
    jarvis_hc_ts_python_failed_solution: "Install Python 3.11 from python.org and tick \"Add Python to PATH\" during install, then re-run install-agent.",
    jarvis_hc_ts_permission_denied_title: "Permission denied",
    jarvis_hc_ts_permission_denied_cause: "macOS or Windows blocked access to your keyboard, mouse or screen recording.",
    jarvis_hc_ts_permission_denied_solution: "On macOS: System Settings → Privacy & Security → grant Accessibility + Screen Recording to Terminal. On Windows: run start-agent as Administrator.",
    jarvis_hc_ts_connection_timeout_title: "Connection timeout",
    jarvis_hc_ts_connection_timeout_cause: "Firewall, VPN or corporate proxy is blocking outbound HTTPS to mylumioos.com.",
    jarvis_hc_ts_connection_timeout_solution: "Allow mylumioos.com in your firewall/VPN, or disable the proxy temporarily and re-run start-agent.",
    jarvis_hc_ts_agent_stopped_title: "Agent stopped unexpectedly",
    jarvis_hc_ts_agent_stopped_cause: "The terminal window was closed, the computer slept, or an update was applied.",
    jarvis_hc_ts_agent_stopped_solution: "Re-open start-agent. Read the last few lines of the terminal — most errors print a clear reason.",
    jarvis_hc_ts_update_failed_title: "Update failed",
    jarvis_hc_ts_update_failed_cause: "A newer Desktop Agent was released and your local copy is out of date.",
    jarvis_hc_ts_update_failed_solution: "Download the newest ZIP from the button above, extract it over the old folder, then re-run start-agent.",
    // FAQ — 9 items
    jarvis_hc_faq_install_every_time_q: "Do I have to install the agent every time?",
    jarvis_hc_faq_install_every_time_a: "No. Run install-agent only once per computer. After that, just double-click start-agent whenever you want Jarvis online.",
    jarvis_hc_faq_can_uninstall_q: "Can I uninstall the Desktop Agent?",
    jarvis_hc_faq_can_uninstall_a: "Yes. Close start-agent, then delete the lumioos-desktop-agent folder. Optionally revoke the paired computer from this page.",
    jarvis_hc_faq_multiple_computers_q: "Can I pair multiple computers?",
    jarvis_hc_faq_multiple_computers_a: "Yes. Pro users can pair up to 2 computers, Power users up to 5. Each computer needs its own 6-digit pairing code.",
    jarvis_hc_faq_windows_and_macos_q: "Can I mix Windows and macOS?",
    jarvis_hc_faq_windows_and_macos_a: "Absolutely — Jarvis treats each computer independently, so you can mix Windows PCs and Macs in the same account.",
    jarvis_hc_faq_auto_start_q: "Does the agent start automatically with my computer?",
    jarvis_hc_faq_auto_start_a: "Not by default. If you want it to auto-start, add start-agent to your OS's login items (Startup on Windows, Login Items on macOS).",
    jarvis_hc_faq_how_to_update_q: "How do I update the Desktop Agent?",
    jarvis_hc_faq_how_to_update_a: "Download the newest ZIP from Jarvis, extract it over your existing folder (keeping your config), then restart start-agent.",
    jarvis_hc_faq_recordings_location_q: "Where are recordings saved?",
    jarvis_hc_faq_recordings_location_a: "Recordings are saved to your OBS Studio default output folder — typically Videos/OBS on Windows or Movies on macOS.",
    jarvis_hc_faq_change_recording_location_q: "Can I change the recording location?",
    jarvis_hc_faq_change_recording_location_a: "Yes. In OBS Studio, open File → Settings → Output → Recording and set any folder you like. Jarvis picks it up automatically.",
    jarvis_hc_faq_remove_computer_q: "How do I remove a paired computer?",
    jarvis_hc_faq_remove_computer_a: "In the Paired computers list, click the trash icon next to the computer. Its agent stops accepting commands immediately.",
  },
  es: {
    // Spanish (most visible strings — rest falls back to English)
    nav_features: "Funciones",
    nav_howit: "Cómo funciona",
    nav_pricing: "Precios",
    nav_download: "Descargar",
    lp_download_eyebrow: "Descargar",
    lp_download_h2: "Lumioos en todos tus dispositivos",
    lp_download_h2_one: "Lumioos ya está en {platform}",
    lp_download_h2_two: "Lumioos para {p1} y {p2}",
    lp_download_sub: "Instala Lumioos en Windows ahora — Apple y Android próximamente.",
    lp_download_sub_one: "Instala Lumioos en {platform}. Más plataformas próximamente.",
    lp_download_sub_two: "Instala en {p1} o {p2} — más dispositivos próximamente.",
    lp_download_live: "Disponible",
    lp_download_soon: "Próximamente",
    lp_download_install: "Instalar gratis",
    lp_download_notify: "Lanzamiento próximo",
    nav_signin: "Iniciar sesión",
    nav_get_started: "Comenzar",
    hero_badge: "Profesionales confían — Claude 4.5 · GPT-5 · Gemini 3",
    hero_h1_a: "Tu espacio de trabajo IA —",
    hero_h1_b: "más inteligente, rápido, seguro",
    hero_sub: "Lumioo es tu asistente IA profesional. Resuelve problemas complejos en chat con soporte de imagen y voz, produce vídeos listos para publicar en 6 idiomas, y entrega trabajo que solía tomar horas. Desde {from_price}/mes.",
    hero_cta_primary: "Empieza gratis — sin tarjeta",
    hero_cta_secondary: "Ver cómo funciona",
    trust_no_card: "Sin tarjeta de crédito",
    trial_badge: "Prueba Pro de {days} días · sin tarjeta",
    trial_banner_text: "{days} días restantes en tu prueba Pro gratuita",
    trial_banner_ending_today: "Tu prueba gratuita termina hoy — actualiza para mantener Pro",
    trial_banner_cta: "Actualizar ahora",
    trial_banner_close: "Descartar",
    trial_pill_label: "Prueba · {days}d",
    trial_pill_cta: "Actualizar",
    trial_pill_tooltip: "Estás en una prueba Pro gratuita — actualiza antes de que termine.",
    trial_ribbon_text: "🎁 Obtén {days} días de Pro gratis — sin tarjeta",
    trial_ribbon_pill: "Oferta limitada",
    trial_ribbon_cta: "Empezar gratis",
    hero_cta_trial: "Empieza tu prueba de {days} días",
    // Refer & Earn page
    ref_back: "Atrás",
    ref_title: "Invita y Gana",
    ref_subtitle: "Invita a un amigo → tú obtienes +{days} días de Pro por cada registro, tu amigo empieza con 14 días de Pro gratis (prueba estándar de 7 días + 7 días de bono de referido).",
    ref_loading: "Cargando…",
    ref_invited: "Invitados",
    ref_days_earned: "Días Pro ganados",
    ref_your_link: "Tu enlace de invitación",
    ref_copy: "Copiar",
    ref_copied: "Copiado",
    ref_share: "Compartir",
    ref_your_code: "Tu código:",
    ref_recent: "Invitaciones recientes",
    ref_days_awarded: "+{days} días Pro",
    ref_how_to_share: "📣 ¿Cómo compartir?",
    ref_share_whatsapp: "Compártelo en grupos de WhatsApp / Telegram",
    ref_share_twitter: "Publícalo en X con una captura de demo",
    ref_share_linkedin: "Publica en LinkedIn con el enlace",
    ref_share_forum: "Menciónalo en foros de Salesforce / Trailhead y Reddit",
    ref_link_copied: "Enlace copiado",
    ref_copy_error: "No se pudo copiar",
    ref_load_error: "No se pudieron cargar las referencias",
    ref_share_message: "Prueba Lumioos con mi enlace — regístrate y obtén 14 días de Pro gratis!",
    trial_ended_close: "Cerrar",
    trial_ended_title: "Bienvenido de vuelta a Free",
    trial_ended_subtitle: "Tu prueba Pro de 7 días acaba de terminar.",
    trial_ended_losing: "Pierdes acceso a",
    trial_ended_feat_video: "🎬 Video Producer (Sora 2)",
    trial_ended_feat_interview: "🎤 Interview Practice (entrevistas simuladas)",
    trial_ended_feat_image: "🖼️ Image Producer (GPT Image 1)",
    trial_ended_feat_salesforce: "⚡ Salesforce / Trailhead Agent",
    trial_ended_promo_eyebrow: "Oferta única",
    trial_ended_promo_headline: "20% DESC. en Pro — solo para ti",
    trial_ended_promo_sub: "El código {code} se aplica automáticamente al pagar. Válido solo ahora.",
    trial_ended_cta_upgrade: "Activar Pro con {code} → 20% DESC.",
    trial_ended_cta_later: "Tal vez después",
    trust_stripe: "Pagos seguros con Stripe",
    trust_privacy: "Tus datos son privados",
    trust_rating: "Adorado por usuarios",
    hero_card_live: "En vivo",
    hero_card_eyebrow: "Respuesta IA en vivo",
    hero_card_question: "¿Cómo arreglo un error de bucle en Salesforce Flow?",
    hero_card_assistant: "Asistente Lumioo",
    hero_card_answer: "Añade una condición de protección al elemento Update Records. Usa un Decision antes del inicio del bucle para verificar si el estado del registro ya coincide — esto rompe la recursión.",
    hero_card_time: "Resuelto en 8s",
    hero_chip_voice: "Voz → Texto",
    hero_chip_image: "Ve tus capturas",
    hero_chip_lang: "6 idiomas",
    stat_1_n: "Idiomas",
    stat_2_n: "Modelos IA",
    stat_3_n: "Tiempo de respuesta",
    stat_4_n: "Disponibilidad",
    feat_section_eyebrow: "Qué hace Lumioo",
    feat_section_h2: "Un espacio. Todos los superpoderes IA.",
    feat_section_sub: "Deja de cambiar entre 6 pestañas. Chatea, mira, escucha, produce — todo desde un solo lugar limpio.",
    feat_chat_title: "Chat IA Inteligente",
    feat_chat_desc: "Pregunta cualquier cosa en lenguaje natural. Adjunta una captura para análisis visual. Habla en lugar de escribir.",
    coming_soon_badge: "Próximamente",
    gs_ad_cta_soon: "Avísame en el lanzamiento",
    gs_ad_locked: "Bloqueado por ahora — pronto disponible.",
    gs_coming_soon_toast: "Game Studio llegará pronto — ¡te avisaremos!",
    feat_video_title: "Productor de Vídeo Cinematográfico",
    feat_video_desc: "Escribe un tema en cualquiera de 6 idiomas. En minutos, obtén un guion, voz IA, escenas cinematográficas y un MP4 listo para publicar.",
    feat_speed_t: "Velocidad rayo",
    feat_speed_d: "Respuestas en segundos. Vídeos en minutos. Cero espera.",
    feat_secure_t: "Seguridad bancaria",
    feat_secure_d: "Sesiones cifradas. Tus prompts nunca entrenan IAs.",
    feat_global_t: "Global por diseño",
    feat_global_d: "Soporte nativo de 6 idiomas — incluyendo español.",
    how_eyebrow: "Cómo funciona",
    how_h2: "Tres pasos. Cero curva de aprendizaje.",
    how_s1_t: "Regístrate gratis",
    how_s1_d: "Sin tarjeta. Crea tu cuenta en menos de 30 segundos.",
    how_s2_t: "Pregunta o describe",
    how_s2_d: "Escribe, habla o sube una captura. O escribe un tema de vídeo en tu idioma.",
    how_s3_t: "Usa el resultado",
    how_s3_d: "Copia la respuesta. Descarga el MP4. Publícalo. Listo.",
    lp_pricing_eyebrow: "Precios simples y justos",
    lp_pricing_h2: "Empieza gratis. Mejora solo cuando lo necesites.",
    lp_pricing_sub: "Todos los planes incluyen funciones IA básicas. Sin tarifas ocultas. Cancela cuando quieras.",
    lp_plan_popular: "Más popular",
    lp_plan_start: "Comenzar",
    cta_h2_a: "¿Listo para trabajar",
    cta_h2_b: "más inteligente?",
    cta_sub: "Únete a profesionales que confían en Lumioo cada día. Gratis para uso personal.",
    cta_btn: "Crea tu cuenta gratis",
    cta_smallprint: "Sin tarjeta. Registro en 30 segundos. Cancela cuando quieras.",
    footer_tag: "Hecho para profesionales.",
    footer_privacy: "Privacidad",
    footer_terms: "Términos",
    side_dashboard: "Panel",
    side_chat: "Chat IA",
    side_video: "Productor de Vídeo",
    side_image: "Productor de Imagen",
    side_cv: "Creador de CV",
    side_interview: "Práctica de Entrevista",
    side_projects: "Proyectos",
    side_billing: "Suscripción",
    side_referrals: "Invitar y Ganar",
    side_admin: "Admin",
    side_ai_workforce: "AI Workforce",
    wf_badge: "ADMIN · PHASE 1",
    wf_title: "AI Workforce",
    wf_subtitle: "Manage your private AI company workforce. Delegate objectives, monitor progress, and approve every action that touches the outside world.",
    wf_total_agents: "Total Agents",
    wf_active_agents: "Active Agents",
    wf_busy_agents: "Busy Agents",
    wf_tasks_in_progress: "Tasks in Progress",
    wf_tasks_completed: "Completed Tasks",
    wf_tasks_failed: "Failed Tasks",
    wf_approvals_pending: "Pending Approvals",
    wf_agents_title: "AI Employees",
    wf_workspace_company: "Company Workspace",
    wf_phase_notice_title: "Sub-Phase 1A · Foundation ready",
    wf_phase_notice_body: "Tasks, CEO orchestration, agent messaging and approvals arrive in Sub-Phase 1B → 1D. The employees above are already configured and ready — no further action needed until then.",
    wf_refresh: "Actualizar",
    wf_ceo_chat_title: "Chat con CEO",
    wf_ceo_chat_empty: 'Habla con el CEO AI naturalmente. Prueba: "¿Qué tareas esperan aprobación?" o "Investiga 3 ideas de registro."',
    wf_ceo_chat_placeholder: "Pregunta cualquier cosa al CEO, o di 'investiga X', 'cancela la tarea', 'aprueba borrador'…",
    wf_ceo_chat_hint: "La intención se detecta automáticamente: las preguntas responden desde la BD real; las intenciones de tarea/control/aprobación llaman a las APIs reales. Sin capacidades falsas — el CEO lo dice cuando una herramienta no está conectada.",
    wf_chat_view_task: "Ver tarea →",
    wf_new_objective: "Nuevo Objetivo",
    wf_task_title_placeholder: "ej. Crear un plan de marketing de 3 días para Lumioos",
    wf_task_desc_placeholder: "Describe el objetivo en detalle. ¿Qué resultado quieres? ¿Restricciones?",
    wf_send_to_ceo: "Enviar al CEO AI",
    wf_ceo_will_plan: "El CEO AI ({model}) planeará → asignará a especialistas → recopilará resultados. Marketing/Sales/Support/Finance entran en la cola de aprobación.",
    wf_recent_tasks: "Tareas Recientes",
    wf_no_tasks: "Aún no hay tareas. Crea tu primer objetivo arriba.",
    wf_recent_activity: "Actividad Reciente",
    wf_no_activity: "Sin actividad aún.",
    wf_agent_chat_empty: "Saluda a {name}, o dale una tarea directa.",
    wf_agent_chat_placeholder: "Habla con {name}…",
    wf_tab_overview: "Resumen",
    wf_tab_chat: "Chat",
    wf_tab_current: "Actual",
    wf_tab_history: "Historial",
    wf_tab_activity: "Actividad",
    wf_tab_memory: "Memoria",
    wf_tab_config: "Config",
    wf_field_status: "Estado",
    wf_field_completed: "Completadas",
    wf_field_completed_count: "{n} completadas",
    wf_field_last_activity: "Última actividad",
    wf_field_none: "—",
    wf_no_active_tasks: "Sin tareas activas.",
    wf_no_history: "Sin historial aún.",
    wf_no_memory: "Sin memoria aún.",
    wf_cfg_model: "Modelo (en ejecución)",
    wf_cfg_allowed_tools: "Herramientas permitidas",
    wf_cfg_system_instructions: "Instrucciones del sistema",
    wf_cfg_agent_id: "ID del agente",
    wf_task_objective: "Objetivo",
    wf_task_ceo_plan: "Plan del CEO",
    wf_task_children: "Sub-tareas ({n})",
    wf_task_view_result: "Ver resultado ({n} caracteres)",
    wf_task_error_prefix: "Error:",
    wf_task_ceo_summary: "Resumen del CEO",
    wf_task_agent_messages: "Mensajes del agente ({n})",
    wf_task_pause: "Pausar",
    wf_task_resume: "Reanudar",
    wf_task_retry: "Reintentar",
    wf_task_cancel: "Cancelar",
    wf_approve: "Aprobar",
    wf_reject: "Rechazar",
    wf_approval_status_prefix: "Aprobación {status}",
    wf_approvals_title: "Aprobaciones Pendientes ({n})",
    wf_no_approvals: "No hay aprobaciones pendientes.",
    wf_lwr_badge: "INVESTIGACIÓN WEB EN VIVO",
    wf_lwr_counts: "{searches} búsquedas · {sources} fuentes · {pages} páginas leídas",
    wf_status_idle: "Inactivo",
    wf_status_working: "Trabajando",
    wf_status_waiting_for_approval: "Esperando aprobación",
    wf_status_paused: "Pausado",
    wf_status_error: "Error",
    wf_status_offline: "Desconectado",
    wf_status_pending: "Pendiente",
    wf_status_planning: "Planeando",
    wf_status_assigned: "Asignada",
    wf_status_in_progress: "En progreso",
    wf_status_completed: "Completada",
    wf_status_failed: "Fallida",
    wf_status_cancelled: "Cancelada",
    wf_leads_title: "Leads",
    wf_leads_open: "Abrir leads",
    wf_leads_overview_title: "Pipeline de leads",
    wf_leads_total: "Total de leads",
    wf_leads_new: "Nuevos",
    wf_leads_qualified: "Calificados",
    wf_leads_reviewing: "En revisión",
    wf_leads_approved: "Aprobados",
    wf_leads_rejected: "Rechazados",
    wf_leads_archived: "Archivados",
    wf_leads_verified: "Verificados",
    wf_leads_needs_review: "Requiere revisión",
    wf_leads_none: "Aún no hay leads. Pide a Sales AI que busque.",
    wf_leads_filter_status: "Estado",
    wf_leads_filter_verification: "Verificación",
    wf_leads_filter_min_score: "Puntaje mínimo",
    wf_leads_filter_industry: "Industria",
    wf_leads_filter_all: "Todos",
    wf_leads_sort: "Ordenar",
    wf_leads_sort_score: "Mayor puntaje",
    wf_leads_sort_newest: "Más recientes",
    wf_leads_sort_name: "Nombre de empresa",
    wf_leads_col_company: "Empresa",
    wf_leads_col_website: "Sitio web",
    wf_leads_col_industry: "Industria",
    wf_leads_col_location: "Ubicación",
    wf_leads_col_score: "Puntaje",
    wf_leads_col_verification: "Verificación",
    wf_leads_col_status: "Estado",
    wf_leads_col_discovered: "Descubierto",
    wf_leads_score_reasons: "Por qué este puntaje",
    wf_leads_concerns: "Preocupaciones",
    wf_leads_sources: "Fuentes de evidencia",
    wf_leads_discovery_task: "Tarea de descubrimiento",
    wf_leads_actions_approve: "Aprobar",
    wf_leads_actions_reject: "Rechazar",
    wf_leads_actions_archive: "Archivar",
    wf_leads_action_ok: "Lead {action}",
    wf_leads_action_fail: "No se pudo {action} el lead",
    wf_leads_no_outreach_note: "Aprobar marca este lead para seguimiento. No se envía correo, DM ni contacto.",
    wf_lead_status_new: "Nuevo",
    wf_lead_status_qualified: "Calificado",
    wf_lead_status_reviewing: "En revisión",
    wf_lead_status_approved: "Aprobado",
    wf_lead_status_rejected: "Rechazado",
    wf_lead_status_archived: "Archivado",
    wf_verif_verified: "Verificado",
    wf_verif_needs_review: "Requiere revisión",
    wf_verif_unverified: "No verificado",
    wf_toast_task_created: "Objetivo enviado al CEO AI — planeación iniciada…",
    wf_toast_task_short: "Proporciona un título y descripción más largos",
    wf_toast_task_create_fail: "No se pudo crear la tarea",
    wf_toast_task_load_fail: "No se pudo cargar la tarea",
    wf_toast_workforce_load_fail: "No se pudo cargar AI Workforce",
    wf_toast_task_action_ok: "Tarea {action}",
    wf_toast_task_action_fail: "No se pudo {action} la tarea",
    wf_toast_approved: "Aprobado",
    wf_toast_rejected: "Rechazado",
    wf_toast_approval_fail: "No se pudo resolver la aprobación",
    wf_chat_error_prefix: "Error:",
    wf_chat_error_fallback: "chat falló",
    side_upgrade: "Mejorar",
    side_logout: "Cerrar sesión",
    side_theme: "Tema",
    pricing_eyebrow: "Planes",
    pricing_h1: "Elige tu plan",
    pricing_sub: "Mejora cuando quieras. Cancela cuando quieras.",
    pricing_current: "Plan actual",
    pricing_monthly: "Mensual",
    pricing_yearly: "Anual",
    pricing_save_2mo: "Ahorra 2 meses",
    pricing_month: "mes",
    pricing_year: "año",
    pricing_subscribe: "Suscribirse",
    pricing_current_plan: "Plan actual",
    redeem_have_code: "¿Tienes código?",
    redeem_apply: "Aplicar",
    chat_send: "Enviar",
    chat_thinking: "Pensando…",
    chat_stop: "Detener",
    chat_continue: "Continuar",
    chat_stopped_marker: "⏹ Detenido",
    chat_continue_prompt: "Por favor, continúa desde donde te detuviste.",
    chat_thinking_fast: "⚡ Rápido",
    chat_thinking_balanced: "🎯 Equilibrado",
    chat_thinking_thorough: "🧠 Profundo",
    bestai_sub: "Actualmente #1 en escritura, código y razonamiento. Cambia a GPT-5 o Gemini 3 cuando quieras — sin coste extra.",
    bestai_table_h: "Elige el modelo adecuado para cada tarea.",
    bestai_table_sub: "Lumioos te da los tres — cambia con un clic por chat.",
    bestai_footnote: "Todos los modelos incluidos en tu suscripción de Lumioos — cambia con un clic, sin coste extra.",
    bestai_h2: "Impulsado por Claude 4.5.",
    bestai_eyebrow: "Predeterminado inteligente",
    bestai_task_writing: "Escritura larga",
    bestai_task_code: "Código y depuración",
    bestai_task_translate: "Traducir (TR/AR/RU)",
    bestai_task_reasoning: "Razonamiento más difícil",
    bestai_task_capable: "Más capaz",
    bestai_task_quick: "Respuestas rápidas",
    gpt56_promo_badge: "NUEVO · EXCLUSIVO PRO Y POWER",
    gpt56_promo_title: "Familia GPT 5.6",
    gpt56_promo_desc: "Conoce la próxima generación de GPT — tres sabores, un solo propósito: darte el equilibrio exacto de profundidad, amplitud y velocidad que necesitas para cada tarea. Disponible hoy en planes {plans}.",
    gpt56_promo_plans_hl: "Pro y Power",
    gpt56_sol_tag: "Razonamiento más profundo",
    gpt56_sol_desc: "Para los problemas más difíciles — análisis largos, investigación, revisión de código compleja. Cuando la precisión importa más que la velocidad.",
    gpt56_terra_tag: "Poder equilibrado",
    gpt56_terra_desc: "Tu caballo de batalla diario. Grandes respuestas, suficientemente rápido, amplio conocimiento — el punto óptimo entre Sol y Luna.",
    gpt56_luna_tag: "El 5.6 más rápido",
    gpt56_luna_desc: "Respuestas ágiles para chat, lluvia de ideas y búsquedas rápidas. Aún más inteligente que la mayoría de modelos — solo más rápido.",
    gpt56_cta_plans: "Ver planes Pro y Power →",
    gpt56_cta_trial: "Comienza tu prueba gratis de 14 días",
    router_promo_badge: "NUEVO · EXCLUSIVO PRO",
    router_promo_desc: "El modelo más poderoso del planeta — enrutado automáticamente a tus tareas más difíciles. Un solo toggle en el chat envía código complejo, análisis y razonamiento a OpenAI GPT-5, mientras las preguntas cotidianas siguen siendo ágiles en Claude 4.5. Sin selector de modelo. Sin fricciones.",
    router_promo_bullet1: "Auto-selecciona GPT-5 para tareas difíciles",
    router_promo_bullet2: "Razonamiento y código líderes en el mundo",
    router_promo_bullet3: "Cola prioritaria, sin límites de tasa",
    router_promo_bullet4: "Toggle de un clic en el chat",
    router_promo_cta: "Actualiza a Pro",
    router_promo_included: "Incluido gratis con cada plan Pro",
    sonnet_promo_pill: "Ideal para tareas generales",
    sonnet_promo_default_label: "— predeterminado en Lumioos",
    sonnet_promo_desc: "El modelo insignia de Anthropic lidera los benchmarks independientes en escritura, código y razonamiento complejo. Menor tasa de alucinación que GPT-5 y mayor calidad multilingüe. Configurado como predeterminado de Lumioos para que los nuevos usuarios obtengan los mejores resultados desde el primer momento.",
    sonnet_col_writing: "Escritura",
    sonnet_col_code: "Código",
    sonnet_col_reasoning: "Razonamiento",
    err_generic: "Algo salió mal",
    err_topic_required: "Escribe un tema",
    err_message_required: "Escribe un mensaje",
    feat_chat_li1: "Carga de imágenes — analiza cualquier captura o foto",
    feat_chat_li2: "Entrada de voz — habla, Lumioo transcribe",
    feat_chat_li3: "Código, documentos, Salesforce, seguridad — ayuda experta",
    feat_chat_li4: "Historial de conversaciones — continúa en cualquier momento",
    stat_1_v: "6",
    stat_2_v: "3+",
    stat_3_v: "8s",
    stat_4_v: "99.9%",
    feat_video_li1: "Scripts en tu idioma (TR · EN · ES · FR · DE · IT · PT · JA · ZH)",
    feat_video_li2: "9 voces de IA naturales — elige el tono perfecto",
    feat_video_li3: "Visuales de IA cinemática — sin aspecto de banco de imágenes",
    feat_video_li4: "Descarga MP4 + narración + escenas",
    lp_plan_free_desc: "Perfecto para probar Lumioo y uso personal.",
    lp_plan_free_f1: "5 imágenes IA / mes",
    lp_plan_free_f2: "10 mensajes de chat / día",
    lp_plan_free_f3: "Los 6 idiomas",
    lp_plan_creator_desc: "Para autónomos, estudiantes y creadores.",
    lp_plan_creator_f1: "15 vídeos / mes — hasta 3 minutos",
    lp_plan_creator_f2: "Chat ilimitado con imagen + voz",
    lp_plan_creator_f3: "Sin marca de agua",
    lp_plan_creator_f4: "Velocidad de respuesta prioritaria",
    lp_plan_pro_desc: "Para profesionales y pequeños equipos.",
    lp_plan_pro_f1: "50 vídeos / mes — hasta 20 minutos",
    lp_plan_pro_f2: "Todo lo de Creator",
    lp_plan_pro_f3: "Salida Full HD 1080p",
    lp_plan_pro_f4: "Soporte prioritario",
    lp_plan_pro_f5: "✨ Chat de CV y revisión — ilimitado (PDF/Word/imagen)",
    lp_plan_power_desc: "Para usuarios intensivos y creadores power.",
    lp_plan_power_f1: "Todo en Pro",
    lp_plan_power_f2: "500 imágenes IA/mes (HD)",
    lp_plan_power_f3: "GPT-5 · 1500 mensajes, Opus 4.5 · 100/mes",
    lp_plan_power_f4: "Soporte prioritario · uso justo",
    lp_plan_power_f5: "✨ Chat de CV y revisión — ilimitado + prioritario",
    lp_pricing_trust1: "Asegurado por Stripe",
    lp_pricing_trust2: "Cancela en cualquier momento",
    lp_pricing_trust3: "Cumple con GDPR",
    auth_eyebrow_login: "Inicia sesión en",
    auth_eyebrow_register: "Crea tu",
    auth_h1_login: "Bienvenido de vuelta.",
    auth_h1_register: "cuenta de Lumioo.",
    auth_sub_login: "Continúa donde lo dejaste.",
    auth_sub_register: "Obtén 50 créditos gratis para empezar.",
    auth_name: "Nombre",
    auth_email: "Correo electrónico",
    auth_password: "Contraseña",
    auth_signin: "Iniciar sesión",
    auth_create: "Crear cuenta",
    auth_no_account: "¿Aún no tienes cuenta?",
    auth_have_account: "¿Ya tienes cuenta?",
    auth_forgot: "¿Olvidaste la contraseña?",
    fp_eyebrow: "Recuperación de cuenta",
    fp_title: "Restablece tu contraseña",
    fp_subtitle: "Introduce el correo vinculado a tu cuenta y te enviaremos un enlace de restablecimiento.",
    fp_send_btn: "Enviar enlace de restablecimiento",
    fp_back_login: "Volver a iniciar sesión",
    fp_sent_title: "Revisa tu bandeja",
    fp_sent_body: "Si existe una cuenta para {email}, un enlace de restablecimiento está en camino. Es válido durante 1 hora.",
    fp_sent_hint: "¿No lo ves? Revisa spam o intenta de nuevo en unos minutos.",
    rp_title: "Establece una nueva contraseña",
    rp_subtitle: "Elige una contraseña segura — al menos 8 caracteres.",
    rp_new_password: "Nueva contraseña",
    rp_confirm_password: "Confirmar contraseña",
    rp_submit_btn: "Guardar nueva contraseña",
    rp_mismatch: "Las contraseñas no coinciden",
    rp_too_short: "La contraseña debe tener al menos 8 caracteres",
    rp_invalid: "Este enlace de restablecimiento es inválido o ha expirado.",
    rp_success: "Contraseña actualizada. Has iniciado sesión.",
    rp_no_token_title: "No se encontró token de restablecimiento",
    rp_no_token_body: "Este enlace parece roto. Por favor, solicita un nuevo correo de restablecimiento.",
    rp_request_new: "Solicitar un nuevo enlace",
    auth_create_one: "Crear uno",
    auth_demo: "Cuenta de demostración",
    welcome_back: "¡Bienvenido de vuelta!",
    account_created: "Cuenta creada. ¡Bienvenido!",
    auth_failed: "Autenticación fallida",
    iv_eyebrow: "Práctica de Entrevistas",
    iv_h1: "Practica cualquier entrevista. En voz alta.",
    iv_sub: "Sube tus hojas de preguntas como fotos. Lumioos extrae cada pregunta y respuesta, crea tu banco privado, y te realiza pruebas — por voz o texto. Perfecto para entrevistas de ciudadanía USCIS, tarjeta verde, trabajo y certificaciones.",
    iv_my_banks: "Mis bancos de preguntas",
    iv_total: "total",
    iv_loading: "Cargando…",
    iv_empty_title: "Aún no hay bancos de preguntas",
    iv_empty_sub: "Crea uno arriba, luego sube una foto de tu hoja de estudio o añade preguntas manualmente.",
    iv_questions: "preguntas",
    iv_open: "Abrir",
    iv_create: "Crear banco",
    iv_bank_name_ph: "Nombre del banco (ej. USCIS Civics)",
    iv_bank_desc_ph: "Descripción breve (opcional)",
    iv_bank_created: "Banco creado",
    iv_create_fail: "No se pudo crear el banco",
    iv_confirm_delete: "¿Eliminar este banco y todas sus preguntas?",
    iv_deleted: "Eliminado",
    iv_delete_fail: "Error al eliminar",
    iv_load_fail: "Error al cargar",
    iv_hint_title: "Cómo funciona",
    iv_hint_sub: "Toma una foto de cualquier hoja de preparación para entrevistas (test de ciudadanía estadounidense, preguntas de tarjeta verde, preparación para entrevista de trabajo, preguntas de certificación). Lumioos la lee con visión de IA, extrae cada pregunta con todas las respuestas aceptadas, y la guarda para siempre. Luego practica por voz (IA pregunta, tú respondes con el micrófono) o por texto.",
    iv_back_library: "Volver a la biblioteca",
    iv_practice: "Practicar",
    iv_start_h2: "Iniciar entrevista",
    iv_mode_text: "Modo texto",
    iv_mode_voice: "Modo voz",
    iv_mode_text_hint: "Lee cada pregunta, escribe tu respuesta. IA califica por significado, no por palabras exactas.",
    iv_mode_voice_hint: "IA pregunta cada cuestión. Toca el micrófono, responde en voz alta. IA transcribe y califica.",
    iv_order_label: "Orden de preguntas",
    iv_order_random: "Aleatorio",
    iv_order_sequential: "Secuencial",
    iv_limit_label: "Cuántas preguntas",
    iv_limit_all: "Todas ({n} preguntas)",
    iv_limit_all_short: "Todas",
    iv_limit_max: "máx {n}",
    iv_limit_clamped: "El banco solo tiene {n} preguntas — usando todas.",
    iv_or: "o",
    iv_start_now: "Empezar ahora",
    iv_start_fail: "No se pudo iniciar la sesión",
    iv_no_questions_start: "Añade al menos una pregunta primero",
    iv_upload_title: "Sube imágenes o PDFs",
    iv_upload_sub: "Fotos, capturas de pantalla o archivos PDF de hojas de preguntas. IA extrae cada pregunta y respuesta automáticamente (hasta 100 archivos, los PDFs se leen página a página).",
    iv_choose_images: "Elige imágenes",
    iv_choose_files: "Elige imágenes o PDFs",
    iv_extracting: "Extrayendo preguntas y respuestas…",
    iv_extracted: "preguntas añadidas desde imágenes",
    iv_extract_fail: "No se pudieron extraer las preguntas",
    iv_budget_partial: "Se añadieron {n} preguntas, pero tu clave de IA se quedó sin crédito a mitad del proceso. Recarga para obtener el resto.",
    iv_partial_extract: "Se añadieron {n} preguntas ({f} lotes fallaron — intenta de nuevo para obtener el resto).",
    iv_progress_label: "Procesando lote {c} de {n}…",
    feat_iv_eyebrow: "Práctica de Entrevistas",
    feat_iv_title: "Prepárate para cualquier entrevista — en voz alta o por escrito",
    feat_iv_desc: "Sube tus hojas de estudio (foto o PDF). Lumioos extrae cada pregunta y respuesta, luego te pone pruebas con un entrevistador de IA en vivo que hace preguntas, escucha tus respuestas habladas, y califica por significado — rigor según la clave de respuestas del examen.",
    feat_iv_li1: "Preparación para ciudadanía y tarjeta verde USCIS",
    feat_iv_li2: "Práctica de entrevistas técnicas y de trabajo",
    feat_iv_li3: "Modos de voz + entrenamiento auditivo (preguntas ocultas)",
    feat_iv_li4: "Calificación estricta + informe por pregunta al final",
    feat_iv_cta: "Iniciar práctica de entrevistas",
    feat_iv_use_cases: "USCIS · Tarjeta Verde · Trabajo · Certificaciones · Cualquier cosa",
    feat_iv_badge: "NUEVO",
    iv_speed_label: "Velocidad del habla",
    iv_speed_slow: "Lenta",
    iv_speed_normal: "Normal",
    iv_speed_fast: "Rápida",
    iv_speed_faster: "Más rápida",
    iv_speed_hint: "Qué tan rápido habla el entrevistador las preguntas.",
    iv_range_label: "Rango de preguntas",
    iv_range_hint: "1 a {n}",
    iv_range_from: "Desde",
    iv_range_to: "hasta",
    iv_range_clear: "limpiar",
    iv_range_note: "Deja en blanco para usar todas las preguntas. El rango se aplica al orden de origen (ej. 1 → 50).",
    iv_range_invalid: "El final debe ser ≥ al inicio.",
    iv_deleted_undo: "Banco eliminado ({n} preguntas). Puedes deshacer en 10 segundos.",
    iv_q_deleted_undo: "Pregunta eliminada. Puedes deshacer en 8 segundos.",
    iv_undo: "Deshacer",
    iv_restored: "Restaurado.",
    iv_restore_fail: "No se pudo restaurar",
    iv_delete_warning: "Eliminación permanente",
    iv_delete_q: "¿Eliminar este banco y sus {n} preguntas?",
    iv_delete_desc: "Estás a punto de eliminar el banco",
    iv_delete_btn: "Eliminar banco",
    iv_voice_label: "Voz del entrevistador",
    iv_voice_female: "Mujer (Nova)",
    iv_voice_male: "Hombre (Ash) — suave",
    iv_voice_female2: "Mujer (Shimmer)",
    iv_voice_male2: "Hombre (Fable) — amigable",
    iv_voice_hint: "Elige la voz de tu entrevistador de IA.",
    iv_finish_early: "Terminar examen",
    iv_finish_early_confirm: "¿Terminar el examen ahora? Has respondido {n} de {total} preguntas.",
    iv_finish_early_btn: "Terminar ahora",
    iv_keep_going: "Continuar",
    iv_finishing: "Finalizando…",
    iv_congrats: "¡Felicidades! 🎉",
    iv_congrats_sub: "Aprobaste con una puntuación excelente.",
    iv_good_job: "¡Bien hecho!",
    iv_good_job_sub: "Desempeño sólido — sigue practicando.",
    iv_keep_practising: "Sigue practicando",
    iv_keep_practising_sub: "Revisa tus respuestas incorrectas abajo e intenta de nuevo.",
    iv_score_label: "Puntuación",
    iv_wrong_review: "Revisar respuestas incorrectas",
    iv_resume_eyebrow: "En progreso",
    iv_resume_title: "Tienes una entrevista sin terminar",
    iv_resume_progress: "{done} / {total} preguntas respondidas hasta ahora",
    iv_resume_btn: "Reanudar",
    iv_resume_discard: "Descartar",
    iv_resume_discard_confirm: "¿Descartar esta sesión sin terminar e iniciar de nuevo?",
    iv_resume_discarded: "Sesión descartada",
    iv_large_upload_warn: "Tu carga es aproximadamente {mb}MB. Las cargas muy grandes pueden fallar en conexiones lentas. ¿Continuar?",
    iv_trash: "Papelera",
    iv_trash_title: "Eliminado recientemente",
    iv_trash_banks: "Bancos eliminados",
    iv_trash_questions: "Preguntas eliminadas",
    iv_trash_empty: "La papelera está vacía.",
    iv_trash_load_fail: "No se pudo cargar la papelera",
    iv_purge: "Eliminar para siempre",
    iv_purge_confirm: "¿Eliminar este banco permanentemente? Esto no se puede deshacer.",
    iv_progress_preparing: "Preparando archivos…",
    iv_report_title: "Desglose pregunta por pregunta",
    iv_your_answer: "Tu respuesta",
    iv_skipped: "(omitida)",
    iv_max_10: "Máx 10 imágenes a la vez",
    iv_max_100: "Máx 100 imágenes a la vez",
    iv_manual_title: "Añadir manualmente",
    iv_manual_sub: "Escribe una pregunta y las respuestas que quieres que Lumioos acepte.",
    iv_add_question: "Añadir pregunta",
    iv_cancel: "Cancelar",
    iv_question: "Pregunta",
    iv_accepted_answers: "Respuestas aceptadas (una por línea)",
    iv_accepted_ph: "Ejecutiva\\nLegislativa\\nJudicial\\nCongreso\\nPresidente",
    iv_min_required: "Mínimo requerido",
    iv_min_hint: "¿Cuántas de las respuestas aceptadas debe decir el usuario? (Normalmente 1)",
    iv_add: "Añadir",
    iv_q_added: "Pregunta añadida",
    iv_add_fail: "No se pudo añadir la pregunta",
    iv_need_q_and_a: "Se requiere pregunta y al menos 1 respuesta",
    iv_question_list: "Preguntas",
    iv_no_questions: "Sin preguntas aún. Sube una foto o añade manualmente.",
    iv_confirm_delete_q: "¿Eliminar esta pregunta?",
    iv_back_bank: "Volver al banco",
    iv_voice_interview: "Entrevista por voz",
    iv_text_interview: "Entrevista por texto",
    iv_record: "Grabar respuesta",
    iv_stop_record: "Detener y transcribir",
    iv_transcribing: "Transcribiendo…",
    iv_voice_answer_ph: "Tu respuesta transcrita aparecerá aquí. También puedes editar antes de enviar.",
    iv_text_answer_ph: "Escribe tu respuesta aquí…",
    iv_submit: "Enviar",
    iv_skip: "Omitir",
    iv_correct: "Correcto",
    iv_wrong: "No exactamente",
    iv_accepted_were: "Las respuestas aceptadas fueron:",
    iv_see_results: "Ver resultados",
    iv_next_question: "Siguiente pregunta",
    iv_need_n_answers: "Proporciona al menos {n} respuestas diferentes",
    iv_results: "Resultados",
    iv_accuracy: "precisión",
    iv_restart: "Reiniciar banco",
    iv_speak: "Leer pregunta",
    iv_show_question: "Mostrar pregunta",
    iv_hide_question: "Ocultar pregunta (entrenamiento auditivo)",
    iv_question_hidden: "Pregunta oculta — escucha el audio",
    iv_voice_intro_line: "¡Hola! Cuando estés listo, presiona Iniciar y comenzaré a hacer las preguntas.",
    iv_voice_ready: "Estoy listo, empecemos",
    iv_show_q_label: "¿Mostrar preguntas en pantalla?",
    iv_show_q_on: "Mostrar",
    iv_show_q_off: "Ocultar (entrenamiento auditivo)",
    iv_show_q_on_hint: "El texto de la pregunta es visible mientras practicas.",
    iv_show_q_off_hint: "Solo se reproduce el audio — excelente para práctica de escucha.",
    iv_starred_label: "¿Qué preguntas hacer?",
    iv_starred_all: "Todas las preguntas",
    iv_starred_only: "Solo destacadas / importantes",
    iv_starred_hint: "Destaca (⭐) preguntas en las que quieras enfocarte. Lumioos destaca automáticamente preguntas marcadas como importantes/probables en tu origen.",
    iv_starred_badge: "Importante",
    iv_star: "Destacar esta pregunta",
    iv_unstar: "Dejar de destacar",
    iv_tts_fail: "No se pudo reproducir el audio de la pregunta",
    iv_stt_fail: "No se pudo transcribir el audio",
    iv_mic_denied: "Acceso al micrófono denegado",
    iv_need_answer: "Escribe o graba una respuesta primero",
    iv_submit_fail: "No se pudo enviar la respuesta",
    iv_skip_fail: "No se pudo omitir",
    side_credits: "Créditos",
    side_language: "Idioma",
    side_integrations: "Integraciones",
    side_help: "Ayuda y Tokens",
    auth_google: "Continuar con Google",
    auth_or: "o con correo",
    integrations_eyebrow: "Conectar",
    integrations_h1: "Integraciones",
    integrations_sub: "Conecta Salesforce, Splunk, Defender, Trend Micro, SentinelOne, CrowdStrike y más. Lumioo obtendrá tus casos y los resolverá.",
    help_eyebrow: "Documentación",
    help_h1: "Guía de Tokens y Clave API",
    help_faq: "Preguntas frecuentes",
    help_sub: "Guías paso a paso para obtener un token de API de cada plataforma compatible. Haz clic en cualquier botón 'Abrir' para saltar directamente a la página correcta.",
    dash_eyebrow: "Panel de control",
    dash_hello: "Hola",
    dash_sub: "Elige una herramienta y comienza a producir.",
    dash_credits_label: "Créditos disponibles",
    dash_open: "Abrir herramienta",
    dash_chat_card_desc: "Pregunta cualquier cosa: Salesforce, ciberseguridad, código, proyectos.",
    dash_video_card_desc: "Tema → paquete completo de YouTube + vídeo MP4.",
    dash_interview_card_desc: "Practica entrevistas de trabajo con un entrevistador IA.",
    dash_pro_only_badge: "Creator y Pro",
    dash_card_unlock: "Mejorar para desbloquear",
    dash_recent_eye: "Proyectos recientes",
    dash_recent_h2: "Tu trabajo más reciente",
    dash_view_all: "Ver todo",
    dash_no_projects: "Sin proyectos aún. Comienza con",
    dash_or: "o",
    chat_eyebrow: "Herramienta",
    chat_h1: "Chat de IA",
    chat_mode_image_hint: "Crear imágenes",
    chat_mode_code_hint: "Ayuda rápida con código",
    chat_mode_cv_hint: "Crear CV",
    chat_mode_video_hint: "Hacer video",
    model_desc_haiku: "Chat rápido del día a día",
    model_desc_sonnet: "Pensamiento y escritura profundos",
    model_desc_gpt4o: "Uso general equilibrado",
    model_desc_gemini: "Multimodal y visión",
    model_desc_gpt5: "Tareas más difíciles · máximo razonamiento",
    model_badge_fast: "RÁPIDO",
    model_locked_toast: "{model} está en el plan {tier}. Mejora para desbloquear.",
    chat_sub: "Pregunta cualquier cosa — redacción, traducción, consejos, código, aprendizaje, ideas.",
    chat_new: "Nuevo chat",
    chat_sessions: "Conversaciones",
    chat_empty_title: "¿Cómo puedo ayudarte hoy?",
    chat_empty_sub: "Comienza a escribir o prueba una de estas sugerencias.",
    chat_placeholder: "Pregunta cualquier cosa a Lumioo…",
    admin_finance_title: "Finanzas",
    admin_finance_sub: "Ingresos, costos, ganancia/pérdida este mes. Estimaciones — Stripe es la fuente real.",
    admin_finance_prev: "anterior",
    admin_finance_refresh: "Actualizar",
    admin_fin_revenue: "Ingresos",
    admin_fin_llm_cost: "Costo IA",
    admin_fin_image_cost: "Costo imágenes",
    admin_fin_net_profit: "Ganancia neta",
    admin_fin_net_loss: "PÉRDIDA neta",
    admin_fin_margin: "Margen",
    admin_fin_paid_tx: "tx pagadas",
    admin_fin_messages: "mensajes",
    admin_fin_images: "imágenes",
    chat_delete_all: "Borrar todo",
    chat_delete_all_confirm: "¿Seguro que quieres eliminar TODAS las {n} conversaciones? Esto no se puede deshacer.",
    chat_delete_all_done: "{n} conversaciones eliminadas",
    chat_model: "Modelo",
    chat_speed: "Velocidad",
    chat_gpt5_meter_label: "Mensajes GPT-5 este mes",
    chat_mode_quick: "Rápido",
    chat_mode_quick_sub: "Gemini Flash · veloz",
    chat_mode_smart: "Inteligente",
    chat_mode_smart_sub: "Sonnet 4.6 · más profundo",
    chat_mode_genius: "Genio",
    chat_mode_genius_sub: "GPT-5 · razonamiento top",
    chat_mode_master: "Maestro",
    chat_mode_master_sub: "Opus 4.5 · el más capaz",
    chat_opus_meter_label: "Maestro (Opus 4.5) este mes",
    chat_delete: "Eliminar",
    chat_copy: "Copiar",
    chat_copied: "Copiado",
    chat_no_sessions: "Sin conversaciones aún.",
    chat_suggest_1: "Explica una alerta SPL de Splunk para inicios de sesión fallidos de administrador",
    chat_suggest_2: "Escribe Python para deduplicar una lista de dicts",
    chat_suggest_3: "Redacta una respuesta de caso de Salesforce para una página Lightning lenta",
    chat_suggest_4: "Planifica un MVP de SaaS para procesamiento de facturas con IA",
    video_eyebrow: "Herramienta",
    video_h1: "Productor de Vídeos de IA",
    video_sub: "Un tema en → un paquete completo de YouTube con un vídeo MP4 terminado.",
    video_topic: "Tema",
    video_topic_ph: "ej. Cómo la IA Remodelará los Ingresos Online en 2026",
    video_tone: "Tono",
    video_length: "Duración",
    video_voice: "Voz",
    video_generate: "Generar paquete de vídeo",
    video_generating: "Produciendo tu vídeo… (30–90s)",
    video_loading_sub: "Escribiendo script, pintando escenas, grabando voz, montando MP4…",
    video_empty: "Tus activos de vídeo generados aparecerán aquí.",
    video_title_l: "Título",
    video_desc_l: "Descripción",
    video_voiceover: "Narración",
    video_download_audio: "Descargar MP3",
    video_download_video: "Descargar MP4",
    video_scenes: "Escenas",
    video_copy_meta: "Copiar metadatos",
    video_meta_copied: "Metadatos copiados",
    video_no_mp4: "MP4 no disponible — aún puedes usar escenas + audio por separado.",
    scene: "Escena",
    image_unavailable: "Imagen no disponible",
    projects_eyebrow: "Historial",
    projects_h1: "Tus proyectos",
    projects_sub: "Todo lo que has producido con Lumioo.",
    projects_empty: "Sin proyectos aún.",
    try_chat: "Prueba AI Chat",
    try_video: "Prueba Productor de Vídeos",
    video_ready: "Paquete de vídeo listo",
    answer_ready: "Respuesta lista",
    stage_queued: "En cola…",
    stage_script: "Escribiendo script…",
    stage_images_audio: "Pintando escenas y grabando voz…",
    stage_stitching: "Montando MP4…",
    stage_done: "Listo",
    chat_attach_image: "Adjuntar imagen",
    chat_websearch_label: "Web",
    chat_websearch_on: "Búsqueda web ACTIVA — Lumioos consultará datos actuales antes de responder",
    chat_websearch_off: "Búsqueda web INACTIVA — Lumioos usa su conocimiento. Activa para eventos actuales.",
    chat_enable_web_retry: "Activar búsqueda web y reintentar",
    chat_start_recording: "Iniciar voz",
    chat_stop_recording: "Detener y transcribir",
    chat_image_attached: "Imagen lista",
    chat_image_remove: "Quitar imagen",
    chat_only_image: "Por favor, elige un archivo de imagen",
    chat_image_too_large: "Imagen demasiado grande (máx 8 MB)",
    chat_drop_title: "Suelta tu imagen para adjuntarla",
    chat_drop_sub: "PNG / JPG / WebP — máx 8 MB",
    chat_upgrade_title: "Has alcanzado tu límite diario",
    chat_upgrade_sub: "Hoy usaste {used} de {limit} mensajes en el plan Free. Mejora tu plan para seguir — el límite se reinicia a medianoche UTC.",
    chat_upgrade_benefits: "Qué desbloqueas",
    chat_upgrade_b1: "Mensajes de chat ilimitados",
    chat_upgrade_b2: "Acceso completo a Práctica de Entrevistas",
    chat_upgrade_b3: "Imagen + voz en el chat",
    chat_upgrade_b4: "Sin marca de agua en videos",
    chat_upgrade_cta: "Ver planes",
    chat_upgrade_later: "Tal vez más tarde",
    iv_gate_title: "Práctica de Entrevistas está bloqueada",
    iv_gate_sub: "Esta es una función de Creator y Pro. Mejora tu plan para desbloquear bancos ilimitados de preguntas, modo voz e informes detallados.",
    iv_gate_what_you_get: "Qué desbloqueas",
    iv_gate_b1: "Bancos de preguntas ilimitados (subida PDF / imagen)",
    iv_gate_b2: "Modos de entrevista por voz + texto con evaluación AI",
    iv_gate_b3: "Entrevistador AI animado + 4 voces",
    iv_gate_b4: "Informes de rendimiento detallados + resumen por email",
    iv_gate_cta: "Ver planes",
    iv_gate_back: "Volver a Lumioos",
    vd_gate_title: "Productor de Vídeo IA bloqueado",
    vd_gate_sub: "Vídeos IA reales con Sora 2 — solo planes Creator y Pro.",
    vd_gate_what_you_get: "Qué desbloqueas",
    vd_gate_b1: "Clips de vídeo IA cinematográficos reales (Sora 2)",
    vd_gate_b2: "Vídeos multi-escena con narración IA en 9 idiomas",
    vd_gate_b3: "Descarga MP4 1280×720 — sin marca de agua",
    vd_gate_b4: "Hasta 15 vídeos/mes en Creator, 50 en Pro",
    vd_gate_cta: "Mejorar para desbloquear",
    vd_gate_back: "Volver al Panel",
    cancel_btn: "Cancelar suscripción",
    cancel_tooltip: "Mantendrás el acceso hasta la fecha de vencimiento",
    cancel_confirm: "¿Cancelar tu suscripción? Mantendrás acceso completo hasta la fecha de vencimiento actual.",
    cancel_ok: "Suscripción cancelada — el acceso continúa hasta el vencimiento.",
    cancel_ok_with_date: "Suscripción cancelada. Mantendrás los beneficios hasta el {date}.",
    cancel_fail: "No se pudo cancelar — inténtalo de nuevo.",
    bug_open: "Reportar error",
    bug_title: "Reportar un error o problema",
    bug_sub: "Cuéntanos qué salió mal. Adjunta una captura o PDF si ayuda.",
    bug_placeholder: "¿Qué esperabas que pasara? ¿Qué pasó realmente?",
    bug_attach: "Adjuntar captura o PDF (opcional)",
    bug_send: "Enviar reporte",
    bug_sending: "Enviando...",
    bug_thanks: "¡Gracias! Lo revisaremos.",
    bug_send_fail: "No se pudo enviar — inténtalo de nuevo.",
    bug_message_short: "Por favor escribe al menos 3 caracteres.",
    bug_file_too_large: "Archivo demasiado grande (máx 5 MB)",
    bug_only_image_or_pdf: "Solo se permiten imágenes o PDFs",
    chat_describe_image: "¿Qué ves en esta imagen?",
    chat_voice_added: "Voz transcrita",
    chat_voice_empty: "No se escuchó nada — intenta de nuevo",
    chat_mic_denied: "Acceso al micrófono denegado",
    chat_recording_ph: "Grabando… haz clic en detener cuando hayas terminado",
    video_language: "Idioma",
    project_view: "Ver",
    project_delete: "Eliminar",
    project_delete_confirm: "Confirmar",
    project_cancel: "Cancelar",
    project_deleted: "Proyecto eliminado",
    project_confirm_delete: "¿Eliminar este proyecto permanentemente?",
    project_back: "Volver a proyectos",
    project_not_found: "Proyecto no encontrado",
    project_no_video: "No hay MP4 guardado para este proyecto.",
    project_download: "Descargar MP4",
    project_download_started: "Descarga iniciada",
    pricing_expires: "se renueva",
    pricing_popular: "Más popular",
    pricing_month_short: "mes",
    pricing_free_default: "Plan predeterminado",
    pricing_redirecting: "Redirigiendo…",
    pricing_disclaimer: "Pagos procesados por Stripe. Al suscribirte aceptas facturación mensual. Cancela desde tu cuenta en cualquier momento.",
    pricing_mobile_note_title: "Los precios mostrados son para el pago web.",
    pricing_mobile_note_body: "Las suscripciones compradas dentro de nuestra app iOS o Android pueden costar más debido a las tarifas de App Store (hasta un 30%). Ahorra más suscribiéndote aquí en la web.",
    pricing_faq_title: "Preguntas frecuentes",
    pricing_faq_why_pro_q: "¿Por qué Pro cuesta $29?",
    pricing_faq_why_pro_a: "Pro ahora incluye video Sora-2, GPT-5, Claude Opus 4.5, GPT Image 1 y chat ilimitado. Comprar esto por separado costaría más de $80/mes (ChatGPT Plus $20 + Runway $15 + Midjourney $10 + Claude Pro $20). Lo agrupamos todo por $29 — ahorras 60%+. Los clientes Pro actuales siguen pagando los $10 originales.",
    pricing_faq_cancel_q: "¿Puedo cancelar en cualquier momento?",
    pricing_faq_cancel_a: "Sí — un clic desde Facturación. Sin reembolsos del mes actual, pero mantienes Pro hasta que termine el período. Nunca auto-renovamos sin avisar.",
    pricing_faq_existing_q: "Me registré antes — ¿cambia mi precio?",
    pricing_faq_existing_a: "No. Si ya pagas $5 (Creator) o $10 (Pro), tu suscripción Stripe se mantiene en ese precio hasta que TÚ canceles o cambies de plan. Solo los nuevos registros ven el precio nuevo.",
    billing_checking: "Confirmando pago…",
    billing_checking_sub: "Esto normalmente tarda unos segundos.",
    billing_paid: "Pago exitoso 🎉",
    billing_paid_sub: "Plan activado:",
    billing_pending: "Aún procesando",
    billing_pending_sub: "Actualiza en un momento — el plan se activará automáticamente.",
    billing_expired: "Sesión expirada",
    billing_failed: "Pago no completado",
    billing_to_dashboard: "Ir al panel de control",
    billing_back: "Volver a precios",
    video_already_running: "Ya se está generando un vídeo. Espera a que termine o desestímalo.",
    video_dismiss_confirm: "¿Desestimar este trabajo? (El vídeo seguirá generándose en segundo plano y aún aparecerá en Proyectos.)",
    pricing_year_short: "año",
    pricing_yearly_savings: "Ahorras ${saved} por año",
    pricing_admin_unlimited: "Admin — Ilimitado (sin límites)",
    pricing_admin_skip: "Admin: ilimitado",
    redeem_required: "Introduce un código",
    redeem_success: "Código aplicado",
    iv_delete_type_to_confirm: 'Escriba "{name}" para confirmar:',
    oauth_err_title: "Salesforce no autorizó la conexión",
    oauth_err_blocked_subtitle: "No es un error de Lumioos — es la política de seguridad de tu org. Solución en 2 minutos:",
    oauth_err_generic_subtitle: "Falló el OAuth. Prueba los pasos o reconecta.",
    oauth_err_step1: "Salesforce → Setup → busca 'Connected Apps OAuth Usage'",
    oauth_err_step2: "Encuentra 'Lumioos' → clic 'Allow' / 'Install'",
    oauth_err_step3: "Vuelve aquí y clic 'Reconectar'",
    oauth_err_alt_title: "Solución permanente:",
    oauth_err_alt_step1: "Setup → App Manager → 'Lumioos' → View",
    oauth_err_alt_step2: "Manage → Edit Policies → 'All users may self-authorize'",
    oauth_err_alt_step3: "Save → reconecta",
    oauth_err_reconnect: "Reconectar",
    oauth_err_close: "Cerrar",
    oauth_err_raw: "Código de error técnico",
    pwa_install_lumioos: "Instalar Lumioos",
    pwa_install_subtitle: "Añadir a la pantalla de inicio — sin app store.",
    pwa_install_short: "Instalar",
    pwa_not_now: "Ahora no",
    pwa_got_it: "Entendido",
    pwa_ios_safari_required: "Abre este sitio en Safari para instalar",
    pwa_ios_safari_required_sub: "En iPhone, solo Safari puede añadir apps a la pantalla de inicio. Copia este enlace y pégalo en Safari.",
    pwa_ios_copy_link: "Copiar enlace",
    pwa_modal_title_ios: "Instalar en iPhone / iPad",
    pwa_modal_title_android: "Instalar en Android",
    pwa_modal_title_mac: "Instalar en Mac",
    pwa_modal_title_desktop: "Instalar en escritorio",
    pwa_modal_ios_step1: "Toca el icono Compartir en la parte inferior de Safari",
    pwa_modal_ios_step2: "Desplázate y toca \"Añadir a pantalla de inicio\"",
    pwa_modal_ios_step3: "Toca \"Añadir\" en la esquina superior derecha",
    pwa_modal_ios_step4: "Lumioos aparecerá en tu pantalla como una app nativa",
    pwa_modal_android_step1: "Toca el menú ⋮ arriba a la derecha en Chrome",
    pwa_modal_android_step2: "Toca \"Añadir a pantalla\" o \"Instalar app\"",
    pwa_modal_android_step3: "Toca \"Instalar\" en el aviso",
    pwa_modal_android_step4: "Lumioos se abre como una app nativa",
    pwa_modal_mac_step1: "Haz clic en el icono de instalar en la barra de direcciones (⊕)",
    pwa_modal_mac_step2: "O: Menú Chrome (⋮) → \"Instalar Lumioos…\"",
    pwa_modal_mac_step3: "Haz clic en \"Instalar\"",
    pwa_modal_mac_step4: "Lumioos se abre en su propia ventana",
    pwa_modal_desktop_step1: "Busca el icono de instalar en la barra de direcciones (⊕ o ↓)",
    pwa_modal_desktop_step2: "Si no lo ves, abre el menú del navegador y busca \"Instalar Lumioos\"",
    pwa_modal_desktop_step3: "Confirma haciendo clic en \"Instalar\"",
    pwa_modal_desktop_step4: "Lumioos se abre en su propia ventana de escritorio",
    // ---------------- Jarvis (Centro de control + Ayuda) ----------------
    jarvis_paired_computers_title: "Ordenadores emparejados",
    jarvis_pair_a_computer_btn: "Emparejar un ordenador",
    jarvis_no_devices_hint: "Aún no hay ordenadores emparejados. Haz clic en \"Emparejar un ordenador\" para empezar.",
    jarvis_send_command_title: "Enviar un comando",
    jarvis_command_placeholder: "Abre OBS, lanza Chrome en mylumioos.com, graba 30 segundos, detén y verifica el vídeo",
    jarvis_target_label: "Destino: {name}",
    jarvis_pair_first_hint: "Empareja un ordenador para poder enviar comandos",
    jarvis_send_to_jarvis_btn: "Enviar a Jarvis",
    jarvis_task_history_title: "Historial de tareas",
    jarvis_no_tasks_hint: "Aún no hay tareas. Envía tu primer comando arriba.",
    jarvis_device_selected: "Seleccionado",
    jarvis_device_select: "Seleccionar",
    jarvis_device_revoked_badge: "Revocado",
    jarvis_status_online: "En línea",
    jarvis_status_offline_last_seen: "Desconectado · última vez {ago}",
    jarvis_status_never: "nunca",
    jarvis_status_unknown: "desconocido",
    jarvis_toast_type_command_first: "Escribe un comando primero",
    jarvis_toast_pair_first: "Empareja y selecciona un ordenador primero",
    jarvis_toast_task_queued: "Tarea en cola — el agente la ejecutará enseguida.",
    jarvis_toast_monthly_limit: "Límite mensual de tareas alcanzado ({max}). Mejora tu plan para más.",
    jarvis_toast_task_queue_failed: "No se pudo encolar la tarea",
    jarvis_toast_revoke_confirm: "¿Revocar este ordenador? El agente dejará de funcionar de inmediato.",
    jarvis_toast_device_revoked: "Ordenador revocado",
    jarvis_toast_device_revoke_failed: "No se pudo revocar el ordenador",
    jarvis_toast_task_cancelled: "Tarea cancelada",
    jarvis_toast_task_cancel_failed: "No se pudo cancelar la tarea",
    jarvis_toast_delete_task_confirm: "¿Eliminar esta tarea del historial?",
    jarvis_toast_task_deleted: "Tarea eliminada",
    jarvis_toast_task_delete_failed: "No se pudo eliminar la tarea",
    jarvis_toast_clear_all_tasks_confirm: "¿Eliminar todo el historial? Las tareas en curso se conservan.",
    jarvis_toast_tasks_cleared: "{n} tareas eliminadas",
    jarvis_toast_delete_device_confirm: "¿Eliminar este ordenador definitivamente? Su historial también se borrará.",
    jarvis_toast_device_deleted: "Ordenador eliminado",
    jarvis_clear_all_tasks_btn: "Borrar todo",
    jarvis_task_status_queued: "En cola",
    jarvis_task_status_running: "En ejecución",
    jarvis_task_status_completed: "Completada",
    jarvis_task_status_failed: "Fallida",
    jarvis_task_status_cancelled: "Cancelada",
    jarvis_task_cancel_btn: "Cancelar",
    jarvis_task_error_label: "Error:",
    jarvis_task_steps_label: "Pasos",
    jarvis_task_screenshots_label: "Capturas ({n})",
    jarvis_task_result_label: "Resultado",
    jarvis_task_steps_count: "{n} pasos",
    jarvis_task_screenshots_count: "{n} capturas",
    jarvis_time_seconds_ago: "hace {n}s",
    jarvis_time_minutes_ago: "hace {n}min",
    jarvis_time_hours_ago: "hace {n}h",
    jarvis_time_days_ago: "hace {n}d",
    jarvis_download_windows: "Descargar para Windows",
    jarvis_download_macos: "Descargar para macOS",
    jarvis_download_linux: "Descargar para Linux (build de macOS)",
    jarvis_alt_downloads_title: "¿Usas otro ordenador?",
    jarvis_sys_title: "Información del sistema",
    jarvis_sys_detected_os: "Sistema detectado",
    jarvis_sys_installed_agent: "Agente instalado",
    jarvis_sys_latest_version: "Última versión",
    jarvis_sys_status_connected: "Conectado",
    jarvis_sys_status_offline: "Desconectado",
    jarvis_sys_status_unpaired: "Sin emparejar",
    jarvis_sys_not_installed: "No instalado",
    jarvis_sys_compat_uptodate: "Tu agente de escritorio está actualizado.",
    jarvis_sys_compat_outdated: "Tu agente v{installed} es anterior a v{latest} — vuelve a descargarlo para las últimas funciones.",
    jarvis_sys_compat_no_agent: "Instala el agente de escritorio abajo para activar Jarvis en este ordenador.",
    jarvis_hc_intro_pill: "Instalación y ayuda",
    jarvis_hc_title: "Centro de instalación y ayuda",
    jarvis_hc_subtitle: "Instala, conecta y soluciona problemas del agente de escritorio en minutos, sin tutoriales.",
    jarvis_hc_search_placeholder: "Buscar temas, pasos, errores…",
    jarvis_hc_no_results: "No hay resultados para tu búsqueda. Prueba con otra palabra.",
    jarvis_hc_tab_wizard: "Asistente de instalación",
    jarvis_hc_tab_troubleshoot: "Solución de problemas",
    jarvis_hc_tab_faq: "Preguntas frecuentes",
    jarvis_hc_video_title: "Vídeo tutorial",
    jarvis_hc_video_placeholder: "El vídeo guiado llegará pronto — mientras tanto, sigue el asistente paso a paso.",
    jarvis_hc_step_of: "Paso {n} de {total}",
    jarvis_hc_prev: "Anterior",
    jarvis_hc_next: "Siguiente",
    jarvis_hc_done: "Listo",
    jarvis_hc_need_help: "¿Necesitas ayuda con este paso?",
    jarvis_hc_screenshot_soon: "La captura de este paso llegará muy pronto.",
    jarvis_hc_troubleshoot_title: "Problemas comunes y soluciones",
    jarvis_hc_troubleshoot_subtitle: "Toca cualquier problema para ver la causa probable y la solución rápida.",
    jarvis_hc_faq_title: "Preguntas frecuentes",
    jarvis_hc_faq_subtitle: "Todo lo que necesitas para instalar, ejecutar y actualizar Jarvis.",
    jarvis_hc_problem_label: "Problema",
    jarvis_hc_cause_label: "Causa probable",
    jarvis_hc_solution_label: "Solución",
    jarvis_hc_step_download_title: "Descargar el agente de escritorio",
    jarvis_hc_step_download_desc: "Pulsa el botón de descarga para obtener el ZIP adaptado a tu sistema (Windows o macOS).",
    jarvis_hc_step_download_help: "Si no se descarga nada, revisa el bloqueador de ventanas y la carpeta de descargas del navegador.",
    jarvis_hc_step_extract_title: "Extraer el archivo descargado",
    jarvis_hc_step_extract_desc: "Haz clic derecho en el ZIP y elige \"Extraer todo\" en Windows, o doble clic en macOS.",
    jarvis_hc_step_extract_help: "Nunca ejecutes los archivos desde dentro del ZIP; extráelo primero.",
    jarvis_hc_step_open_folder_title: "Abrir la carpeta del agente",
    jarvis_hc_step_open_folder_desc: "Entra en la carpeta recién extraída \"lumioos-desktop-agent\" (normalmente en Descargas).",
    jarvis_hc_step_open_folder_help: "Deja esta ventana abierta; harás doble clic en varios archivos aquí en los pasos siguientes.",
    jarvis_hc_step_run_install_title: "Ejecuta install-agent",
    jarvis_hc_step_run_install_desc: "Doble clic en install-agent.bat (Windows) o install-agent.command (macOS). Instala los paquetes de Python necesarios.",
    jarvis_hc_step_run_install_help: "Se abrirá una terminal que se cerrará sola. Solo hace falta ejecutarlo una vez.",
    jarvis_hc_step_generate_code_title: "Generar un código de emparejamiento",
    jarvis_hc_step_generate_code_desc: "Vuelve aquí, haz clic en \"Emparejar un ordenador\" y copia el código de 6 dígitos.",
    jarvis_hc_step_generate_code_help: "Los códigos caducan a los 10 minutos y son de un solo uso. Genera uno nuevo si caduca.",
    jarvis_hc_step_run_pair_title: "Ejecuta pair-agent",
    jarvis_hc_step_run_pair_desc: "Doble clic en pair-agent.bat (Windows) o pair-agent.command (macOS). Te pedirá el código.",
    jarvis_hc_step_run_pair_help: "pair-agent solo se ejecuta la primera vez. Después, siempre start-agent.",
    jarvis_hc_step_paste_code_title: "Pegar el código",
    jarvis_hc_step_paste_code_desc: "Pega el código de 6 dígitos en la terminal y pulsa Enter para autorizar el ordenador.",
    jarvis_hc_step_paste_code_help: "En Windows pega con botón derecho; en macOS usa Cmd+V. Es normal que no aparezca nada al escribir.",
    jarvis_hc_step_connected_title: "Esperar a \"Conectado correctamente\"",
    jarvis_hc_step_connected_desc: "La terminal mostrará \"✓ Emparejado correctamente\". Después puedes cerrar la ventana.",
    jarvis_hc_step_connected_help: "Si falla, revisa la conexión y genera un código nuevo — los antiguos caducan rápido.",
    jarvis_hc_step_run_start_title: "Ejecuta start-agent",
    jarvis_hc_step_run_start_desc: "Doble clic en start-agent.bat (Windows) o start-agent.command (macOS) para poner el agente en línea.",
    jarvis_hc_step_run_start_help: "Deja esta terminal abierta; si la cierras el agente se desconecta.",
    jarvis_hc_step_return_jarvis_title: "Volver a Jarvis",
    jarvis_hc_step_return_jarvis_desc: "Vuelve a esta página en el navegador — no hace falta cerrar sesión ni refrescar.",
    jarvis_hc_step_return_jarvis_help: "El ordenador emparejado aparecerá en la lista en pocos segundos.",
    jarvis_hc_step_verify_online_title: "Verifica que el ordenador esté En línea",
    jarvis_hc_step_verify_online_desc: "Un punto verde junto al nombre significa que el agente está listo para recibir comandos.",
    jarvis_hc_step_verify_online_help: "Un punto gris significa que start-agent no está en marcha. Vuelve a abrirlo en el ordenador.",
    jarvis_hc_step_first_command_title: "Envía tu primer comando",
    jarvis_hc_step_first_command_desc: "Escribe \"open youtube.com\" y pulsa Enviar. Observa el historial para ver las capturas en vivo.",
    jarvis_hc_step_first_command_help: "Empieza por lo simple: abre una web, luego prueba a grabar con OBS o flujos con varios pasos.",
    jarvis_hc_ts_windows_defender_title: "Windows Defender bloqueó la app",
    jarvis_hc_ts_windows_defender_cause: "SmartScreen marca los .bat nuevos que no estén firmados por Microsoft.",
    jarvis_hc_ts_windows_defender_solution: "Pulsa \"Más información\" y luego \"Ejecutar de todos modos\". Windows recordará tu elección.",
    jarvis_hc_ts_macos_security_title: "La seguridad de macOS bloqueó la app",
    jarvis_hc_ts_macos_security_cause: "Gatekeeper impide ejecutar scripts no firmados por defecto.",
    jarvis_hc_ts_macos_security_solution: "Ajustes del Sistema → Privacidad y Seguridad → pulsa \"Abrir de todos modos\" junto al archivo bloqueado.",
    jarvis_hc_ts_pairing_failed_title: "Falló el emparejamiento",
    jarvis_hc_ts_pairing_failed_cause: "El código caducó (10 min), estaba mal escrito o ya fue usado.",
    jarvis_hc_ts_pairing_failed_solution: "Vuelve a pulsar \"Emparejar un ordenador\" y pega el nuevo código en pair-agent antes de 10 minutos.",
    jarvis_hc_ts_agent_offline_title: "El agente está desconectado",
    jarvis_hc_ts_agent_offline_cause: "Se cerró la ventana de start-agent o el ordenador entró en reposo.",
    jarvis_hc_ts_agent_offline_solution: "Abre la carpeta del agente y haz doble clic en start-agent otra vez. Deja la terminal abierta.",
    jarvis_hc_ts_obs_not_detected_title: "No se detecta OBS",
    jarvis_hc_ts_obs_not_detected_cause: "OBS Studio no está instalado o su servidor WebSocket está desactivado.",
    jarvis_hc_ts_obs_not_detected_solution: "Instala OBS Studio 28+ y activa Herramientas → Ajustes del servidor WebSocket → \"Habilitar servidor WebSocket\".",
    jarvis_hc_ts_browser_not_open_title: "El navegador no se abre",
    jarvis_hc_ts_browser_not_open_cause: "Chromium de Playwright no se instaló durante la configuración.",
    jarvis_hc_ts_browser_not_open_solution: "Vuelve a ejecutar install-agent — instalará Playwright y su Chromium automáticamente.",
    jarvis_hc_ts_python_failed_title: "Falló la instalación de Python",
    jarvis_hc_ts_python_failed_cause: "Python 3.10+ no está instalado o se instaló sin \"Add to PATH\".",
    jarvis_hc_ts_python_failed_solution: "Instala Python 3.11 desde python.org marcando \"Add Python to PATH\" y ejecuta install-agent de nuevo.",
    jarvis_hc_ts_permission_denied_title: "Permiso denegado",
    jarvis_hc_ts_permission_denied_cause: "macOS o Windows bloqueó el acceso al teclado, ratón o grabación de pantalla.",
    jarvis_hc_ts_permission_denied_solution: "macOS: da permisos de Accesibilidad y Grabación de pantalla a Terminal. Windows: ejecuta start-agent como administrador.",
    jarvis_hc_ts_connection_timeout_title: "Tiempo de conexión agotado",
    jarvis_hc_ts_connection_timeout_cause: "El firewall, la VPN o un proxy corporativo bloquea HTTPS hacia mylumioos.com.",
    jarvis_hc_ts_connection_timeout_solution: "Permite mylumioos.com en tu firewall o VPN, o desactiva el proxy y reinicia start-agent.",
    jarvis_hc_ts_agent_stopped_title: "El agente se detuvo de forma inesperada",
    jarvis_hc_ts_agent_stopped_cause: "Se cerró la terminal, el ordenador entró en reposo o se aplicó una actualización.",
    jarvis_hc_ts_agent_stopped_solution: "Vuelve a abrir start-agent. Lee las últimas líneas de la terminal — casi siempre indican la causa.",
    jarvis_hc_ts_update_failed_title: "Falló la actualización",
    jarvis_hc_ts_update_failed_cause: "Salió una versión nueva del agente y tu copia local está desactualizada.",
    jarvis_hc_ts_update_failed_solution: "Descarga el ZIP más reciente desde arriba, extráelo sobre la carpeta antigua y ejecuta start-agent.",
    jarvis_hc_faq_install_every_time_q: "¿Tengo que instalar el agente cada vez?",
    jarvis_hc_faq_install_every_time_a: "No. install-agent solo se ejecuta una vez por ordenador. Después basta con hacer doble clic en start-agent.",
    jarvis_hc_faq_can_uninstall_q: "¿Puedo desinstalar el agente?",
    jarvis_hc_faq_can_uninstall_a: "Sí. Cierra start-agent y borra la carpeta lumioos-desktop-agent. Puedes revocar el ordenador desde esta página.",
    jarvis_hc_faq_multiple_computers_q: "¿Puedo emparejar varios ordenadores?",
    jarvis_hc_faq_multiple_computers_a: "Sí. Pro permite hasta 2 y Power hasta 5. Cada ordenador necesita su propio código de 6 dígitos.",
    jarvis_hc_faq_windows_and_macos_q: "¿Puedo combinar Windows y macOS?",
    jarvis_hc_faq_windows_and_macos_a: "Claro. Jarvis trata cada ordenador de forma independiente; puedes mezclar Windows y Mac sin problema.",
    jarvis_hc_faq_auto_start_q: "¿Se inicia con el ordenador?",
    jarvis_hc_faq_auto_start_a: "Por defecto no. Añade start-agent a los ítems de inicio del SO (Startup en Windows, Login Items en macOS).",
    jarvis_hc_faq_how_to_update_q: "¿Cómo actualizo el agente?",
    jarvis_hc_faq_how_to_update_a: "Descarga el ZIP más reciente, extráelo sobre la carpeta existente y reinicia start-agent.",
    jarvis_hc_faq_recordings_location_q: "¿Dónde se guardan las grabaciones?",
    jarvis_hc_faq_recordings_location_a: "En la carpeta de salida por defecto de OBS Studio — normalmente Vídeos/OBS en Windows o Películas en macOS.",
    jarvis_hc_faq_change_recording_location_q: "¿Puedo cambiar la carpeta de grabación?",
    jarvis_hc_faq_change_recording_location_a: "Sí. En OBS: Archivo → Ajustes → Salida → Grabación y elige la carpeta que quieras. Jarvis se adapta solo.",
    jarvis_hc_faq_remove_computer_q: "¿Cómo elimino un ordenador emparejado?",
    jarvis_hc_faq_remove_computer_a: "En la lista de ordenadores emparejados pulsa el icono de la papelera. El agente dejará de aceptar comandos al instante.",
    },
  fr: {
    nav_features: "Fonctionnalités",
    nav_howit: "Comment ça marche",
    nav_pricing: "Tarifs",
    nav_download: "Télécharger",
    lp_download_eyebrow: "Téléchargement",
    lp_download_h2: "Lumioos sur tous vos appareils",
    lp_download_h2_one: "Lumioos est désormais sur {platform}",
    lp_download_h2_two: "Lumioos pour {p1} & {p2}",
    lp_download_sub: "Installez Lumioos sur Windows dès maintenant — Apple et Android arrivent bientôt.",
    lp_download_sub_one: "Installez Lumioos sur {platform}. Plus de plateformes bientôt.",
    lp_download_sub_two: "Installez sur {p1} ou {p2} — plus d'appareils bientôt.",
    lp_download_live: "Disponible",
    lp_download_soon: "Bientôt",
    lp_download_install: "Installer gratuitement",
    lp_download_notify: "Lancement prochain",
    nav_signin: "Se connecter",
    nav_get_started: "Commencer",
    hero_badge: "Approuvé par les pros — Claude 4.5 · GPT-5 · Gemini 3",
    hero_h1_a: "Votre espace de travail IA —",
    hero_h1_b: "plus intelligent, rapide, sûr",
    hero_sub: "Lumioo est votre assistant IA professionnel. Résolvez des problèmes complexes en chat avec image et voix, produisez des vidéos prêtes à publier en 6 langues, et livrez en minutes ce qui prenait des heures. À partir de {from_price}/mois.",
    hero_cta_primary: "Commencer gratuitement — sans carte",
    hero_cta_secondary: "Voir comment ça marche",
    trust_no_card: "Pas de carte requise",
    trial_badge: "Essai Pro de {days} jours · sans carte",
    trial_banner_text: "Il vous reste {days} jours d'essai Pro gratuit",
    trial_banner_ending_today: "Votre essai gratuit se termine aujourd'hui — passez à Pro",
    trial_banner_cta: "Passer à Pro",
    trial_banner_close: "Ignorer",
    trial_pill_label: "Essai · {days}j",
    trial_pill_cta: "Passer Pro",
    trial_pill_tooltip: "Vous êtes en essai Pro gratuit — passez à Pro avant la fin.",
    trial_ribbon_text: "🎁 Profitez de {days} jours de Pro gratuits — sans carte",
    trial_ribbon_pill: "Offre limitée",
    trial_ribbon_cta: "Commencer",
    hero_cta_trial: "Démarrer l'essai gratuit de {days} jours",
    // Refer & Earn page
    ref_back: "Retour",
    ref_title: "Parrainer & Gagner",
    ref_subtitle: "Invitez un ami → vous gagnez +{days} jours de Pro à chaque inscription, votre ami démarre avec 14 jours de Pro gratuits (essai standard de 7 jours + bonus de 7 jours).",
    ref_loading: "Chargement…",
    ref_invited: "Invités",
    ref_days_earned: "Jours Pro gagnés",
    ref_your_link: "Votre lien d'invitation",
    ref_copy: "Copier",
    ref_copied: "Copié",
    ref_share: "Partager",
    ref_your_code: "Votre code :",
    ref_recent: "Invitations récentes",
    ref_days_awarded: "+{days} jours Pro",
    ref_how_to_share: "📣 Comment partager ?",
    ref_share_whatsapp: "Partagez-le dans des groupes WhatsApp / Telegram",
    ref_share_twitter: "Postez sur X avec une capture de démo",
    ref_share_linkedin: "Publiez sur LinkedIn avec le lien",
    ref_share_forum: "Mentionnez-le sur les forums Salesforce / Trailhead et Reddit",
    ref_link_copied: "Lien copié",
    ref_copy_error: "Impossible de copier",
    ref_load_error: "Impossible de charger les parrainages",
    ref_share_message: "Essayez Lumioos avec mon lien — inscrivez-vous et obtenez 14 jours de Pro gratuits !",
    trial_ended_close: "Fermer",
    trial_ended_title: "Bon retour chez Free",
    trial_ended_subtitle: "Votre essai Pro de 7 jours vient de se terminer.",
    trial_ended_losing: "Vous perdez l'accès à",
    trial_ended_feat_video: "🎬 Video Producer (Sora 2)",
    trial_ended_feat_interview: "🎤 Interview Practice (simulations d'entretien)",
    trial_ended_feat_image: "🖼️ Image Producer (GPT Image 1)",
    trial_ended_feat_salesforce: "⚡ Salesforce / Trailhead Agent",
    trial_ended_promo_eyebrow: "Offre unique",
    trial_ended_promo_headline: "20% DE RÉDUC. sur Pro — rien que pour vous",
    trial_ended_promo_sub: "Le code {code} s'applique automatiquement au paiement. Valable uniquement maintenant.",
    trial_ended_cta_upgrade: "Passer Pro avec {code} → -20%",
    trial_ended_cta_later: "Peut-être plus tard",
    trust_stripe: "Paiements sécurisés par Stripe",
    trust_privacy: "Vos données restent privées",
    trust_rating: "Adoré par les premiers utilisateurs",
    hero_card_live: "En direct",
    hero_card_eyebrow: "Réponse IA en direct",
    hero_card_question: "Comment réparer une erreur de boucle Salesforce Flow ?",
    hero_card_assistant: "Assistant Lumioo",
    hero_card_answer: "Ajoutez une condition de garde à l'élément Update Records. Utilisez un Decision avant le début de la boucle pour vérifier si l'état correspond déjà — cela casse la récursion.",
    hero_card_time: "Résolu en 8s",
    hero_chip_voice: "Voix → Texte",
    hero_chip_image: "Voir vos captures",
    hero_chip_lang: "6 langues",
    stat_1_n: "Langues",
    stat_2_n: "Modèles IA",
    stat_3_n: "Temps de réponse",
    stat_4_n: "Disponibilité",
    feat_section_eyebrow: "Ce que fait Lumioo",
    feat_section_h2: "Un espace. Tous les superpouvoirs IA.",
    feat_section_sub: "Arrêtez de jongler avec 6 onglets. Chattez, voyez, écoutez, produisez — depuis un seul espace épuré.",
    feat_chat_title: "Chat IA Intelligent",
    feat_chat_desc: "Demandez n'importe quoi en langage clair. Joignez une capture pour analyse visuelle. Parlez au lieu de taper.",
    coming_soon_badge: "Bientôt disponible",
    gs_ad_cta_soon: "M'avertir au lancement",
    gs_ad_locked: "Verrouillé pour l'instant — bientôt en ligne.",
    gs_coming_soon_toast: "Game Studio arrive bientôt — on vous prévient !",
    feat_video_title: "Producteur Vidéo Cinématographique",
    feat_video_desc: "Tapez un sujet dans une des 6 langues. En minutes, obtenez un script, une narration IA, des scènes cinématographiques et un MP4 prêt à publier.",
    feat_speed_t: "Vitesse éclair",
    feat_speed_d: "Réponses en secondes. Vidéos en minutes. Zéro attente.",
    feat_secure_t: "Sécurité bancaire",
    feat_secure_d: "Sessions chiffrées. Vos prompts n'entraînent jamais les IAs.",
    feat_global_t: "Global par design",
    feat_global_d: "Support natif de 6 langues — dont le français.",
    how_eyebrow: "Comment ça marche",
    how_h2: "Trois étapes. Zéro apprentissage.",
    how_s1_t: "Inscription gratuite",
    how_s1_d: "Pas de carte. Créez votre compte en moins de 30 secondes.",
    how_s2_t: "Demandez ou décrivez",
    how_s2_d: "Tapez, parlez, ou déposez une capture. Ou tapez un sujet vidéo dans votre langue.",
    how_s3_t: "Utilisez le résultat",
    how_s3_d: "Copiez la réponse. Téléchargez le MP4. Publiez. Voilà.",
    lp_pricing_eyebrow: "Tarifs simples et justes",
    lp_pricing_h2: "Commencez gratuitement. Améliorez seulement si besoin.",
    lp_pricing_sub: "Chaque plan inclut les fonctions IA essentielles. Pas de frais cachés. Annulez quand vous voulez.",
    lp_plan_popular: "Le plus populaire",
    lp_plan_start: "Commencer",
    cta_h2_a: "Prêt à travailler",
    cta_h2_b: "plus intelligemment ?",
    cta_sub: "Rejoignez les pros qui font confiance à Lumioo chaque jour. Gratuit pour usage personnel.",
    cta_btn: "Créer votre compte gratuit",
    cta_smallprint: "Sans carte. Inscription en 30s. Annulez quand vous voulez.",
    footer_tag: "Conçu pour les professionnels.",
    footer_privacy: "Confidentialité",
    footer_terms: "Conditions",
    side_dashboard: "Tableau de bord",
    side_chat: "Chat IA",
    side_video: "Producteur Vidéo",
    side_image: "Producteur d'Image",
    side_cv: "Créateur de CV",
    side_interview: "Entraînement Entretien",
    side_projects: "Projets",
    side_billing: "Abonnement",
    side_referrals: "Parrainer & Gagner",
    side_admin: "Admin",
    side_ai_workforce: "AI Workforce",
    wf_badge: "ADMIN · PHASE 1",
    wf_title: "AI Workforce",
    wf_subtitle: "Manage your private AI company workforce. Delegate objectives, monitor progress, and approve every action that touches the outside world.",
    wf_total_agents: "Total Agents",
    wf_active_agents: "Active Agents",
    wf_busy_agents: "Busy Agents",
    wf_tasks_in_progress: "Tasks in Progress",
    wf_tasks_completed: "Completed Tasks",
    wf_tasks_failed: "Failed Tasks",
    wf_approvals_pending: "Pending Approvals",
    wf_agents_title: "AI Employees",
    wf_workspace_company: "Company Workspace",
    wf_phase_notice_title: "Sub-Phase 1A · Foundation ready",
    wf_phase_notice_body: "Tasks, CEO orchestration, agent messaging and approvals arrive in Sub-Phase 1B → 1D. The employees above are already configured and ready — no further action needed until then.",
    wf_refresh: "Actualiser",
    wf_ceo_chat_title: "Chat CEO",
    wf_ceo_chat_empty: 'Parlez naturellement au CEO AI. Essayez : "Quelles tâches attendent une approbation ?" ou "Recherche 3 idées d\'inscription."',
    wf_ceo_chat_placeholder: "Demandez tout au CEO, ou dites 'recherche X', 'annule la tâche', 'approuve le brouillon'…",
    wf_ceo_chat_hint: "L\'intention est détectée automatiquement : les questions répondent depuis la vraie base ; les intentions de tâche/contrôle/approbation appellent les vraies APIs. Aucune capacité fictive — le CEO le dit quand un outil n\'est pas connecté.",
    wf_chat_view_task: "Voir la tâche →",
    wf_new_objective: "Nouvel Objectif",
    wf_task_title_placeholder: "ex. Créer un plan marketing 3 jours pour Lumioos",
    wf_task_desc_placeholder: "Décrivez l\'objectif en détail. Quel résultat voulez-vous ? Des contraintes ?",
    wf_send_to_ceo: "Envoyer au CEO AI",
    wf_ceo_will_plan: "Le CEO AI ({model}) va planifier → assigner aux spécialistes → collecter les résultats. Marketing/Sales/Support/Finance passent par la file d\'approbation.",
    wf_recent_tasks: "Tâches Récentes",
    wf_no_tasks: "Aucune tâche. Créez votre premier objectif ci-dessus.",
    wf_recent_activity: "Activité Récente",
    wf_no_activity: "Aucune activité.",
    wf_agent_chat_empty: "Dites bonjour à {name}, ou donnez une tâche directe.",
    wf_agent_chat_placeholder: "Parler à {name}…",
    wf_tab_overview: "Aperçu",
    wf_tab_chat: "Chat",
    wf_tab_current: "En cours",
    wf_tab_history: "Historique",
    wf_tab_activity: "Activité",
    wf_tab_memory: "Mémoire",
    wf_tab_config: "Config",
    wf_field_status: "Statut",
    wf_field_completed: "Terminées",
    wf_field_completed_count: "{n} terminées",
    wf_field_last_activity: "Dernière activité",
    wf_field_none: "—",
    wf_no_active_tasks: "Aucune tâche active.",
    wf_no_history: "Aucun historique.",
    wf_no_memory: "Aucune mémoire.",
    wf_cfg_model: "Modèle (en cours d\'exécution)",
    wf_cfg_allowed_tools: "Outils autorisés",
    wf_cfg_system_instructions: "Instructions système",
    wf_cfg_agent_id: "ID de l\'agent",
    wf_task_objective: "Objectif",
    wf_task_ceo_plan: "Plan CEO",
    wf_task_children: "Sous-tâches ({n})",
    wf_task_view_result: "Voir le résultat ({n} caractères)",
    wf_task_error_prefix: "Erreur :",
    wf_task_ceo_summary: "Résumé CEO",
    wf_task_agent_messages: "Messages agent ({n})",
    wf_task_pause: "Pause",
    wf_task_resume: "Reprendre",
    wf_task_retry: "Réessayer",
    wf_task_cancel: "Annuler",
    wf_approve: "Approuver",
    wf_reject: "Rejeter",
    wf_approval_status_prefix: "Approbation {status}",
    wf_approvals_title: "Approbations en attente ({n})",
    wf_no_approvals: "Aucune approbation en attente.",
    wf_lwr_badge: "RECHERCHE WEB EN DIRECT",
    wf_lwr_counts: "{searches} recherches · {sources} sources · {pages} pages lues",
    wf_status_idle: "Inactif",
    wf_status_working: "En travail",
    wf_status_waiting_for_approval: "En attente d\'approbation",
    wf_status_paused: "En pause",
    wf_status_error: "Erreur",
    wf_status_offline: "Hors ligne",
    wf_status_pending: "En attente",
    wf_status_planning: "Planification",
    wf_status_assigned: "Assignée",
    wf_status_in_progress: "En cours",
    wf_status_completed: "Terminée",
    wf_status_failed: "Échouée",
    wf_status_cancelled: "Annulée",
    wf_leads_title: "Prospects",
    wf_leads_open: "Ouvrir les prospects",
    wf_leads_overview_title: "Pipeline de prospects",
    wf_leads_total: "Total prospects",
    wf_leads_new: "Nouveaux",
    wf_leads_qualified: "Qualifiés",
    wf_leads_reviewing: "En revue",
    wf_leads_approved: "Approuvés",
    wf_leads_rejected: "Rejetés",
    wf_leads_archived: "Archivés",
    wf_leads_verified: "Vérifiés",
    wf_leads_needs_review: "À revoir",
    wf_leads_none: "Aucun prospect. Demande à Sales AI d\'en trouver.",
    wf_leads_filter_status: "Statut",
    wf_leads_filter_verification: "Vérification",
    wf_leads_filter_min_score: "Score min.",
    wf_leads_filter_industry: "Secteur",
    wf_leads_filter_all: "Tous",
    wf_leads_sort: "Trier",
    wf_leads_sort_score: "Meilleur score",
    wf_leads_sort_newest: "Plus récents",
    wf_leads_sort_name: "Nom de société",
    wf_leads_col_company: "Société",
    wf_leads_col_website: "Site web",
    wf_leads_col_industry: "Secteur",
    wf_leads_col_location: "Lieu",
    wf_leads_col_score: "Score",
    wf_leads_col_verification: "Vérification",
    wf_leads_col_status: "Statut",
    wf_leads_col_discovered: "Découvert",
    wf_leads_score_reasons: "Pourquoi ce score",
    wf_leads_concerns: "Préoccupations",
    wf_leads_sources: "Sources",
    wf_leads_discovery_task: "Tâche de découverte",
    wf_leads_actions_approve: "Approuver",
    wf_leads_actions_reject: "Rejeter",
    wf_leads_actions_archive: "Archiver",
    wf_leads_action_ok: "Prospect {action}",
    wf_leads_action_fail: "Impossible de {action} le prospect",
    wf_leads_no_outreach_note: "L\'approbation marque ce prospect pour suivi. Aucun e-mail, DM ou contact envoyé.",
    wf_lead_status_new: "Nouveau",
    wf_lead_status_qualified: "Qualifié",
    wf_lead_status_reviewing: "En revue",
    wf_lead_status_approved: "Approuvé",
    wf_lead_status_rejected: "Rejeté",
    wf_lead_status_archived: "Archivé",
    wf_verif_verified: "Vérifié",
    wf_verif_needs_review: "À revoir",
    wf_verif_unverified: "Non vérifié",
    wf_toast_task_created: "Objectif envoyé au CEO AI — planification en cours…",
    wf_toast_task_short: "Fournissez un titre et une description plus longs",
    wf_toast_task_create_fail: "Impossible de créer la tâche",
    wf_toast_task_load_fail: "Impossible de charger la tâche",
    wf_toast_workforce_load_fail: "Impossible de charger AI Workforce",
    wf_toast_task_action_ok: "Tâche {action}",
    wf_toast_task_action_fail: "Impossible de {action} la tâche",
    wf_toast_approved: "Approuvé",
    wf_toast_rejected: "Rejeté",
    wf_toast_approval_fail: "Impossible de traiter l\'approbation",
    wf_chat_error_prefix: "Erreur :",
    wf_chat_error_fallback: "échec du chat",
    side_upgrade: "Améliorer",
    side_logout: "Déconnexion",
    side_theme: "Thème",
    pricing_eyebrow: "Plans",
    pricing_h1: "Choisissez votre plan",
    pricing_sub: "Améliorez quand vous voulez. Annulez quand vous voulez.",
    pricing_current: "Plan actuel",
    pricing_monthly: "Mensuel",
    pricing_yearly: "Annuel",
    pricing_save_2mo: "Économisez 2 mois",
    pricing_month: "mois",
    pricing_year: "an",
    pricing_subscribe: "S'abonner",
    pricing_current_plan: "Plan actuel",
    redeem_have_code: "Un code ?",
    redeem_apply: "Appliquer",
    chat_send: "Envoyer",
    chat_thinking: "Réflexion…",
    chat_stop: "Arrêter",
    chat_continue: "Continuer",
    chat_stopped_marker: "⏹ Arrêté",
    chat_continue_prompt: "S'il te plaît, reprends là où tu t'es arrêté.",
    chat_thinking_fast: "⚡ Rapide",
    chat_thinking_balanced: "🎯 Équilibré",
    chat_thinking_thorough: "🧠 Approfondi",
    bestai_sub: "Actuellement #1 en rédaction, code et raisonnement. Basculez sur GPT-5 ou Gemini 3 à tout moment — sans frais supplémentaires.",
    bestai_table_h: "Choisissez le bon modèle pour la tâche.",
    bestai_table_sub: "Lumioos vous en donne trois — basculez en un clic par chat.",
    bestai_footnote: "Tous les modèles inclus dans votre abonnement Lumioos — basculez en un clic, sans frais supplémentaires.",
    bestai_h2: "Propulsé par Claude 4.5.",
    bestai_eyebrow: "Défaut intelligent",
    bestai_task_writing: "Rédaction longue",
    bestai_task_code: "Code et debug",
    bestai_task_translate: "Traduction (TR/AR/RU)",
    bestai_task_reasoning: "Raisonnement le plus difficile",
    bestai_task_capable: "Le plus performant",
    bestai_task_quick: "Réponses rapides",
    gpt56_promo_badge: "NOUVEAU · EXCLUSIVITÉ PRO & POWER",
    gpt56_promo_title: "Famille GPT 5.6",
    gpt56_promo_desc: "Découvrez la nouvelle génération de GPT — trois saveurs, un seul objectif : vous offrir l'équilibre exact de profondeur, d'étendue et de vitesse dont vous avez besoin pour chaque tâche. Disponible dès aujourd'hui sur les plans {plans}.",
    gpt56_promo_plans_hl: "Pro & Power",
    gpt56_sol_tag: "Raisonnement le plus profond",
    gpt56_sol_desc: "Pour les problèmes les plus difficiles — analyses longues, recherche, revue de code complexe. Quand la précision compte plus que la vitesse.",
    gpt56_terra_tag: "Puissance équilibrée",
    gpt56_terra_desc: "Votre cheval de bataille quotidien. Excellentes réponses, assez rapide, large éventail de connaissances — le juste milieu entre Sol et Luna.",
    gpt56_luna_tag: "Le 5.6 le plus rapide",
    gpt56_luna_desc: "Réponses vives pour le chat, le brainstorming et les recherches rapides. Toujours plus malin que la plupart des modèles — juste plus rapide.",
    gpt56_cta_plans: "Voir les plans Pro & Power →",
    gpt56_cta_trial: "Commencer l'essai gratuit de 14 jours",
    router_promo_badge: "NOUVEAU · EXCLUSIVITÉ PRO",
    router_promo_desc: "Le modèle le plus puissant de la planète — automatiquement routé vers vos tâches les plus difficiles. Un seul toggle dans le chat envoie code complexe, analyse et raisonnement à OpenAI GPT-5, tandis que les questions du quotidien restent réactives sur Claude 4.5. Aucun sélecteur de modèle. Aucune friction.",
    router_promo_bullet1: "Sélectionne GPT-5 pour les tâches difficiles",
    router_promo_bullet2: "Raisonnement et code de niveau mondial",
    router_promo_bullet3: "File prioritaire, sans limite de débit",
    router_promo_bullet4: "Toggle en un clic dans le chat",
    router_promo_cta: "Passer au Pro",
    router_promo_included: "Inclus gratuitement dans chaque plan Pro",
    sonnet_promo_pill: "Idéal pour les tâches générales",
    sonnet_promo_default_label: "— par défaut sur Lumioos",
    sonnet_promo_desc: "Le modèle phare d'Anthropic domine les benchmarks indépendants en rédaction, code et raisonnement complexe. Taux d'hallucination inférieur à GPT-5 et meilleure qualité multilingue. Défini comme défaut Lumioos pour que les nouveaux utilisateurs aient le meilleur d'entrée de jeu.",
    sonnet_col_writing: "Rédaction",
    sonnet_col_code: "Code",
    sonnet_col_reasoning: "Raisonnement",
    err_generic: "Une erreur est survenue",
    err_topic_required: "Saisissez un sujet",
    err_message_required: "Saisissez un message",
    feat_chat_li1: "Téléchargement d'images — analysez n'importe quelle capture d'écran ou photo",
    feat_chat_li2: "Entrée vocale — parlez, Lumioo transcrit",
    feat_chat_li3: "Code, documents, Salesforce, sécurité — aide d'expert",
    feat_chat_li4: "Historique des conversations — reprenez à tout moment",
    stat_1_v: "6",
    stat_2_v: "3+",
    stat_3_v: "8s",
    stat_4_v: "99.9%",
    feat_video_li1: "Scripts dans votre langue (TR · EN · ES · FR · DE · IT · PT · JA · ZH)",
    feat_video_li2: "9 voix IA naturelles — choisissez le ton parfait",
    feat_video_li3: "Visuels IA cinématographiques — aucune apparence de stock-footage",
    feat_video_li4: "Téléchargez MP4 + voix off + scènes",
    lp_plan_free_desc: "Parfait pour essayer Lumioo et un usage personnel.",
    lp_plan_free_f1: "5 images IA / mois",
    lp_plan_free_f2: "10 messages de chat / jour",
    lp_plan_free_f3: "Les 6 langues",
    lp_plan_creator_desc: "Pour les freelanceurs, étudiants et créateurs.",
    lp_plan_creator_f1: "15 vidéos / mois — jusqu'à 3 minutes",
    lp_plan_creator_f2: "Chat illimité avec image + voix",
    lp_plan_creator_f3: "Sans filigrane",
    lp_plan_creator_f4: "Vitesse de réponse prioritaire",
    lp_plan_pro_desc: "Pour les professionnels et petites équipes.",
    lp_plan_pro_f1: "50 vidéos / mois — jusqu'à 20 minutes",
    lp_plan_pro_f2: "Tout ce qui est en Creator",
    lp_plan_pro_f3: "Sortie HD 1080p",
    lp_plan_pro_f4: "Support prioritaire",
    lp_plan_pro_f5: "✨ Chat CV & révision — illimité (PDF/Word/image)",
    lp_plan_power_desc: "Pour les utilisateurs intensifs et créateurs power.",
    lp_plan_power_f1: "Tout dans Pro",
    lp_plan_power_f2: "500 images IA/mois (HD)",
    lp_plan_power_f3: "GPT-5 · 1500 messages, Opus 4.5 · 100/mois",
    lp_plan_power_f4: "Support prioritaire · usage équitable",
    lp_plan_power_f5: "✨ Chat CV & révision — illimité + prioritaire",
    lp_pricing_trust1: "Sécurisé par Stripe",
    lp_pricing_trust2: "Annulez à tout moment",
    lp_pricing_trust3: "Conforme au RGPD",
    auth_eyebrow_login: "Connectez-vous à",
    auth_eyebrow_register: "Créez votre",
    auth_h1_login: "Bienvenue.",
    auth_h1_register: "compte Lumioo.",
    auth_sub_login: "Continuez où vous vous étiez arrêté.",
    auth_sub_register: "Obtenez 50 crédits gratuits pour commencer.",
    auth_name: "Nom",
    auth_email: "E-mail",
    auth_password: "Mot de passe",
    auth_signin: "Se connecter",
    auth_create: "Créer un compte",
    auth_no_account: "Pas encore de compte ?",
    auth_have_account: "Vous avez déjà un compte ?",
    auth_forgot: "Mot de passe oublié ?",
    fp_eyebrow: "Récupération de compte",
    fp_title: "Réinitialisez votre mot de passe",
    fp_subtitle: "Entrez l'e-mail associé à votre compte et nous vous enverrons un lien de réinitialisation.",
    fp_send_btn: "Envoyer le lien de réinitialisation",
    fp_back_login: "Retour à la connexion",
    fp_sent_title: "Vérifiez votre boîte de réception",
    fp_sent_body: "Si un compte existe pour {email}, un lien de réinitialisation est en route. Il est valide pendant 1 heure.",
    fp_sent_hint: "Vous ne le voyez pas ? Vérifiez vos spams ou réessayez dans quelques minutes.",
    rp_title: "Définir un nouveau mot de passe",
    rp_subtitle: "Choisissez un mot de passe fort — au moins 8 caractères.",
    rp_new_password: "Nouveau mot de passe",
    rp_confirm_password: "Confirmez le mot de passe",
    rp_submit_btn: "Enregistrer le nouveau mot de passe",
    rp_mismatch: "Les mots de passe ne correspondent pas",
    rp_too_short: "Le mot de passe doit contenir au moins 8 caractères",
    rp_invalid: "Ce lien de réinitialisation est invalide ou expiré.",
    rp_success: "Mot de passe mis à jour. Vous êtes connecté.",
    rp_no_token_title: "Aucun jeton de réinitialisation trouvé",
    rp_no_token_body: "Ce lien semble cassé. Veuillez demander un nouvel e-mail de réinitialisation.",
    rp_request_new: "Demander un nouveau lien",
    auth_create_one: "Créez-en un",
    auth_demo: "Compte de démonstration",
    welcome_back: "Bienvenue !",
    account_created: "Compte créé. Bienvenue !",
    auth_failed: "L'authentification a échoué",
    iv_eyebrow: "Pratique d'entretien",
    iv_h1: "Pratiquez n'importe quel entretien. À haute voix.",
    iv_sub: "Téléchargez vos feuilles de questions sous forme de photos. Lumioos extrait chaque Q&R, crée votre banque privée et vous teste — par voix ou texte. Parfait pour les entretiens de citoyenneté USCIS, carte verte, emploi et certification.",
    iv_my_banks: "Mes banques de questions",
    iv_total: "total",
    iv_loading: "Chargement…",
    iv_empty_title: "Aucune banque de questions pour le moment",
    iv_empty_sub: "Créez-en une ci-dessus, puis téléchargez une photo de votre feuille d'étude ou ajoutez des questions manuellement.",
    iv_questions: "questions",
    iv_open: "Ouvrir",
    iv_create: "Créer une banque",
    iv_bank_name_ph: "Nom de la banque (ex. USCIS Civics)",
    iv_bank_desc_ph: "Brève description (optionnel)",
    iv_bank_created: "Banque créée",
    iv_create_fail: "Impossible de créer la banque",
    iv_confirm_delete: "Supprimer cette banque et toutes ses questions ?",
    iv_deleted: "Supprimé",
    iv_delete_fail: "La suppression a échoué",
    iv_load_fail: "Échec du chargement",
    iv_hint_title: "Comment ça marche",
    iv_hint_sub: "Prenez une photo de n'importe quelle feuille de préparation d'entretien (test de citoyenneté américaine, questions de carte verte, préparation d'entretien d'embauche, questions de certification). Lumioos la lit avec la vision IA, extrait chaque question avec toutes les réponses acceptées et la conserve éternellement. Ensuite, entraînez-vous par voix (l'IA pose la question, vous répondez avec votre micro) ou par texte.",
    iv_back_library: "Retour à la bibliothèque",
    iv_practice: "Pratiquer",
    iv_start_h2: "Commencer l'entretien",
    iv_mode_text: "Mode texte",
    iv_mode_voice: "Mode voix",
    iv_mode_text_hint: "Lisez chaque question, tapez votre réponse. L'IA évalue par sens, pas par mots exacts.",
    iv_mode_voice_hint: "L'IA énonce chaque question. Appuyez sur le micro, répondez à haute voix. L'IA transcrit et évalue.",
    iv_order_label: "Ordre des questions",
    iv_order_random: "Aléatoire",
    iv_order_sequential: "Séquentiel",
    iv_limit_label: "Combien de questions",
    iv_limit_all: "Toutes ({n} questions)",
    iv_limit_all_short: "Toutes",
    iv_limit_max: "max {n}",
    iv_limit_clamped: "La banque n'a que {n} questions — les utiliser toutes.",
    iv_or: "ou",
    iv_start_now: "Commencer maintenant",
    iv_start_fail: "Impossible de démarrer la session",
    iv_no_questions_start: "Ajoutez d'abord au moins une question",
    iv_upload_title: "Téléchargez des images ou des PDF",
    iv_upload_sub: "Photos, captures d'écran ou fichiers PDF de feuilles de questions. L'IA extrait automatiquement chaque Q&R (jusqu'à 100 fichiers, les PDF sont lus page par page).",
    iv_choose_images: "Choisir des images",
    iv_choose_files: "Choisir des images ou des PDF",
    iv_extracting: "Extraction des Q&R…",
    iv_extracted: "questions ajoutées à partir des images",
    iv_extract_fail: "Impossible d'extraire les questions",
    iv_budget_partial: "Ajout de {n} questions, mais votre clé IA n'a plus de crédit à mi-parcours. Rechargez pour obtenir le reste.",
    iv_partial_extract: "Ajout de {n} questions ({f} lots échoués — réessayez pour obtenir le reste).",
    iv_progress_label: "Traitement du lot {c} sur {n}…",
    feat_iv_eyebrow: "Pratique d'entretien",
    feat_iv_title: "Entraînez-vous pour n'importe quel entretien — à haute voix ou par écrit",
    feat_iv_desc: "Téléchargez vos feuilles d'étude (photo ou PDF). Lumioos extrait chaque Q&R, puis vous teste avec un intervieweur IA en direct qui énonce les questions, écoute vos réponses parlées et évalue par sens — strict selon la clé de réponse de l'examen.",
    feat_iv_li1: "Préparation à la citoyenneté USCIS et à la carte verte",
    feat_iv_li2: "Pratique d'entretien d'emploi et technique",
    feat_iv_li3: "Modes voix + entraînement auditif (questions masquées)",
    feat_iv_li4: "Évaluation stricte + rapport par question à la fin",
    feat_iv_cta: "Commencer la pratique d'entretien",
    feat_iv_use_cases: "USCIS · Carte verte · Emploi · Certifications · N'importe quoi",
    feat_iv_badge: "NOUVEAU",
    iv_speed_label: "Vitesse de parole",
    iv_speed_slow: "Lent",
    iv_speed_normal: "Normal",
    iv_speed_fast: "Rapide",
    iv_speed_faster: "Plus rapide",
    iv_speed_hint: "Vitesse à laquelle l'intervieweur énonce les questions.",
    iv_range_label: "Plage de questions",
    iv_range_hint: "1 à {n}",
    iv_range_from: "De",
    iv_range_to: "à",
    iv_range_clear: "effacer",
    iv_range_note: "Laissez vide pour utiliser toutes les questions. La plage s'applique à l'ordre source (ex. 1 → 50).",
    iv_range_invalid: "La fin doit être ≥ au départ.",
    iv_deleted_undo: "Banque supprimée ({n} questions). Vous pouvez annuler dans les 10 secondes.",
    iv_q_deleted_undo: "Question supprimée. Vous pouvez annuler dans les 8 secondes.",
    iv_undo: "Annuler",
    iv_restored: "Restauré.",
    iv_restore_fail: "Impossible de restaurer",
    iv_delete_warning: "Suppression permanente",
    iv_delete_q: "Supprimer cette banque et ses {n} questions ?",
    iv_delete_desc: "Vous êtes sur le point de supprimer la banque",
    iv_delete_btn: "Supprimer la banque",
    iv_voice_label: "Voix de l'intervieweur",
    iv_voice_female: "Féminin (Nova)",
    iv_voice_male: "Masculin (Ash) — doux",
    iv_voice_female2: "Féminin (Shimmer)",
    iv_voice_male2: "Masculin (Fable) — amical",
    iv_voice_hint: "Choisissez la voix de votre intervieweur IA.",
    iv_finish_early: "Terminer l'examen",
    iv_finish_early_confirm: "Terminer l'examen maintenant ? Vous avez répondu à {n} sur {total} questions.",
    iv_finish_early_btn: "Terminer maintenant",
    iv_keep_going: "Continuer",
    iv_finishing: "Fin…",
    iv_congrats: "Félicitations ! 🎉",
    iv_congrats_sub: "Vous avez réussi avec un excellent score.",
    iv_good_job: "Bien joué !",
    iv_good_job_sub: "Performance solide — continuez à pratiquer.",
    iv_keep_practising: "Continuez à pratiquer",
    iv_keep_practising_sub: "Vérifiez vos mauvaises réponses ci-dessous et réessayez.",
    iv_score_label: "Score",
    iv_wrong_review: "Vérifier les mauvaises réponses",
    iv_resume_eyebrow: "En cours",
    iv_resume_title: "Vous avez un entretien inachevé",
    iv_resume_progress: "{done} / {total} questions répondues jusqu'à présent",
    iv_resume_btn: "Reprendre",
    iv_resume_discard: "Abandonner",
    iv_resume_discard_confirm: "Abandonner cette session inachevée et recommencer ?",
    iv_resume_discarded: "Session abandonnée",
    iv_large_upload_warn: "Votre téléchargement est environ {mb}MB. Les très gros téléchargements peuvent échouer sur les connexions lentes. Continuer ?",
    iv_trash: "Corbeille",
    iv_trash_title: "Récemment supprimé",
    iv_trash_banks: "Banques supprimées",
    iv_trash_questions: "Questions supprimées",
    iv_trash_empty: "La corbeille est vide.",
    iv_trash_load_fail: "Impossible de charger la corbeille",
    iv_purge: "Supprimer définitivement",
    iv_purge_confirm: "Supprimer définitivement cette banque ? Cela ne peut pas être annulé.",
    iv_progress_preparing: "Préparation des fichiers…",
    iv_report_title: "Analyse question par question",
    iv_your_answer: "Votre réponse",
    iv_skipped: "(ignoré)",
    iv_max_10: "Max 10 images à la fois",
    iv_max_100: "Max 100 images à la fois",
    iv_manual_title: "Ajouter manuellement",
    iv_manual_sub: "Tapez une question et les réponses que vous voulez que Lumioos accepte.",
    iv_add_question: "Ajouter une question",
    iv_cancel: "Annuler",
    iv_question: "Question",
    iv_accepted_answers: "Réponses acceptées (une par ligne)",
    iv_accepted_ph: "Exécutif\\nLégislatif\\nJudiciaire\\nCongres\\nPrésident",
    iv_min_required: "Minimum requis",
    iv_min_hint: "Combien des réponses acceptées l'utilisateur doit-il donner ? (Généralement 1)",
    iv_add: "Ajouter",
    iv_q_added: "Question ajoutée",
    iv_add_fail: "Impossible d'ajouter la question",
    iv_need_q_and_a: "Question et au moins 1 réponse requises",
    iv_question_list: "Questions",
    iv_no_questions: "Aucune question pour le moment. Téléchargez une photo ou ajoutez manuellement.",
    iv_confirm_delete_q: "Supprimer cette question ?",
    iv_back_bank: "Retour à la banque",
    iv_voice_interview: "Entretien vocal",
    iv_text_interview: "Entretien texte",
    iv_record: "Enregistrer la réponse",
    iv_stop_record: "Arrêter et transcrire",
    iv_transcribing: "Transcription…",
    iv_voice_answer_ph: "Votre réponse transcrite apparaîtra ici. Vous pouvez également modifier avant de soumettre.",
    iv_text_answer_ph: "Tapez votre réponse ici…",
    iv_submit: "Soumettre",
    iv_skip: "Ignorer",
    iv_correct: "Correct",
    iv_wrong: "Pas tout à fait",
    iv_accepted_were: "Les réponses acceptées étaient :",
    iv_see_results: "Voir les résultats",
    iv_next_question: "Question suivante",
    iv_need_n_answers: "Donnez au moins {n} réponses différentes",
    iv_results: "Résultats",
    iv_accuracy: "précision",
    iv_restart: "Recommencer la banque",
    iv_speak: "Énoncer la question",
    iv_show_question: "Afficher la question",
    iv_hide_question: "Masquer la question (entraînement auditif)",
    iv_question_hidden: "Question masquée — écoutez l'audio",
    iv_voice_intro_line: "Bonjour ! Quand vous êtes prêt, appuyez sur Démarrer et je commencerai à poser les questions.",
    iv_voice_ready: "Je suis prêt, commençons",
    iv_show_q_label: "Afficher les questions à l'écran ?",
    iv_show_q_on: "Afficher",
    iv_show_q_off: "Masquer (entraînement auditif)",
    iv_show_q_on_hint: "Le texte de la question est visible lors de la pratique.",
    iv_show_q_off_hint: "Seul l'audio est lu — excellent pour l'entraînement auditif.",
    iv_starred_label: "Quelles questions poser ?",
    iv_starred_all: "Toutes les questions",
    iv_starred_only: "Uniquement les questions marquées comme importantes",
    iv_starred_hint: "Marquez (⭐) les questions sur lesquelles vous voulez vous concentrer. Lumioos marque automatiquement les questions importantes/susceptibles dans votre source.",
    iv_starred_badge: "Important",
    iv_star: "Marquer cette question",
    iv_unstar: "Retirer la marque",
    iv_tts_fail: "Impossible de lire l'audio de la question",
    iv_stt_fail: "Impossible de transcrire l'audio",
    iv_mic_denied: "Accès au microphone refusé",
    iv_need_answer: "Tapez ou enregistrez d'abord une réponse",
    iv_submit_fail: "Impossible de soumettre la réponse",
    iv_skip_fail: "Impossible d'ignorer",
    side_credits: "Crédits",
    side_language: "Langue",
    side_integrations: "Intégrations",
    side_help: "Aide et jetons",
    auth_google: "Continuer avec Google",
    auth_or: "ou avec e-mail",
    integrations_eyebrow: "Connecter",
    integrations_h1: "Intégrations",
    integrations_sub: "Connectez Salesforce, Splunk, Defender, Trend Micro, SentinelOne, CrowdStrike et plus. Lumioo récupérera vos cas et les résoudra.",
    help_eyebrow: "Documentation",
    help_h1: "Guide des jetons et clés API",
    help_faq: "Questions fréquemment posées",
    help_sub: "Guides étape par étape pour obtenir un jeton API de chaque plateforme supportée. Cliquez sur n'importe quel bouton 'Ouvrir' pour accéder directement à la bonne page.",
    dash_eyebrow: "Tableau de bord",
    dash_hello: "Bonjour",
    dash_sub: "Choisissez un outil et commencez à produire.",
    dash_credits_label: "Crédits disponibles",
    dash_open: "Ouvrir l'outil",
    dash_chat_card_desc: "Demandez n'importe quoi : Salesforce, cybersécurité, code, projets.",
    dash_video_card_desc: "Sujet → package YouTube complet + vidéo MP4.",
    dash_interview_card_desc: "Entraîne-toi aux entretiens d'embauche avec un intervieweur IA.",
    dash_pro_only_badge: "Creator & Pro",
    dash_card_unlock: "Améliorer pour débloquer",
    dash_recent_eye: "Projets récents",
    dash_recent_h2: "Votre dernier travail",
    dash_view_all: "Voir tout",
    dash_no_projects: "Aucun projet encore. Commencez par",
    dash_or: "ou",
    chat_eyebrow: "Outil",
    chat_h1: "Chat IA",
    chat_mode_image_hint: "Créer des images",
    chat_mode_code_hint: "Aide rapide pour le code",
    chat_mode_cv_hint: "Créer un CV",
    chat_mode_video_hint: "Créer une vidéo",
    model_desc_haiku: "Chat rapide du quotidien",
    model_desc_sonnet: "Réflexion et écriture approfondies",
    model_desc_gpt4o: "Polyvalent équilibré",
    model_desc_gemini: "Multimodal et vision",
    model_desc_gpt5: "Tâches les plus difficiles · raisonnement de pointe",
    model_badge_fast: "RAPIDE",
    model_locked_toast: "{model} est inclus dans le plan {tier}. Passez au niveau supérieur pour le débloquer.",
    chat_sub: "Demandez n'importe quoi — rédaction, traduction, conseils, code, apprentissage, idées.",
    chat_new: "Nouveau chat",
    chat_sessions: "Conversations",
    chat_empty_title: "Comment puis-je vous aider aujourd'hui ?",
    chat_empty_sub: "Commencez à taper ou essayez l'une de ces invitations.",
    chat_placeholder: "Demandez à Lumioo n'importe quoi…",
    chat_model: "Modèle",
    admin_finance_title: "Finances",
    admin_finance_sub: "Revenus, coûts, profit/perte ce mois. Estimations — Stripe est la source vraie.",
    admin_finance_prev: "précédent",
    admin_finance_refresh: "Actualiser",
    admin_fin_revenue: "Revenus",
    admin_fin_llm_cost: "Coût IA",
    admin_fin_image_cost: "Coût images",
    admin_fin_net_profit: "Profit net",
    admin_fin_net_loss: "PERTE nette",
    admin_fin_margin: "Marge",
    admin_fin_paid_tx: "tx payées",
    admin_fin_messages: "messages",
    admin_fin_images: "images",
    chat_delete_all: "Tout supprimer",
    chat_delete_all_confirm: "Êtes-vous sûr de vouloir supprimer TOUTES les {n} conversations ? Ceci ne peut pas être annulé.",
    chat_delete_all_done: "{n} conversations supprimées",
    chat_speed: "Vitesse",
    chat_gpt5_meter_label: "Messages GPT-5 ce mois",
    chat_mode_quick: "Rapide",
    chat_mode_quick_sub: "Gemini Flash · rapide",
    chat_mode_smart: "Intelligent",
    chat_mode_smart_sub: "Sonnet 4.6 · plus profond",
    chat_mode_genius: "Génie",
    chat_mode_genius_sub: "GPT-5 · raisonnement top",
    chat_mode_master: "Maître",
    chat_mode_master_sub: "Opus 4.5 · le plus puissant",
    chat_opus_meter_label: "Maître (Opus 4.5) ce mois",
    chat_delete: "Supprimer",
    chat_copy: "Copier",
    chat_copied: "Copié",
    chat_no_sessions: "Aucune conversation pour le moment.",
    chat_suggest_1: "Expliquez une alerte Splunk SPL pour les connexions administrateur échouées",
    chat_suggest_2: "Écrivez Python pour dédupliquer une liste de dicts",
    chat_suggest_3: "Rédigez une réponse de cas Salesforce pour une page Lightning lente",
    chat_suggest_4: "Planifiez un MVP SaaS pour le traitement des factures IA",
    video_eyebrow: "Outil",
    video_h1: "Producteur vidéo IA",
    video_sub: "Un sujet → un package YouTube complet avec un MP4 fini.",
    video_topic: "Sujet",
    video_topic_ph: "ex. Comment l'IA restructurera les revenus en ligne en 2026",
    video_tone: "Ton",
    video_length: "Longueur",
    video_voice: "Voix",
    video_generate: "Générer le package vidéo",
    video_generating: "Production de votre vidéo… (30–90s)",
    video_loading_sub: "Rédaction de script, peinture de scènes, enregistrement de voix, assemblage MP4…",
    video_empty: "Vos éléments vidéo générés apparaîtront ici.",
    video_title_l: "Titre",
    video_desc_l: "Description",
    video_voiceover: "Voix off",
    video_download_audio: "Télécharger MP3",
    video_download_video: "Télécharger MP4",
    video_scenes: "Scènes",
    video_copy_meta: "Copier les métadonnées",
    video_meta_copied: "Métadonnées copiées",
    video_no_mp4: "MP4 non disponible — vous pouvez toujours utiliser les scènes + l'audio séparément.",
    scene: "Scène",
    image_unavailable: "Image non disponible",
    projects_eyebrow: "Historique",
    projects_h1: "Vos projets",
    projects_sub: "Tout ce que vous avez produit avec Lumioo.",
    projects_empty: "Aucun projet pour le moment.",
    try_chat: "Essayer AI Chat",
    try_video: "Essayer Video Producer",
    video_ready: "Package vidéo prêt",
    answer_ready: "Réponse prête",
    stage_queued: "En attente…",
    stage_script: "Rédaction du script…",
    stage_images_audio: "Peinture de scènes et enregistrement de voix…",
    stage_stitching: "Assemblage MP4…",
    stage_done: "Terminé",
    chat_attach_image: "Joindre une image",
    chat_websearch_label: "Web",
    chat_websearch_on: "Recherche web ACTIVÉE — Lumioos consulte des données récentes avant de répondre",
    chat_enable_web_retry: "Activer la recherche web et réessayer",
    chat_websearch_off: "Recherche web DÉSACTIVÉE — Lumioos utilise ses connaissances. Activez pour l'actualité.",
    chat_start_recording: "Commencer voix",
    chat_stop_recording: "Arrêter et transcrire",
    chat_image_attached: "Image prête",
    chat_image_remove: "Supprimer l'image",
    chat_only_image: "Veuillez choisir un fichier image",
    chat_image_too_large: "Image trop grande (max 8 MB)",
    chat_drop_title: "Déposez votre image pour la joindre",
    chat_drop_sub: "PNG / JPG / WebP — max 8 Mo",
    chat_upgrade_title: "Limite quotidienne atteinte",
    chat_upgrade_sub: "Vous avez utilisé {used} sur {limit} messages aujourd'hui sur le plan Gratuit. Passez à un plan supérieur pour continuer — la limite se réinitialise à minuit UTC.",
    chat_upgrade_benefits: "Ce que vous débloquez",
    chat_upgrade_b1: "Messages de chat illimités",
    chat_upgrade_b2: "Accès complet à la pratique des entretiens",
    chat_upgrade_b3: "Image + voix dans le chat",
    chat_upgrade_b4: "Pas de filigrane sur les vidéos",
    chat_upgrade_cta: "Voir les plans",
    chat_upgrade_later: "Peut-être plus tard",
    iv_gate_title: "Pratique d'Entretien est verrouillée",
    iv_gate_sub: "Cette fonctionnalité est réservée aux abonnés Creator et Pro. Passez à un plan supérieur pour débloquer des banques de questions illimitées, le mode vocal et des rapports détaillés.",
    iv_gate_what_you_get: "Ce que vous débloquez",
    iv_gate_b1: "Banques de questions illimitées (téléchargement PDF / image)",
    iv_gate_b2: "Modes d'entretien vocal + texte avec évaluation AI",
    iv_gate_b3: "Intervieweur AI animé + 4 voix",
    iv_gate_b4: "Rapports de performance détaillés + résumé par email",
    iv_gate_cta: "Voir les plans",
    iv_gate_back: "Retour à Lumioos",
    vd_gate_title: "Producteur Vidéo IA verrouillé",
    vd_gate_sub: "Vraies vidéos IA avec Sora 2 — uniquement plans Creator et Pro.",
    vd_gate_what_you_get: "Ce que tu débloques",
    vd_gate_b1: "Vrais clips vidéo IA cinématographiques (Sora 2)",
    vd_gate_b2: "Vidéos multi-scènes avec narration IA en 9 langues",
    vd_gate_b3: "Téléchargement MP4 1280×720 — sans filigrane",
    vd_gate_b4: "Jusqu'à 15 vidéos/mois en Creator, 50 en Pro",
    vd_gate_cta: "Améliorer pour débloquer",
    vd_gate_back: "Retour au Tableau de bord",
    cancel_btn: "Annuler l'abonnement",
    cancel_tooltip: "Vous garderez l'accès jusqu'à la date d'expiration",
    cancel_confirm: "Annuler votre abonnement ? Vous garderez l'accès complet jusqu'à la date d'expiration actuelle.",
    cancel_ok: "Abonnement annulé — accès maintenu jusqu'à l'expiration.",
    cancel_ok_with_date: "Abonnement annulé. Vous conserverez vos avantages jusqu'au {date}.",
    cancel_fail: "Impossible d'annuler — veuillez réessayer.",
    bug_open: "Signaler un bug",
    bug_title: "Signaler un bug ou un problème",
    bug_sub: "Dites-nous ce qui ne va pas. Ajoutez une capture ou un PDF si ça aide.",
    bug_placeholder: "Que vous attendiez-vous à voir se produire ? Que s'est-il vraiment passé ?",
    bug_attach: "Joindre une capture ou un PDF (optionnel)",
    bug_send: "Envoyer le rapport",
    bug_sending: "Envoi...",
    bug_thanks: "Merci ! Nous allons examiner cela.",
    bug_send_fail: "Impossible d'envoyer — veuillez réessayer.",
    bug_message_short: "Veuillez écrire au moins 3 caractères.",
    bug_file_too_large: "Fichier trop volumineux (max 5 Mo)",
    bug_only_image_or_pdf: "Seuls les images ou PDF sont autorisés",
    chat_describe_image: "Qu'voyez-vous dans cette image ?",
    chat_voice_added: "Voix transcrite",
    chat_voice_empty: "Impossible d'entendre quelque chose — réessayez",
    chat_mic_denied: "Accès au microphone refusé",
    chat_recording_ph: "Enregistrement… cliquez sur arrêter quand vous avez fini",
    video_language: "Langue",
    project_view: "Afficher",
    project_delete: "Supprimer",
    project_delete_confirm: "Confirmer",
    project_cancel: "Annuler",
    project_deleted: "Projet supprimé",
    project_confirm_delete: "Supprimer définitivement ce projet ?",
    project_back: "Retour aux projets",
    project_not_found: "Projet non trouvé",
    project_no_video: "Aucun MP4 enregistré pour ce projet.",
    project_download: "Télécharger MP4",
    project_download_started: "Téléchargement démarré",
    pricing_expires: "se renouvelle",
    pricing_popular: "Plus populaire",
    pricing_month_short: "mois",
    pricing_free_default: "Plan par défaut",
    pricing_redirecting: "Redirection…",
    pricing_disclaimer: "Paiements traités par Stripe. En vous abonnant, vous acceptez la facturation mensuelle. Annulez à partir de votre compte à tout moment.",
    pricing_mobile_note_title: "Les prix affichés concernent le paiement web.",
    pricing_mobile_note_body: "Les abonnements achetés dans notre app iOS ou Android peuvent coûter plus cher en raison des frais App Store (jusqu'à 30%). Économisez en vous abonnant ici sur le web.",
    pricing_faq_title: "Questions fréquentes",
    pricing_faq_why_pro_q: "Pourquoi Pro coûte $29 ?",
    pricing_faq_why_pro_a: "Pro inclut maintenant Sora-2 vidéo, GPT-5, Claude Opus 4.5, GPT Image 1 et le chat illimité. Acheté séparément, cela coûterait plus de $80/mois (ChatGPT Plus $20 + Runway $15 + Midjourney $10 + Claude Pro $20). On regroupe tout pour $29 — vous économisez 60%+. Les clients Pro existants conservent leur tarif de $10.",
    pricing_faq_cancel_q: "Puis-je annuler à tout moment ?",
    pricing_faq_cancel_a: "Oui — un clic depuis Facturation. Pas de remboursement pour le mois en cours, mais vous gardez Pro jusqu'à la fin de la période. Jamais de renouvellement sans avertissement.",
    pricing_faq_existing_q: "Je me suis inscrit avant — mon prix change ?",
    pricing_faq_existing_a: "Non. Si vous payez déjà $5 (Creator) ou $10 (Pro), votre abonnement Stripe reste à ce prix jusqu'à ce que VOUS annuliez ou changiez de plan. Seuls les nouveaux inscrits voient le nouveau prix.",
    billing_checking: "Confirmation du paiement…",
    billing_checking_sub: "Cela prend généralement quelques secondes.",
    billing_paid: "Paiement réussi 🎉",
    billing_paid_sub: "Plan activé :",
    billing_pending: "Traitement en cours",
    billing_pending_sub: "Actualisez dans un moment — le plan s'activera automatiquement.",
    billing_expired: "Session expirée",
    billing_failed: "Paiement non complété",
    billing_to_dashboard: "Aller au tableau de bord",
    billing_back: "Retour à la tarification",
    video_already_running: "Une vidéo est déjà en cours de génération. Attendez qu'elle se termine ou ignorez-la.",
    video_dismiss_confirm: "Ignorer ce travail ? (La vidéo continuera à être générée en arrière-plan et apparaîtra toujours dans Projets.)",
    pricing_year_short: "an",
    pricing_yearly_savings: "Vous économisez ${saved} par an",
    pricing_admin_unlimited: "Admin — Illimité (aucune limite)",
    pricing_admin_skip: "Admin : illimité",
    redeem_required: "Entrez un code",
    redeem_success: "Code appliqué",
    iv_delete_type_to_confirm: 'Tapez "{name}" pour confirmer :',
    oauth_err_title: "Salesforce n'a pas autorisé la connexion",
    oauth_err_blocked_subtitle: "Ce n'est pas une erreur Lumioos — c'est la politique de sécurité de votre org. Solution en 2 min :",
    oauth_err_generic_subtitle: "Échec OAuth. Essayez les étapes ou reconnectez.",
    oauth_err_step1: "Salesforce → Setup → cherchez 'Connected Apps OAuth Usage'",
    oauth_err_step2: "Trouvez 'Lumioos' → cliquez 'Allow' / 'Install'",
    oauth_err_step3: "Revenez ici et cliquez 'Reconnecter'",
    oauth_err_alt_title: "Solution permanente :",
    oauth_err_alt_step1: "Setup → App Manager → 'Lumioos' → View",
    oauth_err_alt_step2: "Manage → Edit Policies → 'All users may self-authorize'",
    oauth_err_alt_step3: "Save → reconnectez",
    oauth_err_reconnect: "Reconnecter",
    oauth_err_close: "Fermer",
    oauth_err_raw: "Code d'erreur technique",
    pwa_install_lumioos: "Installer Lumioos",
    pwa_install_subtitle: "Ajouter à l'écran d'accueil — pas besoin d'app store.",
    pwa_install_short: "Installer",
    pwa_not_now: "Pas maintenant",
    pwa_got_it: "Compris",
    pwa_ios_safari_required: "Ouvrez ce site dans Safari pour installer",
    pwa_ios_safari_required_sub: "Sur iPhone, seul Safari peut ajouter des apps à l'écran d'accueil. Copiez ce lien et collez-le dans Safari.",
    pwa_ios_copy_link: "Copier le lien",
    pwa_modal_title_ios: "Installer sur iPhone / iPad",
    pwa_modal_title_android: "Installer sur Android",
    pwa_modal_title_mac: "Installer sur Mac",
    pwa_modal_title_desktop: "Installer sur ordinateur",
    pwa_modal_ios_step1: "Touchez l'icône Partager en bas de Safari",
    pwa_modal_ios_step2: "Faites défiler et touchez \"Sur l'écran d'accueil\"",
    pwa_modal_ios_step3: "Touchez \"Ajouter\" en haut à droite",
    pwa_modal_ios_step4: "Lumioos apparaîtra sur votre écran d'accueil",
    pwa_modal_android_step1: "Touchez le menu ⋮ en haut à droite de Chrome",
    pwa_modal_android_step2: "Touchez \"Ajouter à l'écran d'accueil\" ou \"Installer l'app\"",
    pwa_modal_android_step3: "Touchez \"Installer\" dans la popup",
    pwa_modal_android_step4: "Lumioos s'ouvre comme une app native",
    pwa_modal_mac_step1: "Cliquez sur l'icône d'installation dans la barre d'adresse (⊕)",
    pwa_modal_mac_step2: "OU : Menu Chrome (⋮) → \"Installer Lumioos…\"",
    pwa_modal_mac_step3: "Cliquez sur \"Installer\"",
    pwa_modal_mac_step4: "Lumioos s'ouvre dans sa propre fenêtre",
    pwa_modal_desktop_step1: "Cherchez l'icône d'installation dans la barre d'adresse (⊕ ou ↓)",
    pwa_modal_desktop_step2: "Si vous ne la voyez pas, ouvrez le menu du navigateur",
    pwa_modal_desktop_step3: "Confirmez en cliquant sur \"Installer\"",
    pwa_modal_desktop_step4: "Lumioos s'ouvre dans sa propre fenêtre",
    // ---------------- Jarvis (Centre de contrôle + Aide) ----------------
    jarvis_paired_computers_title: "Ordinateurs appairés",
    jarvis_pair_a_computer_btn: "Appairer un ordinateur",
    jarvis_no_devices_hint: "Aucun ordinateur appairé pour le moment. Cliquez sur \"Appairer un ordinateur\" pour commencer.",
    jarvis_send_command_title: "Envoyer une commande",
    jarvis_command_placeholder: "Ouvre OBS, lance Chrome sur mylumioos.com, enregistre 30 secondes, arrête et vérifie la vidéo",
    jarvis_target_label: "Cible : {name}",
    jarvis_pair_first_hint: "Appairez un ordinateur pour envoyer des commandes",
    jarvis_send_to_jarvis_btn: "Envoyer à Jarvis",
    jarvis_task_history_title: "Historique des tâches",
    jarvis_no_tasks_hint: "Aucune tâche pour l'instant. Envoyez votre première commande ci-dessus.",
    jarvis_device_selected: "Sélectionné",
    jarvis_device_select: "Sélectionner",
    jarvis_device_revoked_badge: "Révoqué",
    jarvis_status_online: "En ligne",
    jarvis_status_offline_last_seen: "Hors ligne · vu il y a {ago}",
    jarvis_status_never: "jamais",
    jarvis_status_unknown: "inconnu",
    jarvis_toast_type_command_first: "Écris d'abord une commande",
    jarvis_toast_pair_first: "Appaire et sélectionne un ordinateur d'abord",
    jarvis_toast_task_queued: "Tâche en file — l'agent va s'en occuper.",
    jarvis_toast_monthly_limit: "Limite mensuelle atteinte ({max}). Passez à un plan supérieur.",
    jarvis_toast_task_queue_failed: "Impossible de mettre la tâche en file",
    jarvis_toast_revoke_confirm: "Révoquer cet ordinateur ? L'agent s'arrêtera immédiatement.",
    jarvis_toast_device_revoked: "Ordinateur révoqué",
    jarvis_toast_device_revoke_failed: "Impossible de révoquer l'ordinateur",
    jarvis_toast_task_cancelled: "Tâche annulée",
    jarvis_toast_task_cancel_failed: "Impossible d'annuler la tâche",
    jarvis_toast_delete_task_confirm: "Supprimer cette tâche de l'historique ?",
    jarvis_toast_task_deleted: "Tâche supprimée",
    jarvis_toast_task_delete_failed: "Impossible de supprimer la tâche",
    jarvis_toast_clear_all_tasks_confirm: "Supprimer tout l'historique ? Les tâches en cours sont conservées.",
    jarvis_toast_tasks_cleared: "{n} tâches supprimées",
    jarvis_toast_delete_device_confirm: "Supprimer cet ordinateur définitivement ? Son historique sera aussi effacé.",
    jarvis_toast_device_deleted: "Ordinateur supprimé",
    jarvis_clear_all_tasks_btn: "Tout effacer",
    jarvis_task_status_queued: "En file",
    jarvis_task_status_running: "En cours",
    jarvis_task_status_completed: "Terminée",
    jarvis_task_status_failed: "Échouée",
    jarvis_task_status_cancelled: "Annulée",
    jarvis_task_cancel_btn: "Annuler",
    jarvis_task_error_label: "Erreur :",
    jarvis_task_steps_label: "Étapes",
    jarvis_task_screenshots_label: "Captures ({n})",
    jarvis_task_result_label: "Résultat",
    jarvis_task_steps_count: "{n} étapes",
    jarvis_task_screenshots_count: "{n} captures",
    jarvis_time_seconds_ago: "il y a {n}s",
    jarvis_time_minutes_ago: "il y a {n}min",
    jarvis_time_hours_ago: "il y a {n}h",
    jarvis_time_days_ago: "il y a {n}j",
    jarvis_download_windows: "Télécharger pour Windows",
    jarvis_download_macos: "Télécharger pour macOS",
    jarvis_download_linux: "Télécharger pour Linux (version macOS)",
    jarvis_alt_downloads_title: "Vous utilisez un autre ordinateur ?",
    jarvis_sys_title: "Informations système",
    jarvis_sys_detected_os: "Système détecté",
    jarvis_sys_installed_agent: "Agent installé",
    jarvis_sys_latest_version: "Dernière version",
    jarvis_sys_status_connected: "Connecté",
    jarvis_sys_status_offline: "Hors ligne",
    jarvis_sys_status_unpaired: "Non appairé",
    jarvis_sys_not_installed: "Non installé",
    jarvis_sys_compat_uptodate: "Votre agent de bureau est à jour.",
    jarvis_sys_compat_outdated: "Votre agent v{installed} est antérieur à v{latest} — retéléchargez-le pour les dernières fonctionnalités.",
    jarvis_sys_compat_no_agent: "Installez l'agent de bureau ci-dessous pour activer Jarvis sur cet ordinateur.",
    jarvis_hc_intro_pill: "Installation et aide",
    jarvis_hc_title: "Centre d'installation et d'aide",
    jarvis_hc_subtitle: "Installez, connectez et dépannez votre agent de bureau en quelques minutes — sans tutoriel.",
    jarvis_hc_search_placeholder: "Rechercher un sujet, une étape, une erreur…",
    jarvis_hc_no_results: "Aucun résultat pour votre recherche. Essayez un autre mot.",
    jarvis_hc_tab_wizard: "Assistant d'installation",
    jarvis_hc_tab_troubleshoot: "Dépannage",
    jarvis_hc_tab_faq: "FAQ",
    jarvis_hc_video_title: "Tutoriel vidéo",
    jarvis_hc_video_placeholder: "Le tour guidé en vidéo arrive bientôt — suivez l'assistant étape par étape en attendant.",
    jarvis_hc_step_of: "Étape {n} sur {total}",
    jarvis_hc_prev: "Précédent",
    jarvis_hc_next: "Suivant",
    jarvis_hc_done: "Terminé",
    jarvis_hc_need_help: "Besoin d'aide sur cette étape ?",
    jarvis_hc_screenshot_soon: "L'aperçu de cette étape arrivera bientôt.",
    jarvis_hc_troubleshoot_title: "Problèmes courants et solutions",
    jarvis_hc_troubleshoot_subtitle: "Touchez un problème pour voir la cause probable et la solution rapide.",
    jarvis_hc_faq_title: "Questions fréquentes",
    jarvis_hc_faq_subtitle: "Tout ce qu'il faut savoir pour installer, exécuter et mettre à jour Jarvis.",
    jarvis_hc_problem_label: "Problème",
    jarvis_hc_cause_label: "Cause probable",
    jarvis_hc_solution_label: "Solution",
    jarvis_hc_step_download_title: "Télécharger l'agent de bureau",
    jarvis_hc_step_download_desc: "Cliquez sur le bouton de téléchargement pour obtenir le ZIP adapté à votre système (Windows ou macOS).",
    jarvis_hc_step_download_help: "Si rien ne se télécharge, vérifiez le bloqueur de fenêtres et le dossier Téléchargements.",
    jarvis_hc_step_extract_title: "Extraire le fichier téléchargé",
    jarvis_hc_step_extract_desc: "Clic droit sur le ZIP puis \"Extraire tout\" sous Windows, ou double-clic sous macOS.",
    jarvis_hc_step_extract_help: "N'exécutez jamais les fichiers directement depuis le ZIP — extrayez-le d'abord.",
    jarvis_hc_step_open_folder_title: "Ouvrir le dossier de l'agent",
    jarvis_hc_step_open_folder_desc: "Entrez dans le dossier fraîchement extrait \"lumioos-desktop-agent\" (généralement dans Téléchargements).",
    jarvis_hc_step_open_folder_help: "Gardez cette fenêtre ouverte : vous double-cliquerez sur plusieurs fichiers ici.",
    jarvis_hc_step_run_install_title: "Lancer install-agent",
    jarvis_hc_step_run_install_desc: "Double-cliquez sur install-agent.bat (Windows) ou install-agent.command (macOS). Il installe les paquets Python nécessaires.",
    jarvis_hc_step_run_install_help: "Un terminal s'ouvre puis se ferme seul. À ne faire qu'une fois.",
    jarvis_hc_step_generate_code_title: "Générer un code d'appairage",
    jarvis_hc_step_generate_code_desc: "Revenez ici, cliquez sur \"Appairer un ordinateur\" et copiez le code à 6 chiffres.",
    jarvis_hc_step_generate_code_help: "Les codes expirent au bout de 10 min et sont à usage unique. Régénérez-en un si besoin.",
    jarvis_hc_step_run_pair_title: "Lancer pair-agent",
    jarvis_hc_step_run_pair_desc: "Double-cliquez sur pair-agent.bat (Windows) ou pair-agent.command (macOS). Il demandera le code.",
    jarvis_hc_step_run_pair_help: "pair-agent ne s'exécute que la première fois. Ensuite, utilisez toujours start-agent.",
    jarvis_hc_step_paste_code_title: "Coller le code d'appairage",
    jarvis_hc_step_paste_code_desc: "Collez le code à 6 chiffres dans le terminal et appuyez sur Entrée pour autoriser l'ordinateur.",
    jarvis_hc_step_paste_code_help: "Sous Windows : clic droit pour coller. Sous macOS : Cmd+V. Rien ne s'affiche pendant la saisie, c'est normal.",
    jarvis_hc_step_connected_title: "Attendre \"Connecté avec succès\"",
    jarvis_hc_step_connected_desc: "Le terminal affichera \"✓ Appairé avec succès !\". Vous pouvez ensuite fermer la fenêtre.",
    jarvis_hc_step_connected_help: "En cas d'échec, vérifiez la connexion et régénérez un code — les anciens expirent vite.",
    jarvis_hc_step_run_start_title: "Lancer start-agent",
    jarvis_hc_step_run_start_desc: "Double-cliquez sur start-agent.bat (Windows) ou start-agent.command (macOS) pour mettre l'agent en ligne.",
    jarvis_hc_step_run_start_help: "Laissez ce terminal ouvert : le fermer met l'agent hors ligne.",
    jarvis_hc_step_return_jarvis_title: "Revenir à Jarvis",
    jarvis_hc_step_return_jarvis_desc: "Revenez sur cette page dans le navigateur — pas besoin de se déconnecter ni de rafraîchir.",
    jarvis_hc_step_return_jarvis_help: "L'ordinateur appairé apparaîtra dans la liste en quelques secondes.",
    jarvis_hc_step_verify_online_title: "Vérifier que l'ordinateur est En ligne",
    jarvis_hc_step_verify_online_desc: "Un point vert à côté du nom signifie que l'agent est prêt à recevoir des commandes.",
    jarvis_hc_step_verify_online_help: "Un point gris = start-agent n'est pas lancé. Relancez-le sur l'ordinateur.",
    jarvis_hc_step_first_command_title: "Envoyez votre première commande",
    jarvis_hc_step_first_command_desc: "Tapez \"open youtube.com\" puis Envoyer. Regardez l'historique pour voir les captures en direct.",
    jarvis_hc_step_first_command_help: "Commencez simple : ouvrir un site, puis testez OBS et les workflows en plusieurs étapes.",
    jarvis_hc_ts_windows_defender_title: "Windows Defender a bloqué l'app",
    jarvis_hc_ts_windows_defender_cause: "SmartScreen signale les .bat non signés par Microsoft.",
    jarvis_hc_ts_windows_defender_solution: "Cliquez sur \"Plus d'infos\" puis \"Exécuter quand même\". Windows retiendra votre choix.",
    jarvis_hc_ts_macos_security_title: "La sécurité macOS a bloqué l'app",
    jarvis_hc_ts_macos_security_cause: "Gatekeeper empêche par défaut les scripts non signés.",
    jarvis_hc_ts_macos_security_solution: "Réglages Système → Confidentialité et sécurité → \"Ouvrir quand même\" à côté du fichier bloqué.",
    jarvis_hc_ts_pairing_failed_title: "Échec de l'appairage",
    jarvis_hc_ts_pairing_failed_cause: "Le code a expiré (10 min), a été mal saisi ou déjà utilisé.",
    jarvis_hc_ts_pairing_failed_solution: "Cliquez à nouveau sur \"Appairer un ordinateur\" et collez le nouveau code dans pair-agent avant 10 min.",
    jarvis_hc_ts_agent_offline_title: "L'agent est hors ligne",
    jarvis_hc_ts_agent_offline_cause: "La fenêtre start-agent a été fermée ou l'ordinateur est en veille.",
    jarvis_hc_ts_agent_offline_solution: "Ouvrez le dossier de l'agent et double-cliquez à nouveau sur start-agent. Laissez le terminal ouvert.",
    jarvis_hc_ts_obs_not_detected_title: "OBS non détecté",
    jarvis_hc_ts_obs_not_detected_cause: "OBS Studio n'est pas installé ou son serveur WebSocket est désactivé.",
    jarvis_hc_ts_obs_not_detected_solution: "Installez OBS Studio 28+ puis cochez Outils → Paramètres du serveur WebSocket → \"Activer le serveur WebSocket\".",
    jarvis_hc_ts_browser_not_open_title: "Le navigateur ne s'ouvre pas",
    jarvis_hc_ts_browser_not_open_cause: "Le Chromium intégré à Playwright n'a pas été installé.",
    jarvis_hc_ts_browser_not_open_solution: "Relancez install-agent — il installe Playwright et Chromium automatiquement.",
    jarvis_hc_ts_python_failed_title: "Échec de l'installation de Python",
    jarvis_hc_ts_python_failed_cause: "Python 3.10+ n'est pas installé ou l'option \"Add to PATH\" n'a pas été cochée.",
    jarvis_hc_ts_python_failed_solution: "Installez Python 3.11 depuis python.org en cochant \"Add Python to PATH\", puis relancez install-agent.",
    jarvis_hc_ts_permission_denied_title: "Autorisation refusée",
    jarvis_hc_ts_permission_denied_cause: "macOS ou Windows a bloqué l'accès au clavier, à la souris ou à l'enregistrement d'écran.",
    jarvis_hc_ts_permission_denied_solution: "macOS : accordez Accessibilité + Enregistrement d'écran au Terminal. Windows : lancez start-agent en administrateur.",
    jarvis_hc_ts_connection_timeout_title: "Délai de connexion dépassé",
    jarvis_hc_ts_connection_timeout_cause: "Un pare-feu, un VPN ou un proxy bloque le HTTPS vers mylumioos.com.",
    jarvis_hc_ts_connection_timeout_solution: "Autorisez mylumioos.com dans le pare-feu/VPN ou désactivez le proxy, puis relancez start-agent.",
    jarvis_hc_ts_agent_stopped_title: "L'agent s'est arrêté brusquement",
    jarvis_hc_ts_agent_stopped_cause: "Le terminal a été fermé, l'ordinateur s'est mis en veille ou une mise à jour a été appliquée.",
    jarvis_hc_ts_agent_stopped_solution: "Relancez start-agent. Lisez les dernières lignes du terminal — la cause y est souvent claire.",
    jarvis_hc_ts_update_failed_title: "Échec de la mise à jour",
    jarvis_hc_ts_update_failed_cause: "Une nouvelle version de l'agent est disponible et votre copie locale est obsolète.",
    jarvis_hc_ts_update_failed_solution: "Téléchargez le ZIP le plus récent, extrayez-le par-dessus l'ancien dossier, puis relancez start-agent.",
    jarvis_hc_faq_install_every_time_q: "Faut-il installer l'agent à chaque fois ?",
    jarvis_hc_faq_install_every_time_a: "Non. install-agent ne s'exécute qu'une fois par ordinateur. Ensuite, un double-clic sur start-agent suffit.",
    jarvis_hc_faq_can_uninstall_q: "Puis-je désinstaller l'agent ?",
    jarvis_hc_faq_can_uninstall_a: "Oui. Fermez start-agent puis supprimez le dossier lumioos-desktop-agent. Vous pouvez aussi révoquer l'ordinateur ici.",
    jarvis_hc_faq_multiple_computers_q: "Puis-je appairer plusieurs ordinateurs ?",
    jarvis_hc_faq_multiple_computers_a: "Oui. Pro autorise 2 ordinateurs, Power jusqu'à 5. Chaque ordinateur nécessite son propre code à 6 chiffres.",
    jarvis_hc_faq_windows_and_macos_q: "Puis-je mélanger Windows et macOS ?",
    jarvis_hc_faq_windows_and_macos_a: "Bien sûr — Jarvis gère chaque ordinateur indépendamment, Windows et Mac cohabitent sans souci.",
    jarvis_hc_faq_auto_start_q: "L'agent démarre-t-il avec l'ordinateur ?",
    jarvis_hc_faq_auto_start_a: "Pas par défaut. Ajoutez start-agent aux éléments de démarrage de votre OS (Startup sur Windows, Login Items sur macOS).",
    jarvis_hc_faq_how_to_update_q: "Comment mettre à jour l'agent ?",
    jarvis_hc_faq_how_to_update_a: "Téléchargez le dernier ZIP depuis Jarvis, extrayez-le par-dessus le dossier existant, puis redémarrez start-agent.",
    jarvis_hc_faq_recordings_location_q: "Où sont sauvegardés les enregistrements ?",
    jarvis_hc_faq_recordings_location_a: "Dans le dossier de sortie par défaut d'OBS Studio — généralement Vidéos/OBS sous Windows ou Films sous macOS.",
    jarvis_hc_faq_change_recording_location_q: "Puis-je changer le dossier d'enregistrement ?",
    jarvis_hc_faq_change_recording_location_a: "Oui. Dans OBS : Fichier → Paramètres → Sortie → Enregistrement, choisissez le dossier voulu. Jarvis s'y adapte.",
    jarvis_hc_faq_remove_computer_q: "Comment supprimer un ordinateur appairé ?",
    jarvis_hc_faq_remove_computer_a: "Dans la liste, cliquez sur l'icône corbeille à côté de l'ordinateur. Son agent cesse d'accepter les commandes immédiatement.",
    },
  de: {
    nav_features: "Funktionen",
    nav_howit: "So funktioniert's",
    nav_pricing: "Preise",
    nav_download: "Download",
    lp_download_eyebrow: "Download",
    lp_download_h2: "Lumioos auf jedem Gerät",
    lp_download_h2_one: "Lumioos ist jetzt auf {platform}",
    lp_download_h2_two: "Lumioos für {p1} & {p2}",
    lp_download_sub: "Installiere Lumioos jetzt nativ unter Windows — Apple und Android folgen in Kürze.",
    lp_download_sub_one: "Installiere Lumioos nativ auf {platform}. Weitere Plattformen folgen bald.",
    lp_download_sub_two: "Installiere auf {p1} oder {p2} — weitere Geräte folgen bald.",
    lp_download_live: "Verfügbar",
    lp_download_soon: "Demnächst",
    lp_download_install: "Kostenlos installieren",
    lp_download_notify: "Bald verfügbar",
    nav_signin: "Anmelden",
    nav_get_started: "Loslegen",
    hero_badge: "Profis vertrauen — Claude 4.5 · GPT-5 · Gemini 3",
    hero_h1_a: "Dein KI-Arbeitsplatz —",
    hero_h1_b: "smarter, schneller, sicher",
    hero_sub: "Lumioo ist dein professioneller KI-Assistent. Löse komplexe Probleme im Chat mit Bild- und Sprachunterstützung, produziere veröffentlichungsreife Videos in 6 Sprachen, und liefere in Minuten was sonst Stunden dauerte. Ab {from_price}/Monat.",
    hero_cta_primary: "Kostenlos starten — keine Karte nötig",
    hero_cta_secondary: "So funktioniert's",
    trust_no_card: "Keine Kreditkarte nötig",
    trial_badge: "{days}-Tage Pro-Test · keine Karte nötig",
    trial_banner_text: "Noch {days} Tage in deinem kostenlosen Pro-Test",
    trial_banner_ending_today: "Dein Gratis-Test endet heute — jetzt auf Pro upgraden",
    trial_banner_cta: "Jetzt upgraden",
    trial_banner_close: "Schließen",
    trial_pill_label: "Test · {days}T",
    trial_pill_cta: "Upgraden",
    trial_pill_tooltip: "Du bist im kostenlosen Pro-Test — upgrade vor Ende.",
    trial_ribbon_text: "🎁 Hol dir {days} Tage Pro gratis — keine Karte nötig",
    trial_ribbon_pill: "Befristetes Angebot",
    trial_ribbon_cta: "Kostenlos starten",
    hero_cta_trial: "{days}-Tage-Test starten",
    // Refer & Earn page
    ref_back: "Zurück",
    ref_title: "Empfehlen & Verdienen",
    ref_subtitle: "Lade einen Freund ein → du bekommst +{days} Tage Pro pro Anmeldung, dein Freund startet mit 14 Tagen Pro gratis (Standard 7-Tage-Test + 7 Tage Empfehlungsbonus).",
    ref_loading: "Lädt…",
    ref_invited: "Eingeladen",
    ref_days_earned: "Pro-Tage verdient",
    ref_your_link: "Dein Einladungslink",
    ref_copy: "Kopieren",
    ref_copied: "Kopiert",
    ref_share: "Teilen",
    ref_your_code: "Dein Code:",
    ref_recent: "Letzte Einladungen",
    ref_days_awarded: "+{days} Tage Pro",
    ref_how_to_share: "📣 Wie teilen?",
    ref_share_whatsapp: "Teile in WhatsApp- / Telegram-Gruppen",
    ref_share_twitter: "Poste auf X mit einem Demo-Screenshot",
    ref_share_linkedin: "Poste auf LinkedIn mit dem Link",
    ref_share_forum: "Erwähne es in Salesforce- / Trailhead-Foren und Reddit",
    ref_link_copied: "Link kopiert",
    ref_copy_error: "Konnte nicht kopiert werden",
    ref_load_error: "Empfehlungen konnten nicht geladen werden",
    ref_share_message: "Probier Lumioos mit meinem Link aus — registriere dich und erhalte 14 Tage Pro gratis!",
    trial_ended_close: "Schließen",
    trial_ended_title: "Willkommen zurück bei Free",
    trial_ended_subtitle: "Dein 7-Tage Pro-Test ist gerade abgelaufen.",
    trial_ended_losing: "Du verlierst Zugriff auf",
    trial_ended_feat_video: "🎬 Video Producer (Sora 2)",
    trial_ended_feat_interview: "🎤 Interview Practice (Probegespräche)",
    trial_ended_feat_image: "🖼️ Image Producer (GPT Image 1)",
    trial_ended_feat_salesforce: "⚡ Salesforce / Trailhead Agent",
    trial_ended_promo_eyebrow: "Einmaliges Angebot",
    trial_ended_promo_headline: "20% RABATT auf Pro — nur für dich",
    trial_ended_promo_sub: "Code {code} wird automatisch beim Kauf angewendet. Nur jetzt gültig.",
    trial_ended_cta_upgrade: "Pro upgraden mit {code} → 20% RABATT",
    trial_ended_cta_later: "Vielleicht später",
    trust_stripe: "Stripe-gesicherte Zahlungen",
    trust_privacy: "Deine Daten bleiben privat",
    trust_rating: "Von ersten Nutzern geliebt",
    hero_card_live: "Live",
    hero_card_eyebrow: "Live KI-Antwort",
    hero_card_question: "Wie behebe ich einen Salesforce-Flow-Schleifenfehler?",
    hero_card_assistant: "Lumioo Assistent",
    hero_card_answer: "Füge eine Schutzbedingung zum Update-Records-Element hinzu. Verwende ein Decision vor dem Schleifenanfang, um zu prüfen, ob der Datensatzzustand bereits passt — das durchbricht die Rekursion.",
    hero_card_time: "In 8s gelöst",
    hero_chip_voice: "Sprache → Text",
    hero_chip_image: "Deine Screenshots sehen",
    hero_chip_lang: "6 Sprachen",
    stat_1_n: "Sprachen",
    stat_2_n: "KI-Modelle",
    stat_3_n: "Ø Antwortzeit",
    stat_4_n: "Verfügbarkeit",
    feat_section_eyebrow: "Was Lumioo macht",
    feat_section_h2: "Ein Arbeitsplatz. Jede KI-Superkraft.",
    feat_section_sub: "Schluss mit 6 Tabs. Chatten, sehen, hören, produzieren — alles aus einem sauberen Arbeitsbereich.",
    feat_chat_title: "Smart KI-Chat",
    feat_chat_desc: "Frage alles in einfacher Sprache. Hänge einen Screenshot für visuelle Analyse an. Sprich statt zu tippen.",
    coming_soon_badge: "Bald verfügbar",
    gs_ad_cta_soon: "Beim Start benachrichtigen",
    gs_ad_locked: "Vorerst gesperrt — bald freigeschaltet.",
    gs_coming_soon_toast: "Game Studio kommt bald — wir melden uns!",
    feat_video_title: "Cinematischer Video-Produzent",
    feat_video_desc: "Gib ein Thema in einer von 6 Sprachen ein. In Minuten bekommst du Script, KI-Vertonung, cinematische Szenen und ein veröffentlichungsreifes MP4.",
    feat_speed_t: "Blitzschnell",
    feat_speed_d: "Antworten in Sekunden. Videos in Minuten. Null Wartezeit.",
    feat_secure_t: "Bank-Sicherheit",
    feat_secure_d: "Verschlüsselte Sitzungen. Deine Prompts trainieren nie eine KI.",
    feat_global_t: "Global by Design",
    feat_global_d: "Native Unterstützung für 6 Sprachen — inkl. Deutsch.",
    how_eyebrow: "So funktioniert's",
    how_h2: "Drei Schritte. Null Lernkurve.",
    how_s1_t: "Kostenlos anmelden",
    how_s1_d: "Keine Karte. Konto in unter 30 Sekunden erstellen.",
    how_s2_t: "Fragen oder beschreiben",
    how_s2_d: "Tippen, sprechen oder Screenshot hochladen. Oder ein Video-Thema in deiner Sprache.",
    how_s3_t: "Ergebnis nutzen",
    how_s3_d: "Antwort kopieren. MP4 herunterladen. Veröffentlichen. Fertig.",
    lp_pricing_eyebrow: "Einfache, faire Preise",
    lp_pricing_h2: "Kostenlos starten. Upgrade nur bei Bedarf.",
    lp_pricing_sub: "Jeder Plan enthält Kern-KI-Funktionen. Keine versteckten Gebühren. Jederzeit kündbar.",
    lp_plan_popular: "Am beliebtesten",
    lp_plan_start: "Loslegen",
    cta_h2_a: "Bereit, smarter zu",
    cta_h2_b: "arbeiten?",
    cta_sub: "Schließe dich Profis an, die Lumioo täglich vertrauen. Für privaten Gebrauch immer kostenlos.",
    cta_btn: "Kostenloses Konto erstellen",
    cta_smallprint: "Keine Karte. 30-Sek.-Anmeldung. Jederzeit kündbar.",
    footer_tag: "Für Profis gebaut.",
    footer_privacy: "Datenschutz",
    footer_terms: "Bedingungen",
    side_dashboard: "Dashboard",
    side_chat: "KI-Chat",
    side_video: "Video-Produzent",
    side_image: "Bild-Produzent",
    side_cv: "Lebenslauf-Generator",
    side_interview: "Interview-Training",
    side_projects: "Projekte",
    side_billing: "Abonnement",
    side_referrals: "Parrainer & Gagner",
    side_admin: "Admin",
    side_ai_workforce: "AI Workforce",
    wf_badge: "ADMIN · PHASE 1",
    wf_title: "AI Workforce",
    wf_subtitle: "Manage your private AI company workforce. Delegate objectives, monitor progress, and approve every action that touches the outside world.",
    wf_total_agents: "Total Agents",
    wf_active_agents: "Active Agents",
    wf_busy_agents: "Busy Agents",
    wf_tasks_in_progress: "Tasks in Progress",
    wf_tasks_completed: "Completed Tasks",
    wf_tasks_failed: "Failed Tasks",
    wf_approvals_pending: "Pending Approvals",
    wf_agents_title: "AI Employees",
    wf_workspace_company: "Company Workspace",
    wf_phase_notice_title: "Sub-Phase 1A · Foundation ready",
    wf_phase_notice_body: "Tasks, CEO orchestration, agent messaging and approvals arrive in Sub-Phase 1B → 1D. The employees above are already configured and ready — no further action needed until then.",
    wf_refresh: "Aktualisieren",
    wf_ceo_chat_title: "CEO Chat",
    wf_ceo_chat_empty: 'Sprich natürlich mit dem CEO AI. Probier: "Welche Aufgaben warten auf Freigabe?" oder "Recherchiere 3 Anmelde-Ideen."',
    wf_ceo_chat_placeholder: "Frag den CEO alles oder sag 'recherchiere X', 'brich die Aufgabe ab', 'gib Entwurf frei'…",
    wf_ceo_chat_hint: "Absicht wird automatisch erkannt: Fragen antworten aus der echten DB; Aufgaben-/Steuer-/Freigabeabsichten rufen die echten APIs auf. Keine falschen Fähigkeiten — der CEO sagt es, wenn ein Tool nicht angebunden ist.",
    wf_chat_view_task: "Aufgabe anzeigen →",
    wf_new_objective: "Neues Ziel",
    wf_task_title_placeholder: "z. B. 3-Tage-Marketing-Plan für Lumioos erstellen",
    wf_task_desc_placeholder: "Beschreibe das Ziel im Detail. Welches Ergebnis willst du? Einschränkungen?",
    wf_send_to_ceo: "An CEO AI senden",
    wf_ceo_will_plan: "CEO AI ({model}) plant → weist Spezialisten zu → sammelt Ergebnisse. Marketing/Sales/Support/Finance landen in der Freigabewarteschlange.",
    wf_recent_tasks: "Aktuelle Aufgaben",
    wf_no_tasks: "Noch keine Aufgaben. Erstelle oben dein erstes Ziel.",
    wf_recent_activity: "Aktuelle Aktivität",
    wf_no_activity: "Noch keine Aktivität.",
    wf_agent_chat_empty: "Sag hallo zu {name} oder gib eine direkte Aufgabe.",
    wf_agent_chat_placeholder: "Mit {name} sprechen…",
    wf_tab_overview: "Übersicht",
    wf_tab_chat: "Chat",
    wf_tab_current: "Aktuell",
    wf_tab_history: "Verlauf",
    wf_tab_activity: "Aktivität",
    wf_tab_memory: "Gedächtnis",
    wf_tab_config: "Konfig",
    wf_field_status: "Status",
    wf_field_completed: "Erledigt",
    wf_field_completed_count: "{n} erledigt",
    wf_field_last_activity: "Letzte Aktivität",
    wf_field_none: "—",
    wf_no_active_tasks: "Keine aktiven Aufgaben.",
    wf_no_history: "Noch kein Verlauf.",
    wf_no_memory: "Noch kein Gedächtnis.",
    wf_cfg_model: "Modell (läuft tatsächlich)",
    wf_cfg_allowed_tools: "Zulässige Tools",
    wf_cfg_system_instructions: "Systemanweisungen",
    wf_cfg_agent_id: "Agent-ID",
    wf_task_objective: "Ziel",
    wf_task_ceo_plan: "CEO-Plan",
    wf_task_children: "Unteraufgaben ({n})",
    wf_task_view_result: "Ergebnis anzeigen ({n} Zeichen)",
    wf_task_error_prefix: "Fehler:",
    wf_task_ceo_summary: "CEO-Zusammenfassung",
    wf_task_agent_messages: "Agent-Nachrichten ({n})",
    wf_task_pause: "Pause",
    wf_task_resume: "Fortsetzen",
    wf_task_retry: "Wiederholen",
    wf_task_cancel: "Abbrechen",
    wf_approve: "Freigeben",
    wf_reject: "Ablehnen",
    wf_approval_status_prefix: "Freigabe {status}",
    wf_approvals_title: "Ausstehende Freigaben ({n})",
    wf_no_approvals: "Keine ausstehenden Freigaben.",
    wf_lwr_badge: "LIVE-WEB-RECHERCHE",
    wf_lwr_counts: "{searches} Suchen · {sources} Quellen · {pages} Seiten gelesen",
    wf_status_idle: "Bereit",
    wf_status_working: "Arbeitet",
    wf_status_waiting_for_approval: "Wartet auf Freigabe",
    wf_status_paused: "Pausiert",
    wf_status_error: "Fehler",
    wf_status_offline: "Offline",
    wf_status_pending: "Ausstehend",
    wf_status_planning: "Planung",
    wf_status_assigned: "Zugewiesen",
    wf_status_in_progress: "In Bearbeitung",
    wf_status_completed: "Erledigt",
    wf_status_failed: "Fehlgeschlagen",
    wf_status_cancelled: "Abgebrochen",
    wf_leads_title: "Leads",
    wf_leads_open: "Leads öffnen",
    wf_leads_overview_title: "Lead-Pipeline",
    wf_leads_total: "Leads gesamt",
    wf_leads_new: "Neu",
    wf_leads_qualified: "Qualifiziert",
    wf_leads_reviewing: "In Prüfung",
    wf_leads_approved: "Freigegeben",
    wf_leads_rejected: "Abgelehnt",
    wf_leads_archived: "Archiviert",
    wf_leads_verified: "Verifiziert",
    wf_leads_needs_review: "Prüfung nötig",
    wf_leads_none: "Noch keine Leads. Bitte Sales AI, welche zu finden.",
    wf_leads_filter_status: "Status",
    wf_leads_filter_verification: "Verifizierung",
    wf_leads_filter_min_score: "Min-Score",
    wf_leads_filter_industry: "Branche",
    wf_leads_filter_all: "Alle",
    wf_leads_sort: "Sortieren",
    wf_leads_sort_score: "Höchster Score",
    wf_leads_sort_newest: "Neueste",
    wf_leads_sort_name: "Firmenname",
    wf_leads_col_company: "Firma",
    wf_leads_col_website: "Website",
    wf_leads_col_industry: "Branche",
    wf_leads_col_location: "Ort",
    wf_leads_col_score: "Score",
    wf_leads_col_verification: "Verifizierung",
    wf_leads_col_status: "Status",
    wf_leads_col_discovered: "Entdeckt",
    wf_leads_score_reasons: "Warum dieser Score",
    wf_leads_concerns: "Bedenken",
    wf_leads_sources: "Belegquellen",
    wf_leads_discovery_task: "Entdeckungs-Aufgabe",
    wf_leads_actions_approve: "Freigeben",
    wf_leads_actions_reject: "Ablehnen",
    wf_leads_actions_archive: "Archivieren",
    wf_leads_action_ok: "Lead {action}",
    wf_leads_action_fail: "Lead konnte nicht {action} werden",
    wf_leads_no_outreach_note: "Freigabe markiert diesen Lead für Nachfassen. Keine E-Mail, DM oder Kontaktaufnahme.",
    wf_lead_status_new: "Neu",
    wf_lead_status_qualified: "Qualifiziert",
    wf_lead_status_reviewing: "In Prüfung",
    wf_lead_status_approved: "Freigegeben",
    wf_lead_status_rejected: "Abgelehnt",
    wf_lead_status_archived: "Archiviert",
    wf_verif_verified: "Verifiziert",
    wf_verif_needs_review: "Prüfung nötig",
    wf_verif_unverified: "Unverifiziert",
    wf_toast_task_created: "Ziel an CEO AI gesendet — Planung startet…",
    wf_toast_task_short: "Titel und Beschreibung müssen länger sein",
    wf_toast_task_create_fail: "Aufgabe konnte nicht erstellt werden",
    wf_toast_task_load_fail: "Aufgabe konnte nicht geladen werden",
    wf_toast_workforce_load_fail: "AI Workforce konnte nicht geladen werden",
    wf_toast_task_action_ok: "Aufgabe {action}",
    wf_toast_task_action_fail: "Aufgabe konnte nicht {action} werden",
    wf_toast_approved: "Freigegeben",
    wf_toast_rejected: "Abgelehnt",
    wf_toast_approval_fail: "Freigabe konnte nicht bearbeitet werden",
    wf_chat_error_prefix: "Fehler:",
    wf_chat_error_fallback: "Chat fehlgeschlagen",
    side_upgrade: "Upgrade",
    side_logout: "Abmelden",
    side_theme: "Design",
    pricing_eyebrow: "Pläne",
    pricing_h1: "Wähle deinen Plan",
    pricing_sub: "Jederzeit upgraden. Jederzeit kündigen.",
    pricing_current: "Aktueller Plan",
    pricing_monthly: "Monatlich",
    pricing_yearly: "Jährlich",
    pricing_save_2mo: "2 Monate sparen",
    pricing_month: "Monat",
    pricing_year: "Jahr",
    pricing_subscribe: "Abonnieren",
    pricing_current_plan: "Aktueller Plan",
    redeem_have_code: "Code vorhanden?",
    redeem_apply: "Anwenden",
    chat_send: "Senden",
    chat_thinking: "Denkt nach…",
    chat_stop: "Stopp",
    chat_continue: "Weiter",
    chat_stopped_marker: "⏹ Gestoppt",
    chat_continue_prompt: "Bitte fahre dort fort, wo du aufgehört hast.",
    chat_thinking_fast: "⚡ Schnell",
    chat_thinking_balanced: "🎯 Ausgewogen",
    chat_thinking_thorough: "🧠 Gründlich",
    bestai_sub: "Aktuell #1 in Schreiben, Code und Reasoning. Wechseln Sie jederzeit zu GPT-5 oder Gemini 3 — ohne Aufpreis.",
    bestai_table_h: "Wählen Sie das richtige Modell für die Aufgabe.",
    bestai_table_sub: "Lumioos gibt Ihnen alle drei — mit einem Klick pro Chat wechseln.",
    bestai_footnote: "Alle Modelle in Ihrem Lumioos-Abo enthalten — mit einem Klick wechseln, ohne Aufpreis.",
    bestai_h2: "Angetrieben von Claude 4.5.",
    bestai_eyebrow: "Intelligente Voreinstellung",
    bestai_task_writing: "Langtextschreiben",
    bestai_task_code: "Code & Debug",
    bestai_task_translate: "Übersetzen (TR/AR/RU)",
    bestai_task_reasoning: "Schwierigstes Reasoning",
    bestai_task_capable: "Am leistungsfähigsten",
    bestai_task_quick: "Schnelle Antworten",
    gpt56_promo_badge: "NEU · PRO & POWER EXKLUSIV",
    gpt56_promo_title: "GPT 5.6 Familie",
    gpt56_promo_desc: "Lernen Sie die nächste Generation von GPT kennen — drei Varianten, ein Ziel: die exakte Balance aus Tiefe, Breite und Geschwindigkeit für jede Aufgabe. Ab sofort in den {plans}-Plänen verfügbar.",
    gpt56_promo_plans_hl: "Pro & Power",
    gpt56_sol_tag: "Tiefste Denkleistung",
    gpt56_sol_desc: "Für die schwierigsten Probleme — lange Analysen, Recherche, komplexes Code-Review. Wenn Genauigkeit wichtiger ist als Geschwindigkeit.",
    gpt56_terra_tag: "Ausgewogene Leistung",
    gpt56_terra_desc: "Ihr Arbeitstier für den Alltag. Großartige Antworten, schnell genug, breites Wissen — der perfekte Mittelweg zwischen Sol und Luna.",
    gpt56_luna_tag: "Schnellster 5.6",
    gpt56_luna_desc: "Blitzschnelle Antworten für Chat, Brainstorming und schnelle Recherchen. Immer noch schlauer als die meisten Modelle — nur schneller.",
    gpt56_cta_plans: "Pro & Power-Pläne ansehen →",
    gpt56_cta_trial: "14 Tage kostenlos testen",
    router_promo_badge: "NEU · PRO-EXKLUSIV",
    router_promo_desc: "Das leistungsstärkste Modell der Welt — automatisch zu Ihren schwierigsten Aufgaben geleitet. Ein Toggle im Chat schickt komplexen Code, Analyse und logisches Denken an OpenAI GPT-5, während alltägliche Fragen auf Claude 4.5 flott bleiben. Kein Modellwähler. Keine Reibung.",
    router_promo_bullet1: "Wählt GPT-5 automatisch für schwierige Aufgaben",
    router_promo_bullet2: "Weltweit führendes Reasoning + Code",
    router_promo_bullet3: "Prioritätswarteschlange, keine Ratenlimits",
    router_promo_bullet4: "Ein-Klick-Toggle im Chat",
    router_promo_cta: "Auf Pro upgraden",
    router_promo_included: "Kostenlos in jedem Pro-Plan enthalten",
    sonnet_promo_pill: "Am besten für allgemeine Aufgaben",
    sonnet_promo_default_label: "— Standard in Lumioos",
    sonnet_promo_desc: "Anthropics Flaggschiff-Modell führt unabhängige Benchmarks in Schreiben, Code und komplexem Reasoning an. Niedrigere Halluzinationsrate als GPT-5 und stärkere mehrsprachige Qualität. Als Lumioos-Standard eingerichtet, damit neue Nutzer sofort die besten Ergebnisse erhalten.",
    sonnet_col_writing: "Schreiben",
    sonnet_col_code: "Code",
    sonnet_col_reasoning: "Reasoning",
    err_generic: "Etwas ist schiefgelaufen",
    err_topic_required: "Gib ein Thema ein",
    err_message_required: "Gib eine Nachricht ein",
    feat_chat_li1: "Bilduploads — analysiere Screenshots und Fotos",
    feat_chat_li2: "Spracheingabe — sprich, Lumioo transkribiert",
    feat_chat_li3: "Code, Dokumente, Salesforce, Sicherheit — Experten-Support",
    feat_chat_li4: "Gesprächsverlauf — jederzeit fortfahren",
    stat_1_v: "6",
    stat_2_v: "3+",
    stat_3_v: "8s",
    stat_4_v: "99,9%",
    feat_video_li1: "Skripte in deiner Sprache (TR · EN · ES · FR · DE · IT · PT · JA · ZH)",
    feat_video_li2: "9 natürliche KI-Stimmen — wähle den perfekten Ton",
    feat_video_li3: "Cinematische KI-Bilder — kein Stock-Footage-Look",
    feat_video_li4: "MP4 + Sprachausgabe + Szenen herunterladen",
    lp_plan_free_desc: "Perfekt zum Testen von Lumioo und für persönliche Nutzung.",
    lp_plan_free_f1: "5 KI-Bilder / Monat",
    lp_plan_free_f2: "10 Chat-Nachrichten / Tag",
    lp_plan_free_f3: "Alle 6 Sprachen",
    lp_plan_creator_desc: "Für Freelancer, Studenten und Creator.",
    lp_plan_creator_f1: "15 Videos / Monat — bis zu 3 Minuten",
    lp_plan_creator_f2: "Unbegrenzter Chat mit Bildern + Sprachfunktion",
    lp_plan_creator_f3: "Kein Wasserzeichen",
    lp_plan_creator_f4: "Prioritätsgeschwindigkeit",
    lp_plan_pro_desc: "Für Profis und kleine Teams.",
    lp_plan_pro_f1: "50 Videos / Monat — bis zu 20 Minuten",
    lp_plan_pro_f2: "Alles im Creator-Plan",
    lp_plan_pro_f3: "HD 1080p Output",
    lp_plan_pro_f4: "Prioritäts-Support",
    lp_plan_pro_f5: "✨ CV-Chat & Review — unbegrenzt (PDF/Word/Bild)",
    lp_plan_power_desc: "Für Power-User und intensive Creator.",
    lp_plan_power_f1: "Alles in Pro",
    lp_plan_power_f2: "500 KI-Bilder/Monat (HD)",
    lp_plan_power_f3: "GPT-5 · 1500 Nachrichten, Opus 4.5 · 100/Mt.",
    lp_plan_power_f4: "Prioritäts-Support · faire Nutzung",
    lp_plan_power_f5: "✨ CV-Chat & Review — unbegrenzt + Priorität",
    lp_pricing_trust1: "Gesichert durch Stripe",
    lp_pricing_trust2: "Jederzeit kündbar",
    lp_pricing_trust3: "GDPR-konform",
    auth_eyebrow_login: "Melde dich an bei",
    auth_eyebrow_register: "Erstelle dein",
    auth_h1_login: "Willkommen zurück.",
    auth_h1_register: "Lumioo-Konto.",
    auth_sub_login: "Dort weitermachen, wo du aufgehört hast.",
    auth_sub_register: "Erhalte 50 kostenlose Guthaben zum Starten.",
    auth_name: "Name",
    auth_email: "E-Mail",
    auth_password: "Passwort",
    auth_signin: "Anmelden",
    auth_create: "Konto erstellen",
    auth_no_account: "Noch kein Konto?",
    auth_have_account: "Hast du bereits ein Konto?",
    auth_forgot: "Passwort vergessen?",
    fp_eyebrow: "Kontowiederherstellung",
    fp_title: "Passwort zurücksetzen",
    fp_subtitle: "Gib die E-Mail-Adresse deines Kontos ein und wir senden dir einen Reset-Link.",
    fp_send_btn: "Reset-Link senden",
    fp_back_login: "Zurück zur Anmeldung",
    fp_sent_title: "Prüfe dein Postfach",
    fp_sent_body: "Falls ein Konto für {email} existiert, ist ein Reset-Link unterwegs. Er ist 1 Stunde lang gültig.",
    fp_sent_hint: "Siehst du ihn nicht? Prüfe den Spam-Ordner oder versuche es in ein paar Minuten erneut.",
    rp_title: "Lege ein neues Passwort fest",
    rp_subtitle: "Wähle ein starkes Passwort — mindestens 8 Zeichen.",
    rp_new_password: "Neues Passwort",
    rp_confirm_password: "Passwort bestätigen",
    rp_submit_btn: "Neues Passwort speichern",
    rp_mismatch: "Passwörter stimmen nicht überein",
    rp_too_short: "Passwort muss mindestens 8 Zeichen lang sein",
    rp_invalid: "Dieser Reset-Link ist ungültig oder abgelaufen.",
    rp_success: "Passwort aktualisiert. Du bist angemeldet.",
    rp_no_token_title: "Kein Reset-Token gefunden",
    rp_no_token_body: "Dieser Link scheint fehlerhaft zu sein. Bitte fordere eine neue Reset-E-Mail an.",
    rp_request_new: "Neuen Link anfordern",
    auth_create_one: "Erstelle eines",
    auth_demo: "Demo-Konto",
    welcome_back: "Willkommen zurück!",
    account_created: "Konto erstellt. Willkommen!",
    auth_failed: "Authentifizierung fehlgeschlagen",
    iv_eyebrow: "Interview-Training",
    iv_h1: "Trainiere jedes Interview. Laut und deutlich.",
    iv_sub: "Lade deine Fragenblätter als Fotos hoch. Lumioos extrahiert jede Frage und Antwort, erstellt deine private Fragenbank und testet dich — per Sprache oder Text. Perfekt für USCIS-Einbürgerung, Green Card, Job- und Zertifizierungsinterviews.",
    iv_my_banks: "Meine Fragenbänke",
    iv_total: "gesamt",
    iv_loading: "Wird geladen…",
    iv_empty_title: "Noch keine Fragenbänke",
    iv_empty_sub: "Erstelle eine oben und lade dann ein Foto deines Lernblatts hoch oder füge Fragen manuell hinzu.",
    iv_questions: "Fragen",
    iv_open: "Öffnen",
    iv_create: "Bank erstellen",
    iv_bank_name_ph: "Bankname (z.B. USCIS Civics)",
    iv_bank_desc_ph: "Kurze Beschreibung (optional)",
    iv_bank_created: "Bank erstellt",
    iv_create_fail: "Bank konnte nicht erstellt werden",
    iv_confirm_delete: "Diese Bank und alle ihre Fragen löschen?",
    iv_deleted: "Gelöscht",
    iv_delete_fail: "Löschen fehlgeschlagen",
    iv_load_fail: "Laden fehlgeschlagen",
    iv_hint_title: "So funktioniert es",
    iv_hint_sub: "Mache ein Foto von einem beliebigen Interview-Vorbereitungsblatt (US-Staatsbürgerschaftstest, Green-Card-Fragen, Job-Interview-Vorbereitung, Zertifizierungsfragen). Lumioos liest es mit KI-Vision, extrahiert jede Frage mit allen akzeptierten Antworten und speichert sie für immer. Dann trainiere per Sprache (KI spricht die Frage vor, du antwortest mit deinem Mikrofon) oder per Text.",
    iv_back_library: "Zurück zur Bibliothek",
    iv_practice: "Trainieren",
    iv_start_h2: "Interview starten",
    iv_mode_text: "Text-Modus",
    iv_mode_voice: "Sprach-Modus",
    iv_mode_text_hint: "Lese jede Frage und tippe deine Antwort. KI bewertet nach Sinn, nicht nach exakten Worten.",
    iv_mode_voice_hint: "KI spricht jede Frage vor. Tippe auf das Mikrofon und antworte laut. KI transkribiert und bewertet.",
    iv_order_label: "Fragenreihenfolge",
    iv_order_random: "Zufällig",
    iv_order_sequential: "Sequenziell",
    iv_limit_label: "Wie viele Fragen",
    iv_limit_all: "Alle ({n} Fragen)",
    iv_limit_all_short: "Alle",
    iv_limit_max: "max. {n}",
    iv_limit_clamped: "Bank hat nur {n} Fragen — verwende alle.",
    iv_or: "oder",
    iv_start_now: "Jetzt starten",
    iv_start_fail: "Sitzung konnte nicht gestartet werden",
    iv_no_questions_start: "Füge zuerst mindestens eine Frage hinzu",
    iv_upload_title: "Lade Bilder oder PDFs hoch",
    iv_upload_sub: "Fotos, Screenshots oder PDF-Dateien von Fragenblättern. KI extrahiert automatisch jede Frage und Antwort (bis zu 100 Dateien, PDFs werden Seite für Seite gelesen).",
    iv_choose_images: "Bilder wählen",
    iv_choose_files: "Bilder oder PDFs wählen",
    iv_extracting: "Extrahiere Fragen und Antworten…",
    iv_extracted: "Fragen aus Bildern hinzugefügt",
    iv_extract_fail: "Fragen konnten nicht extrahiert werden",
    iv_budget_partial: "Habe {n} Fragen hinzugefügt, aber dein KI-Schlüssel ist unterwegs zu Ende gegangen. Laden auf, um den Rest zu erhalten.",
    iv_partial_extract: "Habe {n} Fragen hinzugefügt ({f} Batches fehlgeschlagen — versuche erneut, um den Rest zu erhalten).",
    iv_progress_label: "Verarbeite Batch {c} von {n}…",
    feat_iv_eyebrow: "Interview-Training",
    feat_iv_title: "Trainiere jedes Interview — laut oder schriftlich",
    feat_iv_desc: "Lade deine Lernblätter hoch (Foto oder PDF). Lumioos extrahiert jede Frage und Antwort und testet dich dann mit einem Live-KI-Interviewer, der die Fragen spricht, deine gesprochenen Antworten abhört und nach Sinn bewertet — streng nach dem Antwortschlüssel der Prüfung.",
    feat_iv_li1: "USCIS Einbürgerung & Green Card Vorbereitung",
    feat_iv_li2: "Job- und technisches Interview-Training",
    feat_iv_li3: "Sprach- + Hörverstehen-Modi (Fragen verborgen)",
    feat_iv_li4: "Strenge Bewertung + detaillierter Bericht pro Frage am Ende",
    feat_iv_cta: "Starte Interview-Training",
    feat_iv_use_cases: "USCIS · Green Card · Job · Zertifizierungen · Alles",
    feat_iv_badge: "NEU",
    iv_speed_label: "Sprechgeschwindigkeit",
    iv_speed_slow: "Langsam",
    iv_speed_normal: "Normal",
    iv_speed_fast: "Schnell",
    iv_speed_faster: "Schneller",
    iv_speed_hint: "Wie schnell der Interviewer die Fragen spricht.",
    iv_range_label: "Fragenbereich",
    iv_range_hint: "1 bis {n}",
    iv_range_from: "Von",
    iv_range_to: "bis",
    iv_range_clear: "löschen",
    iv_range_note: "Lasse leer, um alle Fragen zu verwenden. Der Bereich bezieht sich auf die Quellenreihenfolge (z.B. 1 → 50).",
    iv_range_invalid: "Ende muss ≥ Start sein.",
    iv_deleted_undo: "Bank gelöscht ({n} Fragen). Du kannst innerhalb von 10 Sekunden rückgängig machen.",
    iv_q_deleted_undo: "Frage gelöscht. Du kannst innerhalb von 8 Sekunden rückgängig machen.",
    iv_undo: "Rückgängig",
    iv_restored: "Wiederhergestellt.",
    iv_restore_fail: "Wiederherstellung fehlgeschlagen",
    iv_delete_warning: "Dauerhaftes Löschen",
    iv_delete_q: "Diese Bank und ihre {n} Fragen löschen?",
    iv_delete_desc: "Du wirst die Bank löschen",
    iv_delete_btn: "Bank löschen",
    iv_voice_label: "Interviewer-Stimme",
    iv_voice_female: "Weiblich (Nova)",
    iv_voice_male: "Männlich (Ash) — sanft",
    iv_voice_female2: "Weiblich (Shimmer)",
    iv_voice_male2: "Männlich (Fable) — freundlich",
    iv_voice_hint: "Wähle die Stimme deines KI-Interviewers.",
    iv_finish_early: "Prüfung beenden",
    iv_finish_early_confirm: "Prüfung jetzt beenden? Du hast {n} von {total} Fragen beantwortet.",
    iv_finish_early_btn: "Jetzt beenden",
    iv_keep_going: "Weitermachen",
    iv_finishing: "Wird beendet…",
    iv_congrats: "Glückwunsch! 🎉",
    iv_congrats_sub: "Du hast mit einer großartigen Punktzahl bestanden.",
    iv_good_job: "Gut gemacht!",
    iv_good_job_sub: "Solide Leistung — halte das Training auf.",
    iv_keep_practising: "Halte das Training auf",
    iv_keep_practising_sub: "Überprüfe deine falschen Antworten unten und versuche es erneut.",
    iv_score_label: "Punktzahl",
    iv_wrong_review: "Überprüfe falsche Antworten",
    iv_resume_eyebrow: "Im Gange",
    iv_resume_title: "Du hast ein unvollendetes Interview",
    iv_resume_progress: "{done} / {total} Fragen bisher beantwortet",
    iv_resume_btn: "Fortsetzen",
    iv_resume_discard: "Verwerfen",
    iv_resume_discard_confirm: "Diese unvollendete Sitzung verwerfen und neu starten?",
    iv_resume_discarded: "Sitzung verworfen",
    iv_large_upload_warn: "Dein Upload ist etwa {mb} MB groß. Sehr große Uploads können bei langsamen Verbindungen fehlschlagen. Fortfahren?",
    iv_trash: "Papierkorb",
    iv_trash_title: "Kürzlich gelöscht",
    iv_trash_banks: "Gelöschte Bänke",
    iv_trash_questions: "Gelöschte Fragen",
    iv_trash_empty: "Papierkorb ist leer.",
    iv_trash_load_fail: "Papierkorb konnte nicht geladen werden",
    iv_purge: "Für immer löschen",
    iv_purge_confirm: "Diese Bank dauerhaft löschen? Das kann nicht rückgängig gemacht werden.",
    iv_progress_preparing: "Dateien werden vorbereitet…",
    iv_report_title: "Frage-für-Frage-Übersicht",
    iv_your_answer: "Deine Antwort",
    iv_skipped: "(übersprungen)",
    iv_max_10: "Max. 10 Bilder gleichzeitig",
    iv_max_100: "Max. 100 Bilder gleichzeitig",
    iv_manual_title: "Manuell hinzufügen",
    iv_manual_sub: "Tippe eine Frage und die Antworten ein, die Lumioos akzeptieren soll.",
    iv_add_question: "Frage hinzufügen",
    iv_cancel: "Abbrechen",
    iv_question: "Frage",
    iv_accepted_answers: "Akzeptierte Antworten (eine pro Zeile)",
    iv_accepted_ph: "Exekutive\\nLegislative\\nJudikative\\nKongress\\nPräsident",
    iv_min_required: "Mindestens erforderlich",
    iv_min_hint: "Wie viele der akzeptierten Antworten muss der Benutzer sagen? (Normalerweise 1)",
    iv_add: "Hinzufügen",
    iv_q_added: "Frage hinzugefügt",
    iv_add_fail: "Frage konnte nicht hinzugefügt werden",
    iv_need_q_and_a: "Frage und mindestens 1 Antwort erforderlich",
    iv_question_list: "Fragen",
    iv_no_questions: "Noch keine Fragen. Lade ein Foto hoch oder füge manuell hinzu.",
    iv_confirm_delete_q: "Diese Frage löschen?",
    iv_back_bank: "Zurück zur Bank",
    iv_voice_interview: "Sprach-Interview",
    iv_text_interview: "Text-Interview",
    iv_record: "Antwort aufzeichnen",
    iv_stop_record: "Stopp & transkribieren",
    iv_transcribing: "Wird transkribiert…",
    iv_voice_answer_ph: "Deine transkribierte Antwort wird hier angezeigt. Du kannst sie auch vor der Übermittlung bearbeiten.",
    iv_text_answer_ph: "Tippe deine Antwort hier ein…",
    iv_submit: "Übermitteln",
    iv_skip: "Überspringen",
    iv_correct: "Richtig",
    iv_wrong: "Nicht ganz",
    iv_accepted_were: "Akzeptierte Antworten waren:",
    iv_see_results: "Ergebnisse anzeigen",
    iv_next_question: "Nächste Frage",
    iv_need_n_answers: "Gib mindestens {n} verschiedene Antworten",
    iv_results: "Ergebnisse",
    iv_accuracy: "Genauigkeit",
    iv_restart: "Bank neu starten",
    iv_speak: "Frage vorlesen",
    iv_show_question: "Frage anzeigen",
    iv_hide_question: "Frage verbergen (Hörverstehen-Training)",
    iv_question_hidden: "Frage verborgen — Höre die Audio",
    iv_voice_intro_line: "Hallo! Wenn du bereit bist, drücke Start und ich werde die Fragen stellen.",
    iv_voice_ready: "Ich bin bereit, lass uns anfangen",
    iv_show_q_label: "Fragen auf dem Bildschirm anzeigen?",
    iv_show_q_on: "Anzeigen",
    iv_show_q_off: "Verbergen (Hörverstehen-Training)",
    iv_show_q_on_hint: "Fragetext ist beim Trainieren sichtbar.",
    iv_show_q_off_hint: "Nur die Audio wird abgespielt — großartig zum Hörverstehen-Training.",
    iv_starred_label: "Welche Fragen sollen gestellt werden?",
    iv_starred_all: "Alle Fragen",
    iv_starred_only: "Nur markierte / wichtige",
    iv_starred_hint: "Markiere (⭐) Fragen, auf die du dich konzentrieren möchtest. Lumioos markiert automatisch Fragen, die in deiner Quelle als wichtig/wahrscheinlich markiert sind.",
    iv_starred_badge: "Wichtig",
    iv_star: "Diese Frage markieren",
    iv_unstar: "Markierung entfernen",
    iv_tts_fail: "Frage-Audio konnte nicht abgespielt werden",
    iv_stt_fail: "Audio konnte nicht transkribiert werden",
    iv_mic_denied: "Mikrofon-Zugriff verweigert",
    iv_need_answer: "Tippe zuerst eine Antwort ein oder nimm sie auf",
    iv_submit_fail: "Antwort konnte nicht übermittelt werden",
    iv_skip_fail: "Überspringe fehlgeschlagen",
    side_credits: "Guthaben",
    side_language: "Sprache",
    side_integrations: "Integrationen",
    side_help: "Hilfe & Tokens",
    auth_google: "Mit Google fortfahren",
    auth_or: "oder mit E-Mail",
    integrations_eyebrow: "Verbinde",
    integrations_h1: "Integrationen",
    integrations_sub: "Verbinde Salesforce, Splunk, Defender, Trend Micro, SentinelOne, CrowdStrike und mehr. Lumioo ruft deine Fälle ab und löst sie.",
    help_eyebrow: "Dokumentation",
    help_h1: "Token & API-Schlüssel-Leitfaden",
    help_faq: "Häufig gestellte Fragen",
    help_sub: "Schritt-für-Schritt-Anleitungen zum Abrufen eines API-Tokens von jeder unterstützten Plattform. Klicke auf eine beliebige Schaltfläche 'Öffnen', um direkt zur richtigen Seite zu springen.",
    dash_eyebrow: "Dashboard",
    dash_hello: "Hallo",
    dash_sub: "Wähle ein Tool und beginne zu produzieren.",
    dash_credits_label: "Verfügbares Guthaben",
    dash_open: "Tool öffnen",
    dash_chat_card_desc: "Frage alles: Salesforce, Cybersicherheit, Code, Projekte.",
    dash_video_card_desc: "Thema → komplettes YouTube-Paket + MP4-Video.",
    dash_interview_card_desc: "Übe Vorstellungsgespräche mit einem KI-Interviewer.",
    dash_pro_only_badge: "Creator & Pro",
    dash_card_unlock: "Upgrade zum Freischalten",
    dash_recent_eye: "Aktuelle Projekte",
    dash_recent_h2: "Deine neueste Arbeit",
    dash_view_all: "Alle anzeigen",
    dash_no_projects: "Noch keine Projekte. Beginne mit",
    dash_or: "oder",
    chat_eyebrow: "Tool",
    chat_h1: "KI-Chat",
    chat_mode_image_hint: "Bilder erstellen",
    chat_mode_code_hint: "Schnelle Code-Hilfe",
    chat_mode_cv_hint: "Lebenslauf erstellen",
    chat_mode_video_hint: "Video erstellen",
    model_desc_haiku: "Schneller Alltagschat",
    model_desc_sonnet: "Tiefes Denken & Schreiben",
    model_desc_gpt4o: "Ausgewogen, allgemein einsetzbar",
    model_desc_gemini: "Multimodal & Bilderkennung",
    model_desc_gpt5: "Schwierigste Aufgaben · Top-Reasoning",
    model_badge_fast: "SCHNELL",
    model_locked_toast: "{model} ist im {tier}-Plan enthalten. Upgrade, um es freizuschalten.",
    chat_sub: "Frage alles — Schreiben, Übersetzung, Rat, Code, Lernen, Ideen.",
    chat_new: "Neuer Chat",
    chat_sessions: "Gespräche",
    chat_empty_title: "Wie kann ich dir heute helfen?",
    chat_empty_sub: "Tippe einfach etwas ein oder versuche einen dieser Vorschläge.",
    chat_placeholder: "Frage Lumioo alles…",
    chat_model: "Modell",
    admin_finance_title: "Finanzen",
    admin_finance_sub: "Umsatz, Kosten, Gewinn/Verlust diesen Monat. Schätzungen — Stripe ist die wahre Quelle.",
    admin_finance_prev: "vorher",
    admin_finance_refresh: "Aktualisieren",
    admin_fin_revenue: "Umsatz",
    admin_fin_llm_cost: "KI-Kosten",
    admin_fin_image_cost: "Bildkosten",
    admin_fin_net_profit: "Nettogewinn",
    admin_fin_net_loss: "Netto-VERLUST",
    admin_fin_margin: "Marge",
    admin_fin_paid_tx: "bezahlte TX",
    admin_fin_messages: "Nachrichten",
    admin_fin_images: "Bilder",
    chat_delete_all: "Alle löschen",
    chat_delete_all_confirm: "Sind Sie sicher, dass Sie ALLE {n} Chats löschen möchten? Dies kann nicht rückgängig gemacht werden.",
    chat_delete_all_done: "{n} Chats gelöscht",
    chat_speed: "Geschwindigkeit",
    chat_gpt5_meter_label: "GPT-5 Nachrichten diesen Monat",
    chat_mode_quick: "Schnell",
    chat_mode_quick_sub: "Gemini Flash · schnell",
    chat_mode_smart: "Smart",
    chat_mode_smart_sub: "Sonnet 4.6 · tiefer",
    chat_mode_genius: "Genie",
    chat_mode_genius_sub: "GPT-5 · top Reasoning",
    chat_mode_master: "Meister",
    chat_mode_master_sub: "Opus 4.5 · am leistungsfähigsten",
    chat_opus_meter_label: "Meister (Opus 4.5) diesen Monat",
    chat_delete: "Löschen",
    chat_copy: "Kopieren",
    chat_copied: "Kopiert",
    chat_no_sessions: "Noch keine Gespräche.",
    chat_suggest_1: "Erkläre einen Splunk SPL-Alert für fehlgeschlagene Admin-Anmeldungen",
    chat_suggest_2: "Schreibe Python, um eine Liste von Dicts zu deduplizieren",
    chat_suggest_3: "Verfasse eine Salesforce-Case-Antwort für eine langsame Lightning-Seite",
    chat_suggest_4: "Plane ein SaaS MVP für KI-Rechnungsverarbeitung",
    video_eyebrow: "Tool",
    video_h1: "KI-Videoproducer",
    video_sub: "Ein Thema → ein komplettes YouTube-Paket mit einem fertigen MP4.",
    video_topic: "Thema",
    video_topic_ph: "z.B. Wie KI Online-Einkommen 2026 umgestalten wird",
    video_tone: "Ton",
    video_length: "Länge",
    video_voice: "Stimme",
    video_generate: "Videopaket generieren",
    video_generating: "Produziere dein Video… (30–90s)",
    video_loading_sub: "Schreibe Skript, male Szenen, nehme Stimme auf, nähe MP4 zusammen…",
    video_empty: "Deine generierten Video-Assets werden hier angezeigt.",
    video_title_l: "Titel",
    video_desc_l: "Beschreibung",
    video_voiceover: "Sprachausgabe",
    video_download_audio: "MP3 herunterladen",
    video_download_video: "MP4 herunterladen",
    video_scenes: "Szenen",
    video_copy_meta: "Metadaten kopieren",
    video_meta_copied: "Metadaten kopiert",
    video_no_mp4: "MP4 nicht verfügbar — du kannst Szenen + Audio separat verwenden.",
    scene: "Szene",
    image_unavailable: "Bild nicht verfügbar",
    projects_eyebrow: "Verlauf",
    projects_h1: "Deine Projekte",
    projects_sub: "Alles, was du mit Lumioo produziert hast.",
    projects_empty: "Noch keine Projekte.",
    try_chat: "Probiere KI-Chat",
    try_video: "Probiere Video Producer",
    video_ready: "Videopaket fertig",
    answer_ready: "Antwort bereit",
    stage_queued: "In Warteschlange…",
    stage_script: "Schreibe Skript…",
    stage_images_audio: "Male Szenen & nehme Stimme auf…",
    stage_stitching: "Nähe MP4 zusammen…",
    stage_done: "Fertig",
    chat_attach_image: "Bild anhängen",
    chat_websearch_label: "Web",
    chat_websearch_on: "Web-Suche AN — Lumioos holt frische Fakten vor der Antwort",
    chat_enable_web_retry: "Web-Suche aktivieren & erneut senden",
    chat_websearch_off: "Web-Suche AUS — Lumioos nutzt sein Wissen. Aktiviere für aktuelle Ereignisse.",
    chat_start_recording: "Sprache starten",
    chat_stop_recording: "Stopp & transkribieren",
    chat_image_attached: "Bild bereit",
    chat_image_remove: "Bild entfernen",
    chat_only_image: "Bitte wähle eine Bilddatei",
    chat_image_too_large: "Bild zu groß (max. 8 MB)",
    chat_drop_title: "Bild hier ablegen zum Anhängen",
    chat_drop_sub: "PNG / JPG / WebP — max 8 MB",
    chat_upgrade_title: "Tageslimit erreicht",
    chat_upgrade_sub: "Du hast heute {used} von {limit} Nachrichten im Free-Plan genutzt. Upgrade um weiterzumachen — das Limit wird um Mitternacht UTC zurückgesetzt.",
    chat_upgrade_benefits: "Was du freischaltest",
    chat_upgrade_b1: "Unbegrenzte Chat-Nachrichten",
    chat_upgrade_b2: "Voller Zugriff auf Interview-Praxis",
    chat_upgrade_b3: "Bild + Stimme im Chat",
    chat_upgrade_b4: "Kein Wasserzeichen auf Videos",
    chat_upgrade_cta: "Pläne ansehen",
    chat_upgrade_later: "Vielleicht später",
    iv_gate_title: "Interview-Praxis ist gesperrt",
    iv_gate_sub: "Diese Funktion ist nur für Creator- und Pro-Abonnenten verfügbar. Upgrade, um unbegrenzte Fragebanken, Sprachmodus und detaillierte Berichte freizuschalten.",
    iv_gate_what_you_get: "Was du freischaltest",
    iv_gate_b1: "Unbegrenzte Fragebanken (PDF / Bild-Upload)",
    iv_gate_b2: "Sprach- + Text-Interview-Modi mit KI-Bewertung",
    iv_gate_b3: "Animierter KI-Interviewer + 4 Stimmen",
    iv_gate_b4: "Detaillierte Leistungsberichte + E-Mail-Zusammenfassung",
    iv_gate_cta: "Pläne ansehen",
    iv_gate_back: "Zurück zu Lumioos",
    vd_gate_title: "KI-Video-Produzent gesperrt",
    vd_gate_sub: "Echte KI-Videos mit Sora 2 — nur Creator- und Pro-Pläne.",
    vd_gate_what_you_get: "Was du freischaltest",
    vd_gate_b1: "Echte kinoreife KI-Videoclips (Sora 2)",
    vd_gate_b2: "Mehrszenen-Videos mit KI-Erzählung in 9 Sprachen",
    vd_gate_b3: "1280×720 MP4-Download — kein Wasserzeichen",
    vd_gate_b4: "Bis zu 15 Videos/Monat bei Creator, 50 bei Pro",
    vd_gate_cta: "Upgrade zum Freischalten",
    vd_gate_back: "Zurück zum Dashboard",
    cancel_btn: "Abonnement kündigen",
    cancel_tooltip: "Du behältst Zugriff bis zum Ablaufdatum",
    cancel_confirm: "Abonnement kündigen? Du behältst vollen Zugriff bis zum aktuellen Ablaufdatum.",
    cancel_ok: "Abonnement gekündigt — Zugriff bleibt bis zum Ablauf bestehen.",
    cancel_ok_with_date: "Abonnement gekündigt. Deine Vorteile bleiben bis zum {date} erhalten.",
    cancel_fail: "Kündigung fehlgeschlagen — bitte erneut versuchen.",
    bug_open: "Fehler melden",
    bug_title: "Fehler oder Problem melden",
    bug_sub: "Erzähl uns, was schiefgelaufen ist. Füge einen Screenshot oder ein PDF hinzu, wenn es hilft.",
    bug_placeholder: "Was hast du erwartet? Was ist tatsächlich passiert?",
    bug_attach: "Screenshot oder PDF anhängen (optional)",
    bug_send: "Bericht senden",
    bug_sending: "Sende...",
    bug_thanks: "Danke! Wir schauen uns das an.",
    bug_send_fail: "Konnte nicht gesendet werden — bitte erneut versuchen.",
    bug_message_short: "Bitte schreibe mindestens 3 Zeichen.",
    bug_file_too_large: "Datei zu groß (max 5 MB)",
    bug_only_image_or_pdf: "Nur Bilder oder PDF-Dateien erlaubt",
    chat_describe_image: "Was siehst du auf diesem Bild?",
    chat_voice_added: "Sprache transkribiert",
    chat_voice_empty: "Konnte nichts hören — versuche es erneut",
    chat_mic_denied: "Mikrofon-Zugriff verweigert",
    chat_recording_ph: "Wird aufgezeichnet… klicke Stopp, wenn fertig",
    video_language: "Sprache",
    project_view: "Anzeigen",
    project_delete: "Löschen",
    project_delete_confirm: "Bestätigen",
    project_cancel: "Abbrechen",
    project_deleted: "Projekt gelöscht",
    project_confirm_delete: "Dieses Projekt dauerhaft löschen?",
    project_back: "Zurück zu Projekten",
    project_not_found: "Projekt nicht gefunden",
    project_no_video: "Kein MP4 für dieses Projekt gespeichert.",
    project_download: "MP4 herunterladen",
    project_download_started: "Download gestartet",
    pricing_expires: "erneuert sich",
    pricing_popular: "Am beliebtesten",
    pricing_month_short: "Mo",
    pricing_free_default: "Standardplan",
    pricing_redirecting: "Leite weiter…",
    pricing_disclaimer: "Zahlungen werden von Stripe verarbeitet. Mit der Anmeldung stimmst du der monatlichen Abrechnung zu. Du kannst jederzeit von deinem Konto aus kündigen.",
    pricing_mobile_note_title: "Die angezeigten Preise gelten für den Web-Checkout.",
    pricing_mobile_note_body: "Abonnements, die in unserer iOS- oder Android-App abgeschlossen werden, können aufgrund der App Store-Gebühren (bis zu 30%) teurer sein. Spare mehr, indem du dich hier im Web anmeldest.",
    pricing_faq_title: "Häufige Fragen",
    pricing_faq_why_pro_q: "Warum kostet Pro $29?",
    pricing_faq_why_pro_a: "Pro enthält jetzt Sora-2 Video, GPT-5, Claude Opus 4.5, GPT Image 1 und unbegrenzten Chat. Einzeln gekauft würde das über $80/Monat kosten (ChatGPT Plus $20 + Runway $15 + Midjourney $10 + Claude Pro $20). Wir bündeln alles für $29 — du sparst über 60%. Bestehende Pro-Kunden bleiben bei ihren $10.",
    pricing_faq_cancel_q: "Kann ich jederzeit kündigen?",
    pricing_faq_cancel_a: "Ja — ein Klick in den Abrechnungseinstellungen. Keine Rückerstattung für den laufenden Monat, aber Pro bleibt bis Periodenende. Wir verlängern nie ohne Hinweis.",
    pricing_faq_existing_q: "Ich habe mich früher angemeldet — ändert sich mein Preis?",
    pricing_faq_existing_a: "Nein. Wenn du bereits $5 (Creator) oder $10 (Pro) zahlst, bleibt dein Stripe-Abo zu diesem Preis, bis DU kündigst oder den Plan wechselst. Nur neue Anmeldungen sehen den neuen Preis.",
    billing_checking: "Zahlung wird bestätigt…",
    billing_checking_sub: "Dies dauert normalerweise ein paar Sekunden.",
    billing_paid: "Zahlung erfolgreich 🎉",
    billing_paid_sub: "Plan aktiviert:",
    billing_pending: "Wird noch verarbeitet",
    billing_pending_sub: "Aktualisiere in einem Moment — der Plan wird automatisch aktiviert.",
    billing_expired: "Sitzung abgelaufen",
    billing_failed: "Zahlung nicht abgeschlossen",
    billing_to_dashboard: "Gehe zum Dashboard",
    billing_back: "Zurück zur Preisgestaltung",
    video_already_running: "Ein Video wird bereits generiert. Warte, bis es fertig ist, oder verwerfe es.",
    video_dismiss_confirm: "Diesen Job verwerfen? (Das Video wird weiter im Hintergrund generiert und erscheint immer noch in Projekten.)",
    pricing_year_short: "Jahr",
    pricing_yearly_savings: "Du sparst ${saved} pro Jahr",
    pricing_admin_unlimited: "Admin — Unbegrenzt (keine Limits)",
    pricing_admin_skip: "Admin: unbegrenzt",
    redeem_required: "Gib einen Code ein",
    redeem_success: "Code angewendet",
    iv_delete_type_to_confirm: 'Tippe "{name}" zum Bestätigen:',
    oauth_err_title: "Salesforce hat die Verbindung nicht autorisiert",
    oauth_err_blocked_subtitle: "Kein Lumioos-Fehler — es ist die Sicherheitsrichtlinie deiner Org. Lösung in 2 Min:",
    oauth_err_generic_subtitle: "OAuth fehlgeschlagen. Probiere die Schritte oder verbinde erneut.",
    oauth_err_step1: "Salesforce → Setup → suche 'Connected Apps OAuth Usage'",
    oauth_err_step2: "Finde 'Lumioos' → klicke 'Allow' / 'Install'",
    oauth_err_step3: "Komm hierher zurück und klicke 'Erneut verbinden'",
    oauth_err_alt_title: "Permanente Lösung:",
    oauth_err_alt_step1: "Setup → App Manager → 'Lumioos' → View",
    oauth_err_alt_step2: "Manage → Edit Policies → 'All users may self-authorize'",
    oauth_err_alt_step3: "Save → erneut verbinden",
    oauth_err_reconnect: "Erneut verbinden",
    oauth_err_close: "Schließen",
    oauth_err_raw: "Technischer Fehlercode",
    pwa_install_lumioos: "Lumioos installieren",
    pwa_install_subtitle: "Zum Startbildschirm hinzufügen — kein App Store nötig.",
    pwa_install_short: "Installieren",
    pwa_not_now: "Nicht jetzt",
    pwa_got_it: "Verstanden",
    pwa_ios_safari_required: "Öffne diese Seite in Safari, um zu installieren",
    pwa_ios_safari_required_sub: "Auf dem iPhone kann nur Safari Apps zum Home-Bildschirm hinzufügen. Kopiere diesen Link und füge ihn in Safari ein.",
    pwa_ios_copy_link: "Link kopieren",
    pwa_modal_title_ios: "Auf iPhone / iPad installieren",
    pwa_modal_title_android: "Auf Android installieren",
    pwa_modal_title_mac: "Auf Mac installieren",
    pwa_modal_title_desktop: "Auf Desktop installieren",
    pwa_modal_ios_step1: "Tippe auf das Teilen-Symbol am unteren Rand von Safari",
    pwa_modal_ios_step2: "Scrolle und tippe auf \"Zum Home-Bildschirm\"",
    pwa_modal_ios_step3: "Tippe auf \"Hinzufügen\" oben rechts",
    pwa_modal_ios_step4: "Lumioos erscheint auf deinem Startbildschirm",
    pwa_modal_android_step1: "Tippe das ⋮ Menü oben rechts in Chrome",
    pwa_modal_android_step2: "Tippe \"Zum Startbildschirm\" oder \"App installieren\"",
    pwa_modal_android_step3: "Tippe \"Installieren\" im Popup",
    pwa_modal_android_step4: "Lumioos öffnet sich wie eine native App",
    pwa_modal_mac_step1: "Klicke auf das Installations-Symbol in der Adressleiste (⊕)",
    pwa_modal_mac_step2: "ODER: Chrome-Menü (⋮) → \"Lumioos installieren…\"",
    pwa_modal_mac_step3: "Klicke \"Installieren\" im Popup",
    pwa_modal_mac_step4: "Lumioos öffnet sich in einem eigenen Fenster",
    pwa_modal_desktop_step1: "Suche das Installations-Symbol in der Adressleiste (⊕ oder ↓)",
    pwa_modal_desktop_step2: "Wenn nicht sichtbar, öffne das Browser-Menü",
    pwa_modal_desktop_step3: "Bestätige mit Klick auf \"Installieren\"",
    pwa_modal_desktop_step4: "Lumioos öffnet sich in einem eigenen Fenster",
    // ---------------- Jarvis (Kontrollzentrum + Hilfe) ----------------
    jarvis_paired_computers_title: "Gekoppelte Computer",
    jarvis_pair_a_computer_btn: "Computer koppeln",
    jarvis_no_devices_hint: "Noch keine Computer gekoppelt. Klicke auf \"Computer koppeln\", um zu starten.",
    jarvis_send_command_title: "Befehl senden",
    jarvis_command_placeholder: "Öffne OBS, starte Chrome auf mylumioos.com, nimm 30 Sekunden auf, stoppe und prüfe das Video",
    jarvis_target_label: "Ziel: {name}",
    jarvis_pair_first_hint: "Koppel einen Computer, um Befehle zu senden",
    jarvis_send_to_jarvis_btn: "An Jarvis senden",
    jarvis_task_history_title: "Aufgabenverlauf",
    jarvis_no_tasks_hint: "Noch keine Aufgaben. Sende oben deinen ersten Befehl.",
    jarvis_device_selected: "Ausgewählt",
    jarvis_device_select: "Auswählen",
    jarvis_device_revoked_badge: "Widerrufen",
    jarvis_status_online: "Online",
    jarvis_status_offline_last_seen: "Offline · zuletzt {ago}",
    jarvis_status_never: "nie",
    jarvis_status_unknown: "unbekannt",
    jarvis_toast_type_command_first: "Gib zuerst einen Befehl ein",
    jarvis_toast_pair_first: "Koppel und wähle zuerst einen Computer",
    jarvis_toast_task_queued: "Aufgabe in Warteschlange — der Agent führt sie gleich aus.",
    jarvis_toast_monthly_limit: "Monatliches Aufgabenlimit erreicht ({max}). Upgrade für mehr.",
    jarvis_toast_task_queue_failed: "Aufgabe konnte nicht in die Warteschlange gestellt werden",
    jarvis_toast_revoke_confirm: "Diesen Computer widerrufen? Der Agent stoppt sofort.",
    jarvis_toast_device_revoked: "Computer widerrufen",
    jarvis_toast_device_revoke_failed: "Computer konnte nicht widerrufen werden",
    jarvis_toast_task_cancelled: "Aufgabe abgebrochen",
    jarvis_toast_task_cancel_failed: "Aufgabe konnte nicht abgebrochen werden",
    jarvis_toast_delete_task_confirm: "Diese Aufgabe aus dem Verlauf löschen?",
    jarvis_toast_task_deleted: "Aufgabe gelöscht",
    jarvis_toast_task_delete_failed: "Aufgabe konnte nicht gelöscht werden",
    jarvis_toast_clear_all_tasks_confirm: "Gesamten Verlauf löschen? Laufende Aufgaben bleiben erhalten.",
    jarvis_toast_tasks_cleared: "{n} Aufgaben gelöscht",
    jarvis_toast_delete_device_confirm: "Diesen Computer dauerhaft entfernen? Sein Verlauf wird ebenfalls gelöscht.",
    jarvis_toast_device_deleted: "Computer entfernt",
    jarvis_clear_all_tasks_btn: "Alles löschen",
    jarvis_task_status_queued: "Warteschlange",
    jarvis_task_status_running: "Läuft",
    jarvis_task_status_completed: "Erledigt",
    jarvis_task_status_failed: "Fehlgeschlagen",
    jarvis_task_status_cancelled: "Abgebrochen",
    jarvis_task_cancel_btn: "Abbrechen",
    jarvis_task_error_label: "Fehler:",
    jarvis_task_steps_label: "Schritte",
    jarvis_task_screenshots_label: "Screenshots ({n})",
    jarvis_task_result_label: "Ergebnis",
    jarvis_task_steps_count: "{n} Schritte",
    jarvis_task_screenshots_count: "{n} Screenshots",
    jarvis_time_seconds_ago: "vor {n}s",
    jarvis_time_minutes_ago: "vor {n}min",
    jarvis_time_hours_ago: "vor {n}h",
    jarvis_time_days_ago: "vor {n}T",
    jarvis_download_windows: "Für Windows herunterladen",
    jarvis_download_macos: "Für macOS herunterladen",
    jarvis_download_linux: "Für Linux herunterladen (macOS-Build)",
    jarvis_alt_downloads_title: "Anderen Computer im Einsatz?",
    jarvis_sys_title: "Systeminformationen",
    jarvis_sys_detected_os: "Erkanntes Betriebssystem",
    jarvis_sys_installed_agent: "Installierter Agent",
    jarvis_sys_latest_version: "Neueste Version",
    jarvis_sys_status_connected: "Verbunden",
    jarvis_sys_status_offline: "Offline",
    jarvis_sys_status_unpaired: "Nicht gekoppelt",
    jarvis_sys_not_installed: "Nicht installiert",
    jarvis_sys_compat_uptodate: "Dein Desktop Agent ist auf dem neuesten Stand.",
    jarvis_sys_compat_outdated: "Installierter Agent v{installed} ist älter als v{latest} — bitte neu herunterladen für die neuesten Funktionen.",
    jarvis_sys_compat_no_agent: "Installiere den Desktop Agent unten, um Jarvis auf diesem Computer zu aktivieren.",
    jarvis_hc_intro_pill: "Einrichtung & Hilfe",
    jarvis_hc_title: "Einrichtungs- und Hilfezentrum",
    jarvis_hc_subtitle: "Installiere, verbinde und behebe Probleme mit dem Desktop Agent in wenigen Minuten — ganz ohne Tutorial.",
    jarvis_hc_search_placeholder: "Themen, Schritte, Fehler suchen…",
    jarvis_hc_no_results: "Keine Treffer für deine Suche. Versuch ein anderes Stichwort.",
    jarvis_hc_tab_wizard: "Einrichtungsassistent",
    jarvis_hc_tab_troubleshoot: "Fehlerbehebung",
    jarvis_hc_tab_faq: "FAQ",
    jarvis_hc_video_title: "Video-Tour",
    jarvis_hc_video_placeholder: "Ein geführtes Video kommt bald — nutze bis dahin den Schritt-für-Schritt-Assistenten.",
    jarvis_hc_step_of: "Schritt {n} von {total}",
    jarvis_hc_prev: "Zurück",
    jarvis_hc_next: "Weiter",
    jarvis_hc_done: "Fertig",
    jarvis_hc_need_help: "Hilfe zu diesem Schritt?",
    jarvis_hc_screenshot_soon: "Ein Screenshot zu diesem Schritt folgt in Kürze.",
    jarvis_hc_troubleshoot_title: "Häufige Probleme & Lösungen",
    jarvis_hc_troubleshoot_subtitle: "Tippe auf ein Problem, um Ursache und Lösung zu sehen.",
    jarvis_hc_faq_title: "Häufig gestellte Fragen",
    jarvis_hc_faq_subtitle: "Alles Wichtige zur Installation, zum Betrieb und zum Update von Jarvis.",
    jarvis_hc_problem_label: "Problem",
    jarvis_hc_cause_label: "Wahrscheinliche Ursache",
    jarvis_hc_solution_label: "Lösung",
    jarvis_hc_step_download_title: "Desktop Agent herunterladen",
    jarvis_hc_step_download_desc: "Klick auf den Download-Button, um die passende ZIP-Datei für dein System (Windows oder macOS) zu erhalten.",
    jarvis_hc_step_download_help: "Wenn nichts heruntergeladen wird, prüfe Popup-Blocker und Download-Ordner deines Browsers.",
    jarvis_hc_step_extract_title: "Heruntergeladene Datei entpacken",
    jarvis_hc_step_extract_desc: "Rechtsklick auf die ZIP → \"Alle extrahieren\" unter Windows, oder Doppelklick unter macOS.",
    jarvis_hc_step_extract_help: "Führe die Dateien nie direkt aus dem ZIP aus — erst entpacken, dann öffnen.",
    jarvis_hc_step_open_folder_title: "Agent-Ordner öffnen",
    jarvis_hc_step_open_folder_desc: "Geh in den soeben entpackten Ordner \"lumioos-desktop-agent\" (meist im Downloads-Ordner).",
    jarvis_hc_step_open_folder_help: "Lass dieses Fenster offen — im Folgenden klickst du hier mehrmals doppelt.",
    jarvis_hc_step_run_install_title: "install-agent ausführen",
    jarvis_hc_step_run_install_desc: "Doppelklick auf install-agent.bat (Windows) oder install-agent.command (macOS). Es installiert die nötigen Python-Pakete.",
    jarvis_hc_step_run_install_help: "Ein Terminal öffnet und schließt sich von selbst. Nur einmal nötig.",
    jarvis_hc_step_generate_code_title: "Koppel-Code erzeugen",
    jarvis_hc_step_generate_code_desc: "Zurück auf diese Seite: klick \"Computer koppeln\" und kopiere den 6-stelligen Code.",
    jarvis_hc_step_generate_code_help: "Codes laufen nach 10 Minuten ab und sind Einmal-Codes. Bei Bedarf einfach neu erzeugen.",
    jarvis_hc_step_run_pair_title: "pair-agent ausführen",
    jarvis_hc_step_run_pair_desc: "Doppelklick auf pair-agent.bat (Windows) oder pair-agent.command (macOS). Ein Terminal fragt nach dem Code.",
    jarvis_hc_step_run_pair_help: "pair-agent nur beim ersten Mal ausführen. Danach immer start-agent.",
    jarvis_hc_step_paste_code_title: "Koppel-Code einfügen",
    jarvis_hc_step_paste_code_desc: "Füge den 6-stelligen Code im Terminal ein und drücke Enter, um den Computer zu autorisieren.",
    jarvis_hc_step_paste_code_help: "Windows: Rechtsklick zum Einfügen. macOS: Cmd+V. Beim Tippen erscheint nichts — das ist normal.",
    jarvis_hc_step_connected_title: "Auf \"Erfolgreich verbunden\" warten",
    jarvis_hc_step_connected_desc: "Das Terminal zeigt \"✓ Erfolgreich gekoppelt!\". Danach kannst du das Fenster schließen.",
    jarvis_hc_step_connected_help: "Bei Fehler: Internet prüfen und neuen Code erzeugen — alte Codes verfallen schnell.",
    jarvis_hc_step_run_start_title: "start-agent ausführen",
    jarvis_hc_step_run_start_desc: "Doppelklick auf start-agent.bat (Windows) oder start-agent.command (macOS), um den Agent online zu bringen.",
    jarvis_hc_step_run_start_help: "Lass das Terminal offen — Schließen bringt den Agent offline.",
    jarvis_hc_step_return_jarvis_title: "Zurück zu Jarvis",
    jarvis_hc_step_return_jarvis_desc: "Kehre im Browser zu dieser Seite zurück — kein Ausloggen oder Neuladen nötig.",
    jarvis_hc_step_return_jarvis_help: "Dein gekoppelter Computer erscheint innerhalb weniger Sekunden in der Liste.",
    jarvis_hc_step_verify_online_title: "Prüfe, ob der Computer Online ist",
    jarvis_hc_step_verify_online_desc: "Ein grüner Punkt am Computernamen bedeutet: Der Agent läuft und wartet auf Befehle.",
    jarvis_hc_step_verify_online_help: "Grauer Punkt = start-agent läuft nicht. Am PC neu starten und erneut prüfen.",
    jarvis_hc_step_first_command_title: "Ersten Befehl senden",
    jarvis_hc_step_first_command_desc: "Tippe \"open youtube.com\" ins Befehlsfeld und klick Senden. Im Verlauf siehst du Live-Screenshots.",
    jarvis_hc_step_first_command_help: "Fang klein an: erst eine Website öffnen, dann OBS-Aufnahmen und mehrschrittige Flows ausprobieren.",
    jarvis_hc_ts_windows_defender_title: "Windows Defender hat die App blockiert",
    jarvis_hc_ts_windows_defender_cause: "SmartScreen markiert nicht Microsoft-signierte .bat-Dateien als Risiko.",
    jarvis_hc_ts_windows_defender_solution: "Klick auf \"Weitere Informationen\" → \"Trotzdem ausführen\". Windows merkt sich diese Entscheidung.",
    jarvis_hc_ts_macos_security_title: "macOS-Sicherheit hat die App blockiert",
    jarvis_hc_ts_macos_security_cause: "Gatekeeper verhindert standardmäßig das Ausführen unsignierter Skripte.",
    jarvis_hc_ts_macos_security_solution: "Systemeinstellungen → Datenschutz & Sicherheit → \"Trotzdem öffnen\" neben der blockierten Datei.",
    jarvis_hc_ts_pairing_failed_title: "Kopplung fehlgeschlagen",
    jarvis_hc_ts_pairing_failed_cause: "Der Code ist abgelaufen (10-min-Limit), wurde falsch eingegeben oder bereits genutzt.",
    jarvis_hc_ts_pairing_failed_solution: "Erzeuge über \"Computer koppeln\" einen frischen Code und füge ihn innerhalb von 10 Minuten in pair-agent ein.",
    jarvis_hc_ts_agent_offline_title: "Desktop Agent ist offline",
    jarvis_hc_ts_agent_offline_cause: "Das start-agent-Fenster wurde geschlossen oder der Computer ist eingeschlafen.",
    jarvis_hc_ts_agent_offline_solution: "Öffne den Agent-Ordner und doppelklicke erneut auf start-agent. Terminal offen lassen.",
    jarvis_hc_ts_obs_not_detected_title: "OBS nicht erkannt",
    jarvis_hc_ts_obs_not_detected_cause: "OBS Studio ist nicht installiert oder sein WebSocket-Server ist deaktiviert.",
    jarvis_hc_ts_obs_not_detected_solution: "Installiere OBS Studio 28+ und aktiviere Werkzeuge → WebSocket-Servereinstellungen → \"WebSocket-Server aktivieren\".",
    jarvis_hc_ts_browser_not_open_title: "Browser öffnet sich nicht",
    jarvis_hc_ts_browser_not_open_cause: "Der eingebettete Chromium von Playwright wurde nicht installiert.",
    jarvis_hc_ts_browser_not_open_solution: "Führe install-agent erneut aus — es installiert Playwright und Chromium automatisch.",
    jarvis_hc_ts_python_failed_title: "Python-Installation fehlgeschlagen",
    jarvis_hc_ts_python_failed_cause: "Python 3.10+ fehlt oder wurde ohne \"Add to PATH\" installiert.",
    jarvis_hc_ts_python_failed_solution: "Installiere Python 3.11 von python.org mit aktiviertem \"Add Python to PATH\" und führe install-agent erneut aus.",
    jarvis_hc_ts_permission_denied_title: "Zugriff verweigert",
    jarvis_hc_ts_permission_denied_cause: "macOS oder Windows blockiert Tastatur-, Maus- oder Bildschirm­aufzeichnungszugriffe.",
    jarvis_hc_ts_permission_denied_solution: "macOS: gib dem Terminal Bedienungshilfen + Bildschirmaufnahme frei. Windows: start-agent als Administrator ausführen.",
    jarvis_hc_ts_connection_timeout_title: "Verbindungs-Timeout",
    jarvis_hc_ts_connection_timeout_cause: "Firewall, VPN oder Firmen-Proxy blockiert HTTPS zu mylumioos.com.",
    jarvis_hc_ts_connection_timeout_solution: "Erlaube mylumioos.com in Firewall/VPN oder deaktiviere den Proxy, dann start-agent neu starten.",
    jarvis_hc_ts_agent_stopped_title: "Agent unerwartet gestoppt",
    jarvis_hc_ts_agent_stopped_cause: "Terminal wurde geschlossen, Computer schlief ein oder ein Update wurde installiert.",
    jarvis_hc_ts_agent_stopped_solution: "start-agent erneut öffnen. Die letzten Terminal-Zeilen zeigen meist die genaue Ursache.",
    jarvis_hc_ts_update_failed_title: "Update fehlgeschlagen",
    jarvis_hc_ts_update_failed_cause: "Eine neuere Desktop-Agent-Version ist erschienen und deine Kopie ist veraltet.",
    jarvis_hc_ts_update_failed_solution: "Lade das neueste ZIP oben, entpacke es über den alten Ordner und starte start-agent neu.",
    jarvis_hc_faq_install_every_time_q: "Muss ich den Agent jedes Mal installieren?",
    jarvis_hc_faq_install_every_time_a: "Nein. install-agent nur einmal pro Computer ausführen. Danach reicht ein Doppelklick auf start-agent.",
    jarvis_hc_faq_can_uninstall_q: "Kann ich den Desktop Agent deinstallieren?",
    jarvis_hc_faq_can_uninstall_a: "Ja. Schließe start-agent und lösche den Ordner lumioos-desktop-agent. Optional den Computer hier widerrufen.",
    jarvis_hc_faq_multiple_computers_q: "Kann ich mehrere Computer koppeln?",
    jarvis_hc_faq_multiple_computers_a: "Ja. Pro erlaubt 2 Computer, Power bis zu 5. Jeder Computer braucht seinen eigenen 6-stelligen Code.",
    jarvis_hc_faq_windows_and_macos_q: "Kann ich Windows und macOS mischen?",
    jarvis_hc_faq_windows_and_macos_a: "Absolut — Jarvis verwaltet jeden Computer eigenständig; Windows und Mac laufen problemlos im selben Konto.",
    jarvis_hc_faq_auto_start_q: "Startet der Agent mit dem Computer?",
    jarvis_hc_faq_auto_start_a: "Standardmäßig nicht. Füge start-agent den Autostart-Programmen hinzu (Windows: Startup, macOS: Login Items).",
    jarvis_hc_faq_how_to_update_q: "Wie aktualisiere ich den Desktop Agent?",
    jarvis_hc_faq_how_to_update_a: "Lade das neueste ZIP von Jarvis, entpacke es über den bestehenden Ordner und starte start-agent neu.",
    jarvis_hc_faq_recordings_location_q: "Wo werden Aufnahmen gespeichert?",
    jarvis_hc_faq_recordings_location_a: "Im Standard-Ausgabeordner von OBS Studio — meist Videos/OBS unter Windows oder Movies unter macOS.",
    jarvis_hc_faq_change_recording_location_q: "Kann ich den Aufnahmeordner ändern?",
    jarvis_hc_faq_change_recording_location_a: "Ja. In OBS: Datei → Einstellungen → Ausgabe → Aufnahme, wähle deinen Ordner. Jarvis übernimmt das automatisch.",
    jarvis_hc_faq_remove_computer_q: "Wie entferne ich einen gekoppelten Computer?",
    jarvis_hc_faq_remove_computer_a: "Klick in der Liste auf das Papierkorb-Symbol neben dem Computer. Sein Agent hört sofort auf, Befehle anzunehmen.",
    },
  it: {
    nav_features: "Funzionalità",
    nav_howit: "Come funziona",
    nav_pricing: "Prezzi",
    nav_download: "Scarica",
    lp_download_eyebrow: "Download",
    lp_download_h2: "Lumioos su ogni dispositivo",
    lp_download_h2_one: "Lumioos è ora su {platform}",
    lp_download_h2_two: "Lumioos per {p1} & {p2}",
    lp_download_sub: "Installa Lumioos su Windows ora — Apple e Android in arrivo.",
    lp_download_sub_one: "Installa Lumioos su {platform}. Altre piattaforme in arrivo.",
    lp_download_sub_two: "Installa su {p1} o {p2} — altri dispositivi in arrivo.",
    lp_download_live: "Disponibile",
    lp_download_soon: "In arrivo",
    lp_download_install: "Installa gratis",
    lp_download_notify: "Presto disponibile",
    nav_signin: "Accedi",
    nav_get_started: "Inizia",
    hero_badge: "Scelto dai professionisti — Claude 4.5 · GPT-5 · Gemini 3",
    hero_h1_a: "Il tuo spazio AI —",
    hero_h1_b: "più intelligente, veloce, sicuro",
    hero_sub: "Lumioo è il tuo assistente AI professionale. Risolvi problemi complessi in chat con supporto immagine e voce, produci video pronti per la pubblicazione in 6 lingue, e consegna in minuti ciò che richiedeva ore. Da {from_price}/mese.",
    hero_cta_primary: "Inizia gratis — nessuna carta",
    hero_cta_secondary: "Scopri come funziona",
    trust_no_card: "Nessuna carta richiesta",
    trial_badge: "Prova Pro di {days} giorni · senza carta",
    trial_banner_text: "{days} giorni rimasti nella tua prova Pro gratuita",
    trial_banner_ending_today: "La tua prova gratuita finisce oggi — passa a Pro",
    trial_banner_cta: "Passa a Pro",
    trial_banner_close: "Chiudi",
    trial_pill_label: "Prova · {days}g",
    trial_pill_cta: "Passa Pro",
    trial_pill_tooltip: "Sei in prova Pro gratuita — passa a Pro prima della fine.",
    trial_ribbon_text: "🎁 Ottieni {days} giorni di Pro gratis — senza carta",
    trial_ribbon_pill: "Offerta limitata",
    trial_ribbon_cta: "Inizia gratis",
    hero_cta_trial: "Inizia la prova di {days} giorni",
    // Refer & Earn page
    ref_back: "Indietro",
    ref_title: "Invita e Guadagna",
    ref_subtitle: "Invita un amico → tu ottieni +{days} giorni di Pro per ogni registrazione, il tuo amico inizia con 14 giorni di Pro gratis (prova standard di 7 giorni + 7 giorni di bonus referral).",
    ref_loading: "Caricamento…",
    ref_invited: "Invitati",
    ref_days_earned: "Giorni Pro guadagnati",
    ref_your_link: "Il tuo link di invito",
    ref_copy: "Copia",
    ref_copied: "Copiato",
    ref_share: "Condividi",
    ref_your_code: "Il tuo codice:",
    ref_recent: "Inviti recenti",
    ref_days_awarded: "+{days} giorni Pro",
    ref_how_to_share: "📣 Come condividere?",
    ref_share_whatsapp: "Condividilo nei gruppi WhatsApp / Telegram",
    ref_share_twitter: "Pubblica su X con uno screenshot della demo",
    ref_share_linkedin: "Pubblica su LinkedIn con il link",
    ref_share_forum: "Menziona nei forum Salesforce / Trailhead e Reddit",
    ref_link_copied: "Link copiato",
    ref_copy_error: "Impossibile copiare",
    ref_load_error: "Impossibile caricare i referral",
    ref_share_message: "Prova Lumioos con il mio link — registrati e ottieni 14 giorni di Pro gratis!",
    trial_ended_close: "Chiudi",
    trial_ended_title: "Bentornato su Free",
    trial_ended_subtitle: "La tua prova Pro di 7 giorni è appena terminata.",
    trial_ended_losing: "Perdi l'accesso a",
    trial_ended_feat_video: "🎬 Video Producer (Sora 2)",
    trial_ended_feat_interview: "🎤 Interview Practice (colloqui simulati)",
    trial_ended_feat_image: "🖼️ Image Producer (GPT Image 1)",
    trial_ended_feat_salesforce: "⚡ Salesforce / Trailhead Agent",
    trial_ended_promo_eyebrow: "Offerta unica",
    trial_ended_promo_headline: "20% SCONTO su Pro — solo per te",
    trial_ended_promo_sub: "Il codice {code} si applica automaticamente al checkout. Valido solo ora.",
    trial_ended_cta_upgrade: "Passa a Pro con {code} → 20% SCONTO",
    trial_ended_cta_later: "Forse più tardi",
    trust_stripe: "Pagamenti sicuri con Stripe",
    trust_privacy: "I tuoi dati restano privati",
    trust_rating: "Amato dai primi utenti",
    hero_card_live: "Live",
    hero_card_eyebrow: "Risposta AI live",
    hero_card_question: "Come risolvo un errore di loop Salesforce Flow?",
    hero_card_assistant: "Assistente Lumioo",
    hero_card_answer: "Aggiungi una condizione di guardia all'elemento Update Records. Usa un Decision prima dell'inizio del loop per verificare se lo stato del record corrisponde già — questo rompe la ricorsione.",
    hero_card_time: "Risolto in 8s",
    hero_chip_voice: "Voce → Testo",
    hero_chip_image: "Vedi i tuoi screenshot",
    hero_chip_lang: "6 lingue",
    stat_1_n: "Lingue",
    stat_2_n: "Modelli AI",
    stat_3_n: "Tempo medio risposta",
    stat_4_n: "Disponibilità",
    feat_section_eyebrow: "Cosa fa Lumioo",
    feat_section_h2: "Uno spazio. Tutti i superpoteri AI.",
    feat_section_sub: "Smetti di gestire 6 schede. Chatta, vedi, ascolta, produci — tutto da un unico spazio pulito.",
    feat_chat_title: "Chat AI Intelligente",
    feat_chat_desc: "Chiedi qualsiasi cosa in linguaggio naturale. Allega uno screenshot per l'analisi visiva. Parla invece di scrivere.",
    coming_soon_badge: "Prossimamente",
    gs_ad_cta_soon: "Avvisami al lancio",
    gs_ad_locked: "Bloccato per ora — in arrivo a breve.",
    gs_coming_soon_toast: "Game Studio arriva presto — ti avviseremo!",
    feat_video_title: "Produttore Video Cinematografico",
    feat_video_desc: "Digita un argomento in una delle 6 lingue. In minuti, ottieni script, narrazione AI, scene cinematografiche e un MP4 pronto.",
    feat_speed_t: "Velocità lampo",
    feat_speed_d: "Risposte in secondi. Video in minuti. Zero attese.",
    feat_secure_t: "Sicurezza bancaria",
    feat_secure_d: "Sessioni cifrate. I tuoi prompt non addestrano mai AI.",
    feat_global_t: "Globale per design",
    feat_global_d: "Supporto nativo per 6 lingue — incluso l'italiano.",
    how_eyebrow: "Come funziona",
    how_h2: "Tre passi. Zero curva di apprendimento.",
    how_s1_t: "Registrazione gratuita",
    how_s1_d: "Nessuna carta. Crea il tuo account in meno di 30 secondi.",
    how_s2_t: "Chiedi o descrivi",
    how_s2_d: "Scrivi, parla o trascina uno screenshot. O scrivi un argomento video nella tua lingua.",
    how_s3_t: "Usa il risultato",
    how_s3_d: "Copia la risposta. Scarica l'MP4. Pubblica. Fatto.",
    lp_pricing_eyebrow: "Prezzi semplici ed equi",
    lp_pricing_h2: "Inizia gratis. Aggiorna solo se serve.",
    lp_pricing_sub: "Ogni piano include funzioni AI essenziali. Nessun costo nascosto. Annulla quando vuoi.",
    lp_plan_popular: "Più popolare",
    lp_plan_start: "Inizia",
    cta_h2_a: "Pronto a lavorare",
    cta_h2_b: "più intelligente?",
    cta_sub: "Unisciti ai professionisti che si fidano di Lumioo ogni giorno. Gratis per uso personale.",
    cta_btn: "Crea il tuo account gratuito",
    cta_smallprint: "Nessuna carta. Registrazione in 30s. Annulla quando vuoi.",
    footer_tag: "Costruito per professionisti.",
    footer_privacy: "Privacy",
    footer_terms: "Termini",
    side_dashboard: "Dashboard",
    side_chat: "Chat AI",
    side_video: "Produttore Video",
    side_image: "Produttore di Immagini",
    side_cv: "Creatore di CV",
    side_interview: "Pratica Colloquio",
    side_projects: "Progetti",
    side_billing: "Abbonamento",
    side_referrals: "Invita & Guadagna",
    side_admin: "Admin",
    side_ai_workforce: "AI Workforce",
    wf_badge: "ADMIN · PHASE 1",
    wf_title: "AI Workforce",
    wf_subtitle: "Manage your private AI company workforce. Delegate objectives, monitor progress, and approve every action that touches the outside world.",
    wf_total_agents: "Total Agents",
    wf_active_agents: "Active Agents",
    wf_busy_agents: "Busy Agents",
    wf_tasks_in_progress: "Tasks in Progress",
    wf_tasks_completed: "Completed Tasks",
    wf_tasks_failed: "Failed Tasks",
    wf_approvals_pending: "Pending Approvals",
    wf_agents_title: "AI Employees",
    wf_workspace_company: "Company Workspace",
    wf_phase_notice_title: "Sub-Phase 1A · Foundation ready",
    wf_phase_notice_body: "Tasks, CEO orchestration, agent messaging and approvals arrive in Sub-Phase 1B → 1D. The employees above are already configured and ready — no further action needed until then.",
    wf_refresh: "Aggiorna",
    wf_ceo_chat_title: "Chat CEO",
    wf_ceo_chat_empty: 'Parla naturalmente con il CEO AI. Prova: "Quali attività sono in attesa di approvazione?" o "Ricerca 3 idee di registrazione."',
    wf_ceo_chat_placeholder: "Chiedi qualsiasi cosa al CEO, o dì 'ricerca X', 'annulla attività', 'approva bozza'…",
    wf_ceo_chat_hint: "L\'intenzione è rilevata automaticamente: le domande rispondono dal DB reale; le intenzioni di attività/controllo/approvazione chiamano le vere API. Nessuna capacità falsa — il CEO lo dice quando uno strumento non è collegato.",
    wf_chat_view_task: "Vedi attività →",
    wf_new_objective: "Nuovo Obiettivo",
    wf_task_title_placeholder: "es. Crea un piano marketing 3 giorni per Lumioos",
    wf_task_desc_placeholder: "Descrivi l\'obiettivo in dettaglio. Che risultato vuoi? Vincoli?",
    wf_send_to_ceo: "Invia al CEO AI",
    wf_ceo_will_plan: "Il CEO AI ({model}) pianificherà → assegnerà agli specialisti → raccoglierà i risultati. Marketing/Sales/Support/Finance entrano nella coda di approvazione.",
    wf_recent_tasks: "Attività Recenti",
    wf_no_tasks: "Ancora nessuna attività. Crea sopra il tuo primo obiettivo.",
    wf_recent_activity: "Attività Recente",
    wf_no_activity: "Nessuna attività.",
    wf_agent_chat_empty: "Saluta {name}, o dai un\'attività diretta.",
    wf_agent_chat_placeholder: "Parla con {name}…",
    wf_tab_overview: "Panoramica",
    wf_tab_chat: "Chat",
    wf_tab_current: "In corso",
    wf_tab_history: "Storico",
    wf_tab_activity: "Attività",
    wf_tab_memory: "Memoria",
    wf_tab_config: "Config",
    wf_field_status: "Stato",
    wf_field_completed: "Completate",
    wf_field_completed_count: "{n} completate",
    wf_field_last_activity: "Ultima attività",
    wf_field_none: "—",
    wf_no_active_tasks: "Nessuna attività attiva.",
    wf_no_history: "Nessuno storico.",
    wf_no_memory: "Nessuna memoria.",
    wf_cfg_model: "Modello (in esecuzione)",
    wf_cfg_allowed_tools: "Strumenti consentiti",
    wf_cfg_system_instructions: "Istruzioni di sistema",
    wf_cfg_agent_id: "ID Agente",
    wf_task_objective: "Obiettivo",
    wf_task_ceo_plan: "Piano CEO",
    wf_task_children: "Sotto-attività ({n})",
    wf_task_view_result: "Vedi risultato ({n} caratteri)",
    wf_task_error_prefix: "Errore:",
    wf_task_ceo_summary: "Riepilogo CEO",
    wf_task_agent_messages: "Messaggi agente ({n})",
    wf_task_pause: "Pausa",
    wf_task_resume: "Riprendi",
    wf_task_retry: "Riprova",
    wf_task_cancel: "Annulla",
    wf_approve: "Approva",
    wf_reject: "Rifiuta",
    wf_approval_status_prefix: "Approvazione {status}",
    wf_approvals_title: "Approvazioni in attesa ({n})",
    wf_no_approvals: "Nessuna approvazione in attesa.",
    wf_lwr_badge: "RICERCA WEB LIVE",
    wf_lwr_counts: "{searches} ricerche · {sources} fonti · {pages} pagine lette",
    wf_status_idle: "Inattivo",
    wf_status_working: "Al lavoro",
    wf_status_waiting_for_approval: "In attesa di approvazione",
    wf_status_paused: "In pausa",
    wf_status_error: "Errore",
    wf_status_offline: "Offline",
    wf_status_pending: "In sospeso",
    wf_status_planning: "Pianificazione",
    wf_status_assigned: "Assegnata",
    wf_status_in_progress: "In corso",
    wf_status_completed: "Completata",
    wf_status_failed: "Fallita",
    wf_status_cancelled: "Annullata",
    wf_leads_title: "Lead",
    wf_leads_open: "Apri lead",
    wf_leads_overview_title: "Pipeline lead",
    wf_leads_total: "Lead totali",
    wf_leads_new: "Nuovi",
    wf_leads_qualified: "Qualificati",
    wf_leads_reviewing: "In revisione",
    wf_leads_approved: "Approvati",
    wf_leads_rejected: "Rifiutati",
    wf_leads_archived: "Archiviati",
    wf_leads_verified: "Verificati",
    wf_leads_needs_review: "Da rivedere",
    wf_leads_none: "Ancora nessun lead. Chiedi a Sales AI di cercarli.",
    wf_leads_filter_status: "Stato",
    wf_leads_filter_verification: "Verifica",
    wf_leads_filter_min_score: "Punteggio min.",
    wf_leads_filter_industry: "Settore",
    wf_leads_filter_all: "Tutti",
    wf_leads_sort: "Ordina",
    wf_leads_sort_score: "Punteggio più alto",
    wf_leads_sort_newest: "Più recenti",
    wf_leads_sort_name: "Nome azienda",
    wf_leads_col_company: "Azienda",
    wf_leads_col_website: "Sito web",
    wf_leads_col_industry: "Settore",
    wf_leads_col_location: "Posizione",
    wf_leads_col_score: "Punteggio",
    wf_leads_col_verification: "Verifica",
    wf_leads_col_status: "Stato",
    wf_leads_col_discovered: "Scoperto",
    wf_leads_score_reasons: "Perché questo punteggio",
    wf_leads_concerns: "Preoccupazioni",
    wf_leads_sources: "Fonti",
    wf_leads_discovery_task: "Attività di scoperta",
    wf_leads_actions_approve: "Approva",
    wf_leads_actions_reject: "Rifiuta",
    wf_leads_actions_archive: "Archivia",
    wf_leads_action_ok: "Lead {action}",
    wf_leads_action_fail: "Impossibile {action} il lead",
    wf_leads_no_outreach_note: "L\'approvazione contrassegna questo lead per follow-up. Nessuna email, DM o contatto viene inviato.",
    wf_lead_status_new: "Nuovo",
    wf_lead_status_qualified: "Qualificato",
    wf_lead_status_reviewing: "In revisione",
    wf_lead_status_approved: "Approvato",
    wf_lead_status_rejected: "Rifiutato",
    wf_lead_status_archived: "Archiviato",
    wf_verif_verified: "Verificato",
    wf_verif_needs_review: "Da rivedere",
    wf_verif_unverified: "Non verificato",
    wf_toast_task_created: "Obiettivo inviato al CEO AI — pianificazione in corso…",
    wf_toast_task_short: "Fornisci titolo e descrizione più lunghi",
    wf_toast_task_create_fail: "Impossibile creare l\'attività",
    wf_toast_task_load_fail: "Impossibile caricare l\'attività",
    wf_toast_workforce_load_fail: "Impossibile caricare AI Workforce",
    wf_toast_task_action_ok: "Attività {action}",
    wf_toast_task_action_fail: "Impossibile {action} l\'attività",
    wf_toast_approved: "Approvato",
    wf_toast_rejected: "Rifiutato",
    wf_toast_approval_fail: "Impossibile risolvere l\'approvazione",
    wf_chat_error_prefix: "Errore:",
    wf_chat_error_fallback: "chat fallita",
    side_upgrade: "Aggiorna",
    side_logout: "Esci",
    side_theme: "Tema",
    pricing_eyebrow: "Piani",
    pricing_h1: "Scegli il tuo piano",
    pricing_sub: "Aggiorna quando vuoi. Annulla quando vuoi.",
    pricing_current: "Piano attuale",
    pricing_monthly: "Mensile",
    pricing_yearly: "Annuale",
    pricing_save_2mo: "Risparmia 2 mesi",
    pricing_month: "mese",
    pricing_year: "anno",
    pricing_subscribe: "Abbonati",
    pricing_current_plan: "Piano attuale",
    redeem_have_code: "Hai un codice?",
    redeem_apply: "Applica",
    chat_send: "Invia",
    chat_thinking: "Sto pensando…",
    chat_stop: "Ferma",
    chat_continue: "Continua",
    chat_stopped_marker: "⏹ Fermato",
    chat_continue_prompt: "Per favore, continua da dove ti sei fermato.",
    chat_thinking_fast: "⚡ Veloce",
    chat_thinking_balanced: "🎯 Bilanciato",
    chat_thinking_thorough: "🧠 Approfondito",
    bestai_sub: "Attualmente #1 in scrittura, codice e ragionamento. Passa a GPT-5 o Gemini 3 in qualsiasi momento — senza costi aggiuntivi.",
    bestai_table_h: "Scegli il modello giusto per il lavoro.",
    bestai_table_sub: "Lumioos ti dà tutti e tre — cambia con un clic per chat.",
    bestai_footnote: "Tutti i modelli inclusi nel tuo abbonamento Lumioos — cambia con un clic, senza costi aggiuntivi.",
    bestai_h2: "Alimentato da Claude 4.5.",
    bestai_eyebrow: "Predefinito intelligente",
    bestai_task_writing: "Scrittura lunga",
    bestai_task_code: "Codice e debug",
    bestai_task_translate: "Traduci (TR/AR/RU)",
    bestai_task_reasoning: "Ragionamento più difficile",
    bestai_task_capable: "Più capace",
    bestai_task_quick: "Risposte rapide",
    gpt56_promo_badge: "NUOVO · ESCLUSIVA PRO & POWER",
    gpt56_promo_title: "Famiglia GPT 5.6",
    gpt56_promo_desc: "Scopri la nuova generazione di GPT — tre varianti, un solo scopo: darti l'esatto equilibrio di profondità, ampiezza e velocità per ogni compito. Disponibile oggi sui piani {plans}.",
    gpt56_promo_plans_hl: "Pro & Power",
    gpt56_sol_tag: "Ragionamento più profondo",
    gpt56_sol_desc: "Per i problemi più difficili — analisi lunghe, ricerca, revisione di codice complessa. Quando la precisione conta più della velocità.",
    gpt56_terra_tag: "Potenza equilibrata",
    gpt56_terra_desc: "Il tuo cavallo di battaglia quotidiano. Ottime risposte, abbastanza veloce, vasta conoscenza — il punto ideale tra Sol e Luna.",
    gpt56_luna_tag: "Il 5.6 più veloce",
    gpt56_luna_desc: "Risposte rapide per chat, brainstorming e ricerche veloci. Ancora più intelligente della maggior parte dei modelli — solo più veloce.",
    gpt56_cta_plans: "Vedi i piani Pro & Power →",
    gpt56_cta_trial: "Inizia la prova gratuita di 14 giorni",
    router_promo_badge: "NUOVO · ESCLUSIVA PRO",
    router_promo_desc: "Il modello più potente del pianeta — instradato automaticamente ai tuoi compiti più difficili. Un solo toggle in chat invia codice complesso, analisi e ragionamento a OpenAI GPT-5, mentre le domande di tutti i giorni restano rapide su Claude 4.5. Nessun selettore di modello. Nessun attrito.",
    router_promo_bullet1: "Seleziona GPT-5 per i compiti difficili",
    router_promo_bullet2: "Ragionamento e codice ai vertici mondiali",
    router_promo_bullet3: "Coda prioritaria, senza limiti di velocità",
    router_promo_bullet4: "Toggle a un clic in chat",
    router_promo_cta: "Passa a Pro",
    router_promo_included: "Incluso gratuitamente in ogni piano Pro",
    sonnet_promo_pill: "Ideale per attività generali",
    sonnet_promo_default_label: "— predefinito su Lumioos",
    sonnet_promo_desc: "Il modello di punta di Anthropic guida i benchmark indipendenti in scrittura, codice e ragionamento complesso. Tasso di allucinazione inferiore a GPT-5 e qualità multilingue superiore. Impostato come predefinito Lumioos così i nuovi utenti ottengono i migliori risultati subito.",
    sonnet_col_writing: "Scrittura",
    sonnet_col_code: "Codice",
    sonnet_col_reasoning: "Ragionamento",
    err_generic: "Qualcosa è andato storto",
    err_topic_required: "Inserisci un argomento",
    err_message_required: "Inserisci un messaggio",
    feat_chat_li1: "Caricamento immagini — analizza qualsiasi screenshot o foto",
    feat_chat_li2: "Input vocale — parla e Lumioo trascritto",
    feat_chat_li3: "Codice, documenti, Salesforce, sicurezza — supporto di esperti",
    feat_chat_li4: "Cronologia conversazioni — riprendi quando vuoi",
    stat_1_v: "6",
    stat_2_v: "3+",
    stat_3_v: "8s",
    stat_4_v: "99.9%",
    feat_video_li1: "Script nella tua lingua (TR · EN · ES · FR · DE · IT · PT · JA · ZH)",
    feat_video_li2: "9 voci AI naturali — scegli il tono perfetto",
    feat_video_li3: "Effetti visivi AI cinematografici — nessun aspetto da video di repertorio",
    feat_video_li4: "Scarica MP4 + voiceover + scene",
    lp_plan_free_desc: "Perfetto per provare Lumioo e l'uso personale.",
    lp_plan_free_f1: "5 immagini IA / mese",
    lp_plan_free_f2: "10 messaggi chat / giorno",
    lp_plan_free_f3: "Tutte le 6 lingue",
    lp_plan_creator_desc: "Per freelancer, studenti e creator.",
    lp_plan_creator_f1: "15 video / mese — fino a 3 minuti",
    lp_plan_creator_f2: "Chat illimitata con immagine e voce",
    lp_plan_creator_f3: "Senza filigrana",
    lp_plan_creator_f4: "Velocità di risposta prioritaria",
    lp_plan_pro_desc: "Per professionisti e piccoli team.",
    lp_plan_pro_f1: "50 video / mese — fino a 20 minuti",
    lp_plan_pro_f2: "Tutto di Creator",
    lp_plan_pro_f3: "Output Full HD 1080p",
    lp_plan_pro_f4: "Supporto prioritario",
    lp_plan_pro_f5: "✨ CV Chat & Review — illimitato (PDF/Word/immagine)",
    lp_plan_power_desc: "Per utenti intensivi e creator power.",
    lp_plan_power_f1: "Tutto in Pro",
    lp_plan_power_f2: "500 immagini IA/mese (HD)",
    lp_plan_power_f3: "GPT-5 · 1500 messaggi, Opus 4.5 · 100/mese",
    lp_plan_power_f4: "Supporto prioritario · uso equo",
    lp_plan_power_f5: "✨ CV Chat & Review — illimitato + prioritario",
    lp_pricing_trust1: "Protetto da Stripe",
    lp_pricing_trust2: "Annulla in qualsiasi momento",
    lp_pricing_trust3: "Conforme al GDPR",
    auth_eyebrow_login: "Accedi a",
    auth_eyebrow_register: "Crea il tuo",
    auth_h1_login: "Bentornato.",
    auth_h1_register: "account Lumioo.",
    auth_sub_login: "Riprendi da dove hai lasciato.",
    auth_sub_register: "Ricevi 50 crediti gratuiti per iniziare.",
    auth_name: "Nome",
    auth_email: "Email",
    auth_password: "Password",
    auth_signin: "Accedi",
    auth_create: "Crea account",
    auth_no_account: "Non hai ancora un account?",
    auth_have_account: "Hai già un account?",
    auth_forgot: "Password dimenticata?",
    fp_eyebrow: "Recupero account",
    fp_title: "Reimposta la tua password",
    fp_subtitle: "Inserisci l'email associata al tuo account e ti invieremo un link di reimpostazione.",
    fp_send_btn: "Invia link di reimpostazione",
    fp_back_login: "Torna al login",
    fp_sent_title: "Controlla la tua inbox",
    fp_sent_body: "Se esiste un account per {email}, un link di reimpostazione è in arrivo. È valido per 1 ora.",
    fp_sent_hint: "Non lo vedi? Controlla lo spam o riprova tra pochi minuti.",
    rp_title: "Imposta una nuova password",
    rp_subtitle: "Scegli una password forte — almeno 8 caratteri.",
    rp_new_password: "Nuova password",
    rp_confirm_password: "Conferma password",
    rp_submit_btn: "Salva nuova password",
    rp_mismatch: "Le password non corrispondono",
    rp_too_short: "La password deve avere almeno 8 caratteri",
    rp_invalid: "Questo link di reimpostazione non è valido o è scaduto.",
    rp_success: "Password aggiornata. Sei collegato.",
    rp_no_token_title: "Nessun token di reimpostazione trovato",
    rp_no_token_body: "Questo link sembra rotto. Richiedi una nuova email di reimpostazione.",
    rp_request_new: "Richiedi un nuovo link",
    auth_create_one: "Creane uno",
    auth_demo: "Account demo",
    welcome_back: "Bentornato!",
    account_created: "Account creato. Benvenuto!",
    auth_failed: "Autenticazione non riuscita",
    iv_eyebrow: "Interview Practice",
    iv_h1: "Pratica qualsiasi intervista. A voce alta.",
    iv_sub: "Carica i tuoi fogli di domande come foto. Lumioos estrae ogni Q&A, crea la tua banca privata e ti interroga — per voce o testo. Perfetto per interviste di cittadinanza USCIS, green card, lavoro e certificazione.",
    iv_my_banks: "Le mie banche di domande",
    iv_total: "totale",
    iv_loading: "Caricamento…",
    iv_empty_title: "Nessuna banca di domande ancora",
    iv_empty_sub: "Creane una qui sopra, quindi carica una foto del tuo foglio di studio o aggiungi domande manualmente.",
    iv_questions: "domande",
    iv_open: "Apri",
    iv_create: "Crea banca",
    iv_bank_name_ph: "Nome della banca (es. USCIS Civics)",
    iv_bank_desc_ph: "Breve descrizione (opzionale)",
    iv_bank_created: "Banca creata",
    iv_create_fail: "Impossibile creare la banca",
    iv_confirm_delete: "Eliminare questa banca e tutte le sue domande?",
    iv_deleted: "Eliminato",
    iv_delete_fail: "Eliminazione non riuscita",
    iv_load_fail: "Caricamento non riuscito",
    iv_hint_title: "Come funziona",
    iv_hint_sub: "Scatta una foto di qualsiasi foglio di preparazione per interviste (test di cittadinanza USA, domande per green card, preparazione per interviste di lavoro, domande di certificazione). Lumioos lo legge con visione AI, estrae ogni domanda con tutte le risposte accettate e la archivia per sempre. Quindi pratica per voce (l'AI parla la domanda, tu rispondi al microfono) o per testo.",
    iv_back_library: "Torna alla libreria",
    iv_practice: "Pratica",
    iv_start_h2: "Inizia intervista",
    iv_mode_text: "Modalità testo",
    iv_mode_voice: "Modalità voce",
    iv_mode_text_hint: "Leggi ogni domanda, digita la tua risposta. L'AI valuta in base al significato, non alle parole esatte.",
    iv_mode_voice_hint: "L'AI parla ogni domanda. Tocca il microfono, rispondi a voce alta. L'AI trascritto e valuta.",
    iv_order_label: "Ordine delle domande",
    iv_order_random: "Casuale",
    iv_order_sequential: "Sequenziale",
    iv_limit_label: "Quante domande",
    iv_limit_all: "Tutte ({n} domande)",
    iv_limit_all_short: "Tutte",
    iv_limit_max: "max {n}",
    iv_limit_clamped: "La banca ha solo {n} domande — usandole tutte.",
    iv_or: "o",
    iv_start_now: "Inizia ora",
    iv_start_fail: "Impossibile avviare la sessione",
    iv_no_questions_start: "Aggiungi almeno una domanda prima",
    iv_upload_title: "Carica immagini o PDF",
    iv_upload_sub: "Foto, screenshot o file PDF di fogli di domande. L'AI estrae ogni Q&A automaticamente (fino a 100 file, i PDF vengono letti pagina per pagina).",
    iv_choose_images: "Scegli immagini",
    iv_choose_files: "Scegli immagini o PDF",
    iv_extracting: "Estrazione Q&A in corso…",
    iv_extracted: "domande aggiunte dalle immagini",
    iv_extract_fail: "Impossibile estrarre domande",
    iv_budget_partial: "Aggiunte {n} domande, ma la tua chiave AI ha esaurito il credito a metà. Ricarica per ottenere il resto.",
    iv_partial_extract: "Aggiunte {n} domande ({f} batch non riusciti — riprova per ottenere il resto).",
    iv_progress_label: "Elaborazione batch {c} di {n}…",
    feat_iv_eyebrow: "Interview Practice",
    feat_iv_title: "Allenati per qualsiasi intervista — a voce alta o per iscritto",
    feat_iv_desc: "Carica i tuoi fogli di studio (foto o PDF). Lumioos estrae ogni Q&A, quindi ti interroga con un intervistatore AI dal vivo che parla le domande, ascolta le tue risposte parlate e valuta in base al significato — rigoroso rispetto alla chiave di risposta dell'esame.",
    feat_iv_li1: "Preparazione alla cittadinanza USCIS e green card",
    feat_iv_li2: "Pratica di interviste di lavoro e tecniche",
    feat_iv_li3: "Modalità voce + ascolto (domande nascoste)",
    feat_iv_li4: "Valutazione rigorosa + rapporto per domanda alla fine",
    feat_iv_cta: "Avvia pratica intervista",
    feat_iv_use_cases: "USCIS · Green Card · Lavoro · Certificazioni · Qualsiasi cosa",
    feat_iv_badge: "NUOVO",
    iv_speed_label: "Velocità di elocuzione",
    iv_speed_slow: "Lenta",
    iv_speed_normal: "Normale",
    iv_speed_fast: "Veloce",
    iv_speed_faster: "Molto veloce",
    iv_speed_hint: "Quanto velocemente l'intervistatore parla le domande.",
    iv_range_label: "Intervallo di domande",
    iv_range_hint: "1 a {n}",
    iv_range_from: "Da",
    iv_range_to: "a",
    iv_range_clear: "cancella",
    iv_range_note: "Lascia vuoto per usare tutte le domande. L'intervallo si applica all'ordine sorgente (es. 1 → 50).",
    iv_range_invalid: "La fine deve essere ≥ all'inizio.",
    iv_deleted_undo: "Banca eliminata ({n} domande). Puoi annullare entro 10 secondi.",
    iv_q_deleted_undo: "Domanda eliminata. Puoi annullare entro 8 secondi.",
    iv_undo: "Annulla",
    iv_restored: "Ripristinato.",
    iv_restore_fail: "Impossibile ripristinare",
    iv_delete_warning: "Elimina in modo permanente",
    iv_delete_q: "Eliminare questa banca e le sue {n} domande?",
    iv_delete_desc: "Stai per eliminare la banca",
    iv_delete_btn: "Elimina banca",
    iv_voice_label: "Voce dell'intervistatore",
    iv_voice_female: "Femmina (Nova)",
    iv_voice_male: "Maschio (Ash) — delicato",
    iv_voice_female2: "Femmina (Shimmer)",
    iv_voice_male2: "Maschio (Fable) — amichevole",
    iv_voice_hint: "Scegli la voce del tuo intervistatore AI.",
    iv_finish_early: "Termina esame",
    iv_finish_early_confirm: "Terminare l'esame ora? Hai risposto a {n} di {total} domande.",
    iv_finish_early_btn: "Termina ora",
    iv_keep_going: "Continua",
    iv_finishing: "Completamento…",
    iv_congrats: "Congratulazioni! 🎉",
    iv_congrats_sub: "Hai superato con un punteggio eccellente.",
    iv_good_job: "Bel lavoro!",
    iv_good_job_sub: "Prestazioni solide — continua a praticare.",
    iv_keep_practising: "Continua a praticare",
    iv_keep_practising_sub: "Rivedi le tue risposte sbagliate di seguito e riprova.",
    iv_score_label: "Punteggio",
    iv_wrong_review: "Rivedi risposte sbagliate",
    iv_resume_eyebrow: "In corso",
    iv_resume_title: "Hai un'intervista incompleta",
    iv_resume_progress: "{done} / {total} domande risposte finora",
    iv_resume_btn: "Riprendi",
    iv_resume_discard: "Scarta",
    iv_resume_discard_confirm: "Scartare questa sessione incompleta e ricominciare da capo?",
    iv_resume_discarded: "Sessione scartata",
    iv_large_upload_warn: "Il tuo caricamento è circa {mb}MB. I caricamenti molto grandi possono fallire su connessioni lente. Continuare?",
    iv_trash: "Cestino",
    iv_trash_title: "Eliminati di recente",
    iv_trash_banks: "Banche eliminate",
    iv_trash_questions: "Domande eliminate",
    iv_trash_empty: "Il cestino è vuoto.",
    iv_trash_load_fail: "Impossibile caricare il cestino",
    iv_purge: "Elimina per sempre",
    iv_purge_confirm: "Eliminare questa banca in modo permanente? Questo non può essere annullato.",
    iv_progress_preparing: "Preparazione dei file…",
    iv_report_title: "Analisi domanda per domanda",
    iv_your_answer: "La tua risposta",
    iv_skipped: "(saltato)",
    iv_max_10: "Max 10 immagini alla volta",
    iv_max_100: "Max 100 immagini alla volta",
    iv_manual_title: "Aggiungi manualmente",
    iv_manual_sub: "Digita una domanda e le risposte che vuoi che Lumioos accetti.",
    iv_add_question: "Aggiungi domanda",
    iv_cancel: "Annulla",
    iv_question: "Domanda",
    iv_accepted_answers: "Risposte accettate (una per riga)",
    iv_accepted_ph: "Esecutivo\\nLegislativo\\nGiudiziario\\nCongresso\\nPresidente",
    iv_min_required: "Minimo richiesto",
    iv_min_hint: "Quante delle risposte accettate deve dire l'utente? (Di solito 1)",
    iv_add: "Aggiungi",
    iv_q_added: "Domanda aggiunta",
    iv_add_fail: "Impossibile aggiungere domanda",
    iv_need_q_and_a: "Domanda e almeno 1 risposta richieste",
    iv_question_list: "Domande",
    iv_no_questions: "Nessuna domanda ancora. Carica una foto o aggiungi manualmente.",
    iv_confirm_delete_q: "Eliminare questa domanda?",
    iv_back_bank: "Torna alla banca",
    iv_voice_interview: "Intervista vocale",
    iv_text_interview: "Intervista testuale",
    iv_record: "Registra risposta",
    iv_stop_record: "Fermi e trascrivi",
    iv_transcribing: "Trascrizione in corso…",
    iv_voice_answer_ph: "La tua risposta trascritta apparirà qui. Puoi anche modificare prima di inviare.",
    iv_text_answer_ph: "Digita la tua risposta qui…",
    iv_submit: "Invia",
    iv_skip: "Salta",
    iv_correct: "Corretto",
    iv_wrong: "Non esattamente",
    iv_accepted_were: "Le risposte accettate erano:",
    iv_see_results: "Vedi i risultati",
    iv_next_question: "Domanda successiva",
    iv_need_n_answers: "Fornisci almeno {n} risposte diverse",
    iv_results: "Risultati",
    iv_accuracy: "precisione",
    iv_restart: "Ricomincia banca",
    iv_speak: "Parla domanda",
    iv_show_question: "Mostra domanda",
    iv_hide_question: "Nascondi domanda (ascolto)",
    iv_question_hidden: "Domanda nascosta — ascolta l'audio",
    iv_voice_intro_line: "Ciao! Quando sei pronto, premi Avvia e inizierò a farti le domande.",
    iv_voice_ready: "Sono pronto, iniziamo",
    iv_show_q_label: "Mostrare le domande sullo schermo?",
    iv_show_q_on: "Mostra",
    iv_show_q_off: "Nascondi (ascolto)",
    iv_show_q_on_hint: "Il testo della domanda è visibile durante l'esercitazione.",
    iv_show_q_off_hint: "Solo l'audio riprodotto — ottimo per la pratica di ascolto.",
    iv_starred_label: "Quali domande chiedere?",
    iv_starred_all: "Tutte le domande",
    iv_starred_only: "Solo stelle / importanti",
    iv_starred_hint: "Stella (⭐) domande su cui vuoi concentrarti. Lumioos stella automaticamente le domande contrassegnate come importanti/probabili nella tua fonte.",
    iv_starred_badge: "Importante",
    iv_star: "Stella questa domanda",
    iv_unstar: "Togli stella",
    iv_tts_fail: "Impossibile riprodurre l'audio della domanda",
    iv_stt_fail: "Impossibile trascrivere l'audio",
    iv_mic_denied: "Accesso al microfono negato",
    iv_need_answer: "Digita o registra prima una risposta",
    iv_submit_fail: "Impossibile inviare risposta",
    iv_skip_fail: "Impossibile saltare",
    side_credits: "Crediti",
    side_language: "Lingua",
    side_integrations: "Integrazioni",
    side_help: "Aiuto e Token",
    auth_google: "Continua con Google",
    auth_or: "o con email",
    integrations_eyebrow: "Connetti",
    integrations_h1: "Integrazioni",
    integrations_sub: "Connetti Salesforce, Splunk, Defender, Trend Micro, SentinelOne, CrowdStrike e altri. Lumioo recupererà i tuoi casi e li risolverà.",
    help_eyebrow: "Documentazione",
    help_h1: "Guida ai token e alle chiavi API",
    help_faq: "Domande frequenti",
    help_sub: "Guide passo dopo passo per ottenere un token API da ogni piattaforma supportata. Fai clic su qualsiasi pulsante 'Apri' per saltare direttamente alla pagina giusta.",
    dash_eyebrow: "Pannello di controllo",
    dash_hello: "Ciao",
    dash_sub: "Scegli uno strumento e inizia a produrre.",
    dash_credits_label: "Crediti disponibili",
    dash_open: "Apri strumento",
    dash_chat_card_desc: "Chiedi qualsiasi cosa: Salesforce, sicurezza informatica, codice, progetti.",
    dash_video_card_desc: "Argomento → pacchetto YouTube completo + video MP4.",
    dash_interview_card_desc: "Esercitati nei colloqui di lavoro con un intervistatore IA.",
    dash_pro_only_badge: "Creator e Pro",
    dash_card_unlock: "Aggiorna per sbloccare",
    dash_recent_eye: "Progetti recenti",
    dash_recent_h2: "I tuoi ultimi lavori",
    dash_view_all: "Visualizza tutti",
    dash_no_projects: "Nessun progetto ancora. Inizia con",
    dash_or: "o",
    chat_eyebrow: "Strumento",
    chat_h1: "Chat AI",
    chat_mode_image_hint: "Crea immagini",
    chat_mode_code_hint: "Aiuto rapido col codice",
    chat_mode_cv_hint: "Crea CV",
    chat_mode_video_hint: "Crea video",
    model_desc_haiku: "Chat veloce quotidiano",
    model_desc_sonnet: "Pensiero profondo e scrittura",
    model_desc_gpt4o: "Equilibrato, uso generale",
    model_desc_gemini: "Multimodale e visione",
    model_desc_gpt5: "Compiti più difficili · top ragionamento",
    model_badge_fast: "VELOCE",
    model_locked_toast: "{model} è nel piano {tier}. Aggiorna per sbloccarlo.",
    chat_sub: "Chiedi qualsiasi cosa — scrittura, traduzione, consiglio, codice, apprendimento, idee.",
    chat_new: "Nuova chat",
    chat_sessions: "Conversazioni",
    chat_empty_title: "Come posso aiutarti oggi?",
    chat_empty_sub: "Inizia a digitare o prova uno di questi suggerimenti.",
    chat_placeholder: "Chiedi a Lumioo qualsiasi cosa…",
    chat_model: "Modello",
    admin_finance_title: "Finanze",
    admin_finance_sub: "Ricavi, costi, profitto/perdita di questo mese. Stime — Stripe è la fonte vera.",
    admin_finance_prev: "precedente",
    admin_finance_refresh: "Aggiorna",
    admin_fin_revenue: "Ricavi",
    admin_fin_llm_cost: "Costo IA",
    admin_fin_image_cost: "Costo immagini",
    admin_fin_net_profit: "Profitto netto",
    admin_fin_net_loss: "PERDITA netta",
    admin_fin_margin: "Margine",
    admin_fin_paid_tx: "tx pagate",
    admin_fin_messages: "messaggi",
    admin_fin_images: "immagini",
    chat_delete_all: "Cancella tutto",
    chat_delete_all_confirm: "Sei sicuro di voler eliminare TUTTE le {n} chat? Questa azione non può essere annullata.",
    chat_delete_all_done: "{n} chat eliminate",
    chat_speed: "Velocità",
    chat_gpt5_meter_label: "Messaggi GPT-5 questo mese",
    chat_mode_quick: "Veloce",
    chat_mode_quick_sub: "Gemini Flash · rapido",
    chat_mode_smart: "Smart",
    chat_mode_smart_sub: "Sonnet 4.6 · più profondo",
    chat_mode_genius: "Genio",
    chat_mode_genius_sub: "GPT-5 · ragionamento top",
    chat_mode_master: "Maestro",
    chat_mode_master_sub: "Opus 4.5 · il più capace",
    chat_opus_meter_label: "Maestro (Opus 4.5) questo mese",
    chat_delete: "Elimina",
    chat_copy: "Copia",
    chat_copied: "Copiato",
    chat_no_sessions: "Nessuna conversazione ancora.",
    chat_suggest_1: "Spiega un avviso SPL Splunk per accessi admin non riusciti",
    chat_suggest_2: "Scrivi Python per deduplicare un elenco di diction",
    chat_suggest_3: "Bozza di risposta al caso Salesforce per una pagina Lightning lenta",
    chat_suggest_4: "Pianifica un MVP SaaS per l'elaborazione delle fatture AI",
    video_eyebrow: "Strumento",
    video_h1: "Produttore video AI",
    video_sub: "Un argomento → un pacchetto YouTube completo con un video MP4 finito.",
    video_topic: "Argomento",
    video_topic_ph: "es. Come l'AI rimodellerà il reddito online nel 2026",
    video_tone: "Tono",
    video_length: "Lunghezza",
    video_voice: "Voce",
    video_generate: "Genera pacchetto video",
    video_generating: "Produzione del tuo video… (30–90s)",
    video_loading_sub: "Scrittura script, disegno scene, registrazione vocale, stitching MP4…",
    video_empty: "Le tue risorse video generate appariranno qui.",
    video_title_l: "Titolo",
    video_desc_l: "Descrizione",
    video_voiceover: "Voiceover",
    video_download_audio: "Scarica MP3",
    video_download_video: "Scarica MP4",
    video_scenes: "Scene",
    video_copy_meta: "Copia metadati",
    video_meta_copied: "Metadati copiati",
    video_no_mp4: "MP4 non disponibile — puoi comunque usare scene e audio separatamente.",
    scene: "Scena",
    image_unavailable: "Immagine non disponibile",
    projects_eyebrow: "Cronologia",
    projects_h1: "I tuoi progetti",
    projects_sub: "Tutto quello che hai prodotto con Lumioo.",
    projects_empty: "Nessun progetto ancora.",
    try_chat: "Prova AI Chat",
    try_video: "Prova Video Producer",
    video_ready: "Pacchetto video pronto",
    answer_ready: "Risposta pronta",
    stage_queued: "In coda…",
    stage_script: "Scrittura script in corso…",
    stage_images_audio: "Disegno scene e registrazione vocale…",
    stage_stitching: "Stitching MP4…",
    stage_done: "Fatto",
    chat_attach_image: "Allega immagine",
    chat_websearch_label: "Web",
    chat_websearch_on: "Ricerca web ATTIVA — Lumioos cercherà dati aggiornati prima di rispondere",
    chat_enable_web_retry: "Attiva ricerca web e riprova",
    chat_websearch_off: "Ricerca web SPENTA — Lumioos usa la sua conoscenza. Attiva per eventi attuali.",
    chat_start_recording: "Inizia voce",
    chat_stop_recording: "Fermi e trascrivi",
    chat_image_attached: "Immagine pronta",
    chat_image_remove: "Rimuovi immagine",
    chat_only_image: "Scegli un file immagine",
    chat_image_too_large: "Immagine troppo grande (max 8 MB)",
    chat_drop_title: "Rilascia l'immagine per allegarla",
    chat_drop_sub: "PNG / JPG / WebP — max 8 MB",
    chat_upgrade_title: "Hai raggiunto il limite giornaliero",
    chat_upgrade_sub: "Hai usato {used} di {limit} messaggi oggi sul piano Free. Esegui l'upgrade per continuare — il limite si resetta a mezzanotte UTC.",
    chat_upgrade_benefits: "Cosa sblocchi",
    chat_upgrade_b1: "Messaggi chat illimitati",
    chat_upgrade_b2: "Accesso completo alla Pratica Colloqui",
    chat_upgrade_b3: "Immagine + voce nella chat",
    chat_upgrade_b4: "Nessuna filigrana sui video",
    chat_upgrade_cta: "Vedi i piani",
    chat_upgrade_later: "Forse più tardi",
    iv_gate_title: "Pratica Colloqui è bloccata",
    iv_gate_sub: "Questa è una funzione Creator e Pro. Esegui l'upgrade per sbloccare banche di domande illimitate, modalità vocale e report dettagliati.",
    iv_gate_what_you_get: "Cosa sblocchi",
    iv_gate_b1: "Banche di domande illimitate (caricamento PDF / immagini)",
    iv_gate_b2: "Modalità colloquio vocale + testo con valutazione AI",
    iv_gate_b3: "Intervistatore AI animato + 4 voci",
    iv_gate_b4: "Report di prestazione dettagliati + riepilogo via email",
    iv_gate_cta: "Vedi i piani",
    iv_gate_back: "Torna a Lumioos",
    vd_gate_title: "Produttore Video IA bloccato",
    vd_gate_sub: "Veri video IA con Sora 2 — solo piani Creator e Pro.",
    vd_gate_what_you_get: "Cosa sblocchi",
    vd_gate_b1: "Veri clip video IA cinematografici (Sora 2)",
    vd_gate_b2: "Video multi-scena con narrazione IA in 9 lingue",
    vd_gate_b3: "Download MP4 1280×720 — senza filigrana",
    vd_gate_b4: "Fino a 15 video/mese su Creator, 50 su Pro",
    vd_gate_cta: "Aggiorna per sbloccare",
    vd_gate_back: "Torna alla Dashboard",
    cancel_btn: "Annulla abbonamento",
    cancel_tooltip: "Manterrai l'accesso fino alla data di scadenza",
    cancel_confirm: "Annullare il tuo abbonamento? Manterrai l'accesso completo fino alla data di scadenza attuale.",
    cancel_ok: "Abbonamento annullato — accesso mantenuto fino alla scadenza.",
    cancel_ok_with_date: "Abbonamento annullato. Manterrai i tuoi vantaggi fino al {date}.",
    cancel_fail: "Impossibile annullare — riprova.",
    bug_open: "Segnala un bug",
    bug_title: "Segnala un bug o un problema",
    bug_sub: "Dicci cosa è andato storto. Allega uno screenshot o PDF se aiuta.",
    bug_placeholder: "Cosa ti aspettavi succedesse? Cosa è successo davvero?",
    bug_attach: "Allega screenshot o PDF (opzionale)",
    bug_send: "Invia segnalazione",
    bug_sending: "Invio...",
    bug_thanks: "Grazie! Ce ne occuperemo.",
    bug_send_fail: "Impossibile inviare — riprova.",
    bug_message_short: "Per favore scrivi almeno 3 caratteri.",
    bug_file_too_large: "File troppo grande (max 5 MB)",
    bug_only_image_or_pdf: "Sono permesse solo immagini o PDF",
    chat_describe_image: "Cosa vedi in questa immagine?",
    chat_voice_added: "Voce trascritta",
    chat_voice_empty: "Non ho sentito nulla — riprova",
    chat_mic_denied: "Accesso al microfono negato",
    chat_recording_ph: "Registrazione… fai clic su stop al termine",
    video_language: "Lingua",
    project_view: "Visualizza",
    project_delete: "Elimina",
    project_delete_confirm: "Conferma",
    project_cancel: "Annulla",
    project_deleted: "Progetto eliminato",
    project_confirm_delete: "Eliminare questo progetto in modo permanente?",
    project_back: "Torna ai progetti",
    project_not_found: "Progetto non trovato",
    project_no_video: "Nessun MP4 salvato per questo progetto.",
    project_download: "Scarica MP4",
    project_download_started: "Download avviato",
    pricing_expires: "rinnova",
    pricing_popular: "Più popolare",
    pricing_month_short: "mese",
    pricing_free_default: "Piano predefinito",
    pricing_redirecting: "Reindirizzamento…",
    pricing_disclaimer: "Pagamenti elaborati da Stripe. Sottoscrivendo accetti la fatturazione mensile. Annulla dal tuo account in qualsiasi momento.",
    pricing_mobile_note_title: "I prezzi mostrati si riferiscono al pagamento web.",
    pricing_mobile_note_body: "Gli abbonamenti acquistati all'interno della nostra app iOS o Android possono costare di più a causa delle commissioni App Store (fino al 30%). Risparmia iscrivendoti qui sul web.",
    pricing_faq_title: "Domande frequenti",
    pricing_faq_why_pro_q: "Perché Pro costa $29?",
    pricing_faq_why_pro_a: "Pro ora include video Sora-2, GPT-5, Claude Opus 4.5, GPT Image 1 e chat illimitata. Comprato separatamente costerebbe oltre $80/mese (ChatGPT Plus $20 + Runway $15 + Midjourney $10 + Claude Pro $20). Tutto insieme per $29 — risparmi oltre il 60%. I clienti Pro esistenti rimangono a $10.",
    pricing_faq_cancel_q: "Posso annullare in qualsiasi momento?",
    pricing_faq_cancel_a: "Sì — un click dalle impostazioni di fatturazione. Niente rimborsi per il mese in corso, ma mantieni Pro fino alla fine del periodo. Non rinnoviamo mai senza preavviso.",
    pricing_faq_existing_q: "Mi sono iscritto prima — il prezzo cambia?",
    pricing_faq_existing_a: "No. Se paghi già $5 (Creator) o $10 (Pro), il tuo abbonamento Stripe rimane a quel prezzo finché TU annulli o cambi piano. Solo le nuove iscrizioni vedono il nuovo prezzo.",
    billing_checking: "Conferma del pagamento…",
    billing_checking_sub: "Di solito questo richiede alcuni secondi.",
    billing_paid: "Pagamento completato 🎉",
    billing_paid_sub: "Piano attivato:",
    billing_pending: "Ancora in elaborazione",
    billing_pending_sub: "Aggiorna tra un momento — il piano si attiverà automaticamente.",
    billing_expired: "Sessione scaduta",
    billing_failed: "Pagamento non completato",
    billing_to_dashboard: "Vai al pannello di controllo",
    billing_back: "Torna ai prezzi",
    video_already_running: "Un video è già in fase di generazione. Aspetta che finisca o chiudilo.",
    video_dismiss_confirm: "Chiudere questo lavoro? (Il video continuerà a essere generato in background e apparirà comunque in Progetti.)",
    pricing_year_short: "anno",
    pricing_yearly_savings: "Risparmi ${saved} all'anno",
    pricing_admin_unlimited: "Admin — Illimitato (nessun limite)",
    pricing_admin_skip: "Admin: illimitato",
    redeem_required: "Inserisci un codice",
    redeem_success: "Codice applicato",
    iv_delete_type_to_confirm: 'Digita "{name}" per confermare:',
    oauth_err_title: "Salesforce non ha autorizzato la connessione",
    oauth_err_blocked_subtitle: "Non è un errore Lumioos — è la policy di sicurezza della tua org. Soluzione in 2 min:",
    oauth_err_generic_subtitle: "OAuth fallito. Prova i passaggi o riconnetti.",
    oauth_err_step1: "Salesforce → Setup → cerca 'Connected Apps OAuth Usage'",
    oauth_err_step2: "Trova 'Lumioos' → clic 'Allow' / 'Install'",
    oauth_err_step3: "Torna qui e clic 'Riconnetti'",
    oauth_err_alt_title: "Soluzione permanente:",
    oauth_err_alt_step1: "Setup → App Manager → 'Lumioos' → View",
    oauth_err_alt_step2: "Manage → Edit Policies → 'All users may self-authorize'",
    oauth_err_alt_step3: "Save → riconnetti",
    oauth_err_reconnect: "Riconnetti",
    oauth_err_close: "Chiudi",
    oauth_err_raw: "Codice errore tecnico",
    pwa_install_lumioos: "Installa Lumioos",
    pwa_install_subtitle: "Aggiungi alla schermata home — no app store.",
    pwa_install_short: "Installa",
    pwa_not_now: "Non ora",
    pwa_got_it: "Capito",
    pwa_ios_safari_required: "Apri questo sito in Safari per installare",
    pwa_ios_safari_required_sub: "Su iPhone, solo Safari può aggiungere app alla schermata Home. Copia questo link e incollalo in Safari.",
    pwa_ios_copy_link: "Copia link",
    pwa_modal_title_ios: "Installa su iPhone / iPad",
    pwa_modal_title_android: "Installa su Android",
    pwa_modal_title_mac: "Installa su Mac",
    pwa_modal_title_desktop: "Installa su desktop",
    pwa_modal_ios_step1: "Tocca l'icona Condividi in basso in Safari",
    pwa_modal_ios_step2: "Scorri e tocca \"Aggiungi alla schermata Home\"",
    pwa_modal_ios_step3: "Tocca \"Aggiungi\" in alto a destra",
    pwa_modal_ios_step4: "Lumioos apparirà sulla home come una app nativa",
    pwa_modal_android_step1: "Tocca il menu ⋮ in alto a destra in Chrome",
    pwa_modal_android_step2: "Tocca \"Aggiungi alla home\" o \"Installa app\"",
    pwa_modal_android_step3: "Tocca \"Installa\" nel popup",
    pwa_modal_android_step4: "Lumioos si apre come una app nativa",
    pwa_modal_mac_step1: "Clicca l'icona di installazione nella barra degli indirizzi (⊕)",
    pwa_modal_mac_step2: "OPPURE: Menu Chrome (⋮) → \"Installa Lumioos…\"",
    pwa_modal_mac_step3: "Clicca \"Installa\"",
    pwa_modal_mac_step4: "Lumioos si apre in una finestra propria",
    pwa_modal_desktop_step1: "Cerca l'icona di installazione nella barra degli indirizzi (⊕ o ↓)",
    pwa_modal_desktop_step2: "Se non la vedi, apri il menu del browser",
    pwa_modal_desktop_step3: "Conferma cliccando \"Installa\"",
    pwa_modal_desktop_step4: "Lumioos si apre in una finestra propria",
    // ---------------- Jarvis (Centro di controllo + Aiuto) ----------------
    jarvis_paired_computers_title: "Computer abbinati",
    jarvis_pair_a_computer_btn: "Abbina un computer",
    jarvis_no_devices_hint: "Nessun computer abbinato. Clicca \"Abbina un computer\" per iniziare.",
    jarvis_send_command_title: "Invia un comando",
    jarvis_command_placeholder: "Apri OBS, avvia Chrome su mylumioos.com, registra 30 secondi, ferma e verifica il video",
    jarvis_target_label: "Destinazione: {name}",
    jarvis_pair_first_hint: "Abbina un computer per abilitare i comandi",
    jarvis_send_to_jarvis_btn: "Invia a Jarvis",
    jarvis_task_history_title: "Cronologia attività",
    jarvis_no_tasks_hint: "Nessuna attività ancora. Invia il primo comando qui sopra.",
    jarvis_device_selected: "Selezionato",
    jarvis_device_select: "Seleziona",
    jarvis_device_revoked_badge: "Revocato",
    jarvis_status_online: "Online",
    jarvis_status_offline_last_seen: "Offline · visto {ago}",
    jarvis_status_never: "mai",
    jarvis_status_unknown: "sconosciuto",
    jarvis_toast_type_command_first: "Scrivi prima un comando",
    jarvis_toast_pair_first: "Abbina e seleziona prima un computer",
    jarvis_toast_task_queued: "Attività in coda — l'agente la eseguirà a breve.",
    jarvis_toast_monthly_limit: "Limite mensile raggiunto ({max}). Passa a un piano superiore.",
    jarvis_toast_task_queue_failed: "Impossibile accodare l'attività",
    jarvis_toast_revoke_confirm: "Revocare questo computer? L'agente si fermerà subito.",
    jarvis_toast_device_revoked: "Computer revocato",
    jarvis_toast_device_revoke_failed: "Impossibile revocare il computer",
    jarvis_toast_task_cancelled: "Attività annullata",
    jarvis_toast_task_cancel_failed: "Impossibile annullare l'attività",
    jarvis_toast_delete_task_confirm: "Eliminare questa attività dalla cronologia?",
    jarvis_toast_task_deleted: "Attività eliminata",
    jarvis_toast_task_delete_failed: "Impossibile eliminare l'attività",
    jarvis_toast_clear_all_tasks_confirm: "Eliminare tutta la cronologia? Le attività in corso vengono conservate.",
    jarvis_toast_tasks_cleared: "{n} attività eliminate",
    jarvis_toast_delete_device_confirm: "Rimuovere definitivamente questo computer? Anche la sua cronologia verrà cancellata.",
    jarvis_toast_device_deleted: "Computer rimosso",
    jarvis_clear_all_tasks_btn: "Cancella tutto",
    jarvis_task_status_queued: "In coda",
    jarvis_task_status_running: "In esecuzione",
    jarvis_task_status_completed: "Completata",
    jarvis_task_status_failed: "Fallita",
    jarvis_task_status_cancelled: "Annullata",
    jarvis_task_cancel_btn: "Annulla",
    jarvis_task_error_label: "Errore:",
    jarvis_task_steps_label: "Passi",
    jarvis_task_screenshots_label: "Screenshot ({n})",
    jarvis_task_result_label: "Risultato",
    jarvis_task_steps_count: "{n} passi",
    jarvis_task_screenshots_count: "{n} screenshot",
    jarvis_time_seconds_ago: "{n}s fa",
    jarvis_time_minutes_ago: "{n}min fa",
    jarvis_time_hours_ago: "{n}h fa",
    jarvis_time_days_ago: "{n}g fa",
    jarvis_download_windows: "Scarica per Windows",
    jarvis_download_macos: "Scarica per macOS",
    jarvis_download_linux: "Scarica per Linux (build macOS)",
    jarvis_alt_downloads_title: "Stai usando un altro computer?",
    jarvis_sys_title: "Informazioni sistema",
    jarvis_sys_detected_os: "Sistema rilevato",
    jarvis_sys_installed_agent: "Agente installato",
    jarvis_sys_latest_version: "Ultima versione",
    jarvis_sys_status_connected: "Connesso",
    jarvis_sys_status_offline: "Offline",
    jarvis_sys_status_unpaired: "Non abbinato",
    jarvis_sys_not_installed: "Non installato",
    jarvis_sys_compat_uptodate: "Il tuo Desktop Agent è aggiornato.",
    jarvis_sys_compat_outdated: "Il tuo agente v{installed} è precedente a v{latest} — riscaricalo per le ultime funzionalità.",
    jarvis_sys_compat_no_agent: "Installa il Desktop Agent qui sotto per attivare Jarvis su questo computer.",
    jarvis_hc_intro_pill: "Configurazione e aiuto",
    jarvis_hc_title: "Centro configurazione e aiuto",
    jarvis_hc_subtitle: "Installa, collega e risolvi problemi del Desktop Agent in pochi minuti — nessun tutorial necessario.",
    jarvis_hc_search_placeholder: "Cerca argomenti, passi, errori…",
    jarvis_hc_no_results: "Nessun risultato. Prova con un'altra parola chiave.",
    jarvis_hc_tab_wizard: "Procedura guidata",
    jarvis_hc_tab_troubleshoot: "Risoluzione problemi",
    jarvis_hc_tab_faq: "Domande frequenti",
    jarvis_hc_video_title: "Video guida",
    jarvis_hc_video_placeholder: "Il tour video guidato arriverà a breve — nel frattempo segui la procedura passo passo.",
    jarvis_hc_step_of: "Passo {n} di {total}",
    jarvis_hc_prev: "Indietro",
    jarvis_hc_next: "Avanti",
    jarvis_hc_done: "Fatto",
    jarvis_hc_need_help: "Serve aiuto per questo passo?",
    jarvis_hc_screenshot_soon: "Uno screenshot d'anteprima arriverà presto.",
    jarvis_hc_troubleshoot_title: "Problemi comuni e soluzioni",
    jarvis_hc_troubleshoot_subtitle: "Tocca un problema per vederne la causa probabile e la soluzione.",
    jarvis_hc_faq_title: "Domande frequenti",
    jarvis_hc_faq_subtitle: "Tutto ciò che serve per installare, eseguire e aggiornare Jarvis.",
    jarvis_hc_problem_label: "Problema",
    jarvis_hc_cause_label: "Causa probabile",
    jarvis_hc_solution_label: "Soluzione",
    jarvis_hc_step_download_title: "Scarica il Desktop Agent",
    jarvis_hc_step_download_desc: "Clicca il pulsante per ottenere lo ZIP adatto al tuo sistema (Windows o macOS).",
    jarvis_hc_step_download_help: "Se non parte nulla, controlla blocco popup e cartella Download del browser.",
    jarvis_hc_step_extract_title: "Estrai il file scaricato",
    jarvis_hc_step_extract_desc: "Tasto destro sullo ZIP → \"Estrai tutto\" su Windows, o doppio clic su macOS.",
    jarvis_hc_step_extract_help: "Non eseguire mai i file direttamente dallo ZIP: prima estrai.",
    jarvis_hc_step_open_folder_title: "Apri la cartella dell'agente",
    jarvis_hc_step_open_folder_desc: "Entra nella cartella \"lumioos-desktop-agent\" appena estratta (di solito in Download).",
    jarvis_hc_step_open_folder_help: "Tieni questa finestra aperta: farai doppio clic su alcuni file nei prossimi passi.",
    jarvis_hc_step_run_install_title: "Esegui install-agent",
    jarvis_hc_step_run_install_desc: "Doppio clic su install-agent.bat (Windows) o install-agent.command (macOS). Installa i pacchetti Python necessari.",
    jarvis_hc_step_run_install_help: "Si apre un terminale che si chiude da solo. Va eseguito una sola volta.",
    jarvis_hc_step_generate_code_title: "Genera un codice di abbinamento",
    jarvis_hc_step_generate_code_desc: "Torna qui, clicca \"Abbina un computer\" e copia il codice a 6 cifre.",
    jarvis_hc_step_generate_code_help: "I codici scadono in 10 minuti e sono monouso. Rigeneralo se scade.",
    jarvis_hc_step_run_pair_title: "Esegui pair-agent",
    jarvis_hc_step_run_pair_desc: "Doppio clic su pair-agent.bat (Windows) o pair-agent.command (macOS). Chiederà il codice.",
    jarvis_hc_step_run_pair_help: "pair-agent va eseguito solo la prima volta. Poi si usa sempre start-agent.",
    jarvis_hc_step_paste_code_title: "Incolla il codice di abbinamento",
    jarvis_hc_step_paste_code_desc: "Incolla il codice a 6 cifre nel terminale e premi Invio per autorizzare il computer.",
    jarvis_hc_step_paste_code_help: "Windows: tasto destro per incollare. macOS: Cmd+V. Durante la digitazione non compare nulla: è normale.",
    jarvis_hc_step_connected_title: "Attendi \"Collegato con successo\"",
    jarvis_hc_step_connected_desc: "Il terminale mostrerà \"✓ Abbinato con successo!\". Puoi chiudere la finestra.",
    jarvis_hc_step_connected_help: "Se fallisce, controlla internet e rigenera il codice — quelli vecchi scadono in fretta.",
    jarvis_hc_step_run_start_title: "Esegui start-agent",
    jarvis_hc_step_run_start_desc: "Doppio clic su start-agent.bat (Windows) o start-agent.command (macOS) per portare l'agente online.",
    jarvis_hc_step_run_start_help: "Lascia il terminale aperto: chiudendolo l'agente va offline.",
    jarvis_hc_step_return_jarvis_title: "Torna a Jarvis",
    jarvis_hc_step_return_jarvis_desc: "Torna a questa pagina nel browser — non serve uscire o ricaricare.",
    jarvis_hc_step_return_jarvis_help: "Il computer abbinato apparirà nella lista in pochi secondi.",
    jarvis_hc_step_verify_online_title: "Verifica che il computer sia Online",
    jarvis_hc_step_verify_online_desc: "Un pallino verde accanto al nome indica che l'agente è attivo e pronto ai comandi.",
    jarvis_hc_step_verify_online_help: "Pallino grigio = start-agent non attivo. Riavvialo sul PC.",
    jarvis_hc_step_first_command_title: "Invia il primo comando",
    jarvis_hc_step_first_command_desc: "Scrivi \"open youtube.com\" e premi Invia. Guarda la cronologia per vedere gli screenshot in tempo reale.",
    jarvis_hc_step_first_command_help: "Inizia da cose semplici: apri un sito, poi prova la registrazione OBS e i flussi multi-passo.",
    jarvis_hc_ts_windows_defender_title: "Windows Defender ha bloccato l'app",
    jarvis_hc_ts_windows_defender_cause: "SmartScreen segnala i .bat nuovi non firmati Microsoft.",
    jarvis_hc_ts_windows_defender_solution: "Clicca \"Ulteriori informazioni\" e poi \"Esegui comunque\". Windows ricorda la scelta.",
    jarvis_hc_ts_macos_security_title: "La sicurezza macOS ha bloccato l'app",
    jarvis_hc_ts_macos_security_cause: "Gatekeeper impedisce di default l'esecuzione di script non firmati.",
    jarvis_hc_ts_macos_security_solution: "Impostazioni di sistema → Privacy e sicurezza → \"Apri comunque\" accanto al file bloccato.",
    jarvis_hc_ts_pairing_failed_title: "Abbinamento fallito",
    jarvis_hc_ts_pairing_failed_cause: "Il codice è scaduto (10 min), scritto male o già usato.",
    jarvis_hc_ts_pairing_failed_solution: "Clicca di nuovo \"Abbina un computer\" e incolla il nuovo codice in pair-agent entro 10 minuti.",
    jarvis_hc_ts_agent_offline_title: "Il Desktop Agent è offline",
    jarvis_hc_ts_agent_offline_cause: "La finestra di start-agent è stata chiusa o il computer è andato in sospensione.",
    jarvis_hc_ts_agent_offline_solution: "Apri la cartella dell'agente e doppio clic su start-agent. Lascia il terminale aperto.",
    jarvis_hc_ts_obs_not_detected_title: "OBS non rilevato",
    jarvis_hc_ts_obs_not_detected_cause: "OBS Studio non è installato o il server WebSocket è disattivato.",
    jarvis_hc_ts_obs_not_detected_solution: "Installa OBS Studio 28+ e attiva Strumenti → Impostazioni server WebSocket → \"Abilita server WebSocket\".",
    jarvis_hc_ts_browser_not_open_title: "Il browser non si apre",
    jarvis_hc_ts_browser_not_open_cause: "Il Chromium integrato di Playwright non è stato installato.",
    jarvis_hc_ts_browser_not_open_solution: "Riesegui install-agent — installerà Playwright e Chromium automaticamente.",
    jarvis_hc_ts_python_failed_title: "Installazione di Python fallita",
    jarvis_hc_ts_python_failed_cause: "Python 3.10+ non è installato o è stato installato senza \"Add to PATH\".",
    jarvis_hc_ts_python_failed_solution: "Installa Python 3.11 da python.org con \"Add Python to PATH\" spuntato, poi riesegui install-agent.",
    jarvis_hc_ts_permission_denied_title: "Permesso negato",
    jarvis_hc_ts_permission_denied_cause: "macOS o Windows ha bloccato l'accesso a tastiera, mouse o registrazione schermo.",
    jarvis_hc_ts_permission_denied_solution: "macOS: concedi Accessibilità e Registrazione schermo al Terminale. Windows: esegui start-agent come amministratore.",
    jarvis_hc_ts_connection_timeout_title: "Timeout di connessione",
    jarvis_hc_ts_connection_timeout_cause: "Firewall, VPN o proxy aziendale bloccano l'HTTPS verso mylumioos.com.",
    jarvis_hc_ts_connection_timeout_solution: "Autorizza mylumioos.com nel firewall/VPN o disattiva il proxy, poi riavvia start-agent.",
    jarvis_hc_ts_agent_stopped_title: "L'agente si è fermato all'improvviso",
    jarvis_hc_ts_agent_stopped_cause: "Il terminale è stato chiuso, il computer è andato in sospensione o è stato applicato un aggiornamento.",
    jarvis_hc_ts_agent_stopped_solution: "Riapri start-agent. Leggi le ultime righe del terminale — di solito la causa è chiara.",
    jarvis_hc_ts_update_failed_title: "Aggiornamento fallito",
    jarvis_hc_ts_update_failed_cause: "È uscita una nuova versione dell'agente e la tua copia è vecchia.",
    jarvis_hc_ts_update_failed_solution: "Scarica lo ZIP più recente dal pulsante sopra, estrailo sopra la vecchia cartella e riavvia start-agent.",
    jarvis_hc_faq_install_every_time_q: "Devo installare l'agente ogni volta?",
    jarvis_hc_faq_install_every_time_a: "No. install-agent va eseguito solo una volta per computer. Poi basta un doppio clic su start-agent.",
    jarvis_hc_faq_can_uninstall_q: "Posso disinstallare il Desktop Agent?",
    jarvis_hc_faq_can_uninstall_a: "Sì. Chiudi start-agent ed elimina la cartella lumioos-desktop-agent. Puoi revocare il computer da questa pagina.",
    jarvis_hc_faq_multiple_computers_q: "Posso abbinare più computer?",
    jarvis_hc_faq_multiple_computers_a: "Sì. Pro permette 2 computer, Power fino a 5. Ogni computer ha bisogno del proprio codice a 6 cifre.",
    jarvis_hc_faq_windows_and_macos_q: "Posso mischiare Windows e macOS?",
    jarvis_hc_faq_windows_and_macos_a: "Assolutamente — Jarvis gestisce ogni computer in modo indipendente: Windows e Mac convivono nello stesso account.",
    jarvis_hc_faq_auto_start_q: "L'agente parte con il computer?",
    jarvis_hc_faq_auto_start_a: "Non di default. Aggiungi start-agent agli elementi di avvio del sistema (Windows: Startup, macOS: Login Items).",
    jarvis_hc_faq_how_to_update_q: "Come aggiorno il Desktop Agent?",
    jarvis_hc_faq_how_to_update_a: "Scarica l'ultimo ZIP da Jarvis, estrailo sopra la cartella esistente e riavvia start-agent.",
    jarvis_hc_faq_recordings_location_q: "Dove vengono salvate le registrazioni?",
    jarvis_hc_faq_recordings_location_a: "Nella cartella di output predefinita di OBS Studio — di solito Video/OBS su Windows o Filmati su macOS.",
    jarvis_hc_faq_change_recording_location_q: "Posso cambiare la cartella di registrazione?",
    jarvis_hc_faq_change_recording_location_a: "Sì. In OBS: File → Impostazioni → Output → Registrazione, scegli la cartella che preferisci. Jarvis la usa in automatico.",
    jarvis_hc_faq_remove_computer_q: "Come rimuovo un computer abbinato?",
    jarvis_hc_faq_remove_computer_a: "Nella lista dei computer abbinati clicca l'icona del cestino. L'agente smette subito di ricevere comandi.",
    },
  tr: {
    nav_features: "Özellikler",
    nav_howit: "Nasıl çalışır",
    nav_pricing: "Fiyatlar",
    nav_download: "İndir",
    nav_support: "Destek",
    lp_download_eyebrow: "İndir",
    lp_download_h2: "Lumioos artık her cihazda",
    lp_download_h2_one: "Lumioos artık {platform}'da",
    lp_download_h2_two: "Lumioos: {p1} ve {p2}",
    lp_download_sub: "Lumioos'u Windows'a hemen kur — Apple ve Android yakında geliyor.",
    lp_download_sub_one: "Lumioos'u {platform} cihazına hemen kur. Diğer platformlar yakında.",
    lp_download_sub_two: "{p1} veya {p2} üzerine kur — diğer cihazlar yakında.",
    lp_download_live: "Yayında",
    lp_download_soon: "Yakında",
    lp_download_install: "Ücretsiz kur",
    lp_download_notify: "Çok yakında",
    nav_signin: "Giriş yap",
    nav_get_started: "Hemen başla",
    hero_badge: "Profesyoneller ve içerik üreticileri seçti — Claude 4.5 · GPT-5 · Gemini 3",
    hero_h1_a: "Yapay zekâ çalışma alanın —",
    hero_h1_b: "daha akıllı, hızlı, güvenli",
    hero_sub: "Lumioos günlük hayatın için AI asistan. E-posta ve makale yaz, 6 dil arasında çevir, yeni konu öğren, gezi planla, kod yaz, fikir üret — üstüne yayına hazır video üret. Tek çalışma alanı, ihtiyacın olan her şey. Aylık {from_price}'dan başlar.",
    hero_cta_primary: "Ücretsiz başla — kart gerekmez",
    hero_cta_secondary: "Nasıl çalışıyor?",
    hero_card_eyebrow: "Canlı AI yanıtı",
    hero_card_question: "Arkadaşıma kısa bir doğum günü mesajı yaz",
    hero_card_assistant: "Lumioos Asistan",
    hero_card_answer: "Doğum günün kutlu olsun! Hayatımın her anında yanımda olduğun için minnettarım. Bu yeni yaşın sana sağlık, mutluluk ve bol kahkaha getirsin. Seni çok seviyorum! 🎉",
    hero_card_time: "4 saniyede yanıtladı",
    feat_section_eyebrow: "Lumioos neler yapar",
    feat_section_h2: "Tek çalışma alanı. İhtiyacın olan her şey.",
    feat_section_sub: "6 sekme arasında geçmeyi bırak. Sohbet et, yaz, çevir, öğren, kod yaz, video üret — hepsi tek temiz alandan.",
    feat_chat_title: "Akıllı AI Sohbet",
    feat_chat_desc: "Her şeyi sor — çeviri, yazı, öğrenme, tavsiye, fikir, kod. Ekran görüntüsü ekle, görsel analiz et. Yazmak yerine konuş. Lumioos günlük soruları, profesyonel işleri ve teknik problemleri eşit ustalıkla anlar.",
    feat_chat_li1: "E-posta, post, makale yaz — her tonda",
    feat_chat_li2: "6 dil arasında çeviri",
    feat_chat_li3: "Resim yükleme + sesli giriş",
    feat_chat_li4: "Gerekirse kod ve teknik yardım",
    trust_no_card: "Kredi kartı gerekmez",
    trial_badge: "{days} gün Pro deneme · kart gerekmez",
    trial_banner_text: "Ücretsiz Pro denemenizde {days} gün kaldı",
    trial_banner_ending_today: "Ücretsiz denemeniz bugün bitiyor — Pro'ya geçin",
    trial_banner_cta: "Şimdi yükselt",
    trial_banner_close: "Kapat",
    trial_pill_label: "Deneme · {days}g kaldı",
    trial_pill_cta: "Yükselt",
    trial_pill_tooltip: "Ücretsiz Pro denemedesin — bitmeden önce yükselt.",
    trial_ribbon_text: "🎁 {days} gün Pro ücretsiz — kredi kartı gerekmez",
    trial_ribbon_pill: "Sınırlı teklif",
    trial_ribbon_cta: "Ücretsiz başla",
    hero_cta_trial: "{days} günlük ücretsiz denemeyi başlat",
    // Refer & Earn page
    ref_back: "Geri",
    ref_title: "Davet Et & Kazan",
    ref_subtitle: "Bir arkadaşını davet et → her başarılı kayıtta sen +{days} gün Pro kazan, arkadaşın 14 gün ücretsiz Pro ile başlasın (normal 7 gün trial + 7 gün referral bonusu).",
    ref_loading: "Yükleniyor…",
    ref_invited: "Davet edilen",
    ref_days_earned: "Kazanılan Pro günü",
    ref_your_link: "Senin davet linkin",
    ref_copy: "Kopyala",
    ref_copied: "Kopyalandı",
    ref_share: "Paylaş",
    ref_your_code: "Kodun:",
    ref_recent: "Son davetler",
    ref_days_awarded: "+{days} gün Pro",
    ref_how_to_share: "📣 Nasıl paylaşırım?",
    ref_share_whatsapp: "WhatsApp / Telegram gruplarına at",
    ref_share_twitter: "X'te demo ekran görüntüsüyle paylaş",
    ref_share_linkedin: "LinkedIn'de bir post + linkini at",
    ref_share_forum: "SF / Trailhead forum / Reddit'inde bahset",
    ref_link_copied: "Link kopyalandı",
    ref_copy_error: "Kopyalanamadı",
    ref_load_error: "Referraller yüklenemedi",
    ref_share_message: "Lumioos'u benim linkimle dene — kayıt ol ve 14 gün ücretsiz Pro kazan!",
    trial_ended_close: "Kapat",
    trial_ended_title: "Tekrar Free'ye Hoşgeldin",
    trial_ended_subtitle: "7 günlük Pro denemen az önce bitti.",
    trial_ended_losing: "Erişimi kaybediyorsun",
    trial_ended_feat_video: "🎬 Video Producer (Sora 2)",
    trial_ended_feat_interview: "🎤 Interview Practice (mülakat simülasyonu)",
    trial_ended_feat_image: "🖼️ Image Producer (GPT Image 1)",
    trial_ended_feat_salesforce: "⚡ Salesforce / Trailhead Agent",
    trial_ended_promo_eyebrow: "Tek seferlik teklif",
    trial_ended_promo_headline: "Pro'da %20 İNDİRİM — sadece sana",
    trial_ended_promo_sub: "Promosyon kodu {code} ödeme sayfasında otomatik uygulanır. Sadece şimdi geçerli.",
    trial_ended_cta_upgrade: "{code} ile Pro'ya geç → %20 İNDİRİM",
    trial_ended_cta_later: "Belki sonra",
    trust_stripe: "Stripe güvenliğiyle ödeme",
    trust_privacy: "Verilerin sana ait kalır",
    trust_rating: "İlk kullanıcılar bayıldı",
    hero_card_live: "Canlı",
    hero_chip_voice: "Sesi yazıya dök",
    hero_chip_image: "Ekran görüntülerini gör",
    hero_chip_lang: "6 dil",
    stat_1_n: "Dil",
    stat_1_v: "6",
    stat_2_n: "AI modeli",
    stat_2_v: "3+",
    stat_3_n: "Ort. yanıt süresi",
    stat_3_v: "8sn",
    stat_4_n: "Çalışma süresi",
    stat_4_v: "%99.9",
    coming_soon_badge: "Çok yakında",
    gs_ad_cta_soon: "Çıkınca haber ver",
    gs_ad_locked: "Şu an kilitli — yakında açılacak.",
    gs_coming_soon_toast: "Game Studio çok yakında — size haber vereceğiz!",
    feat_video_title: "Sinematik Video Üretici",
    feat_video_desc: "6 dilden birinde bir konu yaz. Dakikalar içinde senaryo, AI seslendirme, sinematik sahneler ve yayına hazır MP4 — sosyal medya, pazarlama veya eğitim için kusursuz.",
    feat_video_li1: "Kendi dilinde senaryo (TR · EN · ES · FR · DE · IT · PT · JA · ZH)",
    feat_video_li2: "9 doğal AI ses — mükemmel tonu seç",
    feat_video_li3: "Sinematik AI görseller — stok görüntü hissi yok",
    feat_video_li4: "MP4 + seslendirme + sahne indir",
    feat_speed_t: "Şimşek hızı",
    feat_speed_d: "Sohbet saniyelerde. Video dakikalarda. Bekleme yok.",
    feat_secure_t: "Banka seviyesi güvenlik",
    feat_secure_d: "Uçtan uca şifrelenmiş oturumlar. Komutların asla AI eğitiminde kullanılmaz.",
    feat_global_t: "Küresel tasarım",
    feat_global_d: "6 dilde yerel destek — Türkçe ve İngilizce dahil.",
    how_eyebrow: "Nasıl çalışır",
    how_h2: "Üç adım. Sıfır öğrenme süresi.",
    how_s1_t: "Ücretsiz kaydol",
    how_s1_d: "Kredi kartı yok. 30 saniyeden az sürede e-posta veya Google ile hesap aç.",
    how_s2_t: "Sor veya anlat",
    how_s2_d: "Yaz, konuş ya da sohbete ekran görüntüsü bırak. Veya kendi dilinde bir video konusu yaz.",
    how_s3_t: "Sonucu kullan",
    how_s3_d: "Cevabı işine kopyala. MP4'ü indir. Yayınla. Hazır.",
    lp_pricing_eyebrow: "Basit, adil fiyatlandırma",
    lp_pricing_h2: "Ücretsiz başla. Yalnızca gerektikçe yükselt.",
    lp_pricing_sub: "Her plan temel AI özelliklerini içerir. Gizli ücret yok. İstediğin zaman iptal et.",
    lp_plan_popular: "En popüler",
    lp_plan_start: "Başla",
    lp_plan_free_desc: "Lumioo'yu denemek ve kişisel kullanım için.",
    lp_plan_free_f1: "Ayda 5 AI görsel",
    lp_plan_free_f2: "Günlük 10 sohbet mesajı",
    lp_plan_free_f3: "Tüm 6 dil",
    lp_plan_creator_desc: "Freelancer, öğrenci ve içerik üreticileri için.",
    lp_plan_creator_f1: "Ayda 50 AI görsel (HD)",
    lp_plan_creator_f2: "Sınırsız sohbet + resim + ses",
    lp_plan_creator_f3: "Watermark yok",
    lp_plan_creator_f4: "Öncelikli yanıt hızı",
    lp_plan_pro_desc: "Profesyoneller ve küçük takımlar için.",
    lp_plan_pro_f1: "Ayda 150 AI görsel (HD)",
    lp_plan_pro_f2: "Creator'daki her şey",
    lp_plan_pro_f3: "Tam Mülakat Pratik erişimi",
    lp_plan_pro_f4: "Öncelikli destek",
    lp_plan_pro_f5: "✨ CV Sohbeti & İnceleme — sınırsız (PDF/Word/görsel)",
    lp_plan_power_desc: "Yoğun kullanıcılar ve güçlü içerik üreticileri için.",
    lp_plan_power_f1: "Pro'daki her şey",
    lp_plan_power_f2: "Aylık 500 AI görsel (HD)",
    lp_plan_power_f3: "GPT-5 · 1500 mesaj, Opus 4.5 · 100/ay",
    lp_plan_power_f4: "Öncelikli destek · adil kullanım",
    lp_plan_power_f5: "✨ CV Sohbeti & İnceleme — sınırsız + öncelikli",
    lp_pricing_trust1: "Stripe güvencesi",
    lp_pricing_trust2: "İstediğin zaman iptal",
    lp_pricing_trust3: "KVKK / GDPR uyumlu",
    cta_h2_a: "Daha akıllı çalışmaya",
    cta_h2_b: "hazır mısın?",
    cta_sub: "Lumioo'ya her gün güvenen profesyonellere katıl. Kişisel kullanım için sonsuza dek ücretsiz.",
    cta_btn: "Ücretsiz hesap aç",
    cta_smallprint: "Kredi kartı yok. 30 saniyelik kayıt. İstediğin zaman iptal.",
    footer_tag: "Profesyoneller için kuruldu.",
    footer_privacy: "Gizlilik",
    footer_terms: "Koşullar",
    footer_support: "Destek",
    support_eyebrow: "Destek",
    support_h1: "Nasıl yardımcı olabiliriz?",
    support_sub: "Bize mesaj gönder — hata bildirimi, özellik önerisi, fatura sorusu, ne olursa. Her birini okuyup verdiğin e-posta adresine yanıt veriyoruz.",
    support_back: "Ana sayfaya dön",
    support_name: "Adın",
    support_name_ph: "Ahmet Yılmaz",
    support_email: "E-posta adresin",
    support_message: "Mesaj",
    support_message_ph: "Bize ne anlatmak istersin?",
    support_send: "Mesaj gönder",
    support_sending: "Gönderiliyor…",
    support_send_another: "Yeni mesaj gönder",
    support_sent_h2: "Mesaj gönderildi!",
    support_sent_sub: "Teşekkürler — verdiğin e-postaya genelde 1 iş günü içinde dönüş yapıyoruz.",
    support_validation: "Lütfen tüm alanları doldur (mesaj en az 5 karakter olmalı).",
    support_rate_limit: "Çok fazla mesaj gönderdin — lütfen bir saat sonra tekrar dene.",
    support_error: "Gönderilemedi. Lütfen tekrar dene.",
    support_privacy_note: "Mesajın ekibimize ulaşıyor. E-posta adresini kimseyle paylaşmıyoruz.",
    auth_eyebrow_login: "Hesabına gir",
    auth_eyebrow_register: "Hesabını oluştur",
    auth_h1_login: "Tekrar hoş geldin.",
    auth_h1_register: "Lumioo hesabı.",
    auth_sub_login: "Kaldığın yerden devam et.",
    auth_sub_register: "50 ücretsiz kredi ile başla.",
    auth_name: "Ad",
    auth_email: "E-posta",
    auth_password: "Şifre",
    auth_signin: "Giriş yap",
    auth_create: "Hesap aç",
    auth_no_account: "Hesabın yok mu?",
    auth_have_account: "Zaten hesabın var mı?",
    auth_forgot: "Şifreni mi unuttun?",
    fp_eyebrow: "Hesap kurtarma",
    fp_title: "Şifreni sıfırla",
    fp_subtitle: "Hesabına bağlı e-postayı yaz, sıfırlama linkini gönderelim.",
    fp_send_btn: "Sıfırlama linki gönder",
    fp_back_login: "Girişe geri dön",
    fp_sent_title: "Gelen kutunu kontrol et",
    fp_sent_body: "{email} adresinde bir hesap varsa, sıfırlama linki yolda. Link 1 saat geçerli.",
    fp_sent_hint: "Göremiyor musun? Spam'i kontrol et veya birkaç dakika sonra tekrar dene.",
    rp_title: "Yeni şifreni belirle",
    rp_subtitle: "Güçlü bir şifre seç — en az 8 karakter.",
    rp_new_password: "Yeni şifre",
    rp_confirm_password: "Şifreyi tekrar yaz",
    rp_submit_btn: "Yeni şifreyi kaydet",
    rp_mismatch: "Şifreler eşleşmiyor",
    rp_too_short: "Şifre en az 8 karakter olmalı",
    rp_invalid: "Bu sıfırlama linki geçersiz veya süresi dolmuş.",
    rp_success: "Şifre güncellendi. Giriş yapıldı.",
    rp_no_token_title: "Sıfırlama tokeni bulunamadı",
    rp_no_token_body: "Bu link bozuk görünüyor. Lütfen yeni bir sıfırlama e-postası iste.",
    rp_request_new: "Yeni link iste",
    auth_create_one: "Hesap aç",
    auth_demo: "Demo hesap",
    welcome_back: "Tekrar hoş geldin!",
    account_created: "Hesap oluşturuldu. Hoş geldin!",
    auth_failed: "Kimlik doğrulama başarısız",
    side_dashboard: "Panel",
    side_chat: "AI Sohbet",
    side_video: "Video Üretici",
    side_image: "Görsel Üretici",
    side_cv: "CV Hazırlayıcı",
    side_interview: "Mülakat Pratiği",
    side_games: "Game Studio",
    gs_eyebrow: "Araç",
    gs_h1: "Game Studio",
    gs_sub: "Bir oyunu istediğin tarzda tarif et — Lumioos AI ~15 saniyede indirilebilir HTML oyunu yapar. Telefon, bilgisayar, her yerde oynanır.",
    gs_credits: "kredi",
    gs_examples: "Örnekler — başlangıç olarak kullan",
    gs_title_label: "Oyun adı (opsiyonel)",
    gs_title_ph: "ör. Koyun Kurtar",
    gs_prompt_label: "Oyununu anlat",
    gs_prompt_ph: "Örnek: Bir kedi balıkları toplamak için zıplar. Pastel pixel sanatı. 3 seviye.",
    gs_cost_note: "Üretim başına 3 kredi",
    gs_generate_btn: "Oyunu üret",
    gs_generating_btn: "Üretiliyor…",
    gs_generating: "Oyunun üretiliyor…",
    gs_generating_hint: "~15 saniye — Claude 4.5 kodu yazıyor",
    gs_done: "Oyun hazır! Aşağıdan oyna.",
    gs_generate_failed: "Üretim başarısız — daha net bir tarif dene",
    gs_my_games: "Oyunlarım",
    gs_play: "Oyna",
    gs_download: ".html indir",
    gs_download_short: ".html",
    gs_refresh: "Yenile",
    gs_clear_all: "Tümünü sil",
    gs_clear_confirm: "TÜM oyunlar silinsin mi?",
    gs_clear_yes: "Evet",
    gs_cleared_count: "{count} oyun çöpe taşındı (7 gün içinde geri alınabilir)",
    gs_library_full: "kütüphane dolu — en eski otomatik silinecek",
    gs_trash: "Çöp",
    gs_trash_title: "Çöp Kutusu",
    gs_trash_sub: "Silinen oyunlar 7 gün boyunca burada tutulur, sonra kalıcı olarak silinir.",
    gs_trash_empty: "Çöp kutusu boş.",
    gs_restore: "Geri al",
    gs_restored: "Oyun geri alındı",
    gs_suggest_higher_title: "Uyarı:",
    gs_suggest_higher_body: "Mario, RPG, FPS veya 3D tarzı oyunlar Simple için fazla iddialı. Daha zengin level ve görseller için Detailed (8 kredi) veya Premium (15 kredi) seçin.",
    cancel: "İptal",
    gs_download_failed: "İndirme başarısız",
    gs_delete: "Sil",
    gs_delete_confirm: "Bu oyunu sil?",
    gs_delete_failed: "Silme başarısız",
    gs_locked_title: "Game Studio Pro / Power özelliğidir",
    gs_locked_desc: "Oyun üretmeye başlamak için Pro ($29/ay) veya Power ($79/ay) plana yükselt. Creator ve Free planlarda Game Studio kredisi yok.",
    gs_upgrade_btn: "Planları gör →",
    gs_ad_h2: "Bir oyun hayal et.",
    gs_ad_sub: "Yaz: 'pixel-art ay altında balık yakalayan bir kedi' — 15 saniyede oynanır HTML oyununu al. Telefon, masaüstü, her yerde çalışır. .html dosyasını indir, sonsuza dek sende kalsın.",
    gs_ad_b1: "Tek cümleden üret — herhangi bir stil, herhangi bir mekanik",
    gs_ad_b2: "Tek .html dosyası olarak indir — kurulum yok, sunucu yok",
    gs_ad_b3: "Dokunmatik + klavye kontrolleri hazır — her cihazda oynanır",
    gs_ad_b4: "Pro $29 → ayda 25 kredi · Power $79 → ayda 80 (Pro/Power özel)",
    gs_ad_cta: "Ücretsiz dene — ilk oyununu yap",
    gs_ad_see_plans: "Fiyatlandırma",
    gs_quality_label: "Üretim kalitesi",
    gs_quality_hint: "⚡ İpucu: Premium → hikayeli oyunlar, RPG, FPS tarzı shooter ve basit 3D labirentler için. Gerçek 3D / AAA / online multiplayer desteklenmiyor — tek-dosya HTML5.",
    gs_tier_simple_label: "Basit",
    gs_tier_simple_desc: "Hızlı arcade · Sonnet 4.5",
    gs_tier_detailed_label: "Detaylı",
    gs_tier_detailed_desc: "Çok seviyeli · ses · particle · Sonnet 4.5",
    gs_tier_premium_label: "Premium",
    gs_tier_premium_desc: "Hikaye / RPG / 3D · Opus 4.5",
    gs_cost_note_dyn: "Maliyet: {cost} kredi",
    // ---- MÜLAKAT PRATİĞİ ----
    iv_eyebrow: "Mülakat Pratiği",
    iv_h1: "Her mülakata sesli pratik.",
    iv_sub: "Soru kağıtlarını fotoğraf olarak yükle. Lumioos tüm soru-cevapları çıkarır, kendi özel bankana ekler, seni sesli veya yazılı sınar. ABD vatandaşlık, Green Card, iş ve sertifika mülakatları için ideal.",
    iv_my_banks: "Soru bankalarım",
    iv_total: "toplam",
    iv_loading: "Yükleniyor…",
    iv_empty_title: "Henüz soru bankası yok",
    iv_empty_sub: "Yukarıdan oluştur, sonra çalışma kağıdının fotoğrafını yükle veya manuel ekle.",
    iv_questions: "soru",
    iv_open: "Aç",
    iv_create: "Banka oluştur",
    iv_bank_name_ph: "Banka adı (örn: ABD Vatandaşlık)",
    iv_bank_desc_ph: "Kısa açıklama (opsiyonel)",
    iv_bank_created: "Banka oluşturuldu",
    iv_create_fail: "Banka oluşturulamadı",
    iv_confirm_delete: "Bu bankayı ve tüm sorularını sil?",
    iv_deleted: "Silindi",
    iv_delete_fail: "Silme başarısız",
    iv_load_fail: "Yüklenemedi",
    iv_hint_title: "Nasıl çalışır?",
    iv_hint_sub: "Herhangi bir mülakat hazırlık kağıdının fotoğrafını çek (ABD vatandaşlık testi, Green Card soruları, iş mülakatı, sertifika). Lumioos AI ile okur, tüm soruları kabul edilen tüm cevaplarıyla çıkarır ve kalıcı saklar. Sonra sesli (AI soruyu söyler, sen mikrofonla cevaplarsın) veya yazılı pratik yap.",
    iv_back_library: "Kütüphaneye dön",
    iv_practice: "Pratik",
    iv_start_h2: "Mülakatı başlat",
    iv_mode_text: "Yazılı mod",
    iv_mode_voice: "Sesli mod",
    iv_mode_text_hint: "Her soruyu oku, cevabını yaz. AI kelime kelime değil anlamca değerlendirir.",
    iv_mode_voice_hint: "AI her soruyu sesli söyler. Mikrofona basıp cevabını söyle, AI yazıya döküp değerlendirir.",
    iv_order_label: "Soru sırası",
    iv_order_random: "Rastgele",
    iv_order_sequential: "Sırayla",
    iv_limit_label: "Kaç soru sorulsun",
    iv_limit_all: "Hepsi ({n} soru)",
    iv_limit_all_short: "Hepsi",
    iv_limit_max: "en fazla {n}",
    iv_limit_clamped: "Bankada sadece {n} soru var — hepsi sorulacak.",
    iv_or: "veya",
    iv_start_now: "Başlat",
    iv_start_fail: "Oturum başlatılamadı",
    iv_no_questions_start: "Önce en az bir soru ekle",
    iv_upload_title: "Resim veya PDF yükle",
    iv_upload_sub: "Soru kağıdı fotoğrafları, ekran görüntüleri veya PDF dosyaları. AI tüm soru-cevapları otomatik çıkarır (en fazla 100 dosya, PDF sayfa sayfa okunur).",
    iv_choose_images: "Resim seç",
    iv_choose_files: "Resim veya PDF seç",
    iv_extracting: "Soru-cevaplar çıkarılıyor…",
    iv_extracted: "soru resimden eklendi",
    iv_extract_fail: "Sorular çıkarılamadı",
    iv_budget_partial: "{n} soru eklendi, fakat AI anahtarınızın kredisi yarıda bitti. Bakiye ekleyip kalanı çıkarın.",
    iv_partial_extract: "{n} soru eklendi ({f} parti başarısız oldu — kalanı için tekrar deneyin).",
    iv_progress_label: "Parti {c}/{n} işleniyor…",
    feat_iv_eyebrow: "Mülakat Pratiği",
    feat_iv_title: "Her mülakata sesli veya yazılı pratik",
    feat_iv_desc: "Çalışma kağıtlarını yükle (fotoğraf veya PDF). Lumioos tüm soru-cevapları çıkarır, sonra canlı bir AI mülakatçıyla seni sınar — soruları sesli sorar, cevabını dinler, anlam üzerinden değerlendirir. Cevap anahtarına sıkı sıkıya bağlı kalır.",
    feat_iv_li1: "ABD vatandaşlık ve Green Card hazırlığı",
    feat_iv_li2: "İş & teknik mülakat pratiği",
    feat_iv_li3: "Sesli + kulak modu (soru gizli) destekli",
    feat_iv_li4: "Sıkı puanlama + soru bazlı sonuç raporu",
    feat_iv_cta: "Mülakat pratiğine başla",
    feat_iv_use_cases: "USCIS · Green Card · İş · Sertifika · Her konu",
    feat_iv_badge: "YENİ",
    iv_speed_label: "Konuşma hızı",
    iv_speed_slow: "Yavaş",
    iv_speed_normal: "Normal",
    iv_speed_fast: "Hızlı",
    iv_speed_faster: "Daha hızlı",
    iv_speed_hint: "Mülakatçının soruları okuma hızı.",
    iv_range_label: "Soru aralığı",
    iv_range_hint: "1 → {n}",
    iv_range_from: "Şuradan",
    iv_range_to: "şuraya",
    iv_range_clear: "temizle",
    iv_range_note: "Boş bırakırsan hepsi sorulur. Aralık kaynak sırasına göredir (örn: 1 → 50, ya da 55 → 80).",
    iv_range_invalid: "Bitiş, başlangıçtan büyük olmalı.",
    iv_deleted_undo: "Banka silindi ({n} soru). 10 saniye içinde geri alabilirsin.",
    iv_q_deleted_undo: "Soru silindi. 8 saniye içinde geri alabilirsin.",
    iv_undo: "Geri al",
    iv_restored: "Geri alındı.",
    iv_restore_fail: "Geri alınamadı",
    iv_delete_warning: "Kalıcı silme",
    iv_delete_q: "Bu bankayı ve içindeki {n} soruyu sil?",
    iv_delete_desc: "Silmek üzeresin:",
    iv_delete_type_to_confirm: 'Onaylamak için "{name}" yaz:',
    iv_delete_btn: "Bankayı sil",
    iv_voice_label: "Mülakatçı sesi",
    iv_voice_female: "Kadın (Nova)",
    iv_voice_male: "Erkek (Ash) — yumuşak & kibar",
    iv_voice_female2: "Kadın (Shimmer)",
    iv_voice_male2: "Erkek (Fable) — samimi",
    iv_voice_hint: "AI mülakatçının sesini seç.",
    iv_finish_early: "Sınavı bitir",
    iv_finish_early_confirm: "Sınavı şimdi bitirmek istiyor musun? {n} / {total} soru cevaplandı.",
    iv_finish_early_btn: "Şimdi bitir",
    iv_keep_going: "Devam et",
    iv_finishing: "Bitiriliyor…",
    iv_congrats: "Tebrikler! 🎉",
    iv_congrats_sub: "Harika bir skorla geçtin.",
    iv_good_job: "Aferin!",
    iv_good_job_sub: "Güzel bir performans — pratik yapmaya devam et.",
    iv_keep_practising: "Pratik yapmaya devam et",
    iv_keep_practising_sub: "Aşağıdaki yanlışlarını incele ve tekrar dene.",
    iv_score_label: "Skor",
    iv_wrong_review: "Yanlışları incele",
    iv_resume_eyebrow: "Devam ediyor",
    iv_resume_title: "Yarım kalmış bir mülakatın var",
    iv_resume_progress: "{done} / {total} soru cevaplandı",
    iv_resume_btn: "Devam et",
    iv_resume_discard: "İptal et",
    iv_resume_discard_confirm: "Yarım kalan oturumu iptal edip yeniden başla?",
    iv_resume_discarded: "Oturum iptal edildi",
    iv_large_upload_warn: "Yükleme yaklaşık {mb}MB. Yavaş bağlantılarda çok büyük yüklemeler başarısız olabilir. Devam edilsin mi?",
    iv_trash: "Çöp Kutusu",
    iv_trash_title: "Son silinenler",
    iv_trash_banks: "Silinen bankalar",
    iv_trash_questions: "Silinen sorular",
    iv_trash_empty: "Çöp kutusu boş.",
    iv_trash_load_fail: "Çöp kutusu yüklenemedi",
    iv_purge: "Kalıcı olarak sil",
    iv_purge_confirm: "Bu bankayı kalıcı olarak silmek üzeresin. Geri alınamaz. Emin misin?",
    iv_progress_preparing: "Dosyalar hazırlanıyor…",
    iv_report_title: "Soru bazlı detay",
    iv_your_answer: "Senin cevabın",
    iv_skipped: "(atlandı)",
    iv_max_10: "Tek seferde en fazla 10 resim",
    iv_max_100: "Tek seferde en fazla 100 resim",
    iv_manual_title: "Manuel ekle",
    iv_manual_sub: "Bir soru ve Lumioos'un kabul edeceği cevapları yaz.",
    iv_add_question: "Soru ekle",
    iv_cancel: "İptal",
    iv_question: "Soru",
    iv_accepted_answers: "Kabul edilen cevaplar (her satıra bir tane)",
    iv_accepted_ph: "Yürütme\nYasama\nYargı\nKongre\nBaşkan",
    iv_min_required: "Minimum gerekli",
    iv_min_hint: "Kullanıcı kabul edilen cevaplardan kaç tanesini söylemeli? (Genelde 1)",
    iv_add: "Ekle",
    iv_q_added: "Soru eklendi",
    iv_add_fail: "Soru eklenemedi",
    iv_need_q_and_a: "Soru ve en az 1 cevap gerekli",
    iv_question_list: "Sorular",
    iv_no_questions: "Henüz soru yok. Fotoğraf yükle veya manuel ekle.",
    iv_confirm_delete_q: "Bu soruyu sil?",
    iv_back_bank: "Bankaya dön",
    iv_voice_interview: "Sesli mülakat",
    iv_text_interview: "Yazılı mülakat",
    iv_record: "Cevabı kaydet",
    iv_stop_record: "Durdur & yazıya dök",
    iv_transcribing: "Yazıya dökülüyor…",
    iv_voice_answer_ph: "Yazıya dökülmüş cevabın burada görünecek. Göndermeden önce düzenleyebilirsin.",
    iv_text_answer_ph: "Cevabını buraya yaz…",
    iv_submit: "Gönder",
    iv_skip: "Atla",
    iv_correct: "Doğru",
    iv_wrong: "Tam değil",
    iv_accepted_were: "Kabul edilen cevaplar şunlardı:",
    iv_see_results: "Sonuçları gör",
    iv_next_question: "Sonraki soru",
    iv_need_n_answers: "En az {n} farklı cevap ver",
    iv_results: "Sonuçlar",
    iv_accuracy: "doğruluk",
    iv_restart: "Bankayı yeniden başlat",
    iv_speak: "Soruyu sesli oku",
    iv_show_question: "Soruyu göster",
    iv_hide_question: "Soruyu gizle (kulak çalışması)",
    iv_question_hidden: "Soru gizli — sadece dinleyin",
    iv_voice_intro_line: "Merhaba! Hazır olduğunda Başla'ya bas, soruları sormaya başlayacağım.",
    iv_voice_ready: "Hazırım, başla",
    iv_show_q_label: "Sorular ekranda gösterilsin mi?",
    iv_show_q_on: "Göster",
    iv_show_q_off: "Gizle (kulak çalışması)",
    iv_show_q_on_hint: "Soru metni pratik boyunca görünür.",
    iv_show_q_off_hint: "Sadece ses çalar — dinleme pratiği için ideal.",
    iv_starred_label: "Hangi sorular sorulsun?",
    iv_starred_all: "Tüm sorular",
    iv_starred_only: "Sadece yıldızlı / önemli",
    iv_starred_hint: "Önemsediğin soruları yıldızla (⭐). Lumioos kaynak materyalde 'önemli' veya yıldızlı işaretli soruları otomatik yıldızlar.",
    iv_starred_badge: "Önemli",
    iv_star: "Yıldızla",
    iv_unstar: "Yıldızı kaldır",
    iv_edit_question_tooltip: "Soru ve cevapları düzenle",
    iv_edit_question_label: "Soru",
    iv_edit_answers_label: "Kabul edilen cevaplar (her satıra bir tane)",
    iv_edit_answers_placeholder: "yeni ay\ndolunay\nhilal",
    iv_edit_save: "Kaydet",
    iv_edit_saved: "Soru güncellendi",
    iv_edit_fail: "Değişiklikler kaydedilemedi",
    iv_edit_question_empty: "Soru boş olamaz",
    iv_edit_answers_empty: "En az bir kabul edilen cevap gerekli",
    iv_tts_fail: "Soru sesi çalınamadı",
    iv_stt_fail: "Ses yazıya dökülemedi",
    iv_mic_denied: "Mikrofon izni reddedildi",
    iv_need_answer: "Önce bir cevap yaz veya kaydet",
    iv_submit_fail: "Cevap gönderilemedi",
    iv_skip_fail: "Atlanamadı",
    side_projects: "Projeler",
    side_credits: "Kredi",
    side_logout: "Çıkış",
    delete_account: "Hesabımı sil",
    delete_account_confirm_1: "Bu işlem hesabını ve tüm verilerini (sohbetler, videolar, görseller, CV, abonelik) kalıcı olarak silecek. Geri alınamaz. Devam etmek istiyor musun?",
    delete_account_confirm_2: "Kesinlikle emin misin? Bu işlem geri alınamaz.",
    delete_account_ok: "Hesabın silindi. Onay e-postası birazdan sana ulaşacak.",
    delete_account_err: "Hesap silinemedi. Lütfen tekrar dene veya destek ile iletişime geç.",
    side_theme: "Tema",
    side_language: "Dil",
    side_integrations: "Entegrasyonlar",
    side_help: "Yardım & Token'lar",
    side_admin: "Yönetici",
     side_ai_workforce: "AI İş Gücü",
    wf_badge: "YÖNETİCİ · AŞAMA 1",
    wf_title: "AI İş Gücü",
    wf_subtitle: "Özel AI çalışan ekibini yönet. Hedef ver, ilerlemeyi izle, dış dünyaya dokunan her aksiyonu onayla.",
    wf_total_agents: "Toplam Çalışan",
    wf_active_agents: "Aktif Çalışan",
    wf_busy_agents: "Meşgul Çalışan",
    wf_tasks_in_progress: "Devam Eden Görevler",
    wf_tasks_completed: "Tamamlanan Görevler",
    wf_tasks_failed: "Başarısız Görevler",
    wf_approvals_pending: "Bekleyen Onaylar",
    wf_agents_title: "AI Çalışanları",
    wf_workspace_company: "Şirket Çalışma Alanı",
    wf_phase_notice_title: "Alt-Aşama 1A · Temel Hazır",
    wf_phase_notice_body: "Görevler, CEO orkestrasyonu, ajan mesajlaşması ve onaylar 1B → 1D aşamalarında gelecek. Yukarıdaki çalışanlar hazır ve yapılandırılmış — o zamana kadar başka bir şey yapmana gerek yok.",
    wf_refresh: "Yenile",
    wf_ceo_chat_title: "CEO Sohbeti",
    wf_ceo_chat_empty: 'CEO AI ile doğal konuşun. Deneyin: "Hangi görevler onay bekliyor?" veya "3 kayıt fikri araştır."',
    wf_ceo_chat_placeholder: "CEO'ya bir şey sorun veya 'X araştır', 'görevi iptal et', 'taslağı onayla' deyin…",
    wf_ceo_chat_hint: "Niyet otomatik algılanır: sorular gerçek veritabanından yanıtlanır; görev/kontrol/onay niyetleri gerçek workforce API'lerini çağırır. Sahte yetenek yok — bir araç bağlı değilse CEO açıkça söyler.",
    wf_chat_view_task: "Görevi gör →",
    wf_new_objective: "Yeni Hedef",
    wf_task_title_placeholder: "örn: Lumioos için 3 günlük pazarlama planı oluştur",
    wf_task_desc_placeholder: "Hedefi ayrıntılı anlatın. Hangi sonucu istiyorsunuz? Kısıtlar var mı?",
    wf_send_to_ceo: "CEO AI'ya Gönder",
    wf_ceo_will_plan: "CEO AI ({model}) planlayacak → uzmanlara atayacak → sonuçları toplayacak. Marketing/Sales/Support/Finance çıktıları onay kuyruğuna girer.",
    wf_recent_tasks: "Son Görevler",
    wf_no_tasks: "Henüz görev yok. Yukarıdan ilk hedefini oluştur.",
    wf_recent_activity: "Son Aktivite",
    wf_no_activity: "Henüz aktivite yok.",
    wf_agent_chat_empty: "{name}'a merhaba de veya doğrudan bir görev ver.",
    wf_agent_chat_placeholder: "{name} ile konuş…",
    wf_tab_overview: "Genel",
    wf_tab_chat: "Sohbet",
    wf_tab_current: "Aktif",
    wf_tab_history: "Geçmiş",
    wf_tab_activity: "Aktivite",
    wf_tab_memory: "Bellek",
    wf_tab_config: "Ayarlar",
    wf_field_status: "Durum",
    wf_field_completed: "Tamamlanan",
    wf_field_completed_count: "{n} tamamlandı",
    wf_field_last_activity: "Son aktivite",
    wf_field_none: "—",
    wf_no_active_tasks: "Aktif görev yok.",
    wf_no_history: "Henüz geçmiş yok.",
    wf_no_memory: "Henüz bellek yok.",
    wf_cfg_model: "Model (gerçekte çalışan)",
    wf_cfg_allowed_tools: "İzin verilen araçlar",
    wf_cfg_system_instructions: "Sistem talimatları",
    wf_cfg_agent_id: "Ajan Kimliği",
    wf_task_objective: "Hedef",
    wf_task_ceo_plan: "CEO Planı",
    wf_task_children: "Alt Görevler ({n})",
    wf_task_view_result: "Sonucu gör ({n} karakter)",
    wf_task_error_prefix: "Hata:",
    wf_task_ceo_summary: "CEO Özeti",
    wf_task_agent_messages: "Ajan Mesajları ({n})",
    wf_task_pause: "Duraklat",
    wf_task_resume: "Devam Et",
    wf_task_retry: "Tekrar Dene",
    wf_task_cancel: "İptal",
    wf_approve: "Onayla",
    wf_reject: "Reddet",
    wf_approval_status_prefix: "Onay {status}",
    wf_approvals_title: "Bekleyen Onaylar ({n})",
    wf_no_approvals: "Bekleyen onay yok.",
    wf_lwr_badge: "CANLI WEB ARAŞTIRMASI",
    wf_lwr_counts: "{searches} arama · {sources} kaynak · {pages} sayfa okundu",
    wf_status_idle: "Boşta",
    wf_status_working: "Çalışıyor",
    wf_status_waiting_for_approval: "Onay bekliyor",
    wf_status_paused: "Duraklatıldı",
    wf_status_error: "Hata",
    wf_status_offline: "Çevrimdışı",
    wf_status_pending: "Beklemede",
    wf_status_planning: "Planlanıyor",
    wf_status_assigned: "Atandı",
    wf_status_in_progress: "Devam ediyor",
    wf_status_completed: "Tamamlandı",
    wf_status_failed: "Başarısız",
    wf_status_cancelled: "İptal edildi",
    wf_leads_title: "Adaylar",
    wf_leads_open: "Adayları Aç",
    wf_leads_overview_title: "Aday Pipeline'ı",
    wf_leads_total: "Toplam Aday",
    wf_leads_new: "Yeni",
    wf_leads_qualified: "Yeterli",
    wf_leads_reviewing: "İnceleniyor",
    wf_leads_approved: "Onaylı",
    wf_leads_rejected: "Reddedildi",
    wf_leads_archived: "Arşivlendi",
    wf_leads_verified: "Doğrulandı",
    wf_leads_needs_review: "İnceleme gerekli",
    wf_leads_none: "Henüz aday yok. Sales AI'dan bulmasını isteyin.",
    wf_leads_filter_status: "Durum",
    wf_leads_filter_verification: "Doğrulama",
    wf_leads_filter_min_score: "Min uygunluk skoru",
    wf_leads_filter_industry: "Sektör",
    wf_leads_filter_all: "Hepsi",
    wf_leads_sort: "Sırala",
    wf_leads_sort_score: "En yüksek uygunluk",
    wf_leads_sort_newest: "En yeni",
    wf_leads_sort_name: "Şirket adı",
    wf_leads_col_company: "Şirket",
    wf_leads_col_website: "Website",
    wf_leads_col_industry: "Sektör",
    wf_leads_col_location: "Konum",
    wf_leads_col_score: "Uygunluk",
    wf_leads_col_verification: "Doğrulama",
    wf_leads_col_status: "Durum",
    wf_leads_col_discovered: "Bulunma",
    wf_leads_score_reasons: "Bu skorun nedeni",
    wf_leads_concerns: "Endişeler",
    wf_leads_sources: "Kanıt kaynakları",
    wf_leads_discovery_task: "Bulunduğu görev",
    wf_leads_actions_approve: "Onayla",
    wf_leads_actions_reject: "Reddet",
    wf_leads_actions_archive: "Arşivle",
    wf_leads_action_ok: "Aday {action}",
    wf_leads_action_fail: "Aday {action} yapılamadı",
    wf_leads_no_outreach_note: "Onaylama bu adayı takibe alır. Hiçbir e-posta, DM veya iletişim gönderilmez.",
    wf_lead_status_new: "Yeni",
    wf_lead_status_qualified: "Yeterli",
    wf_lead_status_reviewing: "İnceleniyor",
    wf_lead_status_approved: "Onaylı",
    wf_lead_status_rejected: "Reddedildi",
    wf_lead_status_archived: "Arşivlendi",
    wf_verif_verified: "Doğrulandı",
    wf_verif_needs_review: "İnceleme gerekli",
    wf_verif_unverified: "Doğrulanmadı",
    wf_toast_task_created: "Hedef CEO AI'ya gönderildi — planlama başlıyor…",
    wf_toast_task_short: "Daha uzun bir başlık ve açıklama girin",
    wf_toast_task_create_fail: "Görev oluşturulamadı",
    wf_toast_task_load_fail: "Görev yüklenemedi",
    wf_toast_workforce_load_fail: "AI Workforce yüklenemedi",
    wf_toast_task_action_ok: "Görev {action}",
    wf_toast_task_action_fail: "Görev {action} yapılamadı",
    wf_toast_approved: "Onaylandı",
    wf_toast_rejected: "Reddedildi",
    wf_toast_approval_fail: "Onay çözülemedi",
    wf_chat_error_prefix: "Hata:",
    wf_chat_error_fallback: "sohbet başarısız",
    auth_google: "Google ile devam et",
    auth_or: "veya e-posta ile",
    integrations_eyebrow: "Bağla",
    integrations_h1: "Entegrasyonlar",
    integrations_sub: "Salesforce, Splunk, Defender, Trend Micro, SentinelOne, CrowdStrike ve diğerlerini bağla. Lumioo case'lerini çeker ve çözer.",
    help_eyebrow: "Dokümantasyon",
    help_h1: "Token & API key rehberi",
    help_faq: "Sıkça sorulanlar",
    help_sub: "Her platformdan API token nasıl alınır, adım adım rehber. Doğrudan o platformun ayarlar sayfasına gitmek için 'Aç' butonuna tıkla.",
    dash_eyebrow: "Panel",
    dash_hello: "Merhaba",
    dash_sub: "Bir araç seç ve üretmeye başla.",
    dash_credits_label: "Mevcut kredi",
    dash_open: "Aç",
    dash_chat_card_desc: "Her şeyi sor: Salesforce, güvenlik, kod, projeler.",
    dash_video_card_desc: "Konu → tam YouTube paketi + MP4 video.",
    dash_interview_card_desc: "AI mülakatçıyla iş görüşmesi pratiği yap.",
    dash_pro_only_badge: "Creator ve Pro",
    dash_card_unlock: "Yükselterek aç",
    dash_recent_eye: "Son projeler",
    dash_recent_h2: "Son işlerin",
    dash_view_all: "Hepsini gör",
    dash_no_projects: "Henüz proje yok. Şununla başla:",
    dash_or: "veya",
    chat_eyebrow: "Araç",
    chat_h1: "AI Sohbet",
    chat_sub: "Her şeyi sor — yazı, çeviri, tavsiye, kod, öğrenme, fikir.",
    chat_mode_image_hint: "Görsel oluştur",
    chat_mode_code_hint: "Hızlı kod yardımı",
    chat_mode_cv_hint: "CV oluştur",
    chat_bg_writing: "AI cevabınızı yazıyor…",
    chat_mode_travel: "Tatil",
    chat_mode_travel_hint: "tatil planlayıcı",
    chat_travel_placeholder: "Nereye gidiyorsunuz? Örn: '7 gün Tokyo, orta bütçe, Ekim sonu'",
    travel_mode_pro_only: "Tatil planlayıcı Pro özelliğidir. Sınırsız itinerary için yükseltin.",
    travel_mode_pro_only_short: "Tatil — Pro özelliği",
    chat_cv_placeholder: "CV'ni yükle ya da bana yaz: ad, hedef pozisyon, deneyim, eğitim, beceriler…",
    chat_mode_video_hint: "Video yap",
    model_desc_haiku: "Hızlı günlük sohbet",
    model_desc_sonnet: "Derin düşünce ve yazım",
    model_desc_gpt4o: "Dengeli, genel amaçlı",
    model_desc_gemini: "Çoklu ortam ve görsel",
    model_desc_gpt5: "En zor görevler · üst düzey akıl yürütme",
    model_badge_fast: "HIZLI",
    model_locked_toast: "{model} {tier} planında. Açmak için yükselt.",
    chat_gpt5_this_month: "bu ay",
    chat_gpt5_meter_label: "Bu ay kullanılan GPT-5 mesajları",
    chat_new: "Yeni sohbet",
    chat_sessions: "Sohbetler",
    chat_empty_title: "Bugün nasıl yardım edebilirim?",
    chat_empty_sub: "Yazmaya başla veya örneklerden birini dene.",
    chat_placeholder: "Lumioo'a bir şey sor…",
    chat_send: "Gönder",
    admin_finance_title: "Finans",
    admin_finance_sub: "Bu ayın geliri, maliyetleri ve kâr/zararı. Tahmin — Stripe gerçek kaynaktır.",
    admin_finance_prev: "önceki",
    admin_finance_refresh: "Yenile",
    admin_fin_revenue: "Gelir",
    admin_fin_llm_cost: "AI maliyeti",
    admin_fin_image_cost: "Görsel maliyeti",
    admin_fin_net_profit: "Net kâr",
    admin_fin_net_loss: "Net ZARAR",
    admin_fin_margin: "Marj",
    admin_fin_paid_tx: "ödenmiş işlem",
    admin_fin_messages: "mesaj",
    admin_fin_images: "görsel",
    chat_delete_all: "Tümünü sil",
    chat_delete_all_confirm: "TÜM {n} sohbeti silmek istediğinden emin misin? Bu geri alınamaz.",
    chat_delete_all_done: "{n} sohbet silindi",
    chat_model: "Model",
    chat_speed: "Hız",
    chat_mode_quick: "Hızlı",
    chat_mode_quick_sub: "Gemini Flash · ucu uca hızlı",
    chat_mode_smart: "Akıllı",
    chat_mode_smart_sub: "Sonnet 4.6 · daha derin",
    chat_mode_genius: "Dahi",
    chat_mode_genius_sub: "GPT-5 · en üst akıl yürütme",
    chat_mode_master: "Üstad",
    chat_mode_master_sub: "Opus 4.5 · en yetenekli",
    chat_opus_meter_label: "Bu ay Üstad (Opus 4.5) mesajları",
    chat_thinking: "Düşünüyor…",
    chat_stop: "Durdur",
    chat_continue: "Devam et",
    chat_stopped_marker: "⏹ Durduruldu",
    chat_continue_prompt: "Kaldığın yerden devam et.",
    chat_thinking_fast: "⚡ Hızlı",
    chat_thinking_balanced: "🎯 Dengeli",
    chat_thinking_thorough: "🧠 Detaylı",
    bestai_sub: "Şu anda yazı, kod ve akıl yürütmede #1. İstediğin an GPT-5 veya Gemini 3'e geç — ek ücret yok.",
    bestai_table_h: "Her iş için doğru modeli seç.",
    bestai_table_sub: "Lumioos üçünü de sunar — sohbet başına tek tıkla değiştir.",
    bestai_footnote: "Tüm modeller Lumioos aboneliğine dahil — tek tıkla değiştir, ekstra ücret yok.",
    bestai_h2: "Claude 4.5 ile güçlendirildi.",
    bestai_eyebrow: "Akıllı varsayılan",
    bestai_task_writing: "Uzun form yazı",
    bestai_task_code: "Kod ve hata ayıklama",
    bestai_task_translate: "Çeviri (TR/AR/RU)",
    bestai_task_reasoning: "En zor akıl yürütme",
    bestai_task_capable: "En yetkin",
    bestai_task_quick: "Hızlı cevaplar",
    gpt56_promo_badge: "YENİ · PRO & POWER'A ÖZEL",
    gpt56_promo_title: "GPT 5.6 Ailesi",
    gpt56_promo_desc: "GPT'nin yeni neslini tanıyın — üç farklı sürüm, tek amaç: her göreviniz için ihtiyacınız olan derinlik, kapsam ve hız dengesini size sunmak. Bugünden itibaren {plans} planlarında.",
    gpt56_promo_plans_hl: "Pro & Power",
    gpt56_sol_tag: "En derin akıl yürütme",
    gpt56_sol_desc: "En zor sorunlar için — uzun analizler, araştırma, karmaşık kod incelemesi. Doğruluğun hızdan daha önemli olduğu anlar için.",
    gpt56_terra_tag: "Dengeli güç",
    gpt56_terra_desc: "Günlük iş yükün için ideal. Kaliteli cevaplar, yeterince hızlı, geniş bilgi birikimi — Sol ile Luna arasındaki tatlı nokta.",
    gpt56_luna_tag: "En hızlı 5.6",
    gpt56_luna_desc: "Sohbet, beyin fırtınası ve hızlı aramalar için çevik cevaplar. Çoğu modelden hâlâ daha akıllı — sadece daha hızlı.",
    gpt56_cta_plans: "Pro & Power planlarını gör →",
    gpt56_cta_trial: "14 gün ücretsiz deneyi başlat",
    router_promo_badge: "YENİ · PRO'YA ÖZEL",
    router_promo_desc: "Gezegendeki en güçlü model — en zor görevlerinize otomatik olarak yönlendirilir. Sohbetteki tek bir tıklamayla karmaşık kod, analiz ve akıl yürütme OpenAI GPT-5'e gider, günlük sorular ise Claude 4.5'te akıcı kalır. Model seçici yok. Sürtünme yok.",
    router_promo_bullet1: "Zor görevler için GPT-5'i otomatik seçer",
    router_promo_bullet2: "Dünya lideri akıl yürütme + kod",
    router_promo_bullet3: "Öncelikli sıra, hız limiti yok",
    router_promo_bullet4: "Sohbette tek tıkla aç/kapat",
    router_promo_cta: "Pro'ya yükselt",
    router_promo_included: "Her Pro planında ücretsiz dahil",
    sonnet_promo_pill: "Genel görevler için en iyisi",
    sonnet_promo_default_label: "— Lumioos varsayılanı",
    sonnet_promo_desc: "Anthropic'in amiral gemisi modeli, yazı, kod ve karmaşık akıl yürütme alanlarında bağımsız kıyaslamalarda liderdir. GPT-5'e göre daha düşük halüsinasyon oranı ve daha güçlü çok dilli kalite. Yeni kullanıcıların en iyi sonuçları hemen alması için Lumioos varsayılanı olarak ayarlandı.",
    sonnet_col_writing: "Yazma",
    sonnet_col_code: "Kod",
    sonnet_col_reasoning: "Akıl yürütme",
    chat_delete: "Sil",
    chat_copy: "Kopyala",
    chat_copied: "Kopyalandı",
    chat_no_sessions: "Henüz sohbet yok.",
    chat_suggest_1: "Bu İngilizce maili Türkçeye çevir",
    chat_suggest_2: "Arkadaşıma sıcak bir doğum günü mesajı yaz",
    chat_suggest_3: "Kuantum bilgisayarı basit kelimelerle anlat",
    chat_suggest_4: "İstanbul'a 3 günlük hafta sonu gezisi planla",
    video_eyebrow: "Araç",
    video_h1: "AI Video Üretici",
    video_sub: "Konu yaz → tam YouTube paketi + hazır MP4 al.",
    video_topic: "Konu",
    video_topic_ph: "ör. Yapay Zeka 2026'da Online Geliri Nasıl Dönüştürecek",
    video_tone: "Ton",
    video_length: "Uzunluk",
    video_voice: "Ses",
    video_generate: "Video paketini üret",
    video_generating: "Videonuz üretiliyor… (30-90 sn)",
    video_loading_sub: "Senaryo yazılıyor, sahneler çiziliyor, ses kaydediliyor, MP4 birleştiriliyor…",
    video_empty: "Üretilen video varlıklarınız burada görünecek.",
    video_title_l: "Başlık",
    video_desc_l: "Açıklama",
    video_voiceover: "Seslendirme",
    video_download_audio: "MP3 indir",
    video_download_video: "MP4 indir",
    video_scenes: "Sahneler",
    video_copy_meta: "Bilgileri kopyala",
    video_meta_copied: "Bilgiler kopyalandı",
    video_no_mp4: "MP4 oluşturulamadı — sahneleri ve sesi ayrı ayrı kullanabilirsin.",
    scene: "Sahne",
    image_unavailable: "Görsel yüklenemedi",
    projects_eyebrow: "Geçmiş",
    projects_h1: "Projelerin",
    projects_sub: "Lumioo ile ürettiğin her şey.",
    projects_empty: "Henüz proje yok.",
    projects_clear_all: "Tümünü sil",
    projects_clear_confirm: "TÜM projeleri silmek istiyor musunuz?",
    projects_clear_yes: "Evet, tümünü sil",
    projects_cleared_count: "{count} proje silindi",
    try_chat: "AI Sohbet'i dene",
    try_video: "Video Üretici'yi dene",
    err_generic: "Bir hata oluştu",
    err_topic_required: "Lütfen bir konu gir",
    err_message_required: "Bir mesaj yaz",
    video_ready: "Video paketi hazır",
    answer_ready: "Cevap hazır",
    stage_queued: "Sırada…",
    stage_script: "Senaryo yazılıyor…",
    stage_images_audio: "Sahneler çiziliyor & ses kaydediliyor…",
    stage_stitching: "MP4 birleştiriliyor…",
    stage_done: "Tamamlandı",
    // Chat extras
    chat_attach_image: "Resim ekle",
    chat_websearch_label: "Web",
    chat_websearch_on: "Web arama AÇIK — Lumioos cevap vermeden önce internetten güncel veri çeker",
    chat_enable_web_retry: "Web aramayı aç ve tekrar dene",
    cv_mode_pro_only: "CV sohbet & gözden geçirme Pro özelliğidir. CV oluşturma, dosya yükleme, AI inceleme ve PDF dışa aktarma için Pro'ya yükseltin.",
    cv_upload_title: "CV'ni yükle (opsiyonel)",
    cv_upload_hint: "PDF, Word, TXT veya görsel — Lumioos CV'ni inceleyecek ve başvurduğun mesleğe göre uyarlayacak.",
    cv_upload_btn: "CV yükle",
    cv_upload_ok: "CV yüklendi — hedef mesleği yaz, Lumioos inceleyip uyarlasın",
    cv_upload_image_ok: "CV görseli eklendi — Lumioos bir sonraki mesajda okuyacak",
    cv_upload_ready: "hazır — başvurmak istediğin meslek/pozisyonu yaz",
    cv_upload_too_large: "Dosya çok büyük (en fazla 8 MB)",
    cv_upload_failed: "Bu dosyayı okuyamadım",
    cv_saved_label: "Kayıtlı CV:",
    cv_saved_replace: "Değiştir",
    cv_saved_delete: "Sil",
    cv_saved_delete_confirm: "Kayıtlı CV'ni silmek istediğine emin misin? Bir dahaki sefere tekrar yüklemen gerekecek.",
    cv_saved_deleted: "Kayıtlı CV silindi",
    cv_pdf_btn: "PDF İndir",
    cv_pdf_no_content: "Önce bir mesaj gönder, Lumioos CV'ni hazırlasın.",
    cv_pdf_ready: "PDF hazır",
    cv_pdf_failed: "PDF oluşturulamadı",
    cv_ats_btn: "ATS Skoru",
    cv_ats_prompt: "Hedef iş ilanının açıklamasını yapıştır (en az 20 karakter):",
    cv_ats_too_short: "Daha uzun bir iş tanımı yapıştır",
    cv_ats_ready: "ATS skoru hazır",
    cv_ats_result_title: "ATS Skor Sonucu",
    cv_ats_categories: "Kategoriler",
    cv_ats_matched: "Eşleşen anahtar kelimeler",
    cv_ats_missing: "Eksik anahtar kelimeler",
    cv_ats_recommendations: "Öneriler",
    cv_optimize_btn: "Optimize Et",
    cv_optimize_prompt: "Hedef iş ilanının açıklamasını yapıştır (veya boş bırakıp özel talimat ver):",
    cv_optimize_instruction: "Lumioos CV'ni nasıl optimize etsin?",
    cv_optimize_need_input: "İş tanımı veya bir talimat vermelisin",
    cv_optimize_empty: "CV döndürülmedi",
    cv_optimize_ready: "Optimize edilmiş CV hazır",
    cv_optimize_result_title: "Optimize Edilmiş CV",
    cv_history_btn: "Geçmiş",
    cv_history_title: "CV Sürüm Geçmişi",
    cv_history_empty: "Henüz kayıtlı CV yok.",
    cv_history_current: "Aktif",
    cv_history_restore: "Geri Yükle",
    cv_history_restored: "Sürüm geri yüklendi",
    cv_cover_btn: "Kapak Mektubu",
    cv_cover_title: "AI Kapak Mektubu",
    cv_cover_jd_label: "İş tanımı",
    cv_cover_jd_placeholder: "İş ilanının tam metnini buraya yapıştır…",
    cv_cover_jd_too_short: "Daha uzun bir iş tanımı yapıştır",
    cv_cover_company_label: "Şirket",
    cv_cover_role_label: "Pozisyon",
    cv_cover_tone_label: "Ton",
    cv_cover_tone_confident: "Kendinden emin & profesyonel",
    cv_cover_tone_warm: "Sıcak & samimi",
    cv_cover_tone_formal: "Resmi",
    cv_cover_tone_enthusiastic: "Coşkulu",
    cv_cover_generate: "Kapak Mektubu Oluştur",
    cv_cover_hint: "Kayıtlı CV'ni kullanır — tekrar yüklemene gerek yok.",
    cv_cover_ready: "Kapak mektubu hazır",
    cv_cover_empty: "Kapak mektubu döndürülmedi",
    cv_cover_regenerate: "Yeniden Oluştur",
    cv_cover_success: "Kapak mektubu sohbetine eklendi.",
    cv_cover_pdf_btn: "PDF olarak indir",
    cv_cover_pdf_ready: "Kapak mektubu PDF'i hazır",
    cv_cover_copy_btn: "Kopyala",
    cv_diff_btn: "Diff",
    cv_diff_title: "CV Sürüm Farkı",
    cv_diff_empty: "Değişiklik yok.",
    cv_diff_restore_this: "Bu sürümü geri yükle",
    cv_diff_close: "Kapat",
    copied: "Kopyalandı",
    chat_websearch_off: "Web arama KAPALI — Lumioos kendi bilgisini kullanır. Güncel olaylar için açın.",
    chat_start_recording: "Sesi başlat",
    chat_stop_recording: "Bitir & yazıya dök",
    chat_image_attached: "Resim hazır",
    chat_image_remove: "Resmi kaldır",
    chat_only_image: "Lütfen bir resim dosyası seç",
    chat_image_too_large: "Resim çok büyük (max 8 MB)",
    chat_image_max: "Bir mesaja en fazla 10 resim ekleyebilirsin",
    chat_drop_title: "Eklemek için resmi buraya bırak",
    chat_drop_sub: "PNG / JPG / WebP — maks 8 MB",
    chat_upgrade_title: "Günlük limitin doldu",
    chat_upgrade_sub: "Free planda bugün {used}/{limit} mesaj kullandın. Devam etmek için üyeliğini yükselt — limit her gün gece UTC'de sıfırlanır.",
    chat_upgrade_benefits: "Yükseltince neler açılır",
    chat_upgrade_b1: "Sınırsız sohbet mesajı",
    chat_upgrade_b2: "Mülakat Pratiği'ne tam erişim",
    chat_upgrade_b3: "Sohbette resim + sesli kullanım",
    chat_upgrade_b4: "Videolarda watermark yok",
    chat_upgrade_cta: "Planları gör",
    chat_upgrade_later: "Belki sonra",
    iv_gate_title: "Mülakat Pratiği kilitli",
    iv_gate_sub: "Bu özellik Creator ve Pro üyelere özel. Sınırsız soru bankası, sesli mod ve detaylı raporları açmak için planını yükselt.",
    iv_gate_what_you_get: "Açılacaklar",
    iv_gate_b1: "Sınırsız soru bankası (PDF / resim yükleme)",
    iv_gate_b2: "Sesli + yazılı mülakat modları, AI değerlendirme",
    iv_gate_b3: "Animasyonlu AI mülakatçı + 4 ses seçeneği",
    iv_gate_b4: "Detaylı performans raporu + e-posta özeti",
    iv_gate_cta: "Planları gör",
    iv_gate_back: "Lumioos'a dön",
    vd_gate_title: "AI Video Üretici kilitli",
    vd_gate_sub: "Sora 2 ile gerçek AI videoları — sadece Creator ve Pro planlarında.",
    vd_gate_what_you_get: "Açılacaklar",
    vd_gate_b1: "Sora 2 ile gerçek sinematik AI video klipleri",
    vd_gate_b2: "Çok sahneli videolar, 9 dilde AI seslendirme",
    vd_gate_b3: "1280×720 MP4 indirme — filigran yok",
    vd_gate_b4: "Creator: ayda 15 video, Pro: ayda 50 video",
    vd_gate_cta: "Yükselt ve aç",
    vd_gate_back: "Panele dön",
    cancel_btn: "Aboneliği iptal et",
    cancel_tooltip: "Bitiş tarihine kadar erişimin devam eder",
    cancel_confirm: "Aboneliği iptal etmek istediğine emin misin? Mevcut bitiş tarihine kadar tüm erişimin devam edecek.",
    cancel_ok: "Abonelik iptal edildi — bitiş tarihine kadar erişimin devam edecek.",
    cancel_ok_with_date: "Aboneliğin iptal edildi. {date} tarihine kadar tüm özellikler senin olacak.",
    cancel_fail: "İptal edilemedi — lütfen tekrar dene.",
    bug_open: "Hata bildir",
    bug_title: "Bir hata veya sorun bildir",
    bug_sub: "Ne ters gitti yaz. Yardımcı olur diye ekran görüntüsü veya PDF ekleyebilirsin.",
    bug_placeholder: "Ne olmasını bekliyordun? Aslında ne oldu?",
    bug_attach: "Ekran görüntüsü veya PDF ekle (isteğe bağlı)",
    bug_send: "Bildir",
    bug_sending: "Gönderiliyor...",
    bug_thanks: "Teşekkürler! En kısa zamanda inceleyeceğiz.",
    bug_send_fail: "Gönderilemedi — lütfen tekrar dene.",
    bug_message_short: "Lütfen en az 3 karakter yaz.",
    bug_file_too_large: "Dosya çok büyük (maks 5 MB)",
    bug_only_image_or_pdf: "Sadece resim veya PDF dosyaları kabul edilir",
    chat_describe_image: "Bu resimde ne görüyorsun?",
    chat_voice_added: "Ses metne dönüştürüldü",
    chat_voice_empty: "Ses algılanamadı — tekrar dene",
    chat_mic_denied: "Mikrofon izni reddedildi",
    chat_recording_ph: "Kaydediliyor… bitince durdur'a bas",
    // Video extras
    video_language: "Dil",
    // Projects extras
    project_view: "Görüntüle",
    project_delete: "Sil",
    project_delete_confirm: "Onayla",
    project_cancel: "Vazgeç",
    project_deleted: "Proje silindi",
    project_confirm_delete: "Bu projeyi kalıcı olarak silmek istiyor musun?",
    project_back: "Projelere dön",
    project_not_found: "Proje bulunamadı",
    project_no_video: "Bu projede kaydedilmiş MP4 yok.",
    project_download: "MP4 indir",
    project_download_started: "İndirme başladı",
    // Billing / Pricing
    side_billing: "Abonelik",
    side_referrals: "Davet Et & Kazan",
    side_upgrade: "Yükselt",
    pricing_eyebrow: "Planlar",
    pricing_h1: "Planını seç",
    pricing_sub: "İstediğin zaman yükselt. İstediğin zaman iptal et. Gerçek abonelik, gerçek değer.",
    pricing_current: "Mevcut plan",
    pricing_expires: "yenilenir",
    pricing_popular: "En popüler",
    pricing_month: "ay",
    pricing_month_short: "ay",
    pricing_subscribe: "Abone ol",
    pricing_current_plan: "Aktif plan",
    pricing_free_default: "Varsayılan plan",
    pricing_redirecting: "Yönlendiriliyor…",
    pricing_disclaimer: "Ödemeler Stripe üzerinden işlenir. Abone olarak aylık ücretlendirmeyi kabul edersin. Hesabından istediğin zaman iptal edebilirsin.",
    pricing_mobile_note_title: "Buradaki fiyatlar web ödemesi içindir.",
    pricing_mobile_note_body: "iOS veya Android uygulamamız içinden satın alınan abonelikler, App Store komisyonları (yüzde 30'a kadar) nedeniyle daha yüksek olabilir. Web'den abone olarak daha fazla tasarruf edin.",
    // --- Lumioos Jarvis (Phase 1) ---
    side_jarvis: "Jarvis",
    jarvis_available_with: "Pro ve Power üyeliklerinde mevcut",
    jarvis_locked_body: "Lumioos Jarvis yalnızca Pro ve Power üyeliklerinde kullanılabilir. Bilgisayarınızı uzaktan kontrol etmek, görevleri otomatik çalıştırmak ve zamanlanmış işlemler oluşturmak için üyeliğinizi yükseltin.",
    jarvis_upgrade_to_pro: "Pro'ya Yükselt",
    jarvis_upgrade_to_power: "Power'a Yükselt",
    jarvis_current_plan_prefix: "Mevcut planınız",
    jarvis_month_or_year: "Aylık ve yıllık planlar mevcut",
    jarvis_features_title: "Jarvis neler yapabilir",
    jarvis_feat_pair: "Windows bilgisayarınızı güvenle eşleştirin ve uzaktan kontrol edin",
    jarvis_feat_command: "Türkçe veya İngilizce sesli/yazılı komut gönderin",
    jarvis_feat_schedule: "Zamanlanmış ve tekrarlayan otomasyon görevleri oluşturun",
    jarvis_feat_screenshots: "Canlı ekran görüntüleri ve her adımda doğrulama",
    jarvis_feat_history: "Loglar, durum ve tamamlanma zaman damgalarıyla tam görev geçmişi",
    jarvis_feat_safety: "Acil Durdurma, işlem onayları ve güvenlik için denetim kaydı",
    jarvis_compare_title: "Pro ile Power karşılaştırması",
    jarvis_plan_pro_headline: "Bireysel otomasyon",
    jarvis_plan_power_headline: "Ekip düzeyinde otomasyon",
    jarvis_recommended: "Önerilen",
    jarvis_paired_computers: "eşleşmiş bilgisayar",
    jarvis_tasks_per_month: "görev / ay",
    jarvis_scheduled_tasks: "aktif zamanlanmış görev",
    jarvis_pro_browsers: "Chrome, Edge, OBS Studio, Dosya Gezgini, VS Code, Teams",
    jarvis_pro_history: "14 gün ekran görüntüsü & log saklama",
    jarvis_power_recurring: "Tekrarlayan otomasyon & öncelikli işlem",
    jarvis_power_history: "60 gün ekran görüntüsü & log saklama",
    jarvis_power_advanced: "Gelişmiş yeniden deneme, doğrulama ve kurtarma",
    jarvis_billing_link_line: "Tüm plan detayları ve fiyatları için faturalama sayfasına bakın.",
    jarvis_see_all_plans: "Tüm planları gör",
    jarvis_active_badge: "Jarvis aktif",
    jarvis_dashboard_subtitle: "Bir Windows bilgisayar eşleştirin ve doğal dil komutlarıyla otomasyona başlayın.",
    jarvis_current_plan: "Mevcut plan",
    jarvis_tasks_this_month: "Bu ayki görevler",
    jarvis_pair_soon_title: "Başlamak için bir bilgisayar eşleştirin",
    jarvis_pair_soon_body: "Ücretsiz Lumioos Desktop Agent'ı Windows için indirin ve tek kullanımlık kod ile eşleyin. Bir sonraki sürümde geliyor.",
    jarvis_phase2_soon: "Phase 2 — Desktop Agent çok yakında",
    pricing_faq_title: "Sık sorulanlar",
    pricing_faq_why_pro_q: "Pro neden 29$?",
    pricing_faq_why_pro_a: "Pro artık Sora-2 video, GPT-5, Claude Opus 4.5, GPT Image 1 ve sınırsız chat içeriyor. Ayrı ayrı alınsa aylık 80$+ tutardı (ChatGPT Plus 20$ + Runway 15$ + Midjourney 10$ + Claude Pro 20$). Hepsini 29$'a bir paket yaptık — %60+ tasarruf. Mevcut Pro müşterileri eski 10$ fiyatında kalır.",
    pricing_faq_cancel_q: "İstediğim zaman iptal edebilir miyim?",
    pricing_faq_cancel_a: "Evet — Faturalama ayarlarından tek tıkla. Mevcut ay için iade yok ama dönem bitene kadar Pro açık kalır. Uyarmadan asla otomatik yenilemeyiz.",
    pricing_faq_existing_q: "Daha önce kayıt oldum — fiyatım değişir mi?",
    pricing_faq_existing_a: "Hayır. Zaten 5$ (Creator) veya 10$ (Pro) ödüyorsan, Stripe aboneliğin SEN iptal edene veya plan değiştirene kadar o fiyatta kalır. Sadece yeni kayıtlar yeni fiyatı görür.",
    billing_checking: "Ödeme onaylanıyor…",
    billing_checking_sub: "Bu genelde birkaç saniye sürer.",
    billing_paid: "Ödeme başarılı 🎉",
    billing_paid_sub: "Aktifleştirilen plan:",
    billing_pending: "Hâlâ işleniyor",
    billing_pending_sub: "Birazdan tekrar dene — plan otomatik aktifleşecek.",
    billing_expired: "Oturum süresi doldu",
    billing_failed: "Ödeme tamamlanmadı",
    billing_to_dashboard: "Panele git",
    billing_back: "Fiyatlara dön",
    video_already_running: "Zaten bir video üretiliyor. Bitmesini bekle veya görmezden gel.",
    video_dismiss_confirm: "Bu görevi paneli kapat? (Video arka planda üretilmeye devam edecek ve Projeler'de görünecek.)",
    pricing_monthly: "Aylık",
    pricing_yearly: "Yıllık",
    pricing_save_2mo: "2 ay bedava",
    pricing_year: "yıl",
    pricing_year_short: "yıl",
    pricing_yearly_savings: "Yılda ${saved} tasarruf",
    pricing_admin_unlimited: "Admin — Sınırsız (limit yok)",
    pricing_admin_skip: "Admin: sınırsız",
    redeem_have_code: "Kodun mu var?",
    redeem_apply: "Uygula",
    redeem_required: "Kod gir",
    redeem_success: "Kod uygulandı",
    pwa_install_lumioos: "Lumioos'u Yükle",
    pwa_install_subtitle: "Ana ekranına ekle — app store gerekmiyor.",
    pwa_install_short: "Yükle",
    pwa_not_now: "Şimdi değil",
    pwa_got_it: "Anladım",
    pwa_ios_safari_required: "Yüklemek için bu siteyi Safari'de aç",
    pwa_ios_safari_required_sub: "iPhone'da sadece Safari ana ekrana uygulama ekleyebilir. Linki kopyala, Safari'ye yapıştır.",
    pwa_ios_copy_link: "Linki kopyala",
    pwa_modal_title_ios: "iPhone / iPad'e Yükle",
    pwa_modal_title_android: "Android'e Yükle",
    pwa_modal_title_mac: "Mac'e Yükle",
    pwa_modal_title_desktop: "Masaüstüne Yükle",
    pwa_modal_ios_step1: "Safari'nin altındaki Paylaş ikonuna dokun (yukarı ok)",
    pwa_modal_ios_step2: "Aşağı kaydır ve \"Ana Ekrana Ekle\"ye dokun",
    pwa_modal_ios_step3: "Sağ üstteki \"Ekle\"ye dokun",
    pwa_modal_ios_step4: "Lumioos ana ekranında native app gibi görünür",
    pwa_modal_android_step1: "Chrome'un sağ üstündeki ⋮ menüsüne dokun",
    pwa_modal_android_step2: "\"Ana ekrana ekle\" veya \"Uygulamayı yükle\"ye dokun",
    pwa_modal_android_step3: "Açılan pencerede \"Yükle\"ye dokun",
    pwa_modal_android_step4: "Lumioos native app gibi açılır",
    pwa_modal_mac_step1: "Adres çubuğundaki yükleme ikonuna tıkla (⊕ sağda)",
    pwa_modal_mac_step2: "VEYA: Chrome menüsü (⋮) → \"Lumioos'u Yükle…\"",
    pwa_modal_mac_step3: "Açılan pencerede \"Yükle\"ye tıkla",
    pwa_modal_mac_step4: "Lumioos kendi penceresinde native gibi açılır",
    pwa_modal_desktop_step1: "Adres çubuğundaki yükleme ikonunu ara (⊕ veya ↓)",
    pwa_modal_desktop_step2: "Göremiyorsan tarayıcı menüsünü aç, \"Lumioos'u Yükle\" ara",
    pwa_modal_desktop_step3: "\"Yükle\"ye tıkla",
    pwa_modal_desktop_step4: "Lumioos kendi masaüstü penceresinde açılır",
    // ---------------- Jarvis (Kontrol Merkezi + Yardım Merkezi) ----------------
    jarvis_paired_computers_title: "Eşleşmiş bilgisayarlar",
    jarvis_pair_a_computer_btn: "Bilgisayar eşleştir",
    jarvis_no_devices_hint: "Henüz eşleşmiş bilgisayar yok. Başlamak için \"Bilgisayar eşleştir\"e tıkla.",
    jarvis_send_command_title: "Komut gönder",
    jarvis_command_placeholder: "OBS'u aç, Chrome'da mylumioos.com'u aç, 30 saniye kaydet, durdur ve videoyu doğrula",
    jarvis_target_label: "Hedef: {name}",
    jarvis_pair_first_hint: "Komut göndermek için önce bir bilgisayar eşleştir",
    jarvis_send_to_jarvis_btn: "Jarvis'e gönder",
    jarvis_task_history_title: "Görev geçmişi",
    jarvis_no_tasks_hint: "Henüz görev yok. Yukarıdan ilk komutunu gönder.",
    jarvis_device_selected: "Seçili",
    jarvis_device_select: "Seç",
    jarvis_device_revoked_badge: "İptal edildi",
    jarvis_status_online: "Çevrimiçi",
    jarvis_status_offline_last_seen: "Çevrimdışı · son görülme {ago}",
    jarvis_status_never: "hiç",
    jarvis_status_unknown: "bilinmiyor",
    jarvis_toast_type_command_first: "Önce bir komut yaz",
    jarvis_toast_pair_first: "Önce bir bilgisayar eşleştir ve seç",
    jarvis_toast_task_queued: "Görev sıraya alındı — Agent birazdan çalıştıracak.",
    jarvis_toast_monthly_limit: "Aylık görev limitine ulaşıldı ({max}). Daha fazlası için yükselt.",
    jarvis_toast_task_queue_failed: "Görev sıraya alınamadı",
    jarvis_toast_revoke_confirm: "Bu bilgisayar iptal edilsin mi? Agent hemen çalışmayı bırakır.",
    jarvis_toast_device_revoked: "Bilgisayar iptal edildi",
    jarvis_toast_device_revoke_failed: "Bilgisayar iptal edilemedi",
    jarvis_toast_task_cancelled: "Görev iptal edildi",
    jarvis_toast_task_cancel_failed: "Görev iptal edilemedi",
    jarvis_toast_delete_task_confirm: "Bu görev geçmişten silinsin mi?",
    jarvis_toast_task_deleted: "Görev silindi",
    jarvis_toast_task_delete_failed: "Görev silinemedi",
    jarvis_toast_clear_all_tasks_confirm: "Tüm görev geçmişi silinsin mi? Devam eden görevler korunur.",
    jarvis_toast_tasks_cleared: "{n} görev temizlendi",
    jarvis_toast_delete_device_confirm: "Bu bilgisayar kalıcı olarak kaldırılsın mı? Tüm görev geçmişi de silinir.",
    jarvis_toast_device_deleted: "Bilgisayar kaldırıldı",
    jarvis_clear_all_tasks_btn: "Hepsini temizle",
    jarvis_task_status_queued: "Sırada",
    jarvis_task_status_running: "Çalışıyor",
    jarvis_task_status_completed: "Tamamlandı",
    jarvis_task_status_failed: "Başarısız",
    jarvis_task_status_cancelled: "İptal edildi",
    jarvis_task_cancel_btn: "İptal et",
    jarvis_task_error_label: "Hata:",
    jarvis_task_steps_label: "Adımlar",
    jarvis_task_screenshots_label: "Ekran görüntüleri ({n})",
    jarvis_task_result_label: "Sonuç",
    jarvis_task_steps_count: "{n} adım",
    jarvis_task_screenshots_count: "{n} ekran görüntüsü",
    jarvis_time_seconds_ago: "{n}sn önce",
    jarvis_time_minutes_ago: "{n}dk önce",
    jarvis_time_hours_ago: "{n}sa önce",
    jarvis_time_days_ago: "{n}g önce",
    jarvis_download_windows: "Windows için indir",
    jarvis_download_macos: "macOS için indir",
    jarvis_download_linux: "Linux için indir (macOS sürümü)",
    jarvis_alt_downloads_title: "Başka bir bilgisayar mı kullanıyorsun?",
    jarvis_sys_title: "Sistem bilgisi",
    jarvis_sys_detected_os: "Algılanan işletim sistemi",
    jarvis_sys_installed_agent: "Kurulu Agent",
    jarvis_sys_latest_version: "Son sürüm",
    jarvis_sys_status_connected: "Bağlı",
    jarvis_sys_status_offline: "Çevrimdışı",
    jarvis_sys_status_unpaired: "Eşleşmemiş",
    jarvis_sys_not_installed: "Kurulu değil",
    jarvis_sys_compat_uptodate: "Masaüstü Agent'ın güncel.",
    jarvis_sys_compat_outdated: "Kurulu Agent sürümü v{installed}, en son v{latest} — yeni özellikler için tekrar indirip kur.",
    jarvis_sys_compat_no_agent: "Bu bilgisayarda Jarvis'i etkinleştirmek için aşağıdan Masaüstü Agent'ı kur.",
    // Yardım merkezi — başlık ve kontroller
    jarvis_hc_intro_pill: "Kurulum ve Yardım",
    jarvis_hc_title: "Kurulum ve Yardım Merkezi",
    jarvis_hc_subtitle: "Masaüstü Agent'ı dakikalar içinde kur, bağla ve çalıştır — hiçbir video izlemene gerek yok.",
    jarvis_hc_search_placeholder: "Konu, adım ya da hata ara…",
    jarvis_hc_no_results: "Aramanla eşleşen sonuç yok. Farklı bir kelime dene.",
    jarvis_hc_tab_wizard: "Kurulum Sihirbazı",
    jarvis_hc_tab_troubleshoot: "Sorun Giderme",
    jarvis_hc_tab_faq: "SSS",
    jarvis_hc_video_title: "Video anlatım",
    jarvis_hc_video_placeholder: "Rehberli video turu yakında geliyor — şimdilik adım adım sihirbazı takip et.",
    jarvis_hc_step_of: "{total} adımdan {n}. adım",
    jarvis_hc_prev: "Geri",
    jarvis_hc_next: "İleri",
    jarvis_hc_done: "Bitirdim",
    jarvis_hc_need_help: "Bu adımda yardım gerekli mi?",
    jarvis_hc_screenshot_soon: "Bu adım için ekran görüntüsü önizlemesi yakında eklenecek.",
    jarvis_hc_troubleshoot_title: "Sık karşılaşılan sorunlar ve çözümler",
    jarvis_hc_troubleshoot_subtitle: "Olası nedeni ve hızlı çözümü görmek için sorunun üzerine dokun.",
    jarvis_hc_faq_title: "Sıkça sorulan sorular",
    jarvis_hc_faq_subtitle: "Jarvis'i kurmak, çalıştırmak ve güncellemek hakkında bilmen gereken her şey.",
    jarvis_hc_problem_label: "Sorun",
    jarvis_hc_cause_label: "Olası neden",
    jarvis_hc_solution_label: "Çözüm",
    // Sihirbaz — 12 adım
    jarvis_hc_step_download_title: "Masaüstü Agent'ı indir",
    jarvis_hc_step_download_desc: "İşletim sisteminize uygun ZIP dosyasını indirmek için aşağıdaki indirme düğmesine tıklayın (Windows veya macOS).",
    jarvis_hc_step_download_help: "Hiçbir şey inmediyse tarayıcının pop-up engelleyicisini veya İndirilenler klasörü ayarını kontrol et.",
    jarvis_hc_step_extract_title: "İndirilen dosyayı çıkar",
    jarvis_hc_step_extract_desc: "ZIP dosyasına sağ tıkla ve Windows'ta \"Tümünü Çıkar\"ı seç; macOS'ta çift tıklamak yeterli.",
    jarvis_hc_step_extract_help: "Dosyaları asla ZIP'in içinden direkt çalıştırma — önce çıkart, sonra klasörü aç.",
    jarvis_hc_step_open_folder_title: "Masaüstü Agent klasörünü aç",
    jarvis_hc_step_open_folder_desc: "Yeni çıkardığın \"lumioos-desktop-agent\" klasörüne gir (genellikle İndirilenler içinde bulunur).",
    jarvis_hc_step_open_folder_help: "Bu pencereyi açık tut — sonraki adımlarda buradan birkaç dosyaya çift tıklayacaksın.",
    jarvis_hc_step_run_install_title: "install-agent'ı çalıştır",
    jarvis_hc_step_run_install_desc: "Windows'ta install-agent.bat, macOS'ta install-agent.command dosyasına çift tıkla. Gerekli Python paketlerini yükler.",
    jarvis_hc_step_run_install_help: "Bir terminal penceresi açılıp kendiliğinden kapanır. Bu adımı sadece bir kez çalıştırman yeterli.",
    jarvis_hc_step_generate_code_title: "Eşleşme kodu oluştur",
    jarvis_hc_step_generate_code_desc: "Bu sayfaya dön, \"Bilgisayar eşleştir\"e tıkla ve ekranda çıkan 6 haneli kodu kopyala.",
    jarvis_hc_step_generate_code_help: "Kodlar 10 dakikada geçerliliğini yitirir ve yalnızca bir kez kullanılabilir. Süresi biterse yenisini üret.",
    jarvis_hc_step_run_pair_title: "pair-agent'ı çalıştır",
    jarvis_hc_step_run_pair_desc: "Windows'ta pair-agent.bat veya macOS'ta pair-agent.command dosyasına çift tıkla. Terminal senden eşleşme kodunu isteyecek.",
    jarvis_hc_step_run_pair_help: "pair-agent yalnızca yeni bir bilgisayar eşleştirirken çalıştırılır. Sonrasında hep start-agent kullanılır.",
    jarvis_hc_step_paste_code_title: "Eşleşme kodunu yapıştır",
    jarvis_hc_step_paste_code_desc: "6 haneli kodu terminale yapıştır ve Enter'a bas. Bu, bilgisayarını yetkilendirir.",
    jarvis_hc_step_paste_code_help: "Windows'ta sağ tıklayarak yapıştır; macOS'ta Cmd+V kullan. Yazarken ekranda bir şey görünmemesi normaldir.",
    jarvis_hc_step_connected_title: "\"Bağlantı başarılı\" mesajını bekle",
    jarvis_hc_step_connected_desc: "Terminalde \"✓ Eşleşme başarılı!\" yazısını göreceksin. Sonrasında pencereyi kapatabilirsin.",
    jarvis_hc_step_connected_help: "Eşleşme başarısız olursa internet bağlantını kontrol et ve yeni bir kod üret — eski kodlar hızlıca eskir.",
    jarvis_hc_step_run_start_title: "start-agent'ı çalıştır",
    jarvis_hc_step_run_start_desc: "Agent'ı çevrimiçi hale getirmek için start-agent.bat (Windows) veya start-agent.command (macOS) dosyasına çift tıkla.",
    jarvis_hc_step_run_start_help: "Bu terminal penceresini açık tut — kapatırsan Agent çevrimdışı olur; tekrar açman gerekir.",
    jarvis_hc_step_return_jarvis_title: "Jarvis'e geri dön",
    jarvis_hc_step_return_jarvis_desc: "Tarayıcıdaki bu sayfaya dön — çıkış yapman veya sayfayı yenilemene gerek yok.",
    jarvis_hc_step_return_jarvis_help: "Eşleşen bilgisayarın birkaç saniye içinde Eşleşmiş bilgisayarlar listesinde görünecek.",
    jarvis_hc_step_verify_online_title: "Bilgisayarın Çevrimiçi olduğunu doğrula",
    jarvis_hc_step_verify_online_desc: "Bilgisayar adının yanındaki yeşil nokta, Agent'ın çalıştığını ve komutlara hazır olduğunu gösterir.",
    jarvis_hc_step_verify_online_help: "Gri nokta start-agent'ın çalışmadığı anlamına gelir. Bilgisayarında tekrar aç ve dene.",
    jarvis_hc_step_first_command_title: "İlk komutunu gönder",
    jarvis_hc_step_first_command_desc: "Komut kutusuna \"open youtube.com\" yaz ve Gönder'e bas. Görev geçmişinden canlı ekran görüntülerini izle.",
    jarvis_hc_step_first_command_help: "Küçük başla: önce bir web sitesi açmayı dene, sonra OBS kaydı ve çok adımlı senaryolara geç.",
    // Sorun giderme — 11 konu
    jarvis_hc_ts_windows_defender_title: "Windows Defender uygulamayı engelledi",
    jarvis_hc_ts_windows_defender_cause: "SmartScreen, Microsoft imzalı olmayan yeni .bat dosyalarını otomatik olarak riskli sayar.",
    jarvis_hc_ts_windows_defender_solution: "Pop-up'ta \"Daha fazla bilgi\" ve ardından \"Yine de çalıştır\"a tıkla. Bu tercih Windows tarafından hatırlanır; her seferinde sormaz.",
    jarvis_hc_ts_macos_security_title: "macOS güvenliği uygulamayı engelledi",
    jarvis_hc_ts_macos_security_cause: "Gatekeeper, imzalanmamış betiklerin varsayılan olarak çalışmasına izin vermez.",
    jarvis_hc_ts_macos_security_solution: "Sistem Ayarları → Gizlilik ve Güvenlik → aşağıya kaydır ve engellenen dosyanın yanındaki \"Yine de Aç\"a tıkla.",
    jarvis_hc_ts_pairing_failed_title: "Eşleşme başarısız oldu",
    jarvis_hc_ts_pairing_failed_cause: "Kodun süresi doldu (10 dk limit), yanlış yazıldı ya da zaten kullanıldı.",
    jarvis_hc_ts_pairing_failed_solution: "\"Bilgisayar eşleştir\"e tekrar tıklayıp yeni bir kod al ve 10 dakika içinde pair-agent'a yapıştır.",
    jarvis_hc_ts_agent_offline_title: "Masaüstü Agent çevrimdışı",
    jarvis_hc_ts_agent_offline_cause: "start-agent penceresi kapatıldı veya bilgisayarın uykuya geçti.",
    jarvis_hc_ts_agent_offline_solution: "Masaüstü Agent klasörünü aç ve start-agent'a tekrar çift tıkla. Terminal penceresini açık bırak.",
    jarvis_hc_ts_obs_not_detected_title: "OBS algılanmadı",
    jarvis_hc_ts_obs_not_detected_cause: "OBS Studio kurulu değil veya WebSocket sunucusu (obs-websocket) devre dışı.",
    jarvis_hc_ts_obs_not_detected_solution: "OBS Studio 28 veya üzerini kur, ardından OBS'te Araçlar → WebSocket Sunucu Ayarları'ndan \"WebSocket sunucusunu etkinleştir\"i işaretle.",
    jarvis_hc_ts_browser_not_open_title: "Tarayıcı açılmadı",
    jarvis_hc_ts_browser_not_open_cause: "Playwright'ın yerleşik Chromium tarayıcısı kurulum sırasında yüklenmemiş.",
    jarvis_hc_ts_browser_not_open_solution: "install-agent'ı yeniden çalıştır — Playwright ve Chromium tarayıcısını otomatik olarak kurar.",
    jarvis_hc_ts_python_failed_title: "Python kurulumu başarısız",
    jarvis_hc_ts_python_failed_cause: "Python 3.10+ kurulu değil ya da \"Add to PATH\" işaretlenmeden kurulmuş.",
    jarvis_hc_ts_python_failed_solution: "python.org'dan Python 3.11'i indir, kurulum sırasında \"Add Python to PATH\" seçeneğini işaretle ve install-agent'ı tekrar çalıştır.",
    jarvis_hc_ts_permission_denied_title: "Erişim reddedildi",
    jarvis_hc_ts_permission_denied_cause: "macOS ya da Windows klavye, fare veya ekran kaydı erişimini engelledi.",
    jarvis_hc_ts_permission_denied_solution: "macOS: Sistem Ayarları → Gizlilik ve Güvenlik'ten Terminal'e Erişilebilirlik + Ekran Kaydı izni ver. Windows: start-agent'ı yönetici olarak çalıştır.",
    jarvis_hc_ts_connection_timeout_title: "Bağlantı zaman aşımına uğradı",
    jarvis_hc_ts_connection_timeout_cause: "Güvenlik duvarı, VPN veya kurumsal proxy mylumioos.com'a giden HTTPS trafiğini engelliyor.",
    jarvis_hc_ts_connection_timeout_solution: "Güvenlik duvarı/VPN'de mylumioos.com'a izin ver ya da proxy'yi geçici olarak kapat ve start-agent'ı tekrar çalıştır.",
    jarvis_hc_ts_agent_stopped_title: "Agent beklenmedik şekilde durdu",
    jarvis_hc_ts_agent_stopped_cause: "Terminal penceresi kapatıldı, bilgisayar uykuya geçti veya bir güncelleme uygulandı.",
    jarvis_hc_ts_agent_stopped_solution: "start-agent'ı tekrar aç. Terminalin son birkaç satırını oku — çoğu hata net bir açıklama basar.",
    jarvis_hc_ts_update_failed_title: "Güncelleme başarısız",
    jarvis_hc_ts_update_failed_cause: "Yeni bir Masaüstü Agent sürümü çıkmış ve yerel kopyan güncel değil.",
    jarvis_hc_ts_update_failed_solution: "Yukarıdaki indir düğmesinden en güncel ZIP'i indir, eski klasörün üzerine çıkart ve start-agent'ı tekrar çalıştır.",
    // SSS — 9 madde
    jarvis_hc_faq_install_every_time_q: "Agent'ı her seferinde kurmam gerekiyor mu?",
    jarvis_hc_faq_install_every_time_a: "Hayır. install-agent'ı bilgisayar başına yalnızca bir kez çalıştırırsın. Sonrasında Jarvis'i çevrimiçi yapmak için start-agent'a çift tıklaman yeterli.",
    jarvis_hc_faq_can_uninstall_q: "Masaüstü Agent'ı kaldırabilir miyim?",
    jarvis_hc_faq_can_uninstall_a: "Evet. Önce start-agent'ı kapat, sonra lumioos-desktop-agent klasörünü sil. Dilersen eşleşen bilgisayarı da bu sayfadan iptal edebilirsin.",
    jarvis_hc_faq_multiple_computers_q: "Birden fazla bilgisayar eşleştirebilir miyim?",
    jarvis_hc_faq_multiple_computers_a: "Evet. Pro kullanıcılar 2, Power kullanıcılar 5 bilgisayara kadar eşleştirebilir. Her bilgisayar için ayrı bir 6 haneli kod üretilir.",
    jarvis_hc_faq_windows_and_macos_q: "Aynı anda Windows ve macOS kullanabilir miyim?",
    jarvis_hc_faq_windows_and_macos_a: "Kesinlikle — Jarvis her bilgisayarı bağımsız yönetir; aynı hesap altında Windows PC ve Mac'i rahatça karışık kullanabilirsin.",
    jarvis_hc_faq_auto_start_q: "Bilgisayarımla birlikte otomatik başlıyor mu?",
    jarvis_hc_faq_auto_start_a: "Varsayılan olarak hayır. Otomatik başlatmak istersen start-agent'ı işletim sisteminin başlangıç uygulamalarına ekle (Windows'ta Startup, macOS'ta Login Items).",
    jarvis_hc_faq_how_to_update_q: "Masaüstü Agent'ı nasıl güncellerim?",
    jarvis_hc_faq_how_to_update_a: "Jarvis'ten en güncel ZIP'i indir, mevcut klasörün üzerine çıkart (ayarların korunur), ardından start-agent'ı yeniden başlat.",
    jarvis_hc_faq_recordings_location_q: "Kayıtlar nereye kaydediliyor?",
    jarvis_hc_faq_recordings_location_a: "Kayıtlar OBS Studio'nun varsayılan çıktı klasörüne kaydedilir — genelde Windows'ta Videolar/OBS, macOS'ta ise Filmler klasörüdür.",
    jarvis_hc_faq_change_recording_location_q: "Kayıt konumunu değiştirebilir miyim?",
    jarvis_hc_faq_change_recording_location_a: "Evet. OBS Studio'da Dosya → Ayarlar → Çıktı → Kayıt bölümünden istediğin klasörü seç. Jarvis yeni konumu otomatik algılar.",
    jarvis_hc_faq_remove_computer_q: "Eşleşen bir bilgisayarı nasıl kaldırırım?",
    jarvis_hc_faq_remove_computer_a: "Eşleşmiş bilgisayarlar listesinde bilgisayarın yanındaki çöp kutusu simgesine tıkla. Agent anında komut almayı bırakır.",
    },
};

export const LANGS = [
  { code: "en", label: "EN", name: "English", flag: "🇬🇧" },
  { code: "tr", label: "TR", name: "Türkçe", flag: "🇹🇷" },
  { code: "es", label: "ES", name: "Español", flag: "🇪🇸" },
  { code: "fr", label: "FR", name: "Français", flag: "🇫🇷" },
  { code: "de", label: "DE", name: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "IT", name: "Italiano", flag: "🇮🇹" },
];

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("smartai_lang") || "en";
    return dict[saved] ? saved : "en";
  });

  // Admin-driven overrides — fetched from /api/i18n/overrides on boot and
  // re-fetched whenever an admin saves a change. Shape:
  //   { en: { key: "Custom text" }, tr: { key: "..." }, ... }
  // Empty / missing langs fall back to dict[lang] then dict.en then the key.
  const [overrides, setOverrides] = useState({});

  const refreshOverrides = useCallback(async () => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/i18n/overrides?ts=${Date.now()}`;
      const r = await fetch(url, { cache: "no-store" });
      if (!r.ok) return;
      const j = await r.json();
      if (j && j.overrides) setOverrides(j.overrides);
    } catch (_) {
      // Best effort — falls back to bundled defaults on network failure.
    }
  }, []);

  useEffect(() => {
    refreshOverrides();
  }, [refreshOverrides]);

  useEffect(() => {
    localStorage.setItem("smartai_lang", lang);
    document.documentElement.lang = lang;
    // If the user is logged in, persist the preference to the backend
    // so transactional emails go in the language they last selected.
    const token = localStorage.getItem("smartai_token");
    if (token) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me/lang`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ lang }),
      }).catch(() => { /* best effort, ignore */ });
    }
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      // Resolution order: admin override for current lang → bundled dict for
      // current lang → bundled English default → raw key. Overrides are
      // strictly per-language: an English override never leaks into Turkish.
      const langOv = overrides[lang] || {};
      let s;
      if (typeof langOv[key] === "string") {
        s = langOv[key];
      } else {
        s = (dict[lang] && dict[lang][key]) || dict.en[key] || key;
      }
      if (vars && typeof s === "string") {
        for (const k in vars) {
          s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(vars[k]));
        }
      }
      return s;
    },
    [lang, overrides]
  );

  // Legacy binary toggle (EN↔TR) — kept for callers that haven't migrated to setLang
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "tr" : "en")), []);

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t, refreshOverrides, overrides }}>
      {children}
    </I18nContext.Provider>
  );
}

// Export the raw dictionary so the Admin "Site Copy" editor can list every
// known i18n key + its default English/Turkish/etc. text alongside the
// override fields. Lazy import in the admin page keeps this out of the
// landing-page bundle.
export { dict as I18N_DICT };

export const useT = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useT must be used within I18nProvider");
  return ctx;
};
